webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(5);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(7);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	__webpack_require__(9);
	
	var _angularUiRouter = __webpack_require__(10);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(11);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	__webpack_require__(13);
	
	var _app = __webpack_require__(15);
	
	var _auth = __webpack_require__(16);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(28);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _admin = __webpack_require__(41);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _navbar = __webpack_require__(93);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(96);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _main = __webpack_require__(98);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _order = __webpack_require__(101);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _orderNew = __webpack_require__(105);
	
	var _orderNew2 = _interopRequireDefault(_orderNew);
	
	var _app2 = __webpack_require__(17);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(19);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _socket = __webpack_require__(108);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _modal = __webpack_require__(162);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _fileInput = __webpack_require__(164);
	
	var _fileInput2 = _interopRequireDefault(_fileInput);
	
	var _datePicker = __webpack_require__(165);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _repeatEndWatch = __webpack_require__(167);
	
	var _repeatEndWatch2 = _interopRequireDefault(_repeatEndWatch);
	
	var _resultControls = __webpack_require__(168);
	
	var _resultControls2 = _interopRequireDefault(_resultControls);
	
	var _pagination = __webpack_require__(170);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _autoComplete = __webpack_require__(171);
	
	var _autoComplete2 = _interopRequireDefault(_autoComplete);
	
	var _autoCompleteJobClass = __webpack_require__(172);
	
	var _autoCompleteJobClass2 = _interopRequireDefault(_autoCompleteJobClass);
	
	var _autoCompleteCompanyGl = __webpack_require__(173);
	
	var _autoCompleteCompanyGl2 = _interopRequireDefault(_autoCompleteCompanyGl);
	
	var _autoCompleteAccountingUnit = __webpack_require__(210);
	
	var _autoCompleteAccountingUnit2 = _interopRequireDefault(_autoCompleteAccountingUnit);
	
	var _autoCompleteLocationCode = __webpack_require__(211);
	
	var _autoCompleteLocationCode2 = _interopRequireDefault(_autoCompleteLocationCode);
	
	__webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(214);
	__webpack_require__(216);
	
	_angular2.default.module('wftOrderFormApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, 'btford.socket-io', _angularUiRouter2.default, _angularUiBootstrap2.default, _auth2.default, _account2.default, _admin2.default, 'validation.match', _navbar2.default, _footer2.default, _main2.default, _order2.default, _orderNew2.default, _modal2.default, _app3.default, _socket2.default, _util2.default, _fileInput2.default, _datePicker2.default, _repeatEndWatch2.default, _resultControls2.default, _pagination2.default, _autoComplete2.default, _autoCompleteJobClass2.default, _autoCompleteCompanyGl2.default, _autoCompleteAccountingUnit2.default, _autoCompleteLocationCode2.default]).config(_app.routeConfig).run(['$rootScope', '$location', 'Auth', 'Util', function ($rootScope, $location, Auth, Util) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    Auth.isLoggedIn(function (loggedIn) {
	      if (next.authenticate && !loggedIn) {
	        $location.path('/login');
	      }
	    });
	  });
	  $rootScope.$on('$stateChangeSuccess', function () {
	    Util.scrollToTop();
	  });
	}]);
	
	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, ['wftOrderFormApp'], {
	    strictDi: true
	  });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(14);
	module.exports = 'validation.match';


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	/*!
	 * angular-validation-match
	 * Checks if one input matches another
	 * @version v1.9.0
	 * @link https://github.com/TheSharpieOne/angular-validation-match
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(window, angular, undefined){'use strict';
	
	match.$inject = ["$parse"];
	angular.module('validation.match', []);
	
	angular.module('validation.match').directive('match', match);
	
	function match ($parse) {
	    return {
	        require: '?ngModel',
	        restrict: 'A',
	        link: function(scope, elem, attrs, ctrl) {
	            if(!ctrl || !attrs.match) {
	                return;
	            }
	
	            var matchGetter = $parse(attrs.match);
	            var caselessGetter = $parse(attrs.matchCaseless);
	            var noMatchGetter = $parse(attrs.notMatch);
	            var matchIgnoreEmptyGetter = $parse(attrs.matchIgnoreEmpty);
	
	            scope.$watch(getMatchValue, function(){
	                ctrl.$$parseAndValidate();
	            });
	
	            ctrl.$validators.match = function(modelValue, viewValue){
	              var matcher = modelValue || viewValue;
	              var match = getMatchValue();
	              var notMatch = noMatchGetter(scope);
	              var value;
	
	              if (matchIgnoreEmptyGetter(scope) && !viewValue) {
	                return true;
	              }
	
	              if(caselessGetter(scope)){
	                value = angular.lowercase(matcher) === angular.lowercase(match);
	              }else{
	                value = matcher === match;
	              }
	              /*jslint bitwise: true */
	              value ^= notMatch;
	              /*jslint bitwise: false */
	              return !!value;
	            };
	
	            function getMatchValue(){
	                var match = matchGetter(scope);
	                if(angular.isObject(match) && match.hasOwnProperty('$viewValue')){
	                    match = match.$viewValue;
	                }
	                return match;
	            }
	        }
	    };
	}
	})(window, window.angular);


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $locationProvider.html5Mode(true);
	}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	addInterceptor.$inject = ['$httpProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(17);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _util = __webpack_require__(19);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _interceptor = __webpack_require__(24);
	
	var _router = __webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _user = __webpack_require__(27);
	
	var _angularUiRouter = __webpack_require__(10);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addInterceptor($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('authInterceptor');
	}
	
	exports.default = _angular2.default.module('wftOrderFormApp.auth', [_app2.default, _util2.default, _angularCookies2.default, _angularUiRouter2.default]).factory('authInterceptor', _interceptor.authInterceptor).run(_router.routerDecorator).factory('Auth', _auth.AuthService).factory('User', _user.UserResource).config(['$httpProvider', addInterceptor]).name;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('wftOrderFormApp.constants', []).constant('appConfig', __webpack_require__(18)).name;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	exports = module.exports = {
	  // List of user roles
	  userRoles: ['guest', 'user', 'admin']
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('wftOrderFormApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(22);
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    },
	    cancelRequest: function cancelRequest(canceller) {
	      return function (callback) {
	        canceller.resolve();
	        if (_.isFunction(callback)) {
	          callback(null);
	        }
	      };
	    },
	    scrollToTop: function scrollToTop() {
	      $('html, body').animate({ scrollTop: 0 }, { duration: 750 });
	    }
	  };
	
	  return Util;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	authInterceptor.$inject = ['$rootScope', '$q', '$cookies', '$injector', 'Util'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authInterceptor = authInterceptor;
	function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
	  'ngInject';
	
	  var state;
	  return {
	    request: function request(config) {
	      config.headers = config.headers || {};
	      if ($cookies.get('token') && Util.isSameOrigin(config.url)) {
	        config.headers.Authorization = 'Bearer ' + $cookies.get('token');
	      }
	      return config;
	    },
	    responseError: function responseError(response) {
	      if (response.status === 401) {
	        (state || (state = $injector.get('$state'))).go('login');
	
	        $cookies.remove('token');
	      }
	      return $q.reject(response);
	    }
	  };
	}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';
	
	routerDecorator.$inject = ['$rootScope', '$state', 'Auth'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerDecorator = routerDecorator;
	function routerDecorator($rootScope, $state, Auth) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    if (!next.authenticate) {
	      return;
	    }
	
	    if (next.name === 'admin') {
	      event.preventDefault = true;
	      $state.go('admin.users');
	      return;
	    }
	
	    if (typeof next.authenticate === 'string') {
	      Auth.hasRole(next.authenticate).then(function (has) {
	        if (has) {
	          return;
	        }
	
	        event.preventDefault();
	        return Auth.isLoggedIn().then(function (is) {
	          $state.go(is ? 'main' : 'login');
	        });
	      });
	    } else {
	      Auth.isLoggedIn().then(function (is) {
	        if (is) {
	          return;
	        }
	
	        event.preventDefault();
	
	        $state.go('login');
	      });
	    }
	  });
	}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuthService.$inject = ['$location', '$http', '$cookies', '$q', 'appConfig', 'Util', 'User'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthService = AuthService;
	
	var _lodash = __webpack_require__(22);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _User = function _User() {
	  _classCallCheck(this, _User);
	
	  this._id = '';
	  this.name = '';
	  this.email = '';
	  this.role = '';
	  this.$promise = undefined;
	};
	
	function AuthService($location, $http, $cookies, $q, appConfig, Util, User) {
	  'ngInject';
	
	  var safeCb = Util.safeCb;
	  var currentUser = new _User();
	  var userRoles = appConfig.userRoles || [];
	
	  var _hasRole = function _hasRole(userRole, role) {
	    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
	  };
	
	  if ($cookies.get('token') && $location.path() !== '/logout') {
	    currentUser = User.get();
	  }
	
	  var Auth = {
	    login: function login(_ref, callback) {
	      var email = _ref.email,
	          password = _ref.password;
	
	      return $http.post('/auth/local', {
	        email: email,
	        password: password
	      }).then(function (res) {
	        $cookies.put('token', res.data.token);
	        currentUser = User.get();
	        return currentUser.$promise;
	      }).then(function (user) {
	        safeCb(callback)(null, user);
	        return user;
	      }).catch(function (err) {
	        Auth.logout();
	        safeCb(callback)(err.data);
	        return $q.reject(err.data);
	      });
	    },
	    logout: function logout() {
	      $cookies.remove('token');
	      currentUser = new _User();
	    },
	    createUser: function createUser(user, callback) {
	      return User.save(user, function (data) {
	        $cookies.put('token', data.token);
	        currentUser = User.get();
	        return safeCb(callback)(null, user);
	      }, function (err) {
	        Auth.logout();
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    changePassword: function changePassword(oldPassword, newPassword, callback) {
	      return User.changePassword({
	        id: currentUser._id
	      }, {
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    getCurrentUser: function getCurrentUser(callback) {
	      var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;
	
	      return $q.when(value).then(function (user) {
	        safeCb(callback)(user);
	        return user;
	      }, function () {
	        safeCb(callback)({});
	        return {};
	      });
	    },
	    getCurrentUserSync: function getCurrentUserSync() {
	      return currentUser;
	    },
	    isLoggedIn: function isLoggedIn(callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var is = _.get(user, 'role');
	
	        safeCb(callback)(is);
	        return is;
	      });
	    },
	    isLoggedInSync: function isLoggedInSync() {
	      return !!_.get(currentUser, 'role');
	    },
	    hasRole: function hasRole(role, callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var has = _hasRole(_.get(user, 'role'), role);
	
	        safeCb(callback)(has);
	        return has;
	      });
	    },
	    hasRoleSync: function hasRoleSync(role) {
	      return _hasRole(_.get(currentUser, 'role'), role);
	    },
	    isAdmin: function isAdmin() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return Auth.hasRole(Reflect.apply([].concat, ['admin'], args));
	    },
	    isAdminSync: function isAdminSync() {
	      return Auth.hasRoleSync('admin');
	    },
	    canExportOrders: function canExportOrders() {
	      return _.get(currentUser, 'canExportOrders') || Auth.isAdminSync();
	    },
	    getToken: function getToken() {
	      return $cookies.get('token');
	    }
	  };
	
	  return Auth;
	}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';
	
	UserResource.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserResource = UserResource;
	function UserResource($resource) {
	  'ngInject';
	
	  return $resource('/api/users/:id/:controller', {
	    id: '@_id'
	  }, {
	    changePassword: {
	      method: 'PUT',
	      params: {
	        controller: 'password'
	      }
	    },
	    get: {
	      method: 'GET',
	      params: {
	        id: 'me'
	      }
	    }
	  });
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(10);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _account = __webpack_require__(29);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _login = __webpack_require__(34);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _recover = __webpack_require__(36);
	
	var _recover2 = _interopRequireDefault(_recover);
	
	var _settings = __webpack_require__(39);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('wftOrderFormApp.account', [_angularUiRouter2.default, _login2.default, _recover2.default, _settings2.default]).config(_account2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('login', {
	    url: '/login',
	    template: __webpack_require__(30),
	    controller: 'LoginController',
	    controllerAs: 'vm'
	  }).state('logout', {
	    url: '/logout?referrer',
	    referrer: 'main',
	    template: '',
	    controller: ['$state', 'Auth', function controller($state, Auth) {
	      'ngInject';
	
	      Auth.logout();
	
	      window.location.href = '/';
	    }]
	  }).state('recoverRequest', {
	    url: '/recover/request',
	    template: __webpack_require__(31),
	    controller: 'RecoverRequestController',
	    controllerAs: 'vm'
	  }).state('recoverPassword', {
	    url: '/recover/password/:token',
	    template: __webpack_require__(32),
	    controller: 'RecoverPasswordController',
	    controllerAs: 'vm'
	  }).state('settings', {
	    url: '/settings',
	    template: __webpack_require__(33),
	    controller: 'SettingsController',
	    controllerAs: 'vm',
	    authenticate: true
	  });
	}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"login-page\">\n  <header class=\"banner\" id=\"banner\">\n    <div class=\"container\"></div>\n  </header>\n  <div class=\"container\">\n    <div class=\"page-header\">\n      <h3>Login</h3>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-sm-6\">\n        <form class=\"form\" name=\"form\" ng-submit=\"vm.login(form)\" novalidate>\n          <div class=\"form-group\">\n            <label for=\"email\" class=\"required\">Email</label>\n            <input type=\"email\" name=\"email\" class=\"form-control input-sm\" ng-model=\"vm.user.email\" required>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"password\" class=\"required\">Password</label>\n            <input type=\"password\" name=\"password\" class=\"form-control input-sm\" ng-model=\"vm.user.password\" required>\n            <a ui-sref=\"recoverRequest\" class=\"recover-password-link\">Forgot Password <i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></a>\n          </div>\n          <div class=\"form-group has-error\">\n            <p class=\"help-block\" ng-show=\"form.email.$error.required && form.password.$error.required && vm.submitted\">Please enter your email and password.</p>\n            <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">Please enter a valid email.</p>\n            <p class=\"help-block\">{{ vm.errors.login }}</p>\n          </div>\n          <div>\n            <button type=\"submit\" class=\"btn btn-primary btn-sm\">Login</button>\n            <button type=\"reset\" class=\"btn btn-default btn-sm\">Clear</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"recover-page\">\n  <header class=\"banner\" id=\"banner\">\n    <div class=\"container\"></div>\n  </header>\n  <div class=\"container\">\n    <div class=\"page-header\">\n      <h3>Forgot Password</h3>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-sm-6\" ng-if=\"!vm.showThankYou\">\n        <p>Please enter your email below and we'll send you instructions on how to reset your password.</p>\n        <form class=\"form\" name=\"form\" ng-submit=\"vm.submitForm(form)\" novalidate>\n          <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && vm.submitted}\">\n            <input type=\"text\" id=\"user-email\" name=\"requesterEmail\" class=\"form-control input-sm\" placeholder=\"Enter Your Email\" ng-model=\"vm.form.requesterEmail\" required />\n          </div>\n          <button class=\"btn btn-lg btn-primary btn-sm\" type=\"submit\" ng-disabled=\"!form.$dirty || form.$invalid || vm.isSaving\">Submit</button>\n        </form>\n      </div>\n      <div class=\"col-sm-6\" ng-if=\"vm.showThankYou\">\n        <p>Thank you! An email had been sent to {{vm.form.requesterEmail}}.<br />Please allow 5 to 10 minutes for email to arrive.</p>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"recover-page\">\n  <header class=\"banner\" id=\"banner\">\n    <div class=\"container\"></div>\n  </header>\n  <div class=\"container\">\n    <div class=\"page-header\">\n      <h3>New Password</h3>\n    </div>\n    <div class=\"row\" ng-if=\"vm.showExpiredMsg\">\n      <div class=\"col-sm-6\">\n        <div class=\"alert alert-danger\">\n          <i class=\"fa fa-bug\" aria-hidden=\"true\"></i> Your reset link has expired or used. <a ui-sref=\"recoverRequest\">Click here request a new link</a>.\n        </div>\n      </div>\n    </div>\n    <div class=\"row\" ng-if=\"vm.showForm\">\n      <div class=\"col-sm-6\" ng-if=\"!vm.showThankYou\">\n        <p>Please enter your new password below.</p>\n        <form class=\"form\" name=\"form\" ng-submit=\"vm.submitForm(form)\" novalidate>\n          <div class=\"form-group\">\n            <label class=\"required\">New Password</label>\n            <input type=\"password\" name=\"newPassword\" class=\"form-control input-sm\" ng-model=\"vm.form.newPassword\" ng-minlength=\"4\" required/>\n            <p class=\"help-block small-text\" ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && form.newPassword.$dirty\">\n              Password must be at least 4 characters.\n            </p>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"required\">Confirm New Password</label>\n            <input type=\"password\" name=\"confirmPassword\" class=\"form-control input-sm\" ng-model=\"vm.form.confirmPassword\" match=\"vm.form.newPassword\" ng-minlength=\"4\" required=\"\"/>\n            <p class=\"help-block small-text\" ng-show=\"form.confirmPassword.$error.match\">\n              Passwords must match.\n            </p>\n          </div>\n          <button class=\"btn btn-lg btn-primary btn-sm\" type=\"submit\" ng-disabled=\"!form.$dirty || form.$invalid || vm.isSaving\">Submit</button>\n        </form>\n      </div>\n      <div class=\"col-sm-6\" ng-if=\"vm.showThankYou\">\n        <p>Thank you! Your new password had been successfully saved. <a ui-sref=\"login\">Click here to login</a>.</p>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"settings-page\">\n  <header class=\"banner\" id=\"banner\">\n    <div class=\"container\"></div>\n  </header>\n  <div class=\"container\">\n    <div class=\"page-header\">\n      <h3>Change Password</h3>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-sm-6\">\n        <form class=\"form\" name=\"form\" ng-submit=\"vm.changePassword(form)\" novalidate>\n          <div class=\"form-group\">\n            <label class=\"required\">Current Password</label>\n            <input type=\"password\" name=\"password\" class=\"form-control input-sm\" ng-model=\"vm.user.oldPassword\" mongoose-error/>\n            <p class=\"help-block small-text\" ng-show=\"form.password.$error.mongoose\">\n              {{ vm.errors.other }}\n            </p>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"required\">New Password</label>\n            <input type=\"password\" name=\"newPassword\" class=\"form-control input-sm\" ng-model=\"vm.user.newPassword\" ng-minlength=\"4\" required/>\n            <p class=\"help-block small-text\" ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && (form.newPassword.$dirty || vm.submitted)\">\n              Password must be at least 4 characters.\n            </p>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"required\">Confirm New Password</label>\n            <input type=\"password\" name=\"confirmPassword\" class=\"form-control input-sm\" ng-model=\"vm.user.confirmPassword\" match=\"vm.user.newPassword\" ng-minlength=\"4\" required=\"\"/>\n            <p class=\"help-block small-text\" ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\n              Passwords must match.\n            </p>\n          </div>\n          <p class=\"help-block\"> {{ vm.message }} </p>\n          <button class=\"btn btn-lg btn-primary btn-sm\" type=\"submit\">Save changes</button>\n        </form>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _login = __webpack_require__(35);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('wftOrderFormApp.login', []).controller('LoginController', _login2.default).name;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginController = function () {
	
	  /*@ngInject*/
	  LoginController.$inject = ['Auth', '$state'];
	  function LoginController(Auth, $state) {
	    _classCallCheck(this, LoginController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {
	      login: undefined
	    };
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	  }
	
	  _createClass(LoginController, [{
	    key: 'login',
	    value: function login(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.login({
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this.$state.go('main');
	        }).catch(function (err) {
	          _this.errors.login = err.message;
	        });
	      }
	    }
	  }]);
	
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _recoverRequest = __webpack_require__(37);
	
	var _recoverRequest2 = _interopRequireDefault(_recoverRequest);
	
	var _recoverPassword = __webpack_require__(38);
	
	var _recoverPassword2 = _interopRequireDefault(_recoverPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('wftOrderFormApp.recover', []).controller('RecoverRequestController', _recoverRequest2.default).controller('RecoverPasswordController', _recoverPassword2.default).name;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RecoverRequestController = function () {
	  /*@ngInject*/
	  RecoverRequestController.$inject = ['$http', '$q', '$timeout'];
	  function RecoverRequestController($http, $q, $timeout) {
	    _classCallCheck(this, RecoverRequestController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$timeout = $timeout;
	
	    this.form = {};
	    this.submitted = false;
	    this.isSaving = false;
	    this.errors;
	    this.showThankYou = false;
	  }
	
	  _createClass(RecoverRequestController, [{
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        var self = this;
	        this.submitted = true;
	        this.isSaving = true;
	        this.$http.post('/api/users/recover/password', this.form).then(function (response) {
	          self.showThankYou = true;
	        }, function (err) {
	          self.isSaving = false;
	
	          self.errors = {};
	          angular.forEach(err.data.errors, function (error, field) {
	            form[field].$setValidity('mongoose', false);
	            self.errors[field] = error.message;
	          });
	        });
	      }
	    }
	  }]);
	
	  return RecoverRequestController;
	}();
	
	exports.default = RecoverRequestController;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RecoverPasswordController = function () {
	  /*@ngInject*/
	  RecoverPasswordController.$inject = ['$http', '$q', '$stateParams', '$timeout'];
	  function RecoverPasswordController($http, $q, $stateParams, $timeout) {
	    _classCallCheck(this, RecoverPasswordController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$stateParams = $stateParams;
	    this.$timeout = $timeout;
	
	    this.showExpiredMsg = false;
	    this.showForm = false;
	
	    this.form = {};
	    this.submitted = false;
	    this.isSaving = false;
	    this.errors;
	    this.showThankYou = false;
	  }
	
	  _createClass(RecoverPasswordController, [{
	    key: 'getData',
	    value: function getData() {
	      var self = this;
	      this.$http.get('/api/users/recover/password/verifyToken/' + this.$stateParams.token).then(function (response) {
	        if (response.data.status && response.data.status === 'expired') {
	          self.showExpiredMsg = true;
	          self.showForm = false;
	          return;
	        }
	        self.showForm = true;
	      }, function (err) {
	        self.showExpiredMsg = true;
	        self.showForm = false;
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        var self = this;
	        this.submitted = true;
	        this.isSaving = true;
	        var payload = {
	          newPassword: this.form.newPassword
	        };
	        this.$http.post('/api/users/recover/password/new/' + this.$stateParams.token, payload).then(function (response) {
	          self.showThankYou = true;
	        }, function (err) {
	          self.isSaving = false;
	
	          self.errors = {};
	          angular.forEach(err.data.errors, function (error, field) {
	            form[field].$setValidity('mongoose', false);
	            self.errors[field] = error.message;
	          });
	        });
	      }
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      this.getData();
	    }
	  }]);
	
	  return RecoverPasswordController;
	}();
	
	exports.default = RecoverPasswordController;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _settings = __webpack_require__(40);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('wftOrderFormApp.settings', []).controller('SettingsController', _settings2.default).name;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SettingsController = function () {
	
	  /*@ngInject*/
	  SettingsController.$inject = ['Auth'];
	  function SettingsController(Auth) {
	    _classCallCheck(this, SettingsController);
	
	    this.user = {
	      oldPassword: '',
	      newPassword: '',
	      confirmPassword: ''
	    };
	    this.errors = {
	      other: undefined
	    };
	    this.message = '';
	    this.submitted = false;
	
	    this.Auth = Auth;
	  }
	
	  _createClass(SettingsController, [{
	    key: 'changePassword',
	    value: function changePassword(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.changePassword(this.user.oldPassword, this.user.newPassword).then(function () {
	          _this.message = 'Password successfully changed.';
	        }).catch(function () {
	          form.password.$setValidity('mongoose', false);
	          _this.errors.other = 'Incorrect password';
	          _this.message = '';
	        });
	      }
	    }
	  }]);
	
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _admin = __webpack_require__(42);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _admin3 = __webpack_require__(50);
	
	var _admin4 = _interopRequireDefault(_admin3);
	
	var _users = __webpack_require__(51);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _userModal = __webpack_require__(54);
	
	var _userModal2 = _interopRequireDefault(_userModal);
	
	var _userPasswordModal = __webpack_require__(57);
	
	var _userPasswordModal2 = _interopRequireDefault(_userPasswordModal);
	
	var _companyGLs = __webpack_require__(58);
	
	var _companyGLs2 = _interopRequireDefault(_companyGLs);
	
	var _companyGLsUpload = __webpack_require__(73);
	
	var _companyGLsUpload2 = _interopRequireDefault(_companyGLsUpload);
	
	var _companyGLForm = __webpack_require__(74);
	
	var _companyGLForm2 = _interopRequireDefault(_companyGLForm);
	
	var _accountingUnits = __webpack_require__(75);
	
	var _accountingUnits2 = _interopRequireDefault(_accountingUnits);
	
	var _accountingUnitsUpload = __webpack_require__(78);
	
	var _accountingUnitsUpload2 = _interopRequireDefault(_accountingUnitsUpload);
	
	var _accountingUnitForm = __webpack_require__(79);
	
	var _accountingUnitForm2 = _interopRequireDefault(_accountingUnitForm);
	
	var _locationCodes = __webpack_require__(80);
	
	var _locationCodes2 = _interopRequireDefault(_locationCodes);
	
	var _locationCodesUpload = __webpack_require__(83);
	
	var _locationCodesUpload2 = _interopRequireDefault(_locationCodesUpload);
	
	var _locationCodeForm = __webpack_require__(84);
	
	var _locationCodeForm2 = _interopRequireDefault(_locationCodeForm);
	
	var _companyAddresses = __webpack_require__(85);
	
	var _companyAddresses2 = _interopRequireDefault(_companyAddresses);
	
	var _companyAddressesUpload = __webpack_require__(88);
	
	var _companyAddressesUpload2 = _interopRequireDefault(_companyAddressesUpload);
	
	var _companyAddressForm = __webpack_require__(89);
	
	var _companyAddressForm2 = _interopRequireDefault(_companyAddressForm);
	
	var _jobClass = __webpack_require__(90);
	
	var _jobClass2 = _interopRequireDefault(_jobClass);
	
	var _jobClassUpload = __webpack_require__(92);
	
	var _jobClassUpload2 = _interopRequireDefault(_jobClassUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('wftOrderFormApp.admin', ['wftOrderFormApp.auth', 'ui.router']).config(_admin2.default).controller('AdminController', _admin4.default).controller('UsersController', _users2.default).controller('UserModalController', _userModal2.default).controller('UserPasswordModalController', _userPasswordModal2.default).controller('CompanyGLsController', _companyGLs2.default).controller('CompanyGLsUploadController', _companyGLsUpload2.default).controller('CompanyGLFormController', _companyGLForm2.default).controller('AccountingUnitsController', _accountingUnits2.default).controller('AccountingUnitsUploadController', _accountingUnitsUpload2.default).controller('AccountingUnitFormController', _accountingUnitForm2.default).controller('LocationCodesController', _locationCodes2.default).controller('LocationCodesUploadController', _locationCodesUpload2.default).controller('LocationCodeFormController', _locationCodeForm2.default).controller('CompanyAddressesController', _companyAddresses2.default).controller('CompanyAddressesUploadController', _companyAddressesUpload2.default).controller('CompanyAddressFormController', _companyAddressForm2.default).controller('JobClassController', _jobClass2.default).controller('JobClassUploadController', _jobClassUpload2.default).name;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('admin', {
	    abstract: true,
	    url: '/admin',
	    template: __webpack_require__(43),
	    controller: 'AdminController',
	    controllerAs: 'AdminCtrl'
	  }).state('admin.users', {
	    url: '/users?_pageNum&_pageSize&_sortyBy&name&email&role',
	    template: __webpack_require__(44),
	    controller: 'UsersController',
	    controllerAs: 'UsersCtrl',
	    authenticate: 'admin'
	  }).state('admin.companyGLs', {
	    url: '/companyGLs?_pageNum&_pageSize&_sortyBy&name&facilityName&areaName&costCenter&city&state',
	    template: __webpack_require__(45),
	    controller: 'CompanyGLsController',
	    controllerAs: 'CompanyGLsCtrl',
	    authenticate: 'admin'
	  }).state('admin.accountingUnits', {
	    url: '/accountingUnits?_pageNum&_pageSize&_sortyBy&name&facilityName&areaName&costCenter&city&state',
	    template: __webpack_require__(46),
	    controller: 'AccountingUnitsController',
	    controllerAs: 'AccountingUnitsCtrl',
	    authenticate: 'admin'
	  }).state('admin.locationCodes', {
	    url: '/locationCodes?_pageNum&_pageSize&_sortyBy&name&facilityName&areaName&costCenter&city&state',
	    template: __webpack_require__(47),
	    controller: 'LocationCodesController',
	    controllerAs: 'LocationCodesCtrl',
	    authenticate: 'admin'
	  }).state('admin.addresses', {
	    url: '/addresses?_pageNum&_pageSize&_sortyBy&name&facilityName&areaName&costCenter&city&state',
	    template: __webpack_require__(48),
	    controller: 'CompanyAddressesController',
	    controllerAs: 'CompanyAddressesCtrl',
	    authenticate: 'admin'
	  }).state('admin.jobClass', {
	    url: '/jobClass?_pageNum&_pageSize&_sortyBy&jobCode&JobClass',
	    template: __webpack_require__(49),
	    controller: 'JobClassController',
	    controllerAs: 'JobClassCtrl',
	    authenticate: 'admin'
	  });
	}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"admin-page\">\n  <header class=\"banner\" id=\"banner\">\n    <div class=\"container\"></div>\n  </header>\n  <div class=\"container\">\n    <ol class=\"breadcrumb\">\n      <li><a href=\"/\">Home</a></li>\n      <li><a href=\"/admin/users\">Admin</a></li>\n      <li class=\"active\">{{AdminCtrl.currentAdminPageTitle}}</li>\n    </ol>\n    <ul class=\"nav nav-tabs\">\n      <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"admin.users\">Users</a></li>\n      <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"admin.companyGLs\">Company GLs</a></li>\n      <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"admin.accountingUnits\">Accounting Units</a></li>\n      <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"admin.locationCodes\">Location Codes</a></li>\n      <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"admin.addresses\">Addresses</a></li>\n      <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"admin.jobClass\">Job Class</a></li>\n      <!--<li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"admin.rates\">Rates</a></li>\n      <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"admin.systems\">Systems</a></li>-->\n    </ul>\n    <div class=\"tab-content\" ui-view=\"\"></div>\n  </div>\n</div>\n"

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"buttons\">\n  <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"UsersCtrl.openUserModal()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Add User</button>\n</div>\n<div class=\"form-container\">\n  <form name=\"form\" class=\"form-inline\" ng-submit=\"UsersCtrl.search(form)\" novalidate>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"name\" name=\"name\" class=\"form-control input-sm\" placeholder=\"Name\" ng-model=\"UsersCtrl.form.name\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"email\" name=\"email\" class=\"form-control input-sm\" placeholder=\"Email\" ng-model=\"UsersCtrl.form.email\" />\n    </div>\n    <div class=\"form-group\">\n      <select id=\"role\" name=\"role\" class=\"form-control input-sm\" ng-options=\"option as option for option in UsersCtrl.roleOptions\" ng-model=\"UsersCtrl.form.role\">\n        <option value=\"\">Select a Role</option>\n      </select>\n    </div>\n    <div class=\"form-group\">\n      <button type=\"submit\" class=\"btn btn-primary btn-sm\">Search</button>\n      <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"UsersCtrl.clearSearch()\">Clear</button>\n    </div>\n  </form>\n</div>\n<div class=\"result-controls-pagination-container clearfix\">\n  <result-controls data-total=\"UsersCtrl.result.total\"\n                   data-page-size-options=\"UsersCtrl.pageSizeOptions\"\n                   data-page-size=\"UsersCtrl.pagination._pageSize\"\n                   data-page-size-callback=\"UsersCtrl.updatePageSize(pageSize)\"\n                   data-sort-by-options=\"UsersCtrl.sortByOptions\"\n                   data-sort-by=\"UsersCtrl.pagination._sortBy\"\n                   data-sort-by-callback=\"UsersCtrl.updateSortBy(sortBy)\"></result-controls>\n  <pagination data-id=\"top\" data-total=\"UsersCtrl.result.total\" data-page-num=\"UsersCtrl.result.pageNum\" data-page-size=\"UsersCtrl.result.pageSize\" data-callback=\"UsersCtrl.gotoPage(pageNum)\"></pagination>\n</div>\n<div class=\"table-responsive\">\n  <table class=\"table table-bordered table-striped table-hover\">\n    <thead>\n      <tr>\n        <th width=\"10%\">Actions</th>\n        <th width=\"15\">#</th>\n        <th>Name</th>\n        <th>Email</th>\n        <th>Role</th>\n        <th class=\"no-wrap\">Can Export Orders?</th>\n        <th class=\"no-wrap\" width=\"10%\">Last Logged In</th>\n        <th class=\"no-wrap\" width=\"10%\">Created By</th>\n        <th class=\"no-wrap\" width=\"10%\">Created Date</th>\n        <th class=\"no-wrap\" width=\"10%\">Modified By</th>\n        <th class=\"no-wrap\" width=\"10%\">Modified Date</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"item in UsersCtrl.result.items\">\n        <td class=\"actions no-wrap\">\n          <a ng-click=\"UsersCtrl.openUserModal(item)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> Edit</a>\n          <a ng-click=\"UsersCtrl.openUserPasswordModal(item)\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i> Password</a>\n          <a ng-click=\"UsersCtrl.delete(item)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i> Delete</a>\n        </td>\n        <td>{{$index + 1}}</td>\n        <td class=\"no-wrap\">{{item.name}}</td>\n        <td class=\"no-wrap\">{{item.email}}</td>\n        <td>{{item.role}}</td>\n        <td>{{item.canExportOrders}}</td>\n        <td class=\"no-wrap\">{{item.lastLoggedIn | date: 'MM/dd/yyyy hh:mm a'}}</td>\n        <td class=\"no-wrap\">{{item.createdBy}}</td>\n        <td class=\"no-wrap\">{{item.createdDate | date: 'MM/dd/yyyy hh:mm a'}}</td>\n        <td class=\"no-wrap\">{{item.modifiedBy}}</td>\n        <td class=\"no-wrap\">{{item.modifiedDate | date: 'MM/dd/yyyy hh:mm a'}}</td>\n      </tr>\n      <tr ng-if=\"UsersCtrl.result.total===0\">\n        <td colspan=\"12\">{{UsersCtrl.tableMsg}}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"buttons\">\n  <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"CompanyGLsCtrl.openUploadModal()\"><i class=\"fa fa-arrow-up\" aria-hidden=\"true\"></i> Upload Company GL Excel File</button>\n  <!-- <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"CompanyGLsCtrl.openForm()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Add a Company GL</button> -->\n</div>\n<div class=\"form-container\">\n  <form name=\"form\" class=\"form-inline\" ng-submit=\"CompanyGLsCtrl.search(form)\" novalidate>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"facilityName\" name=\"facilityName\" class=\"form-control input-sm\" placeholder=\"Company Name\" ng-model=\"CompanyGLsCtrl.form.facilityName\" auto-complete-facility-name auto-complete-form=\"form\" auto-complete-extra-params=\"CompanyGLsCtrl.form\" auto-complete-related-fields=\"['areaName', 'costCenter']\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"areaName\" name=\"areaName\" class=\"form-control input-sm\" placeholder=\"Area Name\" ng-model=\"CompanyGLsCtrl.form.areaName\" auto-complete-facility-area-name auto-complete-form=\"form\" auto-complete-extra-params=\"CompanyGLsCtrl.form\" auto-complete-related-fields=\"['facilityName', 'costCenter']\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"costCenter\" name=\"costCenter\" class=\"form-control input-sm\" placeholder=\"Cost Center\" ng-model=\"CompanyGLsCtrl.form.costCenter\" auto-complete-facility-cost-center auto-complete-form=\"form\" auto-complete-extra-params=\"CompanyGLsCtrl.form\" auto-complete-related-fields=\"['facilityName', 'areaName']\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"city\" name=\"city\" class=\"form-control input-sm\" placeholder=\"City\" ng-model=\"CompanyGLsCtrl.form.city\" />\n    </div>\n    <div class=\"form-group\">\n      <button type=\"submit\" class=\"btn btn-primary btn-sm\">Search</button>\n      <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"CompanyGLsCtrl.clearSearch()\">Clear</button>\n    </div>\n  </form>\n</div>\n<div class=\"result-controls-pagination-container clearfix\">\n  <result-controls data-total=\"CompanyGLsCtrl.result.total\"\n                   data-page-size-options=\"CompanyGLsCtrl.pageSizeOptions\"\n                   data-page-size=\"CompanyGLsCtrl.pagination._pageSize\"\n                   data-page-size-callback=\"CompanyGLsCtrl.updatePageSize(pageSize)\"\n                   data-sort-by-options=\"CompanyGLsCtrl.sortByOptions\"\n                   data-sort-by=\"CompanyGLsCtrl.pagination._sortBy\"\n                   data-sort-by-callback=\"CompanyGLsCtrl.updateSortBy(sortBy)\"></result-controls>\n  <pagination data-id=\"top\" data-total=\"CompanyGLsCtrl.result.total\" data-page-num=\"CompanyGLsCtrl.result.pageNum\" data-page-size=\"CompanyGLsCtrl.result.pageSize\" data-callback=\"CompanyGLsCtrl.gotoPage(pageNum)\"></pagination>\n</div>\n<div class=\"table-responsive\">\n  <table class=\"table table-bordered table-striped table-hover\">\n    <thead>\n      <tr>\n        <th width=\"10%\">Actions</th>\n        <th width=\"15\">#</th>\n        <th class=\"no-wrap\">GL</th>\n        <th class=\"no-wrap\">Region Name</th>\n        <th class=\"no-wrap\">Region Abbr</th>\n        <th class=\"no-wrap\">System Name</th>\n        <th class=\"no-wrap\">System Abbr</th>\n        <th class=\"no-wrap\">Company Name</th>\n        <th class=\"no-wrap\">Ministry</th>\n        <th class=\"no-wrap\" width=\"10%\">Uploaded By</th>\n        <th class=\"no-wrap\" width=\"10%\">Uploaded Date</th>\n        <th class=\"no-wrap\" width=\"10%\">Re-Uploaded By</th>\n        <th class=\"no-wrap\" width=\"10%\">Re-Uploaded Date</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"item in CompanyGLsCtrl.result.items\">\n        <td class=\"actions no-wrap\">\n          <!--<a ng-click=\"\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> Edit</a>-->\n          <a ng-click=\"CompanyGLsCtrl.delete(item)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i> Delete</a>\n        </td>\n        <td>{{CompanyGLsCtrl.rowNumb($index)}}</td>\n        <td class=\"no-wrap\">{{item.gl}}</td>\n        <td class=\"no-wrap\">{{item.regionName}}</td>\n        <td class=\"no-wrap\">{{item.regionAbbr}}</td>\n        <td class=\"no-wrap\">{{item.systemName}}</td>\n        <td class=\"no-wrap\">{{item.systemAbbr}}</td>\n        <td class=\"no-wrap\">{{item.companyName}}</td>\n        <td class=\"no-wrap\">{{item.ministry}}</td>\n        <td class=\"no-wrap\">{{item.createdBy}}</td>\n        <td class=\"no-wrap\">{{item.createdDate | date: 'MM/dd/yyyy hh:mm a'}}</td>\n        <td class=\"no-wrap\">{{item.modifiedBy}}</td>\n        <td class=\"no-wrap\">{{item.modifiedDate | date: 'MM/dd/yyyy hh:mm a'}}</td>\n      </tr>\n      <tr ng-if=\"CompanyGLsCtrl.result.total===0\">\n        <td colspan=\"16\">{{CompanyGLsCtrl.tableMsg}}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"buttons\">\n  <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"AccountingUnitsCtrl.openUploadModal()\"><i class=\"fa fa-arrow-up\" aria-hidden=\"true\"></i> Upload Accounting Unit Excel File</button>\n  <!-- <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"AccountingUnitsCtrl.openCompanyForm()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Add a Accounting Unit</button> -->\n</div>\n<div class=\"form-container\">\n  <form name=\"form\" class=\"form-inline\" ng-submit=\"AccountingUnitsCtrl.search(form)\" novalidate>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"facilityName\" name=\"facilityName\" class=\"form-control input-sm\" placeholder=\"Company Name\" ng-model=\"AccountingUnitsCtrl.form.facilityName\" auto-complete-facility-name auto-complete-form=\"form\" auto-complete-extra-params=\"AccountingUnitsCtrl.form\" auto-complete-related-fields=\"['areaName', 'costCenter']\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"areaName\" name=\"areaName\" class=\"form-control input-sm\" placeholder=\"Area Name\" ng-model=\"AccountingUnitsCtrl.form.areaName\" auto-complete-facility-area-name auto-complete-form=\"form\" auto-complete-extra-params=\"AccountingUnitsCtrl.form\" auto-complete-related-fields=\"['facilityName', 'costCenter']\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"costCenter\" name=\"costCenter\" class=\"form-control input-sm\" placeholder=\"Cost Center\" ng-model=\"AccountingUnitsCtrl.form.costCenter\" auto-complete-facility-cost-center auto-complete-form=\"form\" auto-complete-extra-params=\"AccountingUnitsCtrl.form\" auto-complete-related-fields=\"['facilityName', 'areaName']\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"city\" name=\"city\" class=\"form-control input-sm\" placeholder=\"City\" ng-model=\"AccountingUnitsCtrl.form.city\" />\n    </div>\n    <div class=\"form-group\">\n      <button type=\"submit\" class=\"btn btn-primary btn-sm\">Search</button>\n      <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"AccountingUnitsCtrl.clearSearch()\">Clear</button>\n    </div>\n  </form>\n</div>\n<div class=\"result-controls-pagination-container clearfix\">\n  <result-controls data-total=\"AccountingUnitsCtrl.result.total\"\n                   data-page-size-options=\"AccountingUnitsCtrl.pageSizeOptions\"\n                   data-page-size=\"AccountingUnitsCtrl.pagination._pageSize\"\n                   data-page-size-callback=\"AccountingUnitsCtrl.updatePageSize(pageSize)\"\n                   data-sort-by-options=\"AccountingUnitsCtrl.sortByOptions\"\n                   data-sort-by=\"AccountingUnitsCtrl.pagination._sortBy\"\n                   data-sort-by-callback=\"AccountingUnitsCtrl.updateSortBy(sortBy)\"></result-controls>\n  <pagination data-id=\"top\" data-total=\"AccountingUnitsCtrl.result.total\" data-page-num=\"AccountingUnitsCtrl.result.pageNum\" data-page-size=\"AccountingUnitsCtrl.result.pageSize\" data-callback=\"AccountingUnitsCtrl.gotoPage(pageNum)\"></pagination>\n</div>\n<div class=\"table-responsive\">\n  <table class=\"table table-bordered table-striped table-hover\">\n    <thead>\n      <tr>\n        <th width=\"10%\">Actions</th>\n        <th width=\"15\">#</th>\n        <th class=\"no-wrap\">HROrganizationUnit</th>\n        <th class=\"no-wrap\">ShortDescription</th>\n        <th class=\"no-wrap\">Description</th>\n        <th class=\"no-wrap\">ParentUnitShortDescription</th>\n        <th class=\"no-wrap\">MVS or BSC?</th>\n        <th class=\"no-wrap\" width=\"10%\">Uploaded By</th>\n        <th class=\"no-wrap\" width=\"10%\">Uploaded Date</th>\n        <th class=\"no-wrap\" width=\"10%\">Re-Uploaded By</th>\n        <th class=\"no-wrap\" width=\"10%\">Re-Uploaded Date</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"item in AccountingUnitsCtrl.result.items\">\n        <td class=\"actions no-wrap\">\n          <!--<a ng-click=\"\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> Edit</a>-->\n          <a ng-click=\"AccountingUnitsCtrl.delete(item)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i> Delete</a>\n        </td>\n        <td>{{AccountingUnitsCtrl.rowNumb($index)}}</td>\n        <td class=\"no-wrap\">{{item.hrOrganizationUnit}}</td>\n        <td class=\"no-wrap\">{{item.shortDescription}}</td>\n        <td class=\"no-wrap\">{{item.description}}</td>\n        <td class=\"no-wrap\">{{item.parentUnitShortDescription}}</td>\n        <td class=\"no-wrap\">{{item.mvsOrBsc}}</td>\n        <td class=\"no-wrap\">{{item.createdBy}}</td>\n        <td class=\"no-wrap\">{{item.createdDate | date: 'MM/dd/yyyy hh:mm a'}}</td>\n        <td class=\"no-wrap\">{{item.modifiedBy}}</td>\n        <td class=\"no-wrap\">{{item.modifiedDate | date: 'MM/dd/yyyy hh:mm a'}}</td>\n      </tr>\n      <tr ng-if=\"AccountingUnitsCtrl.result.total===0\">\n        <td colspan=\"16\">{{AccountingUnitsCtrl.tableMsg}}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"buttons\">\n  <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"LocationCodesCtrl.openUploadModal()\"><i class=\"fa fa-arrow-up\" aria-hidden=\"true\"></i> Upload Location Code Excel File</button>\n  <!-- <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"LocationCodesCtrl.openCompanyForm()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Add a Location Code</button> -->\n</div>\n<div class=\"form-container\">\n  <form name=\"form\" class=\"form-inline\" ng-submit=\"LocationCodesCtrl.search(form)\" novalidate>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"facilityName\" name=\"facilityName\" class=\"form-control input-sm\" placeholder=\"Company Name\" ng-model=\"LocationCodesCtrl.form.facilityName\" auto-complete-facility-name auto-complete-form=\"form\" auto-complete-extra-params=\"LocationCodesCtrl.form\" auto-complete-related-fields=\"['areaName', 'costCenter']\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"areaName\" name=\"areaName\" class=\"form-control input-sm\" placeholder=\"Area Name\" ng-model=\"LocationCodesCtrl.form.areaName\" auto-complete-facility-area-name auto-complete-form=\"form\" auto-complete-extra-params=\"LocationCodesCtrl.form\" auto-complete-related-fields=\"['facilityName', 'costCenter']\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"costCenter\" name=\"costCenter\" class=\"form-control input-sm\" placeholder=\"Cost Center\" ng-model=\"LocationCodesCtrl.form.costCenter\" auto-complete-facility-cost-center auto-complete-form=\"form\" auto-complete-extra-params=\"LocationCodesCtrl.form\" auto-complete-related-fields=\"['facilityName', 'areaName']\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"city\" name=\"city\" class=\"form-control input-sm\" placeholder=\"City\" ng-model=\"LocationCodesCtrl.form.city\" />\n    </div>\n    <div class=\"form-group\">\n      <button type=\"submit\" class=\"btn btn-primary btn-sm\">Search</button>\n      <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"LocationCodesCtrl.clearSearch()\">Clear</button>\n    </div>\n  </form>\n</div>\n<div class=\"result-controls-pagination-container clearfix\">\n  <result-controls data-total=\"LocationCodesCtrl.result.total\"\n                   data-page-size-options=\"LocationCodesCtrl.pageSizeOptions\"\n                   data-page-size=\"LocationCodesCtrl.pagination._pageSize\"\n                   data-page-size-callback=\"LocationCodesCtrl.updatePageSize(pageSize)\"\n                   data-sort-by-options=\"LocationCodesCtrl.sortByOptions\"\n                   data-sort-by=\"LocationCodesCtrl.pagination._sortBy\"\n                   data-sort-by-callback=\"LocationCodesCtrl.updateSortBy(sortBy)\"></result-controls>\n  <pagination data-id=\"top\" data-total=\"LocationCodesCtrl.result.total\" data-page-num=\"LocationCodesCtrl.result.pageNum\" data-page-size=\"LocationCodesCtrl.result.pageSize\" data-callback=\"LocationCodesCtrl.gotoPage(pageNum)\"></pagination>\n</div>\n<div class=\"table-responsive\">\n  <table class=\"table table-bordered table-striped table-hover\">\n    <thead>\n      <tr>\n        <th width=\"10%\">Actions</th>\n        <th width=\"15\">#</th>\n        <th class=\"no-wrap\">HR Location</th>\n        <th class=\"no-wrap\">Description</th>\n        <th class=\"no-wrap\">MVS or BSC?</th>\n        <th class=\"no-wrap\" width=\"10%\">Uploaded By</th>\n        <th class=\"no-wrap\" width=\"10%\">Uploaded Date</th>\n        <th class=\"no-wrap\" width=\"10%\">Re-Uploaded By</th>\n        <th class=\"no-wrap\" width=\"10%\">Re-Uploaded Date</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"item in LocationCodesCtrl.result.items\">\n        <td class=\"actions no-wrap\">\n          <!--<a ng-click=\"\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> Edit</a>-->\n          <a ng-click=\"LocationCodesCtrl.delete(item)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i> Delete</a>\n        </td>\n        <td>{{LocationCodesCtrl.rowNumb($index)}}</td>\n        <td class=\"no-wrap\">{{item.hrLocation}}</td>\n        <td class=\"no-wrap\">{{item.description}}</td>\n        <td class=\"no-wrap\">{{item.mvsOrBsc}}</td>\n        <td class=\"no-wrap\">{{item.createdBy}}</td>\n        <td class=\"no-wrap\">{{item.createdDate | date: 'MM/dd/yyyy hh:mm a'}}</td>\n        <td class=\"no-wrap\">{{item.modifiedBy}}</td>\n        <td class=\"no-wrap\">{{item.modifiedDate | date: 'MM/dd/yyyy hh:mm a'}}</td>\n      </tr>\n      <tr ng-if=\"LocationCodesCtrl.result.total===0\">\n        <td colspan=\"16\">{{LocationCodesCtrl.tableMsg}}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"buttons\">\n  <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"CompanyAddressesCtrl.openUploadModal()\"><i class=\"fa fa-arrow-up\" aria-hidden=\"true\"></i> Upload Company Address Excel File</button>\n  <!-- <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"CompanyAddressesCtrl.openForm()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Add a Company Address</button> -->\n</div>\n<div class=\"form-container\">\n  <form name=\"form\" class=\"form-inline\" ng-submit=\"CompanyAddressesCtrl.search(form)\" novalidate>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"facilityName\" name=\"facilityName\" class=\"form-control input-sm\" placeholder=\"Company Name\" ng-model=\"CompanyAddressesCtrl.form.facilityName\" auto-complete-facility-name auto-complete-form=\"form\" auto-complete-extra-params=\"CompanyAddressesCtrl.form\" auto-complete-related-fields=\"['areaName', 'costCenter']\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"areaName\" name=\"areaName\" class=\"form-control input-sm\" placeholder=\"Area Name\" ng-model=\"CompanyAddressesCtrl.form.areaName\" auto-complete-facility-area-name auto-complete-form=\"form\" auto-complete-extra-params=\"CompanyAddressesCtrl.form\" auto-complete-related-fields=\"['facilityName', 'costCenter']\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"costCenter\" name=\"costCenter\" class=\"form-control input-sm\" placeholder=\"Cost Center\" ng-model=\"CompanyAddressesCtrl.form.costCenter\" auto-complete-facility-cost-center auto-complete-form=\"form\" auto-complete-extra-params=\"CompanyAddressesCtrl.form\" auto-complete-related-fields=\"['facilityName', 'areaName']\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"city\" name=\"city\" class=\"form-control input-sm\" placeholder=\"City\" ng-model=\"CompanyAddressesCtrl.form.city\" />\n    </div>\n    <div class=\"form-group\">\n      <button type=\"submit\" class=\"btn btn-primary btn-sm\">Search</button>\n      <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"CompanyAddressesCtrl.clearSearch()\">Clear</button>\n    </div>\n  </form>\n</div>\n<div class=\"result-controls-pagination-container clearfix\">\n  <result-controls data-total=\"CompanyAddressesCtrl.result.total\"\n                   data-page-size-options=\"CompanyAddressesCtrl.pageSizeOptions\"\n                   data-page-size=\"CompanyAddressesCtrl.pagination._pageSize\"\n                   data-page-size-callback=\"CompanyAddressesCtrl.updatePageSize(pageSize)\"\n                   data-sort-by-options=\"CompanyAddressesCtrl.sortByOptions\"\n                   data-sort-by=\"CompanyAddressesCtrl.pagination._sortBy\"\n                   data-sort-by-callback=\"CompanyAddressesCtrl.updateSortBy(sortBy)\"></result-controls>\n  <pagination data-id=\"top\" data-total=\"CompanyAddressesCtrl.result.total\" data-page-num=\"CompanyAddressesCtrl.result.pageNum\" data-page-size=\"CompanyAddressesCtrl.result.pageSize\" data-callback=\"CompanyAddressesCtrl.gotoPage(pageNum)\"></pagination>\n</div>\n<div class=\"table-responsive\">\n  <table class=\"table table-bordered table-striped table-hover\">\n    <thead>\n      <tr>\n        <th width=\"10%\">Actions</th>\n        <th width=\"15\">#</th>\n        <th class=\"no-wrap\">HR Organization</th>\n        <th class=\"no-wrap\">HR Location</th>\n        <th class=\"no-wrap\">Description</th>\n        <th class=\"no-wrap\">Municipality</th>\n        <th class=\"no-wrap\">State / Province</th>\n        <th class=\"no-wrap\">Country</th>\n        <th class=\"no-wrap\">Display Address</th>\n        <th class=\"no-wrap\" width=\"10%\">Uploaded By</th>\n        <th class=\"no-wrap\" width=\"10%\">Uploaded Date</th>\n        <th class=\"no-wrap\" width=\"10%\">Re-Uploaded By</th>\n        <th class=\"no-wrap\" width=\"10%\">Re-Uploaded Date</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"item in CompanyAddressesCtrl.result.items\">\n        <td class=\"actions no-wrap\">\n          <!--<a ng-click=\"\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> Edit</a>-->\n          <a ng-click=\"CompanyAddressesCtrl.delete(item)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i> Delete</a>\n        </td>\n        <td>{{CompanyAddressesCtrl.rowNumb($index)}}</td>\n        <td class=\"no-wrap\">{{item.hrOrganization}}</td>\n        <td class=\"no-wrap\">{{item.hrLocation}}</td>\n        <td class=\"no-wrap\">{{item.description}}</td>\n        <td class=\"no-wrap\">{{item.municipality}}</td>\n        <td class=\"no-wrap\">{{item.stateProvince}}</td>\n        <td class=\"no-wrap\">{{item.country}}</td>\n        <td class=\"no-wrap\">{{item.displayAddress}}</td>\n        <td class=\"no-wrap\">{{item.createdBy}}</td>\n        <td class=\"no-wrap\">{{item.createdDate | date: 'MM/dd/yyyy hh:mm a'}}</td>\n        <td class=\"no-wrap\">{{item.modifiedBy}}</td>\n        <td class=\"no-wrap\">{{item.modifiedDate | date: 'MM/dd/yyyy hh:mm a'}}</td>\n      </tr>\n      <tr ng-if=\"CompanyAddressesCtrl.result.total===0\">\n        <td colspan=\"16\">{{CompanyAddressesCtrl.tableMsg}}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"buttons\">\n  <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"JobClassCtrl.openUploadModal()\"><i class=\"fa fa-arrow-up\" aria-hidden=\"true\"></i> Upload Job Class Excel File</button>\n</div>\n<div class=\"form-container\">\n  <form name=\"form\" class=\"form-inline\" ng-submit=\"JobClassCtrl.search(form)\" novalidate>\n    <!-- <div class=\"form-group\">\n      <input type=\"text\" id=\"jobCode\" name=\"jobCode\" class=\"form-control input-sm\" placeholder=\"Job Code\" ng-model=\"JobClassCtrl.form.jobCode\" />\n    </div> -->\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"jobClass\" name=\"jobClass\" class=\"form-control input-sm\" placeholder=\"Job Class\" ng-model=\"JobClassCtrl.form.name\" />\n    </div>\n    <div class=\"form-group\">\n      <input type=\"text\" id=\"id\" name=\"id\" class=\"form-control input-sm\" placeholder=\"System Id\" ng-model=\"JobClassCtrl.form.id\" />\n    </div>\n    <div class=\"form-group\">\n      <button type=\"submit\" class=\"btn btn-primary btn-sm\">Search</button>\n      <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"JobClassCtrl.clearSearch()\">Clear</button>\n    </div>\n  </form>\n</div>\n<div class=\"result-controls-pagination-container clearfix\">\n  <result-controls data-total=\"JobClassCtrl.result.total\"\n                   data-page-size-options=\"JobClassCtrl.pageSizeOptions\"\n                   data-page-size=\"JobClassCtrl.pagination._pageSize\"\n                   data-page-size-callback=\"JobClassCtrl.updatePageSize(pageSize)\"\n                   data-sort-by-options=\"JobClassCtrl.sortByOptions\"\n                   data-sort-by=\"JobClassCtrl.pagination._sortBy\"\n                   data-sort-by-callback=\"JobClassCtrl.updateSortBy(sortBy)\"></result-controls>\n  <pagination data-id=\"top\" data-total=\"JobClassCtrl.result.total\" data-page-num=\"JobClassCtrl.result.pageNum\" data-page-size=\"JobClassCtrl.result.pageSize\" data-callback=\"JobClassCtrl.gotoPage(pageNum)\"></pagination>\n</div>\n<div class=\"table-responsive\">\n  <table class=\"table table-bordered table-striped table-hover\">\n    <thead>\n      <tr>\n        <th width=\"10%\">Actions</th>\n        <th width=\"15\">#</th>\n        <th class=\"no-wrap\" width=\"10%\">Name</th>\n        <th class=\"no-wrap\">Description</th>\n        <th class=\"no-wrap\" width=\"10%\">Uploaded By</th>\n        <th class=\"no-wrap\" width=\"10%\">Uploaded Date</th>\n        <!--<th class=\"no-wrap\" width=\"10%\">Modified By</th>\n        <th class=\"no-wrap\" width=\"10%\">Modified Date</th>-->\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"item in JobClassCtrl.result.items\">\n        <td class=\"actions no-wrap\">\n          <!--<a ng-click=\"\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> Edit</a>-->\n          <a ng-click=\"JobClassCtrl.delete(item)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i> Delete</a>\n        </td>\n        <td>{{JobClassCtrl.rowNumb($index)}}</td>\n        <td class=\"no-wrap\">{{item.name}}</td>\n        <td class=\"no-wrap\">{{item.description}}</td>\n        <td class=\"no-wrap\">{{item.createdBy}}</td>\n        <td class=\"no-wrap\">{{item.createdDate | date: 'MM/dd/yyyy hh:mm a'}}</td>\n        <!--<td class=\"no-wrap\">{{item.modifiedBy}}</td>\n        <td class=\"no-wrap\">{{item.modifiedDate | date: 'MM/dd/yyyy hh:mm a'}}</td>-->\n      </tr>\n      <tr ng-if=\"JobClassCtrl.result.total===0\">\n        <td colspan=\"7\">{{JobClassCtrl.tableMsg}}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminController =
	/*@ngInject*/
	['$rootScope', function AdminController($rootScope) {
	  _classCallCheck(this, AdminController);
	
	  this.currentAdminPageTitle = 'Users';
	
	  var self = this;
	  $rootScope.$watch('currentAdminPageTitle', function (title) {
	    if (title) {
	      self.currentAdminPageTitle = title;
	    }
	  });
	}];
	
	exports.default = AdminController;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UsersController = function () {
	  /*@ngInject*/
	  UsersController.$inject = ['$rootScope', '$http', '$q', '$state', '$stateParams', '$uibModal', 'Modal'];
	  function UsersController($rootScope, $http, $q, $state, $stateParams, $uibModal, Modal) {
	    _classCallCheck(this, UsersController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$uibModal = $uibModal;
	    this.Modal = Modal;
	
	    $rootScope.currentAdminPageTitle = 'Users';
	    this.route = 'admin.users';
	
	    this.tableMsg = '';
	    this.form = {};
	    this.roleOptions = ['user', 'admin'];
	    this.systemOptions = [];
	    this.result = {};
	    this.pageSizeOptions = [10, 20, 30, 40, 50];
	    this.sortByOptions = {
	      name: 'Name',
	      email: 'Email',
	      lastLoggedIn: 'Last Logged In'
	    };
	    this.pagination = {
	      _paging: true,
	      _selector: 'All',
	      _pageSize: 10,
	      _pageNum: 1,
	      _sortBy: 'lastLoggedIn desc'
	    };
	  }
	
	  _createClass(UsersController, [{
	    key: 'getSystems',
	    value: function getSystems() {
	      var deferred = this.$q.defer();
	      var self = this;
	      var params = {
	        _selector: 'name',
	        _pageSize: 'All'
	      };
	      this.$http.get('/api/types/systems', { params: params }).then(function (response) {
	        self.systemOptions = response.data;
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'setDefaultSearchForm',
	    value: function setDefaultSearchForm() {
	      var _pageNum = 1;
	      if (this.$stateParams._pageNum) {
	        _pageNum = parseInt(this.$stateParams._pageNum);
	      }
	      this.pageNumVal = _pageNum;
	      var _pageSize = 100;
	      if (this.$stateParams._pageSize) {
	        _pageSize = parseInt(this.$stateParams._pageSize);
	      }
	      this.pageSizeVal = _pageSize;
	    }
	  }, {
	    key: 'buildQuery',
	    value: function buildQuery() {
	      return angular.extend(angular.copy(this.form), this.pagination);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var self = this;
	      this.$http.get('/api/users', {
	        params: this.buildQuery()
	      }).then(function (response) {
	        angular.forEach(response.data.items, function (item) {
	          if (item.system && item.system.length) {
	            item.systems = item.system.join(', ');
	          }
	        });
	        if (response.data.total === 0) {
	          self.tableMsg = 'No record found.';
	        }
	        self.result = response.data;
	      }, function (err) {});
	    }
	  }, {
	    key: 'search',
	    value: function search(form) {
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'clearSearch',
	    value: function clearSearch() {
	      this.form = {};
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'openUserModal',
	    value: function openUserModal(_user) {
	      var self = this;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        ariaLabelledBy: 'modal-title',
	        ariaDescribedBy: 'modal-body',
	        template: __webpack_require__(52),
	        controller: 'UserModalController',
	        controllerAs: '$ctrl',
	        size: 'md',
	        resolve: {
	          user: function user() {
	            return _user;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        self.getData();
	      }, function () {});
	    }
	  }, {
	    key: 'openUserPasswordModal',
	    value: function openUserPasswordModal(_user2) {
	      var self = this;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        ariaLabelledBy: 'modal-title',
	        ariaDescribedBy: 'modal-body',
	        template: __webpack_require__(53),
	        controller: 'UserPasswordModalController',
	        controllerAs: '$ctrl',
	        size: 'md',
	        resolve: {
	          user: function user() {
	            return _user2;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        self.getData();
	      }, function () {});
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(item) {
	      var self = this;
	      this.Modal.confirm.delete(function () {
	        self.$http.delete('/api/users/' + item._id).then(function (response) {
	          self.getData();
	        }, function (err) {});
	      })('' + item.name);
	    }
	  }, {
	    key: 'rowNumb',
	    value: function rowNumb(idx) {
	      return idx + 1 + (this.data.results.pageNum !== 1 ? this.data.results.pageSize * this.data.results.pageNum - this.data.results.pageSize : 0);
	    }
	  }, {
	    key: 'renderCompleted',
	    value: function renderCompleted() {
	      this.tableRendered = true;
	    }
	  }, {
	    key: 'updateSortBy',
	    value: function updateSortBy(sortBy) {
	      this.pagination._sortBy = sortBy;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'updatePageSize',
	    value: function updatePageSize(pageSize) {
	      this.pagination._pageSize = pageSize;
	      this.pagination._pageNum = 1;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'gotoPage',
	    value: function gotoPage(pageNum) {
	      this.pagination._pageNum = pageNum;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var self = this;
	      this.getSystems().then(function () {
	        if (window.system) {
	          self.form.system = window.system;
	        }
	        self.getData();
	      });
	    }
	  }]);
	
	  return UsersController;
	}();
	
	exports.default = UsersController;

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"uploader-modal user\">\n  <form class=\"form\" name=\"form\" ng-submit=\"$ctrl.submitForm(form)\" novalidate>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\" id=\"modal-title\"><i class=\"fa\" ng-class=\"{'fa-plus': $ctrl.isAdd, 'fa-pencil-square-o': !$ctrl.isAdd}\" aria-hidden=\"true\"></i> {{!$ctrl.isAdd ? 'Edit' : 'Add'}} User</h4>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div class=\"form-group\" ng-class=\"{'has-error': form.name.$invalid && $ctrl.submitted}\">\n        <label for=\"user-name\" class=\"required\">Name</label>\n        <input type=\"text\" id=\"user-name\" name=\"name\" class=\"form-control input-sm\" placeholder=\"Name\" ng-model=\"$ctrl.form.name\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"user-email\" class=\"required\">Email</label>\n        <input type=\"text\" id=\"user-email\" name=\"email\" class=\"form-control input-sm\" placeholder=\"Email\" ng-model=\"$ctrl.form.email\" required />\n        <p class=\"help-block small-text\" ng-show=\"form.email.$error.mongoose\">\n          {{ $ctrl.errors.email }}\n        </p>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <div class=\"form-group\" ng-class=\"{'has-error': form.role.$invalid && $ctrl.submitted}\">\n            <label for=\"user-role\" class=\"required\">Role</label>\n            <select id=\"user-role\" name=\"role\" class=\"form-control input-sm\" ng-options=\"option as option for option in $ctrl.roleOptions\" ng-model=\"$ctrl.form.role\"  required>\n              <option value=\"\">Select a Role</option>\n            </select>\n          </div>\n        </div>\n        <div class=\"col-sm-6\">\n          <div class=\"form-group\" ng-class=\"{'has-error': form.role.$invalid && $ctrl.submitted}\">\n            <label for=\"user-export-orders\" class=\"required\">Export Orders</label>\n            <select id=\"user-export-orders\" name=\"canExportOrders\" class=\"form-control input-sm\" ng-options=\"option as option for option in $ctrl.exportOptions\" ng-model=\"$ctrl.form.canExportOrders\"  required>\n              <option value=\"\">Select an Answer</option>\n            </select>\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group\" ng-if=\"$ctrl.isAdd\">\n        <label for=\"user-newPassword\" class=\"required\">New Password</label>\n        <input type=\"password\" id=\"user-newPassword\" name=\"newPassword\" class=\"form-control input-sm\" ng-model=\"$ctrl.form.newPassword\" ng-minlength=\"4\" required/>\n        <p class=\"help-block small-text\" ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && form.newPassword.$dirty\">\n          Password must be at least 4 characters.\n        </p>\n      </div>\n      <div class=\"form-group\" ng-if=\"$ctrl.isAdd\">\n        <label for=\"user-confirmPassword\" class=\"required\">Confirm New Password</label>\n        <input type=\"password\" id=\"user-confirmPassword\" name=\"confirmPassword\" class=\"form-control input-sm\" ng-model=\"$ctrl.form.confirmPassword\" match=\"$ctrl.form.newPassword\" ng-minlength=\"4\" required=\"\"/>\n        <p class=\"help-block small-text\" ng-show=\"form.confirmPassword.$error.match\">\n          Passwords must match.\n        </p>\n      </div>\n    </div>\n    <div class=\"modal-footer clearfix\">\n      <div class=\"alert alert-info pull-left\" ng-if=\"$ctrl.isSaving\">\n        Saving....\n      </div>\n      <div class=\"alert alert-danger pull-left\" ng-if=\"$ctrl.errors\">\n        Form has error(s).\n      </div>\n      <button class=\"btn btn-primary btn-sm\" type=\"submit\" ng-disabled=\"!form.$dirty || form.$invalid || $ctrl.isSaving\">Save</button>\n      <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"uploader-modal user\">\n  <form class=\"form\" name=\"form\" ng-submit=\"$ctrl.submitForm(form)\" novalidate>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\" id=\"modal-title\">Reset {{$ctrl.user.name}}'s Password</h4>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div class=\"form-group\">\n        <label for=\"user-newPassword\" class=\"required\">New Password</label>\n        <input type=\"password\" id=\"user-newPassword\" name=\"newPassword\" class=\"form-control input-sm\" ng-model=\"$ctrl.form.newPassword\" ng-minlength=\"4\" required/>\n        <p class=\"help-block small-text\" ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && form.newPassword.$dirty\">\n          Password must be at least 4 characters.\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"user-confirmPassword\" class=\"required\">Confirm New Password</label>\n        <input type=\"password\" id=\"user-confirmPassword\" name=\"confirmPassword\" class=\"form-control input-sm\" ng-model=\"$ctrl.form.confirmPassword\" match=\"$ctrl.form.newPassword\" ng-minlength=\"4\" required=\"\"/>\n        <p class=\"help-block small-text\" ng-show=\"form.confirmPassword.$error.match\">\n          Passwords must match.\n        </p>\n      </div>\n    </div>\n    <div class=\"modal-footer clearfix\">\n      <div class=\"alert alert-info pull-left\" ng-if=\"$ctrl.isSaving\">\n        Saving....\n      </div>\n      <button class=\"btn btn-primary btn-sm\" type=\"submit\" ng-disabled=\"!form.$dirty || form.$invalid || $ctrl.isSaving\">Save</button>\n      <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _async = __webpack_require__(55);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserModalController = function () {
	  /*@ngInject*/
	  UserModalController.$inject = ['$http', '$q', '$timeout', '$uibModalInstance', 'user'];
	  function UserModalController($http, $q, $timeout, $uibModalInstance, user) {
	    _classCallCheck(this, UserModalController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$timeout = $timeout;
	    this.$uibModalInstance = $uibModalInstance;
	
	    this.user = user;
	
	    this.isAdd = true;
	    this.roleOptions = ['admin', 'user'];
	    this.exportOptions = ['Yes', 'No'];
	    this.systemOptions = [];
	    this.form = {};
	    this.submitted = false;
	    this.isSaving = false;
	    this.errors;
	  }
	
	  _createClass(UserModalController, [{
	    key: 'getData',
	    value: function getData(id) {
	      var self = this;
	      this.$http.get('/api/users/' + id).then(function (response) {
	        response.data.canExportOrders = response.data.canExportOrders ? 'Yes' : 'No';
	        self.form = response.data;
	      }, function (err) {});
	    }
	  }, {
	    key: 'update',
	    value: function update(form, id, payload) {
	      var self = this;
	      this.$http.put('/api/users/' + id, payload).then(function (response) {
	        self.$uibModalInstance.close();
	      }, function (err) {
	        self.isSaving = false;
	
	        self.errors = {};
	        angular.forEach(err.data.errors, function (error, field) {
	          form[field].$setValidity('mongoose', false);
	          self.errors[field] = error.message;
	        });
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(form, payload) {
	      var self = this;
	      this.$http.post('/api/users', payload).then(function (response) {
	        self.$uibModalInstance.close();
	      }, function (err) {
	        self.isSaving = false;
	
	        self.errors = {};
	        angular.forEach(err.data.errors, function (error, field) {
	          form[field].$setValidity('mongoose', false);
	          self.errors[field] = error.message;
	        });
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        var self = this;
	        this.submitted = true;
	        this.isSaving = true;
	        var payload = {
	          name: this.form.name,
	          email: this.form.email,
	          role: this.form.role,
	          canExportOrders: this.form.canExportOrders === 'Yes' ? true : false
	        };
	
	        if (this.user && this.user._id) {
	          this.update(form, this.user._id, payload);
	        } else {
	          payload.password = this.form.confirmPassword;
	          self.create(form, payload);
	        }
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var self = this;
	
	      if (self.user && self.user._id) {
	        self.isAdd = false;
	        self.getData(self.user._id);
	      } else {
	        self.form = {
	          role: 'user',
	          canExportOrders: 'No'
	        };
	      }
	    }
	  }]);
	
	  return UserModalController;
	}();
	
	exports.default = UserModalController;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, process) {/*!
	 * async
	 * https://github.com/caolan/async
	 *
	 * Copyright 2010-2014 Caolan McMahon
	 * Released under the MIT license
	 */
	(function () {
	
	    var async = {};
	    function noop() {}
	    function identity(v) {
	        return v;
	    }
	    function toBool(v) {
	        return !!v;
	    }
	    function notId(v) {
	        return !v;
	    }
	
	    // global on the server, window in the browser
	    var previous_async;
	
	    // Establish the root object, `window` (`self`) in the browser, `global`
	    // on the server, or `this` in some virtual machines. We use `self`
	    // instead of `window` for `WebWorker` support.
	    var root = typeof self === 'object' && self.self === self && self ||
	            typeof global === 'object' && global.global === global && global ||
	            this;
	
	    if (root != null) {
	        previous_async = root.async;
	    }
	
	    async.noConflict = function () {
	        root.async = previous_async;
	        return async;
	    };
	
	    function only_once(fn) {
	        return function() {
	            if (fn === null) throw new Error("Callback was already called.");
	            fn.apply(this, arguments);
	            fn = null;
	        };
	    }
	
	    function _once(fn) {
	        return function() {
	            if (fn === null) return;
	            fn.apply(this, arguments);
	            fn = null;
	        };
	    }
	
	    //// cross-browser compatiblity functions ////
	
	    var _toString = Object.prototype.toString;
	
	    var _isArray = Array.isArray || function (obj) {
	        return _toString.call(obj) === '[object Array]';
	    };
	
	    // Ported from underscore.js isObject
	    var _isObject = function(obj) {
	        var type = typeof obj;
	        return type === 'function' || type === 'object' && !!obj;
	    };
	
	    function _isArrayLike(arr) {
	        return _isArray(arr) || (
	            // has a positive integer length property
	            typeof arr.length === "number" &&
	            arr.length >= 0 &&
	            arr.length % 1 === 0
	        );
	    }
	
	    function _arrayEach(arr, iterator) {
	        var index = -1,
	            length = arr.length;
	
	        while (++index < length) {
	            iterator(arr[index], index, arr);
	        }
	    }
	
	    function _map(arr, iterator) {
	        var index = -1,
	            length = arr.length,
	            result = Array(length);
	
	        while (++index < length) {
	            result[index] = iterator(arr[index], index, arr);
	        }
	        return result;
	    }
	
	    function _range(count) {
	        return _map(Array(count), function (v, i) { return i; });
	    }
	
	    function _reduce(arr, iterator, memo) {
	        _arrayEach(arr, function (x, i, a) {
	            memo = iterator(memo, x, i, a);
	        });
	        return memo;
	    }
	
	    function _forEachOf(object, iterator) {
	        _arrayEach(_keys(object), function (key) {
	            iterator(object[key], key);
	        });
	    }
	
	    function _indexOf(arr, item) {
	        for (var i = 0; i < arr.length; i++) {
	            if (arr[i] === item) return i;
	        }
	        return -1;
	    }
	
	    var _keys = Object.keys || function (obj) {
	        var keys = [];
	        for (var k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                keys.push(k);
	            }
	        }
	        return keys;
	    };
	
	    function _keyIterator(coll) {
	        var i = -1;
	        var len;
	        var keys;
	        if (_isArrayLike(coll)) {
	            len = coll.length;
	            return function next() {
	                i++;
	                return i < len ? i : null;
	            };
	        } else {
	            keys = _keys(coll);
	            len = keys.length;
	            return function next() {
	                i++;
	                return i < len ? keys[i] : null;
	            };
	        }
	    }
	
	    // Similar to ES6's rest param (http://ariya.ofilabs.com/2013/03/es6-and-rest-parameter.html)
	    // This accumulates the arguments passed into an array, after a given index.
	    // From underscore.js (https://github.com/jashkenas/underscore/pull/2140).
	    function _restParam(func, startIndex) {
	        startIndex = startIndex == null ? func.length - 1 : +startIndex;
	        return function() {
	            var length = Math.max(arguments.length - startIndex, 0);
	            var rest = Array(length);
	            for (var index = 0; index < length; index++) {
	                rest[index] = arguments[index + startIndex];
	            }
	            switch (startIndex) {
	                case 0: return func.call(this, rest);
	                case 1: return func.call(this, arguments[0], rest);
	            }
	            // Currently unused but handle cases outside of the switch statement:
	            // var args = Array(startIndex + 1);
	            // for (index = 0; index < startIndex; index++) {
	            //     args[index] = arguments[index];
	            // }
	            // args[startIndex] = rest;
	            // return func.apply(this, args);
	        };
	    }
	
	    function _withoutIndex(iterator) {
	        return function (value, index, callback) {
	            return iterator(value, callback);
	        };
	    }
	
	    //// exported async module functions ////
	
	    //// nextTick implementation with browser-compatible fallback ////
	
	    // capture the global reference to guard against fakeTimer mocks
	    var _setImmediate = typeof setImmediate === 'function' && setImmediate;
	
	    var _delay = _setImmediate ? function(fn) {
	        // not a direct alias for IE10 compatibility
	        _setImmediate(fn);
	    } : function(fn) {
	        setTimeout(fn, 0);
	    };
	
	    if (typeof process === 'object' && typeof process.nextTick === 'function') {
	        async.nextTick = process.nextTick;
	    } else {
	        async.nextTick = _delay;
	    }
	    async.setImmediate = _setImmediate ? _delay : async.nextTick;
	
	
	    async.forEach =
	    async.each = function (arr, iterator, callback) {
	        return async.eachOf(arr, _withoutIndex(iterator), callback);
	    };
	
	    async.forEachSeries =
	    async.eachSeries = function (arr, iterator, callback) {
	        return async.eachOfSeries(arr, _withoutIndex(iterator), callback);
	    };
	
	
	    async.forEachLimit =
	    async.eachLimit = function (arr, limit, iterator, callback) {
	        return _eachOfLimit(limit)(arr, _withoutIndex(iterator), callback);
	    };
	
	    async.forEachOf =
	    async.eachOf = function (object, iterator, callback) {
	        callback = _once(callback || noop);
	        object = object || [];
	
	        var iter = _keyIterator(object);
	        var key, completed = 0;
	
	        while ((key = iter()) != null) {
	            completed += 1;
	            iterator(object[key], key, only_once(done));
	        }
	
	        if (completed === 0) callback(null);
	
	        function done(err) {
	            completed--;
	            if (err) {
	                callback(err);
	            }
	            // Check key is null in case iterator isn't exhausted
	            // and done resolved synchronously.
	            else if (key === null && completed <= 0) {
	                callback(null);
	            }
	        }
	    };
	
	    async.forEachOfSeries =
	    async.eachOfSeries = function (obj, iterator, callback) {
	        callback = _once(callback || noop);
	        obj = obj || [];
	        var nextKey = _keyIterator(obj);
	        var key = nextKey();
	        function iterate() {
	            var sync = true;
	            if (key === null) {
	                return callback(null);
	            }
	            iterator(obj[key], key, only_once(function (err) {
	                if (err) {
	                    callback(err);
	                }
	                else {
	                    key = nextKey();
	                    if (key === null) {
	                        return callback(null);
	                    } else {
	                        if (sync) {
	                            async.setImmediate(iterate);
	                        } else {
	                            iterate();
	                        }
	                    }
	                }
	            }));
	            sync = false;
	        }
	        iterate();
	    };
	
	
	
	    async.forEachOfLimit =
	    async.eachOfLimit = function (obj, limit, iterator, callback) {
	        _eachOfLimit(limit)(obj, iterator, callback);
	    };
	
	    function _eachOfLimit(limit) {
	
	        return function (obj, iterator, callback) {
	            callback = _once(callback || noop);
	            obj = obj || [];
	            var nextKey = _keyIterator(obj);
	            if (limit <= 0) {
	                return callback(null);
	            }
	            var done = false;
	            var running = 0;
	            var errored = false;
	
	            (function replenish () {
	                if (done && running <= 0) {
	                    return callback(null);
	                }
	
	                while (running < limit && !errored) {
	                    var key = nextKey();
	                    if (key === null) {
	                        done = true;
	                        if (running <= 0) {
	                            callback(null);
	                        }
	                        return;
	                    }
	                    running += 1;
	                    iterator(obj[key], key, only_once(function (err) {
	                        running -= 1;
	                        if (err) {
	                            callback(err);
	                            errored = true;
	                        }
	                        else {
	                            replenish();
	                        }
	                    }));
	                }
	            })();
	        };
	    }
	
	
	    function doParallel(fn) {
	        return function (obj, iterator, callback) {
	            return fn(async.eachOf, obj, iterator, callback);
	        };
	    }
	    function doParallelLimit(fn) {
	        return function (obj, limit, iterator, callback) {
	            return fn(_eachOfLimit(limit), obj, iterator, callback);
	        };
	    }
	    function doSeries(fn) {
	        return function (obj, iterator, callback) {
	            return fn(async.eachOfSeries, obj, iterator, callback);
	        };
	    }
	
	    function _asyncMap(eachfn, arr, iterator, callback) {
	        callback = _once(callback || noop);
	        arr = arr || [];
	        var results = _isArrayLike(arr) ? [] : {};
	        eachfn(arr, function (value, index, callback) {
	            iterator(value, function (err, v) {
	                results[index] = v;
	                callback(err);
	            });
	        }, function (err) {
	            callback(err, results);
	        });
	    }
	
	    async.map = doParallel(_asyncMap);
	    async.mapSeries = doSeries(_asyncMap);
	    async.mapLimit = doParallelLimit(_asyncMap);
	
	    // reduce only has a series version, as doing reduce in parallel won't
	    // work in many situations.
	    async.inject =
	    async.foldl =
	    async.reduce = function (arr, memo, iterator, callback) {
	        async.eachOfSeries(arr, function (x, i, callback) {
	            iterator(memo, x, function (err, v) {
	                memo = v;
	                callback(err);
	            });
	        }, function (err) {
	            callback(err, memo);
	        });
	    };
	
	    async.foldr =
	    async.reduceRight = function (arr, memo, iterator, callback) {
	        var reversed = _map(arr, identity).reverse();
	        async.reduce(reversed, memo, iterator, callback);
	    };
	
	    async.transform = function (arr, memo, iterator, callback) {
	        if (arguments.length === 3) {
	            callback = iterator;
	            iterator = memo;
	            memo = _isArray(arr) ? [] : {};
	        }
	
	        async.eachOf(arr, function(v, k, cb) {
	            iterator(memo, v, k, cb);
	        }, function(err) {
	            callback(err, memo);
	        });
	    };
	
	    function _filter(eachfn, arr, iterator, callback) {
	        var results = [];
	        eachfn(arr, function (x, index, callback) {
	            iterator(x, function (v) {
	                if (v) {
	                    results.push({index: index, value: x});
	                }
	                callback();
	            });
	        }, function () {
	            callback(_map(results.sort(function (a, b) {
	                return a.index - b.index;
	            }), function (x) {
	                return x.value;
	            }));
	        });
	    }
	
	    async.select =
	    async.filter = doParallel(_filter);
	
	    async.selectLimit =
	    async.filterLimit = doParallelLimit(_filter);
	
	    async.selectSeries =
	    async.filterSeries = doSeries(_filter);
	
	    function _reject(eachfn, arr, iterator, callback) {
	        _filter(eachfn, arr, function(value, cb) {
	            iterator(value, function(v) {
	                cb(!v);
	            });
	        }, callback);
	    }
	    async.reject = doParallel(_reject);
	    async.rejectLimit = doParallelLimit(_reject);
	    async.rejectSeries = doSeries(_reject);
	
	    function _createTester(eachfn, check, getResult) {
	        return function(arr, limit, iterator, cb) {
	            function done() {
	                if (cb) cb(getResult(false, void 0));
	            }
	            function iteratee(x, _, callback) {
	                if (!cb) return callback();
	                iterator(x, function (v) {
	                    if (cb && check(v)) {
	                        cb(getResult(true, x));
	                        cb = iterator = false;
	                    }
	                    callback();
	                });
	            }
	            if (arguments.length > 3) {
	                eachfn(arr, limit, iteratee, done);
	            } else {
	                cb = iterator;
	                iterator = limit;
	                eachfn(arr, iteratee, done);
	            }
	        };
	    }
	
	    async.any =
	    async.some = _createTester(async.eachOf, toBool, identity);
	
	    async.someLimit = _createTester(async.eachOfLimit, toBool, identity);
	
	    async.all =
	    async.every = _createTester(async.eachOf, notId, notId);
	
	    async.everyLimit = _createTester(async.eachOfLimit, notId, notId);
	
	    function _findGetResult(v, x) {
	        return x;
	    }
	    async.detect = _createTester(async.eachOf, identity, _findGetResult);
	    async.detectSeries = _createTester(async.eachOfSeries, identity, _findGetResult);
	    async.detectLimit = _createTester(async.eachOfLimit, identity, _findGetResult);
	
	    async.sortBy = function (arr, iterator, callback) {
	        async.map(arr, function (x, callback) {
	            iterator(x, function (err, criteria) {
	                if (err) {
	                    callback(err);
	                }
	                else {
	                    callback(null, {value: x, criteria: criteria});
	                }
	            });
	        }, function (err, results) {
	            if (err) {
	                return callback(err);
	            }
	            else {
	                callback(null, _map(results.sort(comparator), function (x) {
	                    return x.value;
	                }));
	            }
	
	        });
	
	        function comparator(left, right) {
	            var a = left.criteria, b = right.criteria;
	            return a < b ? -1 : a > b ? 1 : 0;
	        }
	    };
	
	    async.auto = function (tasks, concurrency, callback) {
	        if (typeof arguments[1] === 'function') {
	            // concurrency is optional, shift the args.
	            callback = concurrency;
	            concurrency = null;
	        }
	        callback = _once(callback || noop);
	        var keys = _keys(tasks);
	        var remainingTasks = keys.length;
	        if (!remainingTasks) {
	            return callback(null);
	        }
	        if (!concurrency) {
	            concurrency = remainingTasks;
	        }
	
	        var results = {};
	        var runningTasks = 0;
	
	        var hasError = false;
	
	        var listeners = [];
	        function addListener(fn) {
	            listeners.unshift(fn);
	        }
	        function removeListener(fn) {
	            var idx = _indexOf(listeners, fn);
	            if (idx >= 0) listeners.splice(idx, 1);
	        }
	        function taskComplete() {
	            remainingTasks--;
	            _arrayEach(listeners.slice(0), function (fn) {
	                fn();
	            });
	        }
	
	        addListener(function () {
	            if (!remainingTasks) {
	                callback(null, results);
	            }
	        });
	
	        _arrayEach(keys, function (k) {
	            if (hasError) return;
	            var task = _isArray(tasks[k]) ? tasks[k]: [tasks[k]];
	            var taskCallback = _restParam(function(err, args) {
	                runningTasks--;
	                if (args.length <= 1) {
	                    args = args[0];
	                }
	                if (err) {
	                    var safeResults = {};
	                    _forEachOf(results, function(val, rkey) {
	                        safeResults[rkey] = val;
	                    });
	                    safeResults[k] = args;
	                    hasError = true;
	
	                    callback(err, safeResults);
	                }
	                else {
	                    results[k] = args;
	                    async.setImmediate(taskComplete);
	                }
	            });
	            var requires = task.slice(0, task.length - 1);
	            // prevent dead-locks
	            var len = requires.length;
	            var dep;
	            while (len--) {
	                if (!(dep = tasks[requires[len]])) {
	                    throw new Error('Has nonexistent dependency in ' + requires.join(', '));
	                }
	                if (_isArray(dep) && _indexOf(dep, k) >= 0) {
	                    throw new Error('Has cyclic dependencies');
	                }
	            }
	            function ready() {
	                return runningTasks < concurrency && _reduce(requires, function (a, x) {
	                    return (a && results.hasOwnProperty(x));
	                }, true) && !results.hasOwnProperty(k);
	            }
	            if (ready()) {
	                runningTasks++;
	                task[task.length - 1](taskCallback, results);
	            }
	            else {
	                addListener(listener);
	            }
	            function listener() {
	                if (ready()) {
	                    runningTasks++;
	                    removeListener(listener);
	                    task[task.length - 1](taskCallback, results);
	                }
	            }
	        });
	    };
	
	
	
	    async.retry = function(times, task, callback) {
	        var DEFAULT_TIMES = 5;
	        var DEFAULT_INTERVAL = 0;
	
	        var attempts = [];
	
	        var opts = {
	            times: DEFAULT_TIMES,
	            interval: DEFAULT_INTERVAL
	        };
	
	        function parseTimes(acc, t){
	            if(typeof t === 'number'){
	                acc.times = parseInt(t, 10) || DEFAULT_TIMES;
	            } else if(typeof t === 'object'){
	                acc.times = parseInt(t.times, 10) || DEFAULT_TIMES;
	                acc.interval = parseInt(t.interval, 10) || DEFAULT_INTERVAL;
	            } else {
	                throw new Error('Unsupported argument type for \'times\': ' + typeof t);
	            }
	        }
	
	        var length = arguments.length;
	        if (length < 1 || length > 3) {
	            throw new Error('Invalid arguments - must be either (task), (task, callback), (times, task) or (times, task, callback)');
	        } else if (length <= 2 && typeof times === 'function') {
	            callback = task;
	            task = times;
	        }
	        if (typeof times !== 'function') {
	            parseTimes(opts, times);
	        }
	        opts.callback = callback;
	        opts.task = task;
	
	        function wrappedTask(wrappedCallback, wrappedResults) {
	            function retryAttempt(task, finalAttempt) {
	                return function(seriesCallback) {
	                    task(function(err, result){
	                        seriesCallback(!err || finalAttempt, {err: err, result: result});
	                    }, wrappedResults);
	                };
	            }
	
	            function retryInterval(interval){
	                return function(seriesCallback){
	                    setTimeout(function(){
	                        seriesCallback(null);
	                    }, interval);
	                };
	            }
	
	            while (opts.times) {
	
	                var finalAttempt = !(opts.times-=1);
	                attempts.push(retryAttempt(opts.task, finalAttempt));
	                if(!finalAttempt && opts.interval > 0){
	                    attempts.push(retryInterval(opts.interval));
	                }
	            }
	
	            async.series(attempts, function(done, data){
	                data = data[data.length - 1];
	                (wrappedCallback || opts.callback)(data.err, data.result);
	            });
	        }
	
	        // If a callback is passed, run this as a controll flow
	        return opts.callback ? wrappedTask() : wrappedTask;
	    };
	
	    async.waterfall = function (tasks, callback) {
	        callback = _once(callback || noop);
	        if (!_isArray(tasks)) {
	            var err = new Error('First argument to waterfall must be an array of functions');
	            return callback(err);
	        }
	        if (!tasks.length) {
	            return callback();
	        }
	        function wrapIterator(iterator) {
	            return _restParam(function (err, args) {
	                if (err) {
	                    callback.apply(null, [err].concat(args));
	                }
	                else {
	                    var next = iterator.next();
	                    if (next) {
	                        args.push(wrapIterator(next));
	                    }
	                    else {
	                        args.push(callback);
	                    }
	                    ensureAsync(iterator).apply(null, args);
	                }
	            });
	        }
	        wrapIterator(async.iterator(tasks))();
	    };
	
	    function _parallel(eachfn, tasks, callback) {
	        callback = callback || noop;
	        var results = _isArrayLike(tasks) ? [] : {};
	
	        eachfn(tasks, function (task, key, callback) {
	            task(_restParam(function (err, args) {
	                if (args.length <= 1) {
	                    args = args[0];
	                }
	                results[key] = args;
	                callback(err);
	            }));
	        }, function (err) {
	            callback(err, results);
	        });
	    }
	
	    async.parallel = function (tasks, callback) {
	        _parallel(async.eachOf, tasks, callback);
	    };
	
	    async.parallelLimit = function(tasks, limit, callback) {
	        _parallel(_eachOfLimit(limit), tasks, callback);
	    };
	
	    async.series = function(tasks, callback) {
	        _parallel(async.eachOfSeries, tasks, callback);
	    };
	
	    async.iterator = function (tasks) {
	        function makeCallback(index) {
	            function fn() {
	                if (tasks.length) {
	                    tasks[index].apply(null, arguments);
	                }
	                return fn.next();
	            }
	            fn.next = function () {
	                return (index < tasks.length - 1) ? makeCallback(index + 1): null;
	            };
	            return fn;
	        }
	        return makeCallback(0);
	    };
	
	    async.apply = _restParam(function (fn, args) {
	        return _restParam(function (callArgs) {
	            return fn.apply(
	                null, args.concat(callArgs)
	            );
	        });
	    });
	
	    function _concat(eachfn, arr, fn, callback) {
	        var result = [];
	        eachfn(arr, function (x, index, cb) {
	            fn(x, function (err, y) {
	                result = result.concat(y || []);
	                cb(err);
	            });
	        }, function (err) {
	            callback(err, result);
	        });
	    }
	    async.concat = doParallel(_concat);
	    async.concatSeries = doSeries(_concat);
	
	    async.whilst = function (test, iterator, callback) {
	        callback = callback || noop;
	        if (test()) {
	            var next = _restParam(function(err, args) {
	                if (err) {
	                    callback(err);
	                } else if (test.apply(this, args)) {
	                    iterator(next);
	                } else {
	                    callback.apply(null, [null].concat(args));
	                }
	            });
	            iterator(next);
	        } else {
	            callback(null);
	        }
	    };
	
	    async.doWhilst = function (iterator, test, callback) {
	        var calls = 0;
	        return async.whilst(function() {
	            return ++calls <= 1 || test.apply(this, arguments);
	        }, iterator, callback);
	    };
	
	    async.until = function (test, iterator, callback) {
	        return async.whilst(function() {
	            return !test.apply(this, arguments);
	        }, iterator, callback);
	    };
	
	    async.doUntil = function (iterator, test, callback) {
	        return async.doWhilst(iterator, function() {
	            return !test.apply(this, arguments);
	        }, callback);
	    };
	
	    async.during = function (test, iterator, callback) {
	        callback = callback || noop;
	
	        var next = _restParam(function(err, args) {
	            if (err) {
	                callback(err);
	            } else {
	                args.push(check);
	                test.apply(this, args);
	            }
	        });
	
	        var check = function(err, truth) {
	            if (err) {
	                callback(err);
	            } else if (truth) {
	                iterator(next);
	            } else {
	                callback(null);
	            }
	        };
	
	        test(check);
	    };
	
	    async.doDuring = function (iterator, test, callback) {
	        var calls = 0;
	        async.during(function(next) {
	            if (calls++ < 1) {
	                next(null, true);
	            } else {
	                test.apply(this, arguments);
	            }
	        }, iterator, callback);
	    };
	
	    function _queue(worker, concurrency, payload) {
	        if (concurrency == null) {
	            concurrency = 1;
	        }
	        else if(concurrency === 0) {
	            throw new Error('Concurrency must not be zero');
	        }
	        function _insert(q, data, pos, callback) {
	            if (callback != null && typeof callback !== "function") {
	                throw new Error("task callback must be a function");
	            }
	            q.started = true;
	            if (!_isArray(data)) {
	                data = [data];
	            }
	            if(data.length === 0 && q.idle()) {
	                // call drain immediately if there are no tasks
	                return async.setImmediate(function() {
	                    q.drain();
	                });
	            }
	            _arrayEach(data, function(task) {
	                var item = {
	                    data: task,
	                    callback: callback || noop
	                };
	
	                if (pos) {
	                    q.tasks.unshift(item);
	                } else {
	                    q.tasks.push(item);
	                }
	
	                if (q.tasks.length === q.concurrency) {
	                    q.saturated();
	                }
	            });
	            async.setImmediate(q.process);
	        }
	        function _next(q, tasks) {
	            return function(){
	                workers -= 1;
	
	                var removed = false;
	                var args = arguments;
	                _arrayEach(tasks, function (task) {
	                    _arrayEach(workersList, function (worker, index) {
	                        if (worker === task && !removed) {
	                            workersList.splice(index, 1);
	                            removed = true;
	                        }
	                    });
	
	                    task.callback.apply(task, args);
	                });
	                if (q.tasks.length + workers === 0) {
	                    q.drain();
	                }
	                q.process();
	            };
	        }
	
	        var workers = 0;
	        var workersList = [];
	        var q = {
	            tasks: [],
	            concurrency: concurrency,
	            payload: payload,
	            saturated: noop,
	            empty: noop,
	            drain: noop,
	            started: false,
	            paused: false,
	            push: function (data, callback) {
	                _insert(q, data, false, callback);
	            },
	            kill: function () {
	                q.drain = noop;
	                q.tasks = [];
	            },
	            unshift: function (data, callback) {
	                _insert(q, data, true, callback);
	            },
	            process: function () {
	                while(!q.paused && workers < q.concurrency && q.tasks.length){
	
	                    var tasks = q.payload ?
	                        q.tasks.splice(0, q.payload) :
	                        q.tasks.splice(0, q.tasks.length);
	
	                    var data = _map(tasks, function (task) {
	                        return task.data;
	                    });
	
	                    if (q.tasks.length === 0) {
	                        q.empty();
	                    }
	                    workers += 1;
	                    workersList.push(tasks[0]);
	                    var cb = only_once(_next(q, tasks));
	                    worker(data, cb);
	                }
	            },
	            length: function () {
	                return q.tasks.length;
	            },
	            running: function () {
	                return workers;
	            },
	            workersList: function () {
	                return workersList;
	            },
	            idle: function() {
	                return q.tasks.length + workers === 0;
	            },
	            pause: function () {
	                q.paused = true;
	            },
	            resume: function () {
	                if (q.paused === false) { return; }
	                q.paused = false;
	                var resumeCount = Math.min(q.concurrency, q.tasks.length);
	                // Need to call q.process once per concurrent
	                // worker to preserve full concurrency after pause
	                for (var w = 1; w <= resumeCount; w++) {
	                    async.setImmediate(q.process);
	                }
	            }
	        };
	        return q;
	    }
	
	    async.queue = function (worker, concurrency) {
	        var q = _queue(function (items, cb) {
	            worker(items[0], cb);
	        }, concurrency, 1);
	
	        return q;
	    };
	
	    async.priorityQueue = function (worker, concurrency) {
	
	        function _compareTasks(a, b){
	            return a.priority - b.priority;
	        }
	
	        function _binarySearch(sequence, item, compare) {
	            var beg = -1,
	                end = sequence.length - 1;
	            while (beg < end) {
	                var mid = beg + ((end - beg + 1) >>> 1);
	                if (compare(item, sequence[mid]) >= 0) {
	                    beg = mid;
	                } else {
	                    end = mid - 1;
	                }
	            }
	            return beg;
	        }
	
	        function _insert(q, data, priority, callback) {
	            if (callback != null && typeof callback !== "function") {
	                throw new Error("task callback must be a function");
	            }
	            q.started = true;
	            if (!_isArray(data)) {
	                data = [data];
	            }
	            if(data.length === 0) {
	                // call drain immediately if there are no tasks
	                return async.setImmediate(function() {
	                    q.drain();
	                });
	            }
	            _arrayEach(data, function(task) {
	                var item = {
	                    data: task,
	                    priority: priority,
	                    callback: typeof callback === 'function' ? callback : noop
	                };
	
	                q.tasks.splice(_binarySearch(q.tasks, item, _compareTasks) + 1, 0, item);
	
	                if (q.tasks.length === q.concurrency) {
	                    q.saturated();
	                }
	                async.setImmediate(q.process);
	            });
	        }
	
	        // Start with a normal queue
	        var q = async.queue(worker, concurrency);
	
	        // Override push to accept second parameter representing priority
	        q.push = function (data, priority, callback) {
	            _insert(q, data, priority, callback);
	        };
	
	        // Remove unshift function
	        delete q.unshift;
	
	        return q;
	    };
	
	    async.cargo = function (worker, payload) {
	        return _queue(worker, 1, payload);
	    };
	
	    function _console_fn(name) {
	        return _restParam(function (fn, args) {
	            fn.apply(null, args.concat([_restParam(function (err, args) {
	                if (typeof console === 'object') {
	                    if (err) {
	                        if (console.error) {
	                            console.error(err);
	                        }
	                    }
	                    else if (console[name]) {
	                        _arrayEach(args, function (x) {
	                            console[name](x);
	                        });
	                    }
	                }
	            })]));
	        });
	    }
	    async.log = _console_fn('log');
	    async.dir = _console_fn('dir');
	    /*async.info = _console_fn('info');
	    async.warn = _console_fn('warn');
	    async.error = _console_fn('error');*/
	
	    async.memoize = function (fn, hasher) {
	        var memo = {};
	        var queues = {};
	        var has = Object.prototype.hasOwnProperty;
	        hasher = hasher || identity;
	        var memoized = _restParam(function memoized(args) {
	            var callback = args.pop();
	            var key = hasher.apply(null, args);
	            if (has.call(memo, key)) {   
	                async.setImmediate(function () {
	                    callback.apply(null, memo[key]);
	                });
	            }
	            else if (has.call(queues, key)) {
	                queues[key].push(callback);
	            }
	            else {
	                queues[key] = [callback];
	                fn.apply(null, args.concat([_restParam(function (args) {
	                    memo[key] = args;
	                    var q = queues[key];
	                    delete queues[key];
	                    for (var i = 0, l = q.length; i < l; i++) {
	                        q[i].apply(null, args);
	                    }
	                })]));
	            }
	        });
	        memoized.memo = memo;
	        memoized.unmemoized = fn;
	        return memoized;
	    };
	
	    async.unmemoize = function (fn) {
	        return function () {
	            return (fn.unmemoized || fn).apply(null, arguments);
	        };
	    };
	
	    function _times(mapper) {
	        return function (count, iterator, callback) {
	            mapper(_range(count), iterator, callback);
	        };
	    }
	
	    async.times = _times(async.map);
	    async.timesSeries = _times(async.mapSeries);
	    async.timesLimit = function (count, limit, iterator, callback) {
	        return async.mapLimit(_range(count), limit, iterator, callback);
	    };
	
	    async.seq = function (/* functions... */) {
	        var fns = arguments;
	        return _restParam(function (args) {
	            var that = this;
	
	            var callback = args[args.length - 1];
	            if (typeof callback == 'function') {
	                args.pop();
	            } else {
	                callback = noop;
	            }
	
	            async.reduce(fns, args, function (newargs, fn, cb) {
	                fn.apply(that, newargs.concat([_restParam(function (err, nextargs) {
	                    cb(err, nextargs);
	                })]));
	            },
	            function (err, results) {
	                callback.apply(that, [err].concat(results));
	            });
	        });
	    };
	
	    async.compose = function (/* functions... */) {
	        return async.seq.apply(null, Array.prototype.reverse.call(arguments));
	    };
	
	
	    function _applyEach(eachfn) {
	        return _restParam(function(fns, args) {
	            var go = _restParam(function(args) {
	                var that = this;
	                var callback = args.pop();
	                return eachfn(fns, function (fn, _, cb) {
	                    fn.apply(that, args.concat([cb]));
	                },
	                callback);
	            });
	            if (args.length) {
	                return go.apply(this, args);
	            }
	            else {
	                return go;
	            }
	        });
	    }
	
	    async.applyEach = _applyEach(async.eachOf);
	    async.applyEachSeries = _applyEach(async.eachOfSeries);
	
	
	    async.forever = function (fn, callback) {
	        var done = only_once(callback || noop);
	        var task = ensureAsync(fn);
	        function next(err) {
	            if (err) {
	                return done(err);
	            }
	            task(next);
	        }
	        next();
	    };
	
	    function ensureAsync(fn) {
	        return _restParam(function (args) {
	            var callback = args.pop();
	            args.push(function () {
	                var innerArgs = arguments;
	                if (sync) {
	                    async.setImmediate(function () {
	                        callback.apply(null, innerArgs);
	                    });
	                } else {
	                    callback.apply(null, innerArgs);
	                }
	            });
	            var sync = true;
	            fn.apply(this, args);
	            sync = false;
	        });
	    }
	
	    async.ensureAsync = ensureAsync;
	
	    async.constant = _restParam(function(values) {
	        var args = [null].concat(values);
	        return function (callback) {
	            return callback.apply(this, args);
	        };
	    });
	
	    async.wrapSync =
	    async.asyncify = function asyncify(func) {
	        return _restParam(function (args) {
	            var callback = args.pop();
	            var result;
	            try {
	                result = func.apply(this, args);
	            } catch (e) {
	                return callback(e);
	            }
	            // if result is Promise object
	            if (_isObject(result) && typeof result.then === "function") {
	                result.then(function(value) {
	                    callback(null, value);
	                })["catch"](function(err) {
	                    callback(err.message ? err : new Error(err));
	                });
	            } else {
	                callback(null, result);
	            }
	        });
	    };
	
	    // Node.js
	    if (typeof module === 'object' && module.exports) {
	        module.exports = async;
	    }
	    // AMD / RequireJS
	    else if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return async;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    // included directly via <script> tag
	    else {
	        root.async = async;
	    }
	
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(56)))

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _async = __webpack_require__(55);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserPasswordModalController = function () {
	  /*@ngInject*/
	  UserPasswordModalController.$inject = ['$http', '$q', '$timeout', '$uibModalInstance', 'user'];
	  function UserPasswordModalController($http, $q, $timeout, $uibModalInstance, user) {
	    _classCallCheck(this, UserPasswordModalController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$timeout = $timeout;
	    this.$uibModalInstance = $uibModalInstance;
	
	    this.user = user;
	
	    this.isAdd = true;
	    this.form = {};
	    this.submitted = false;
	    this.isSaving = false;
	    this.errors;
	  }
	
	  _createClass(UserPasswordModalController, [{
	    key: 'update',
	    value: function update(id, payload) {
	      var self = this;
	      this.$http.put('/api/users/' + id + '/reset', payload).then(function (response) {
	        self.$uibModalInstance.close();
	      }, function (err) {
	        self.isSaving = false;
	        self.errors = {};
	        angular.forEach(err.data.errors, function (error, field) {
	          form[field].$setValidity('mongoose', false);
	          self.errors[field] = error.message;
	        });
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        var self = this;
	        this.submitted = true;
	        this.isSaving = true;
	        if (this.user && this.user._id) {
	          var payload = {
	            password: this.form.confirmPassword
	          };
	          this.update(this.user._id, payload);
	        }
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.user && this.user._id) {
	        this.isAdd = false;
	      }
	    }
	  }]);
	
	  return UserPasswordModalController;
	}();
	
	exports.default = UserPasswordModalController;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(59);
	var autocomplete = __webpack_require__(63);
	
	var CompanyGLsController = function () {
	  /*@ngInject*/
	  CompanyGLsController.$inject = ['$rootScope', '$scope', '$http', '$q', '$state', '$stateParams', '$uibModal', 'Modal'];
	  function CompanyGLsController($rootScope, $scope, $http, $q, $state, $stateParams, $uibModal, Modal) {
	    _classCallCheck(this, CompanyGLsController);
	
	    this.$scope = $scope;
	    this.$http = $http;
	    this.$q = $q;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$uibModal = $uibModal;
	    this.Modal = Modal;
	
	    $rootScope.currentAdminPageTitle = 'Company GLs';
	    this.route = 'admin.companyGLs';
	
	    this.tableMsg = '';
	    this.form = {};
	    this.systemOptions = [];
	    this.result = {};
	    this.pageSizeOptions = [10, 20, 30, 40, 50];
	    this.sortByOptions = {
	      companyName: 'Company Name',
	      gl: 'GL',
	      createdDate: 'Uploaded Date',
	      modifiedDate: 'Re-Uploaded Date'
	    };
	    this.pagination = {
	      _paging: true,
	      _selector: 'All',
	      _pageSize: 10,
	      _pageNum: 1,
	      _sortBy: 'gl asc'
	    };
	  }
	
	  _createClass(CompanyGLsController, [{
	    key: 'setDefaultSearchForm',
	    value: function setDefaultSearchForm() {
	      var _pageNum = 1;
	      if (this.$stateParams._pageNum) {
	        _pageNum = parseInt(this.$stateParams._pageNum);
	      }
	      this.pageNumVal = _pageNum;
	      var _pageSize = 100;
	      if (this.$stateParams._pageSize) {
	        _pageSize = parseInt(this.$stateParams._pageSize);
	      }
	      this.pageSizeVal = _pageSize;
	    }
	  }, {
	    key: 'buildQuery',
	    value: function buildQuery() {
	      return angular.extend(angular.copy(this.form), this.pagination);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var self = this;
	      this.$http.get('/api/types/companies/gls', {
	        params: this.buildQuery()
	      }).then(function (response) {
	        if (response.data.total === 0) {
	          self.tableMsg = 'No record found.';
	        }
	        self.result = response.data;
	      }, function (err) {});
	    }
	  }, {
	    key: 'search',
	    value: function search(form) {
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'clearSearch',
	    value: function clearSearch() {
	      this.form = {};
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'openUploadModal',
	    value: function openUploadModal() {
	      var self = this;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        ariaLabelledBy: 'modal-title',
	        ariaDescribedBy: 'modal-body',
	        template: __webpack_require__(71),
	        controller: 'CompanyGLsUploadController',
	        controllerAs: '$ctrl',
	        size: 'lg'
	      });
	      modalInstance.result.then(function () {
	        self.getData();
	      }, function () {});
	    }
	  }, {
	    key: 'openForm',
	    value: function openForm(item) {
	      var self = this;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        ariaLabelledBy: 'modal-title',
	        ariaDescribedBy: 'modal-body',
	        template: __webpack_require__(72),
	        controller: 'CompanyGLFormController',
	        controllerAs: '$ctrl',
	        size: 'md',
	        resolve: {
	          facility: function facility() {
	            return item;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        self.getData();
	      }, function () {});
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(item) {
	      var self = this;
	      this.Modal.confirm.delete(function () {
	        self.$http.delete('/api/types/companies/gls/' + item._id).then(function (response) {
	          self.getData();
	        }, function (err) {});
	      })(item.facilityName + ' / ' + item.deptName + ' / ' + item.costCenter + ' company');
	    }
	  }, {
	    key: 'rowNumb',
	    value: function rowNumb(idx) {
	      return idx + 1 + (this.result.pageNum !== 1 ? this.result.pageSize * this.result.pageNum - this.result.pageSize : 0);
	    }
	  }, {
	    key: 'updateSortBy',
	    value: function updateSortBy(sortBy) {
	      this.pagination._sortBy = sortBy;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'updatePageSize',
	    value: function updatePageSize(pageSize) {
	      this.pagination._pageSize = pageSize;
	      this.pagination._pageNum = 1;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'gotoPage',
	    value: function gotoPage(pageNum) {
	      this.pagination._pageNum = pageNum;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      this.getData();
	    }
	  }]);
	
	  return CompanyGLsController;
	}();
	
	exports.default = CompanyGLsController;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Autocomplete 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Autocomplete
	//>>group: Widgets
	//>>description: Lists suggested words as the user is typing.
	//>>docs: http://api.jqueryui.com/autocomplete/
	//>>demos: http://jqueryui.com/autocomplete/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/autocomplete.css
	//>>css.theme: ../../themes/base/theme.css
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(21),
				__webpack_require__(64),
				__webpack_require__(65),
				__webpack_require__(67),
				__webpack_require__(68),
				__webpack_require__(66),
				__webpack_require__(70)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	$.widget( "ui.autocomplete", {
		version: "1.12.1",
		defaultElement: "<input>",
		options: {
			appendTo: null,
			autoFocus: false,
			delay: 300,
			minLength: 1,
			position: {
				my: "left top",
				at: "left bottom",
				collision: "none"
			},
			source: null,
	
			// Callbacks
			change: null,
			close: null,
			focus: null,
			open: null,
			response: null,
			search: null,
			select: null
		},
	
		requestIndex: 0,
		pending: 0,
	
		_create: function() {
	
			// Some browsers only repeat keydown events, not keypress events,
			// so we use the suppressKeyPress flag to determine if we've already
			// handled the keydown event. #7269
			// Unfortunately the code for & in keypress is the same as the up arrow,
			// so we use the suppressKeyPressRepeat flag to avoid handling keypress
			// events when we know the keydown event was used to modify the
			// search term. #7799
			var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
				nodeName = this.element[ 0 ].nodeName.toLowerCase(),
				isTextarea = nodeName === "textarea",
				isInput = nodeName === "input";
	
			// Textareas are always multi-line
			// Inputs are always single-line, even if inside a contentEditable element
			// IE also treats inputs as contentEditable
			// All other element types are determined by whether or not they're contentEditable
			this.isMultiLine = isTextarea || !isInput && this._isContentEditable( this.element );
	
			this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
			this.isNewMenu = true;
	
			this._addClass( "ui-autocomplete-input" );
			this.element.attr( "autocomplete", "off" );
	
			this._on( this.element, {
				keydown: function( event ) {
					if ( this.element.prop( "readOnly" ) ) {
						suppressKeyPress = true;
						suppressInput = true;
						suppressKeyPressRepeat = true;
						return;
					}
	
					suppressKeyPress = false;
					suppressInput = false;
					suppressKeyPressRepeat = false;
					var keyCode = $.ui.keyCode;
					switch ( event.keyCode ) {
					case keyCode.PAGE_UP:
						suppressKeyPress = true;
						this._move( "previousPage", event );
						break;
					case keyCode.PAGE_DOWN:
						suppressKeyPress = true;
						this._move( "nextPage", event );
						break;
					case keyCode.UP:
						suppressKeyPress = true;
						this._keyEvent( "previous", event );
						break;
					case keyCode.DOWN:
						suppressKeyPress = true;
						this._keyEvent( "next", event );
						break;
					case keyCode.ENTER:
	
						// when menu is open and has focus
						if ( this.menu.active ) {
	
							// #6055 - Opera still allows the keypress to occur
							// which causes forms to submit
							suppressKeyPress = true;
							event.preventDefault();
							this.menu.select( event );
						}
						break;
					case keyCode.TAB:
						if ( this.menu.active ) {
							this.menu.select( event );
						}
						break;
					case keyCode.ESCAPE:
						if ( this.menu.element.is( ":visible" ) ) {
							if ( !this.isMultiLine ) {
								this._value( this.term );
							}
							this.close( event );
	
							// Different browsers have different default behavior for escape
							// Single press can mean undo or clear
							// Double press in IE means clear the whole form
							event.preventDefault();
						}
						break;
					default:
						suppressKeyPressRepeat = true;
	
						// search timeout should be triggered before the input value is changed
						this._searchTimeout( event );
						break;
					}
				},
				keypress: function( event ) {
					if ( suppressKeyPress ) {
						suppressKeyPress = false;
						if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
							event.preventDefault();
						}
						return;
					}
					if ( suppressKeyPressRepeat ) {
						return;
					}
	
					// Replicate some key handlers to allow them to repeat in Firefox and Opera
					var keyCode = $.ui.keyCode;
					switch ( event.keyCode ) {
					case keyCode.PAGE_UP:
						this._move( "previousPage", event );
						break;
					case keyCode.PAGE_DOWN:
						this._move( "nextPage", event );
						break;
					case keyCode.UP:
						this._keyEvent( "previous", event );
						break;
					case keyCode.DOWN:
						this._keyEvent( "next", event );
						break;
					}
				},
				input: function( event ) {
					if ( suppressInput ) {
						suppressInput = false;
						event.preventDefault();
						return;
					}
					this._searchTimeout( event );
				},
				focus: function() {
					this.selectedItem = null;
					this.previous = this._value();
				},
				blur: function( event ) {
					if ( this.cancelBlur ) {
						delete this.cancelBlur;
						return;
					}
	
					clearTimeout( this.searching );
					this.close( event );
					this._change( event );
				}
			} );
	
			this._initSource();
			this.menu = $( "<ul>" )
				.appendTo( this._appendTo() )
				.menu( {
	
					// disable ARIA support, the live region takes care of that
					role: null
				} )
				.hide()
				.menu( "instance" );
	
			this._addClass( this.menu.element, "ui-autocomplete", "ui-front" );
			this._on( this.menu.element, {
				mousedown: function( event ) {
	
					// prevent moving focus out of the text field
					event.preventDefault();
	
					// IE doesn't prevent moving focus even with event.preventDefault()
					// so we set a flag to know when we should ignore the blur event
					this.cancelBlur = true;
					this._delay( function() {
						delete this.cancelBlur;
	
						// Support: IE 8 only
						// Right clicking a menu item or selecting text from the menu items will
						// result in focus moving out of the input. However, we've already received
						// and ignored the blur event because of the cancelBlur flag set above. So
						// we restore focus to ensure that the menu closes properly based on the user's
						// next actions.
						if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
							this.element.trigger( "focus" );
						}
					} );
				},
				menufocus: function( event, ui ) {
					var label, item;
	
					// support: Firefox
					// Prevent accidental activation of menu items in Firefox (#7024 #9118)
					if ( this.isNewMenu ) {
						this.isNewMenu = false;
						if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
							this.menu.blur();
	
							this.document.one( "mousemove", function() {
								$( event.target ).trigger( event.originalEvent );
							} );
	
							return;
						}
					}
	
					item = ui.item.data( "ui-autocomplete-item" );
					if ( false !== this._trigger( "focus", event, { item: item } ) ) {
	
						// use value to match what will end up in the input, if it was a key event
						if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
							this._value( item.value );
						}
					}
	
					// Announce the value in the liveRegion
					label = ui.item.attr( "aria-label" ) || item.value;
					if ( label && $.trim( label ).length ) {
						this.liveRegion.children().hide();
						$( "<div>" ).text( label ).appendTo( this.liveRegion );
					}
				},
				menuselect: function( event, ui ) {
					var item = ui.item.data( "ui-autocomplete-item" ),
						previous = this.previous;
	
					// Only trigger when focus was lost (click on menu)
					if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
						this.element.trigger( "focus" );
						this.previous = previous;
	
						// #6109 - IE triggers two focus events and the second
						// is asynchronous, so we need to reset the previous
						// term synchronously and asynchronously :-(
						this._delay( function() {
							this.previous = previous;
							this.selectedItem = item;
						} );
					}
	
					if ( false !== this._trigger( "select", event, { item: item } ) ) {
						this._value( item.value );
					}
	
					// reset the term after the select event
					// this allows custom select handling to work properly
					this.term = this._value();
	
					this.close( event );
					this.selectedItem = item;
				}
			} );
	
			this.liveRegion = $( "<div>", {
				role: "status",
				"aria-live": "assertive",
				"aria-relevant": "additions"
			} )
				.appendTo( this.document[ 0 ].body );
	
			this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );
	
			// Turning off autocomplete prevents the browser from remembering the
			// value when navigating through history, so we re-enable autocomplete
			// if the page is unloaded before the widget is destroyed. #7790
			this._on( this.window, {
				beforeunload: function() {
					this.element.removeAttr( "autocomplete" );
				}
			} );
		},
	
		_destroy: function() {
			clearTimeout( this.searching );
			this.element.removeAttr( "autocomplete" );
			this.menu.element.remove();
			this.liveRegion.remove();
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
			if ( key === "source" ) {
				this._initSource();
			}
			if ( key === "appendTo" ) {
				this.menu.element.appendTo( this._appendTo() );
			}
			if ( key === "disabled" && value && this.xhr ) {
				this.xhr.abort();
			}
		},
	
		_isEventTargetInWidget: function( event ) {
			var menuElement = this.menu.element[ 0 ];
	
			return event.target === this.element[ 0 ] ||
				event.target === menuElement ||
				$.contains( menuElement, event.target );
		},
	
		_closeOnClickOutside: function( event ) {
			if ( !this._isEventTargetInWidget( event ) ) {
				this.close();
			}
		},
	
		_appendTo: function() {
			var element = this.options.appendTo;
	
			if ( element ) {
				element = element.jquery || element.nodeType ?
					$( element ) :
					this.document.find( element ).eq( 0 );
			}
	
			if ( !element || !element[ 0 ] ) {
				element = this.element.closest( ".ui-front, dialog" );
			}
	
			if ( !element.length ) {
				element = this.document[ 0 ].body;
			}
	
			return element;
		},
	
		_initSource: function() {
			var array, url,
				that = this;
			if ( $.isArray( this.options.source ) ) {
				array = this.options.source;
				this.source = function( request, response ) {
					response( $.ui.autocomplete.filter( array, request.term ) );
				};
			} else if ( typeof this.options.source === "string" ) {
				url = this.options.source;
				this.source = function( request, response ) {
					if ( that.xhr ) {
						that.xhr.abort();
					}
					that.xhr = $.ajax( {
						url: url,
						data: request,
						dataType: "json",
						success: function( data ) {
							response( data );
						},
						error: function() {
							response( [] );
						}
					} );
				};
			} else {
				this.source = this.options.source;
			}
		},
	
		_searchTimeout: function( event ) {
			clearTimeout( this.searching );
			this.searching = this._delay( function() {
	
				// Search if the value has changed, or if the user retypes the same value (see #7434)
				var equalValues = this.term === this._value(),
					menuVisible = this.menu.element.is( ":visible" ),
					modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
	
				if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
					this.selectedItem = null;
					this.search( null, event );
				}
			}, this.options.delay );
		},
	
		search: function( value, event ) {
			value = value != null ? value : this._value();
	
			// Always save the actual value, not the one passed as an argument
			this.term = this._value();
	
			if ( value.length < this.options.minLength ) {
				return this.close( event );
			}
	
			if ( this._trigger( "search", event ) === false ) {
				return;
			}
	
			return this._search( value );
		},
	
		_search: function( value ) {
			this.pending++;
			this._addClass( "ui-autocomplete-loading" );
			this.cancelSearch = false;
	
			this.source( { term: value }, this._response() );
		},
	
		_response: function() {
			var index = ++this.requestIndex;
	
			return $.proxy( function( content ) {
				if ( index === this.requestIndex ) {
					this.__response( content );
				}
	
				this.pending--;
				if ( !this.pending ) {
					this._removeClass( "ui-autocomplete-loading" );
				}
			}, this );
		},
	
		__response: function( content ) {
			if ( content ) {
				content = this._normalize( content );
			}
			this._trigger( "response", null, { content: content } );
			if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
				this._suggest( content );
				this._trigger( "open" );
			} else {
	
				// use ._close() instead of .close() so we don't cancel future searches
				this._close();
			}
		},
	
		close: function( event ) {
			this.cancelSearch = true;
			this._close( event );
		},
	
		_close: function( event ) {
	
			// Remove the handler that closes the menu on outside clicks
			this._off( this.document, "mousedown" );
	
			if ( this.menu.element.is( ":visible" ) ) {
				this.menu.element.hide();
				this.menu.blur();
				this.isNewMenu = true;
				this._trigger( "close", event );
			}
		},
	
		_change: function( event ) {
			if ( this.previous !== this._value() ) {
				this._trigger( "change", event, { item: this.selectedItem } );
			}
		},
	
		_normalize: function( items ) {
	
			// assume all items have the right format when the first item is complete
			if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
				return items;
			}
			return $.map( items, function( item ) {
				if ( typeof item === "string" ) {
					return {
						label: item,
						value: item
					};
				}
				return $.extend( {}, item, {
					label: item.label || item.value,
					value: item.value || item.label
				} );
			} );
		},
	
		_suggest: function( items ) {
			var ul = this.menu.element.empty();
			this._renderMenu( ul, items );
			this.isNewMenu = true;
			this.menu.refresh();
	
			// Size and position menu
			ul.show();
			this._resizeMenu();
			ul.position( $.extend( {
				of: this.element
			}, this.options.position ) );
	
			if ( this.options.autoFocus ) {
				this.menu.next();
			}
	
			// Listen for interactions outside of the widget (#6642)
			this._on( this.document, {
				mousedown: "_closeOnClickOutside"
			} );
		},
	
		_resizeMenu: function() {
			var ul = this.menu.element;
			ul.outerWidth( Math.max(
	
				// Firefox wraps long text (possibly a rounding bug)
				// so we add 1px to avoid the wrapping (#7513)
				ul.width( "" ).outerWidth() + 1,
				this.element.outerWidth()
			) );
		},
	
		_renderMenu: function( ul, items ) {
			var that = this;
			$.each( items, function( index, item ) {
				that._renderItemData( ul, item );
			} );
		},
	
		_renderItemData: function( ul, item ) {
			return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
		},
	
		_renderItem: function( ul, item ) {
			return $( "<li>" )
				.append( $( "<div>" ).text( item.label ) )
				.appendTo( ul );
		},
	
		_move: function( direction, event ) {
			if ( !this.menu.element.is( ":visible" ) ) {
				this.search( null, event );
				return;
			}
			if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
					this.menu.isLastItem() && /^next/.test( direction ) ) {
	
				if ( !this.isMultiLine ) {
					this._value( this.term );
				}
	
				this.menu.blur();
				return;
			}
			this.menu[ direction ]( event );
		},
	
		widget: function() {
			return this.menu.element;
		},
	
		_value: function() {
			return this.valueMethod.apply( this.element, arguments );
		},
	
		_keyEvent: function( keyEvent, event ) {
			if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
				this._move( keyEvent, event );
	
				// Prevents moving cursor to beginning/end of the text field in some browsers
				event.preventDefault();
			}
		},
	
		// Support: Chrome <=50
		// We should be able to just use this.element.prop( "isContentEditable" )
		// but hidden elements always report false in Chrome.
		// https://code.google.com/p/chromium/issues/detail?id=313082
		_isContentEditable: function( element ) {
			if ( !element.length ) {
				return false;
			}
	
			var editable = element.prop( "contentEditable" );
	
			if ( editable === "inherit" ) {
			  return this._isContentEditable( element.parent() );
			}
	
			return editable === "true";
		}
	} );
	
	$.extend( $.ui.autocomplete, {
		escapeRegex: function( value ) {
			return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
		},
		filter: function( array, term ) {
			var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
			return $.grep( array, function( value ) {
				return matcher.test( value.label || value.value || value );
			} );
		}
	} );
	
	// Live region extension, adding a `messages` option
	// NOTE: This is an experimental API. We are still investigating
	// a full solution for string manipulation and internationalization.
	$.widget( "ui.autocomplete", $.ui.autocomplete, {
		options: {
			messages: {
				noResults: "No search results.",
				results: function( amount ) {
					return amount + ( amount > 1 ? " results are" : " result is" ) +
						" available, use up and down arrow keys to navigate.";
				}
			}
		},
	
		__response: function( content ) {
			var message;
			this._superApply( arguments );
			if ( this.options.disabled || this.cancelSearch ) {
				return;
			}
			if ( content && content.length ) {
				message = this.options.messages.results( content.length );
			} else {
				message = this.options.messages.noResults;
			}
			this.liveRegion.children().hide();
			$( "<div>" ).text( message ).appendTo( this.liveRegion );
		}
	} );
	
	return $.ui.autocomplete;
	
	} ) );


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Menu 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Menu
	//>>group: Widgets
	//>>description: Creates nestable menus.
	//>>docs: http://api.jqueryui.com/menu/
	//>>demos: http://jqueryui.com/menu/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/menu.css
	//>>css.theme: ../../themes/base/theme.css
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(21),
				__webpack_require__(65),
				__webpack_require__(67),
				__webpack_require__(68),
				__webpack_require__(69),
				__webpack_require__(66),
				__webpack_require__(70)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	return $.widget( "ui.menu", {
		version: "1.12.1",
		defaultElement: "<ul>",
		delay: 300,
		options: {
			icons: {
				submenu: "ui-icon-caret-1-e"
			},
			items: "> *",
			menus: "ul",
			position: {
				my: "left top",
				at: "right top"
			},
			role: "menu",
	
			// Callbacks
			blur: null,
			focus: null,
			select: null
		},
	
		_create: function() {
			this.activeMenu = this.element;
	
			// Flag used to prevent firing of the click handler
			// as the event bubbles up through nested menus
			this.mouseHandled = false;
			this.element
				.uniqueId()
				.attr( {
					role: this.options.role,
					tabIndex: 0
				} );
	
			this._addClass( "ui-menu", "ui-widget ui-widget-content" );
			this._on( {
	
				// Prevent focus from sticking to links inside menu after clicking
				// them (focus should always stay on UL during navigation).
				"mousedown .ui-menu-item": function( event ) {
					event.preventDefault();
				},
				"click .ui-menu-item": function( event ) {
					var target = $( event.target );
					var active = $( $.ui.safeActiveElement( this.document[ 0 ] ) );
					if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
						this.select( event );
	
						// Only set the mouseHandled flag if the event will bubble, see #9469.
						if ( !event.isPropagationStopped() ) {
							this.mouseHandled = true;
						}
	
						// Open submenu on click
						if ( target.has( ".ui-menu" ).length ) {
							this.expand( event );
						} else if ( !this.element.is( ":focus" ) &&
								active.closest( ".ui-menu" ).length ) {
	
							// Redirect focus to the menu
							this.element.trigger( "focus", [ true ] );
	
							// If the active item is on the top level, let it stay active.
							// Otherwise, blur the active item since it is no longer visible.
							if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
								clearTimeout( this.timer );
							}
						}
					}
				},
				"mouseenter .ui-menu-item": function( event ) {
	
					// Ignore mouse events while typeahead is active, see #10458.
					// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
					// is over an item in the menu
					if ( this.previousFilter ) {
						return;
					}
	
					var actualTarget = $( event.target ).closest( ".ui-menu-item" ),
						target = $( event.currentTarget );
	
					// Ignore bubbled events on parent items, see #11641
					if ( actualTarget[ 0 ] !== target[ 0 ] ) {
						return;
					}
	
					// Remove ui-state-active class from siblings of the newly focused menu item
					// to avoid a jump caused by adjacent elements both having a class with a border
					this._removeClass( target.siblings().children( ".ui-state-active" ),
						null, "ui-state-active" );
					this.focus( event, target );
				},
				mouseleave: "collapseAll",
				"mouseleave .ui-menu": "collapseAll",
				focus: function( event, keepActiveItem ) {
	
					// If there's already an active item, keep it active
					// If not, activate the first item
					var item = this.active || this.element.find( this.options.items ).eq( 0 );
	
					if ( !keepActiveItem ) {
						this.focus( event, item );
					}
				},
				blur: function( event ) {
					this._delay( function() {
						var notContained = !$.contains(
							this.element[ 0 ],
							$.ui.safeActiveElement( this.document[ 0 ] )
						);
						if ( notContained ) {
							this.collapseAll( event );
						}
					} );
				},
				keydown: "_keydown"
			} );
	
			this.refresh();
	
			// Clicks outside of a menu collapse any open menus
			this._on( this.document, {
				click: function( event ) {
					if ( this._closeOnDocumentClick( event ) ) {
						this.collapseAll( event );
					}
	
					// Reset the mouseHandled flag
					this.mouseHandled = false;
				}
			} );
		},
	
		_destroy: function() {
			var items = this.element.find( ".ui-menu-item" )
					.removeAttr( "role aria-disabled" ),
				submenus = items.children( ".ui-menu-item-wrapper" )
					.removeUniqueId()
					.removeAttr( "tabIndex role aria-haspopup" );
	
			// Destroy (sub)menus
			this.element
				.removeAttr( "aria-activedescendant" )
				.find( ".ui-menu" ).addBack()
					.removeAttr( "role aria-labelledby aria-expanded aria-hidden aria-disabled " +
						"tabIndex" )
					.removeUniqueId()
					.show();
	
			submenus.children().each( function() {
				var elem = $( this );
				if ( elem.data( "ui-menu-submenu-caret" ) ) {
					elem.remove();
				}
			} );
		},
	
		_keydown: function( event ) {
			var match, prev, character, skip,
				preventDefault = true;
	
			switch ( event.keyCode ) {
			case $.ui.keyCode.PAGE_UP:
				this.previousPage( event );
				break;
			case $.ui.keyCode.PAGE_DOWN:
				this.nextPage( event );
				break;
			case $.ui.keyCode.HOME:
				this._move( "first", "first", event );
				break;
			case $.ui.keyCode.END:
				this._move( "last", "last", event );
				break;
			case $.ui.keyCode.UP:
				this.previous( event );
				break;
			case $.ui.keyCode.DOWN:
				this.next( event );
				break;
			case $.ui.keyCode.LEFT:
				this.collapse( event );
				break;
			case $.ui.keyCode.RIGHT:
				if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
					this.expand( event );
				}
				break;
			case $.ui.keyCode.ENTER:
			case $.ui.keyCode.SPACE:
				this._activate( event );
				break;
			case $.ui.keyCode.ESCAPE:
				this.collapse( event );
				break;
			default:
				preventDefault = false;
				prev = this.previousFilter || "";
				skip = false;
	
				// Support number pad values
				character = event.keyCode >= 96 && event.keyCode <= 105 ?
					( event.keyCode - 96 ).toString() : String.fromCharCode( event.keyCode );
	
				clearTimeout( this.filterTimer );
	
				if ( character === prev ) {
					skip = true;
				} else {
					character = prev + character;
				}
	
				match = this._filterMenuItems( character );
				match = skip && match.index( this.active.next() ) !== -1 ?
					this.active.nextAll( ".ui-menu-item" ) :
					match;
	
				// If no matches on the current filter, reset to the last character pressed
				// to move down the menu to the first item that starts with that character
				if ( !match.length ) {
					character = String.fromCharCode( event.keyCode );
					match = this._filterMenuItems( character );
				}
	
				if ( match.length ) {
					this.focus( event, match );
					this.previousFilter = character;
					this.filterTimer = this._delay( function() {
						delete this.previousFilter;
					}, 1000 );
				} else {
					delete this.previousFilter;
				}
			}
	
			if ( preventDefault ) {
				event.preventDefault();
			}
		},
	
		_activate: function( event ) {
			if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
				if ( this.active.children( "[aria-haspopup='true']" ).length ) {
					this.expand( event );
				} else {
					this.select( event );
				}
			}
		},
	
		refresh: function() {
			var menus, items, newSubmenus, newItems, newWrappers,
				that = this,
				icon = this.options.icons.submenu,
				submenus = this.element.find( this.options.menus );
	
			this._toggleClass( "ui-menu-icons", null, !!this.element.find( ".ui-icon" ).length );
	
			// Initialize nested menus
			newSubmenus = submenus.filter( ":not(.ui-menu)" )
				.hide()
				.attr( {
					role: this.options.role,
					"aria-hidden": "true",
					"aria-expanded": "false"
				} )
				.each( function() {
					var menu = $( this ),
						item = menu.prev(),
						submenuCaret = $( "<span>" ).data( "ui-menu-submenu-caret", true );
	
					that._addClass( submenuCaret, "ui-menu-icon", "ui-icon " + icon );
					item
						.attr( "aria-haspopup", "true" )
						.prepend( submenuCaret );
					menu.attr( "aria-labelledby", item.attr( "id" ) );
				} );
	
			this._addClass( newSubmenus, "ui-menu", "ui-widget ui-widget-content ui-front" );
	
			menus = submenus.add( this.element );
			items = menus.find( this.options.items );
	
			// Initialize menu-items containing spaces and/or dashes only as dividers
			items.not( ".ui-menu-item" ).each( function() {
				var item = $( this );
				if ( that._isDivider( item ) ) {
					that._addClass( item, "ui-menu-divider", "ui-widget-content" );
				}
			} );
	
			// Don't refresh list items that are already adapted
			newItems = items.not( ".ui-menu-item, .ui-menu-divider" );
			newWrappers = newItems.children()
				.not( ".ui-menu" )
					.uniqueId()
					.attr( {
						tabIndex: -1,
						role: this._itemRole()
					} );
			this._addClass( newItems, "ui-menu-item" )
				._addClass( newWrappers, "ui-menu-item-wrapper" );
	
			// Add aria-disabled attribute to any disabled menu item
			items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );
	
			// If the active item has been removed, blur the menu
			if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
				this.blur();
			}
		},
	
		_itemRole: function() {
			return {
				menu: "menuitem",
				listbox: "option"
			}[ this.options.role ];
		},
	
		_setOption: function( key, value ) {
			if ( key === "icons" ) {
				var icons = this.element.find( ".ui-menu-icon" );
				this._removeClass( icons, null, this.options.icons.submenu )
					._addClass( icons, null, value.submenu );
			}
			this._super( key, value );
		},
	
		_setOptionDisabled: function( value ) {
			this._super( value );
	
			this.element.attr( "aria-disabled", String( value ) );
			this._toggleClass( null, "ui-state-disabled", !!value );
		},
	
		focus: function( event, item ) {
			var nested, focused, activeParent;
			this.blur( event, event && event.type === "focus" );
	
			this._scrollIntoView( item );
	
			this.active = item.first();
	
			focused = this.active.children( ".ui-menu-item-wrapper" );
			this._addClass( focused, null, "ui-state-active" );
	
			// Only update aria-activedescendant if there's a role
			// otherwise we assume focus is managed elsewhere
			if ( this.options.role ) {
				this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
			}
	
			// Highlight active parent menu item, if any
			activeParent = this.active
				.parent()
					.closest( ".ui-menu-item" )
						.children( ".ui-menu-item-wrapper" );
			this._addClass( activeParent, null, "ui-state-active" );
	
			if ( event && event.type === "keydown" ) {
				this._close();
			} else {
				this.timer = this._delay( function() {
					this._close();
				}, this.delay );
			}
	
			nested = item.children( ".ui-menu" );
			if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
				this._startOpening( nested );
			}
			this.activeMenu = item.parent();
	
			this._trigger( "focus", event, { item: item } );
		},
	
		_scrollIntoView: function( item ) {
			var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
			if ( this._hasScroll() ) {
				borderTop = parseFloat( $.css( this.activeMenu[ 0 ], "borderTopWidth" ) ) || 0;
				paddingTop = parseFloat( $.css( this.activeMenu[ 0 ], "paddingTop" ) ) || 0;
				offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
				scroll = this.activeMenu.scrollTop();
				elementHeight = this.activeMenu.height();
				itemHeight = item.outerHeight();
	
				if ( offset < 0 ) {
					this.activeMenu.scrollTop( scroll + offset );
				} else if ( offset + itemHeight > elementHeight ) {
					this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
				}
			}
		},
	
		blur: function( event, fromFocus ) {
			if ( !fromFocus ) {
				clearTimeout( this.timer );
			}
	
			if ( !this.active ) {
				return;
			}
	
			this._removeClass( this.active.children( ".ui-menu-item-wrapper" ),
				null, "ui-state-active" );
	
			this._trigger( "blur", event, { item: this.active } );
			this.active = null;
		},
	
		_startOpening: function( submenu ) {
			clearTimeout( this.timer );
	
			// Don't open if already open fixes a Firefox bug that caused a .5 pixel
			// shift in the submenu position when mousing over the caret icon
			if ( submenu.attr( "aria-hidden" ) !== "true" ) {
				return;
			}
	
			this.timer = this._delay( function() {
				this._close();
				this._open( submenu );
			}, this.delay );
		},
	
		_open: function( submenu ) {
			var position = $.extend( {
				of: this.active
			}, this.options.position );
	
			clearTimeout( this.timer );
			this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
				.hide()
				.attr( "aria-hidden", "true" );
	
			submenu
				.show()
				.removeAttr( "aria-hidden" )
				.attr( "aria-expanded", "true" )
				.position( position );
		},
	
		collapseAll: function( event, all ) {
			clearTimeout( this.timer );
			this.timer = this._delay( function() {
	
				// If we were passed an event, look for the submenu that contains the event
				var currentMenu = all ? this.element :
					$( event && event.target ).closest( this.element.find( ".ui-menu" ) );
	
				// If we found no valid submenu ancestor, use the main menu to close all
				// sub menus anyway
				if ( !currentMenu.length ) {
					currentMenu = this.element;
				}
	
				this._close( currentMenu );
	
				this.blur( event );
	
				// Work around active item staying active after menu is blurred
				this._removeClass( currentMenu.find( ".ui-state-active" ), null, "ui-state-active" );
	
				this.activeMenu = currentMenu;
			}, this.delay );
		},
	
		// With no arguments, closes the currently active menu - if nothing is active
		// it closes all menus.  If passed an argument, it will search for menus BELOW
		_close: function( startMenu ) {
			if ( !startMenu ) {
				startMenu = this.active ? this.active.parent() : this.element;
			}
	
			startMenu.find( ".ui-menu" )
				.hide()
				.attr( "aria-hidden", "true" )
				.attr( "aria-expanded", "false" );
		},
	
		_closeOnDocumentClick: function( event ) {
			return !$( event.target ).closest( ".ui-menu" ).length;
		},
	
		_isDivider: function( item ) {
	
			// Match hyphen, em dash, en dash
			return !/[^\-\u2014\u2013\s]/.test( item.text() );
		},
	
		collapse: function( event ) {
			var newItem = this.active &&
				this.active.parent().closest( ".ui-menu-item", this.element );
			if ( newItem && newItem.length ) {
				this._close();
				this.focus( event, newItem );
			}
		},
	
		expand: function( event ) {
			var newItem = this.active &&
				this.active
					.children( ".ui-menu " )
						.find( this.options.items )
							.first();
	
			if ( newItem && newItem.length ) {
				this._open( newItem.parent() );
	
				// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
				this._delay( function() {
					this.focus( event, newItem );
				} );
			}
		},
	
		next: function( event ) {
			this._move( "next", "first", event );
		},
	
		previous: function( event ) {
			this._move( "prev", "last", event );
		},
	
		isFirstItem: function() {
			return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
		},
	
		isLastItem: function() {
			return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
		},
	
		_move: function( direction, filter, event ) {
			var next;
			if ( this.active ) {
				if ( direction === "first" || direction === "last" ) {
					next = this.active
						[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
						.eq( -1 );
				} else {
					next = this.active
						[ direction + "All" ]( ".ui-menu-item" )
						.eq( 0 );
				}
			}
			if ( !next || !next.length || !this.active ) {
				next = this.activeMenu.find( this.options.items )[ filter ]();
			}
	
			this.focus( event, next );
		},
	
		nextPage: function( event ) {
			var item, base, height;
	
			if ( !this.active ) {
				this.next( event );
				return;
			}
			if ( this.isLastItem() ) {
				return;
			}
			if ( this._hasScroll() ) {
				base = this.active.offset().top;
				height = this.element.height();
				this.active.nextAll( ".ui-menu-item" ).each( function() {
					item = $( this );
					return item.offset().top - base - height < 0;
				} );
	
				this.focus( event, item );
			} else {
				this.focus( event, this.activeMenu.find( this.options.items )
					[ !this.active ? "first" : "last" ]() );
			}
		},
	
		previousPage: function( event ) {
			var item, base, height;
			if ( !this.active ) {
				this.next( event );
				return;
			}
			if ( this.isFirstItem() ) {
				return;
			}
			if ( this._hasScroll() ) {
				base = this.active.offset().top;
				height = this.element.height();
				this.active.prevAll( ".ui-menu-item" ).each( function() {
					item = $( this );
					return item.offset().top - base + height > 0;
				} );
	
				this.focus( event, item );
			} else {
				this.focus( event, this.activeMenu.find( this.options.items ).first() );
			}
		},
	
		_hasScroll: function() {
			return this.element.outerHeight() < this.element.prop( "scrollHeight" );
		},
	
		select: function( event ) {
	
			// TODO: It should never be possible to not have an active item at this
			// point, but the tests don't trigger mouseenter before click.
			this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
			var ui = { item: this.active };
			if ( !this.active.has( ".ui-menu" ).length ) {
				this.collapseAll( event, true );
			}
			this._trigger( "select", event, ui );
		},
	
		_filterMenuItems: function( character ) {
			var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
				regex = new RegExp( "^" + escapedCharacter, "i" );
	
			return this.activeMenu
				.find( this.options.items )
	
					// Only match on items, not dividers or other content (#10571)
					.filter( ".ui-menu-item" )
						.filter( function() {
							return regex.test(
								$.trim( $( this ).children( ".ui-menu-item-wrapper" ).text() ) );
						} );
		}
	} );
	
	} ) );


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Keycode 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Keycode
	//>>group: Core
	//>>description: Provide keycodes as keynames
	//>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(21), __webpack_require__(66) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.ui.keyCode = {
		BACKSPACE: 8,
		COMMA: 188,
		DELETE: 46,
		DOWN: 40,
		END: 35,
		ENTER: 13,
		ESCAPE: 27,
		HOME: 36,
		LEFT: 37,
		PAGE_DOWN: 34,
		PAGE_UP: 33,
		PERIOD: 190,
		RIGHT: 39,
		SPACE: 32,
		TAB: 9,
		UP: 38
	};
	
	} ) );


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(21) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	$.ui = $.ui || {};
	
	return $.ui.version = "1.12.1";
	
	} ) );


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Position 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/position/
	 */
	
	//>>label: Position
	//>>group: Core
	//>>description: Positions elements relative to other elements.
	//>>docs: http://api.jqueryui.com/position/
	//>>demos: http://jqueryui.com/position/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(21), __webpack_require__(66) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	( function() {
	var cachedScrollbarWidth,
		max = Math.max,
		abs = Math.abs,
		rhorizontal = /left|center|right/,
		rvertical = /top|center|bottom/,
		roffset = /[\+\-]\d+(\.[\d]+)?%?/,
		rposition = /^\w+/,
		rpercent = /%$/,
		_position = $.fn.position;
	
	function getOffsets( offsets, width, height ) {
		return [
			parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
			parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
		];
	}
	
	function parseCss( element, property ) {
		return parseInt( $.css( element, property ), 10 ) || 0;
	}
	
	function getDimensions( elem ) {
		var raw = elem[ 0 ];
		if ( raw.nodeType === 9 ) {
			return {
				width: elem.width(),
				height: elem.height(),
				offset: { top: 0, left: 0 }
			};
		}
		if ( $.isWindow( raw ) ) {
			return {
				width: elem.width(),
				height: elem.height(),
				offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
			};
		}
		if ( raw.preventDefault ) {
			return {
				width: 0,
				height: 0,
				offset: { top: raw.pageY, left: raw.pageX }
			};
		}
		return {
			width: elem.outerWidth(),
			height: elem.outerHeight(),
			offset: elem.offset()
		};
	}
	
	$.position = {
		scrollbarWidth: function() {
			if ( cachedScrollbarWidth !== undefined ) {
				return cachedScrollbarWidth;
			}
			var w1, w2,
				div = $( "<div " +
					"style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'>" +
					"<div style='height:100px;width:auto;'></div></div>" ),
				innerDiv = div.children()[ 0 ];
	
			$( "body" ).append( div );
			w1 = innerDiv.offsetWidth;
			div.css( "overflow", "scroll" );
	
			w2 = innerDiv.offsetWidth;
	
			if ( w1 === w2 ) {
				w2 = div[ 0 ].clientWidth;
			}
	
			div.remove();
	
			return ( cachedScrollbarWidth = w1 - w2 );
		},
		getScrollInfo: function( within ) {
			var overflowX = within.isWindow || within.isDocument ? "" :
					within.element.css( "overflow-x" ),
				overflowY = within.isWindow || within.isDocument ? "" :
					within.element.css( "overflow-y" ),
				hasOverflowX = overflowX === "scroll" ||
					( overflowX === "auto" && within.width < within.element[ 0 ].scrollWidth ),
				hasOverflowY = overflowY === "scroll" ||
					( overflowY === "auto" && within.height < within.element[ 0 ].scrollHeight );
			return {
				width: hasOverflowY ? $.position.scrollbarWidth() : 0,
				height: hasOverflowX ? $.position.scrollbarWidth() : 0
			};
		},
		getWithinInfo: function( element ) {
			var withinElement = $( element || window ),
				isWindow = $.isWindow( withinElement[ 0 ] ),
				isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9,
				hasOffset = !isWindow && !isDocument;
			return {
				element: withinElement,
				isWindow: isWindow,
				isDocument: isDocument,
				offset: hasOffset ? $( element ).offset() : { left: 0, top: 0 },
				scrollLeft: withinElement.scrollLeft(),
				scrollTop: withinElement.scrollTop(),
				width: withinElement.outerWidth(),
				height: withinElement.outerHeight()
			};
		}
	};
	
	$.fn.position = function( options ) {
		if ( !options || !options.of ) {
			return _position.apply( this, arguments );
		}
	
		// Make a copy, we don't want to modify arguments
		options = $.extend( {}, options );
	
		var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
			target = $( options.of ),
			within = $.position.getWithinInfo( options.within ),
			scrollInfo = $.position.getScrollInfo( within ),
			collision = ( options.collision || "flip" ).split( " " ),
			offsets = {};
	
		dimensions = getDimensions( target );
		if ( target[ 0 ].preventDefault ) {
	
			// Force left top to allow flipping
			options.at = "left top";
		}
		targetWidth = dimensions.width;
		targetHeight = dimensions.height;
		targetOffset = dimensions.offset;
	
		// Clone to reuse original targetOffset later
		basePosition = $.extend( {}, targetOffset );
	
		// Force my and at to have valid horizontal and vertical positions
		// if a value is missing or invalid, it will be converted to center
		$.each( [ "my", "at" ], function() {
			var pos = ( options[ this ] || "" ).split( " " ),
				horizontalOffset,
				verticalOffset;
	
			if ( pos.length === 1 ) {
				pos = rhorizontal.test( pos[ 0 ] ) ?
					pos.concat( [ "center" ] ) :
					rvertical.test( pos[ 0 ] ) ?
						[ "center" ].concat( pos ) :
						[ "center", "center" ];
			}
			pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
			pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";
	
			// Calculate offsets
			horizontalOffset = roffset.exec( pos[ 0 ] );
			verticalOffset = roffset.exec( pos[ 1 ] );
			offsets[ this ] = [
				horizontalOffset ? horizontalOffset[ 0 ] : 0,
				verticalOffset ? verticalOffset[ 0 ] : 0
			];
	
			// Reduce to just the positions without the offsets
			options[ this ] = [
				rposition.exec( pos[ 0 ] )[ 0 ],
				rposition.exec( pos[ 1 ] )[ 0 ]
			];
		} );
	
		// Normalize collision option
		if ( collision.length === 1 ) {
			collision[ 1 ] = collision[ 0 ];
		}
	
		if ( options.at[ 0 ] === "right" ) {
			basePosition.left += targetWidth;
		} else if ( options.at[ 0 ] === "center" ) {
			basePosition.left += targetWidth / 2;
		}
	
		if ( options.at[ 1 ] === "bottom" ) {
			basePosition.top += targetHeight;
		} else if ( options.at[ 1 ] === "center" ) {
			basePosition.top += targetHeight / 2;
		}
	
		atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
		basePosition.left += atOffset[ 0 ];
		basePosition.top += atOffset[ 1 ];
	
		return this.each( function() {
			var collisionPosition, using,
				elem = $( this ),
				elemWidth = elem.outerWidth(),
				elemHeight = elem.outerHeight(),
				marginLeft = parseCss( this, "marginLeft" ),
				marginTop = parseCss( this, "marginTop" ),
				collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) +
					scrollInfo.width,
				collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) +
					scrollInfo.height,
				position = $.extend( {}, basePosition ),
				myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );
	
			if ( options.my[ 0 ] === "right" ) {
				position.left -= elemWidth;
			} else if ( options.my[ 0 ] === "center" ) {
				position.left -= elemWidth / 2;
			}
	
			if ( options.my[ 1 ] === "bottom" ) {
				position.top -= elemHeight;
			} else if ( options.my[ 1 ] === "center" ) {
				position.top -= elemHeight / 2;
			}
	
			position.left += myOffset[ 0 ];
			position.top += myOffset[ 1 ];
	
			collisionPosition = {
				marginLeft: marginLeft,
				marginTop: marginTop
			};
	
			$.each( [ "left", "top" ], function( i, dir ) {
				if ( $.ui.position[ collision[ i ] ] ) {
					$.ui.position[ collision[ i ] ][ dir ]( position, {
						targetWidth: targetWidth,
						targetHeight: targetHeight,
						elemWidth: elemWidth,
						elemHeight: elemHeight,
						collisionPosition: collisionPosition,
						collisionWidth: collisionWidth,
						collisionHeight: collisionHeight,
						offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
						my: options.my,
						at: options.at,
						within: within,
						elem: elem
					} );
				}
			} );
	
			if ( options.using ) {
	
				// Adds feedback as second argument to using callback, if present
				using = function( props ) {
					var left = targetOffset.left - position.left,
						right = left + targetWidth - elemWidth,
						top = targetOffset.top - position.top,
						bottom = top + targetHeight - elemHeight,
						feedback = {
							target: {
								element: target,
								left: targetOffset.left,
								top: targetOffset.top,
								width: targetWidth,
								height: targetHeight
							},
							element: {
								element: elem,
								left: position.left,
								top: position.top,
								width: elemWidth,
								height: elemHeight
							},
							horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
							vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
						};
					if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
						feedback.horizontal = "center";
					}
					if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
						feedback.vertical = "middle";
					}
					if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
						feedback.important = "horizontal";
					} else {
						feedback.important = "vertical";
					}
					options.using.call( this, props, feedback );
				};
			}
	
			elem.offset( $.extend( position, { using: using } ) );
		} );
	};
	
	$.ui.position = {
		fit: {
			left: function( position, data ) {
				var within = data.within,
					withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
					outerWidth = within.width,
					collisionPosLeft = position.left - data.collisionPosition.marginLeft,
					overLeft = withinOffset - collisionPosLeft,
					overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
					newOverRight;
	
				// Element is wider than within
				if ( data.collisionWidth > outerWidth ) {
	
					// Element is initially over the left side of within
					if ( overLeft > 0 && overRight <= 0 ) {
						newOverRight = position.left + overLeft + data.collisionWidth - outerWidth -
							withinOffset;
						position.left += overLeft - newOverRight;
	
					// Element is initially over right side of within
					} else if ( overRight > 0 && overLeft <= 0 ) {
						position.left = withinOffset;
	
					// Element is initially over both left and right sides of within
					} else {
						if ( overLeft > overRight ) {
							position.left = withinOffset + outerWidth - data.collisionWidth;
						} else {
							position.left = withinOffset;
						}
					}
	
				// Too far left -> align with left edge
				} else if ( overLeft > 0 ) {
					position.left += overLeft;
	
				// Too far right -> align with right edge
				} else if ( overRight > 0 ) {
					position.left -= overRight;
	
				// Adjust based on position and margin
				} else {
					position.left = max( position.left - collisionPosLeft, position.left );
				}
			},
			top: function( position, data ) {
				var within = data.within,
					withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
					outerHeight = data.within.height,
					collisionPosTop = position.top - data.collisionPosition.marginTop,
					overTop = withinOffset - collisionPosTop,
					overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
					newOverBottom;
	
				// Element is taller than within
				if ( data.collisionHeight > outerHeight ) {
	
					// Element is initially over the top of within
					if ( overTop > 0 && overBottom <= 0 ) {
						newOverBottom = position.top + overTop + data.collisionHeight - outerHeight -
							withinOffset;
						position.top += overTop - newOverBottom;
	
					// Element is initially over bottom of within
					} else if ( overBottom > 0 && overTop <= 0 ) {
						position.top = withinOffset;
	
					// Element is initially over both top and bottom of within
					} else {
						if ( overTop > overBottom ) {
							position.top = withinOffset + outerHeight - data.collisionHeight;
						} else {
							position.top = withinOffset;
						}
					}
	
				// Too far up -> align with top
				} else if ( overTop > 0 ) {
					position.top += overTop;
	
				// Too far down -> align with bottom edge
				} else if ( overBottom > 0 ) {
					position.top -= overBottom;
	
				// Adjust based on position and margin
				} else {
					position.top = max( position.top - collisionPosTop, position.top );
				}
			}
		},
		flip: {
			left: function( position, data ) {
				var within = data.within,
					withinOffset = within.offset.left + within.scrollLeft,
					outerWidth = within.width,
					offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
					collisionPosLeft = position.left - data.collisionPosition.marginLeft,
					overLeft = collisionPosLeft - offsetLeft,
					overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
					myOffset = data.my[ 0 ] === "left" ?
						-data.elemWidth :
						data.my[ 0 ] === "right" ?
							data.elemWidth :
							0,
					atOffset = data.at[ 0 ] === "left" ?
						data.targetWidth :
						data.at[ 0 ] === "right" ?
							-data.targetWidth :
							0,
					offset = -2 * data.offset[ 0 ],
					newOverRight,
					newOverLeft;
	
				if ( overLeft < 0 ) {
					newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth -
						outerWidth - withinOffset;
					if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
						position.left += myOffset + atOffset + offset;
					}
				} else if ( overRight > 0 ) {
					newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset +
						atOffset + offset - offsetLeft;
					if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
						position.left += myOffset + atOffset + offset;
					}
				}
			},
			top: function( position, data ) {
				var within = data.within,
					withinOffset = within.offset.top + within.scrollTop,
					outerHeight = within.height,
					offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
					collisionPosTop = position.top - data.collisionPosition.marginTop,
					overTop = collisionPosTop - offsetTop,
					overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
					top = data.my[ 1 ] === "top",
					myOffset = top ?
						-data.elemHeight :
						data.my[ 1 ] === "bottom" ?
							data.elemHeight :
							0,
					atOffset = data.at[ 1 ] === "top" ?
						data.targetHeight :
						data.at[ 1 ] === "bottom" ?
							-data.targetHeight :
							0,
					offset = -2 * data.offset[ 1 ],
					newOverTop,
					newOverBottom;
				if ( overTop < 0 ) {
					newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight -
						outerHeight - withinOffset;
					if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
						position.top += myOffset + atOffset + offset;
					}
				} else if ( overBottom > 0 ) {
					newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset +
						offset - offsetTop;
					if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
						position.top += myOffset + atOffset + offset;
					}
				}
			}
		},
		flipfit: {
			left: function() {
				$.ui.position.flip.left.apply( this, arguments );
				$.ui.position.fit.left.apply( this, arguments );
			},
			top: function() {
				$.ui.position.flip.top.apply( this, arguments );
				$.ui.position.fit.top.apply( this, arguments );
			}
		}
	};
	
	} )();
	
	return $.ui.position;
	
	} ) );


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(21), __webpack_require__(66) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.ui.safeActiveElement = function( document ) {
		var activeElement;
	
		// Support: IE 9 only
		// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
		try {
			activeElement = document.activeElement;
		} catch ( error ) {
			activeElement = document.body;
		}
	
		// Support: IE 9 - 11 only
		// IE may return null instead of an element
		// Interestingly, this only seems to occur when NOT in an iframe
		if ( !activeElement ) {
			activeElement = document.body;
		}
	
		// Support: IE 11 only
		// IE11 returns a seemingly empty object in some cases when accessing
		// document.activeElement from an <iframe>
		if ( !activeElement.nodeName ) {
			activeElement = document.body;
		}
	
		return activeElement;
	};
	
	} ) );


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Unique ID 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: uniqueId
	//>>group: Core
	//>>description: Functions to generate and remove uniqueId's
	//>>docs: http://api.jqueryui.com/uniqueId/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(21), __webpack_require__(66) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	return $.fn.extend( {
		uniqueId: ( function() {
			var uuid = 0;
	
			return function() {
				return this.each( function() {
					if ( !this.id ) {
						this.id = "ui-id-" + ( ++uuid );
					}
				} );
			};
		} )(),
	
		removeUniqueId: function() {
			return this.each( function() {
				if ( /^ui-id-\d+$/.test( this.id ) ) {
					$( this ).removeAttr( "id" );
				}
			} );
		}
	} );
	
	} ) );


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Widget 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Widget
	//>>group: Core
	//>>description: Provides a factory for creating stateful widgets with a common API.
	//>>docs: http://api.jqueryui.com/jQuery.widget/
	//>>demos: http://jqueryui.com/widget/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(21), __webpack_require__(66) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var widgetUuid = 0;
	var widgetSlice = Array.prototype.slice;
	
	$.cleanData = ( function( orig ) {
		return function( elems ) {
			var events, elem, i;
			for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
				try {
	
					// Only trigger remove when necessary to save time
					events = $._data( elem, "events" );
					if ( events && events.remove ) {
						$( elem ).triggerHandler( "remove" );
					}
	
				// Http://bugs.jquery.com/ticket/8235
				} catch ( e ) {}
			}
			orig( elems );
		};
	} )( $.cleanData );
	
	$.widget = function( name, base, prototype ) {
		var existingConstructor, constructor, basePrototype;
	
		// ProxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		var proxiedPrototype = {};
	
		var namespace = name.split( "." )[ 0 ];
		name = name.split( "." )[ 1 ];
		var fullName = namespace + "-" + name;
	
		if ( !prototype ) {
			prototype = base;
			base = $.Widget;
		}
	
		if ( $.isArray( prototype ) ) {
			prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
		}
	
		// Create selector for plugin
		$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
			return !!$.data( elem, fullName );
		};
	
		$[ namespace ] = $[ namespace ] || {};
		existingConstructor = $[ namespace ][ name ];
		constructor = $[ namespace ][ name ] = function( options, element ) {
	
			// Allow instantiation without "new" keyword
			if ( !this._createWidget ) {
				return new constructor( options, element );
			}
	
			// Allow instantiation without initializing for simple inheritance
			// must use "new" keyword (the code above always passes args)
			if ( arguments.length ) {
				this._createWidget( options, element );
			}
		};
	
		// Extend with the existing constructor to carry over any static properties
		$.extend( constructor, existingConstructor, {
			version: prototype.version,
	
			// Copy the object used to create the prototype in case we need to
			// redefine the widget later
			_proto: $.extend( {}, prototype ),
	
			// Track widgets that inherit from this widget in case this widget is
			// redefined after a widget inherits from it
			_childConstructors: []
		} );
	
		basePrototype = new base();
	
		// We need to make the options hash a property directly on the new instance
		// otherwise we'll modify the options hash on the prototype that we're
		// inheriting from
		basePrototype.options = $.widget.extend( {}, basePrototype.options );
		$.each( prototype, function( prop, value ) {
			if ( !$.isFunction( value ) ) {
				proxiedPrototype[ prop ] = value;
				return;
			}
			proxiedPrototype[ prop ] = ( function() {
				function _super() {
					return base.prototype[ prop ].apply( this, arguments );
				}
	
				function _superApply( args ) {
					return base.prototype[ prop ].apply( this, args );
				}
	
				return function() {
					var __super = this._super;
					var __superApply = this._superApply;
					var returnValue;
	
					this._super = _super;
					this._superApply = _superApply;
	
					returnValue = value.apply( this, arguments );
	
					this._super = __super;
					this._superApply = __superApply;
	
					return returnValue;
				};
			} )();
		} );
		constructor.prototype = $.widget.extend( basePrototype, {
	
			// TODO: remove support for widgetEventPrefix
			// always use the name + a colon as the prefix, e.g., draggable:start
			// don't prefix for widgets that aren't DOM-based
			widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
		}, proxiedPrototype, {
			constructor: constructor,
			namespace: namespace,
			widgetName: name,
			widgetFullName: fullName
		} );
	
		// If this widget is being redefined then we need to find all widgets that
		// are inheriting from it and redefine all of them so that they inherit from
		// the new version of this widget. We're essentially trying to replace one
		// level in the prototype chain.
		if ( existingConstructor ) {
			$.each( existingConstructor._childConstructors, function( i, child ) {
				var childPrototype = child.prototype;
	
				// Redefine the child widget using the same prototype that was
				// originally used, but inherit from the new version of the base
				$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
					child._proto );
			} );
	
			// Remove the list of existing child constructors from the old constructor
			// so the old child constructors can be garbage collected
			delete existingConstructor._childConstructors;
		} else {
			base._childConstructors.push( constructor );
		}
	
		$.widget.bridge( name, constructor );
	
		return constructor;
	};
	
	$.widget.extend = function( target ) {
		var input = widgetSlice.call( arguments, 1 );
		var inputIndex = 0;
		var inputLength = input.length;
		var key;
		var value;
	
		for ( ; inputIndex < inputLength; inputIndex++ ) {
			for ( key in input[ inputIndex ] ) {
				value = input[ inputIndex ][ key ];
				if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
	
					// Clone objects
					if ( $.isPlainObject( value ) ) {
						target[ key ] = $.isPlainObject( target[ key ] ) ?
							$.widget.extend( {}, target[ key ], value ) :
	
							// Don't extend strings, arrays, etc. with objects
							$.widget.extend( {}, value );
	
					// Copy everything else by reference
					} else {
						target[ key ] = value;
					}
				}
			}
		}
		return target;
	};
	
	$.widget.bridge = function( name, object ) {
		var fullName = object.prototype.widgetFullName || name;
		$.fn[ name ] = function( options ) {
			var isMethodCall = typeof options === "string";
			var args = widgetSlice.call( arguments, 1 );
			var returnValue = this;
	
			if ( isMethodCall ) {
	
				// If this is an empty collection, we need to have the instance method
				// return undefined instead of the jQuery instance
				if ( !this.length && options === "instance" ) {
					returnValue = undefined;
				} else {
					this.each( function() {
						var methodValue;
						var instance = $.data( this, fullName );
	
						if ( options === "instance" ) {
							returnValue = instance;
							return false;
						}
	
						if ( !instance ) {
							return $.error( "cannot call methods on " + name +
								" prior to initialization; " +
								"attempted to call method '" + options + "'" );
						}
	
						if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
							return $.error( "no such method '" + options + "' for " + name +
								" widget instance" );
						}
	
						methodValue = instance[ options ].apply( instance, args );
	
						if ( methodValue !== instance && methodValue !== undefined ) {
							returnValue = methodValue && methodValue.jquery ?
								returnValue.pushStack( methodValue.get() ) :
								methodValue;
							return false;
						}
					} );
				}
			} else {
	
				// Allow multiple hashes to be passed on init
				if ( args.length ) {
					options = $.widget.extend.apply( null, [ options ].concat( args ) );
				}
	
				this.each( function() {
					var instance = $.data( this, fullName );
					if ( instance ) {
						instance.option( options || {} );
						if ( instance._init ) {
							instance._init();
						}
					} else {
						$.data( this, fullName, new object( options, this ) );
					}
				} );
			}
	
			return returnValue;
		};
	};
	
	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];
	
	$.Widget.prototype = {
		widgetName: "widget",
		widgetEventPrefix: "",
		defaultElement: "<div>",
	
		options: {
			classes: {},
			disabled: false,
	
			// Callbacks
			create: null
		},
	
		_createWidget: function( options, element ) {
			element = $( element || this.defaultElement || this )[ 0 ];
			this.element = $( element );
			this.uuid = widgetUuid++;
			this.eventNamespace = "." + this.widgetName + this.uuid;
	
			this.bindings = $();
			this.hoverable = $();
			this.focusable = $();
			this.classesElementLookup = {};
	
			if ( element !== this ) {
				$.data( element, this.widgetFullName, this );
				this._on( true, this.element, {
					remove: function( event ) {
						if ( event.target === element ) {
							this.destroy();
						}
					}
				} );
				this.document = $( element.style ?
	
					// Element within the document
					element.ownerDocument :
	
					// Element is window or document
					element.document || element );
				this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
			}
	
			this.options = $.widget.extend( {},
				this.options,
				this._getCreateOptions(),
				options );
	
			this._create();
	
			if ( this.options.disabled ) {
				this._setOptionDisabled( this.options.disabled );
			}
	
			this._trigger( "create", null, this._getCreateEventData() );
			this._init();
		},
	
		_getCreateOptions: function() {
			return {};
		},
	
		_getCreateEventData: $.noop,
	
		_create: $.noop,
	
		_init: $.noop,
	
		destroy: function() {
			var that = this;
	
			this._destroy();
			$.each( this.classesElementLookup, function( key, value ) {
				that._removeClass( value, key );
			} );
	
			// We can probably remove the unbind calls in 2.0
			// all event bindings should go through this._on()
			this.element
				.off( this.eventNamespace )
				.removeData( this.widgetFullName );
			this.widget()
				.off( this.eventNamespace )
				.removeAttr( "aria-disabled" );
	
			// Clean up events and states
			this.bindings.off( this.eventNamespace );
		},
	
		_destroy: $.noop,
	
		widget: function() {
			return this.element;
		},
	
		option: function( key, value ) {
			var options = key;
			var parts;
			var curOption;
			var i;
	
			if ( arguments.length === 0 ) {
	
				// Don't return a reference to the internal hash
				return $.widget.extend( {}, this.options );
			}
	
			if ( typeof key === "string" ) {
	
				// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
				options = {};
				parts = key.split( "." );
				key = parts.shift();
				if ( parts.length ) {
					curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
					for ( i = 0; i < parts.length - 1; i++ ) {
						curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
						curOption = curOption[ parts[ i ] ];
					}
					key = parts.pop();
					if ( arguments.length === 1 ) {
						return curOption[ key ] === undefined ? null : curOption[ key ];
					}
					curOption[ key ] = value;
				} else {
					if ( arguments.length === 1 ) {
						return this.options[ key ] === undefined ? null : this.options[ key ];
					}
					options[ key ] = value;
				}
			}
	
			this._setOptions( options );
	
			return this;
		},
	
		_setOptions: function( options ) {
			var key;
	
			for ( key in options ) {
				this._setOption( key, options[ key ] );
			}
	
			return this;
		},
	
		_setOption: function( key, value ) {
			if ( key === "classes" ) {
				this._setOptionClasses( value );
			}
	
			this.options[ key ] = value;
	
			if ( key === "disabled" ) {
				this._setOptionDisabled( value );
			}
	
			return this;
		},
	
		_setOptionClasses: function( value ) {
			var classKey, elements, currentElements;
	
			for ( classKey in value ) {
				currentElements = this.classesElementLookup[ classKey ];
				if ( value[ classKey ] === this.options.classes[ classKey ] ||
						!currentElements ||
						!currentElements.length ) {
					continue;
				}
	
				// We are doing this to create a new jQuery object because the _removeClass() call
				// on the next line is going to destroy the reference to the current elements being
				// tracked. We need to save a copy of this collection so that we can add the new classes
				// below.
				elements = $( currentElements.get() );
				this._removeClass( currentElements, classKey );
	
				// We don't use _addClass() here, because that uses this.options.classes
				// for generating the string of classes. We want to use the value passed in from
				// _setOption(), this is the new value of the classes option which was passed to
				// _setOption(). We pass this value directly to _classes().
				elements.addClass( this._classes( {
					element: elements,
					keys: classKey,
					classes: value,
					add: true
				} ) );
			}
		},
	
		_setOptionDisabled: function( value ) {
			this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );
	
			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this._removeClass( this.hoverable, null, "ui-state-hover" );
				this._removeClass( this.focusable, null, "ui-state-focus" );
			}
		},
	
		enable: function() {
			return this._setOptions( { disabled: false } );
		},
	
		disable: function() {
			return this._setOptions( { disabled: true } );
		},
	
		_classes: function( options ) {
			var full = [];
			var that = this;
	
			options = $.extend( {
				element: this.element,
				classes: this.options.classes || {}
			}, options );
	
			function processClassString( classes, checkOption ) {
				var current, i;
				for ( i = 0; i < classes.length; i++ ) {
					current = that.classesElementLookup[ classes[ i ] ] || $();
					if ( options.add ) {
						current = $( $.unique( current.get().concat( options.element.get() ) ) );
					} else {
						current = $( current.not( options.element ).get() );
					}
					that.classesElementLookup[ classes[ i ] ] = current;
					full.push( classes[ i ] );
					if ( checkOption && options.classes[ classes[ i ] ] ) {
						full.push( options.classes[ classes[ i ] ] );
					}
				}
			}
	
			this._on( options.element, {
				"remove": "_untrackClassesElement"
			} );
	
			if ( options.keys ) {
				processClassString( options.keys.match( /\S+/g ) || [], true );
			}
			if ( options.extra ) {
				processClassString( options.extra.match( /\S+/g ) || [] );
			}
	
			return full.join( " " );
		},
	
		_untrackClassesElement: function( event ) {
			var that = this;
			$.each( that.classesElementLookup, function( key, value ) {
				if ( $.inArray( event.target, value ) !== -1 ) {
					that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
				}
			} );
		},
	
		_removeClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, false );
		},
	
		_addClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, true );
		},
	
		_toggleClass: function( element, keys, extra, add ) {
			add = ( typeof add === "boolean" ) ? add : extra;
			var shift = ( typeof element === "string" || element === null ),
				options = {
					extra: shift ? keys : extra,
					keys: shift ? element : keys,
					element: shift ? this.element : element,
					add: add
				};
			options.element.toggleClass( this._classes( options ), add );
			return this;
		},
	
		_on: function( suppressDisabledCheck, element, handlers ) {
			var delegateElement;
			var instance = this;
	
			// No suppressDisabledCheck flag, shuffle arguments
			if ( typeof suppressDisabledCheck !== "boolean" ) {
				handlers = element;
				element = suppressDisabledCheck;
				suppressDisabledCheck = false;
			}
	
			// No element argument, shuffle and use this.element
			if ( !handlers ) {
				handlers = element;
				element = this.element;
				delegateElement = this.widget();
			} else {
				element = delegateElement = $( element );
				this.bindings = this.bindings.add( element );
			}
	
			$.each( handlers, function( event, handler ) {
				function handlerProxy() {
	
					// Allow widgets to customize the disabled handling
					// - disabled as an array instead of boolean
					// - disabled class as method for disabling individual parts
					if ( !suppressDisabledCheck &&
							( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
						return;
					}
					return ( typeof handler === "string" ? instance[ handler ] : handler )
						.apply( instance, arguments );
				}
	
				// Copy the guid so direct unbinding works
				if ( typeof handler !== "string" ) {
					handlerProxy.guid = handler.guid =
						handler.guid || handlerProxy.guid || $.guid++;
				}
	
				var match = event.match( /^([\w:-]*)\s*(.*)$/ );
				var eventName = match[ 1 ] + instance.eventNamespace;
				var selector = match[ 2 ];
	
				if ( selector ) {
					delegateElement.on( eventName, selector, handlerProxy );
				} else {
					element.on( eventName, handlerProxy );
				}
			} );
		},
	
		_off: function( element, eventName ) {
			eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
				this.eventNamespace;
			element.off( eventName ).off( eventName );
	
			// Clear the stack to avoid memory leaks (#10056)
			this.bindings = $( this.bindings.not( element ).get() );
			this.focusable = $( this.focusable.not( element ).get() );
			this.hoverable = $( this.hoverable.not( element ).get() );
		},
	
		_delay: function( handler, delay ) {
			function handlerProxy() {
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}
			var instance = this;
			return setTimeout( handlerProxy, delay || 0 );
		},
	
		_hoverable: function( element ) {
			this.hoverable = this.hoverable.add( element );
			this._on( element, {
				mouseenter: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
				},
				mouseleave: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
				}
			} );
		},
	
		_focusable: function( element ) {
			this.focusable = this.focusable.add( element );
			this._on( element, {
				focusin: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
				},
				focusout: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
				}
			} );
		},
	
		_trigger: function( type, event, data ) {
			var prop, orig;
			var callback = this.options[ type ];
	
			data = data || {};
			event = $.Event( event );
			event.type = ( type === this.widgetEventPrefix ?
				type :
				this.widgetEventPrefix + type ).toLowerCase();
	
			// The original event may come from any element
			// so we need to reset the target on the new event
			event.target = this.element[ 0 ];
	
			// Copy original event properties over to the new event
			orig = event.originalEvent;
			if ( orig ) {
				for ( prop in orig ) {
					if ( !( prop in event ) ) {
						event[ prop ] = orig[ prop ];
					}
				}
			}
	
			this.element.trigger( event, data );
			return !( $.isFunction( callback ) &&
				callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
				event.isDefaultPrevented() );
		}
	};
	
	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
		$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
			if ( typeof options === "string" ) {
				options = { effect: options };
			}
	
			var hasOptions;
			var effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
	
			options = options || {};
			if ( typeof options === "number" ) {
				options = { duration: options };
			}
	
			hasOptions = !$.isEmptyObject( options );
			options.complete = callback;
	
			if ( options.delay ) {
				element.delay( options.delay );
			}
	
			if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
				element[ method ]( options );
			} else if ( effectName !== method && element[ effectName ] ) {
				element[ effectName ]( options.duration, options.easing, callback );
			} else {
				element.queue( function( next ) {
					$( this )[ method ]();
					if ( callback ) {
						callback.call( element[ 0 ] );
					}
					next();
				} );
			}
		};
	} );
	
	return $.widget;
	
	} ) );


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"uploader-modal facility\">\n  <form class=\"form\" name=\"form\" ng-submit=\"$ctrl.submitForm(form)\" novalidate>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\" id=\"modal-title\">Company GL Uploader</h4>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div class=\"alert alert-warning\">This uploader will only process data in sheet name \"{{$ctrl.targetSheetName}}\"</div>\n      <div class=\"uploader-section\" ng-if=\"!$ctrl.sizeOf($ctrl.data.excel)\">\n        <label>Select Your Excel File</label>\n        <div class=form-group\">\n          <input type=\"file\" file-input=\"$ctrl.fileInputField\" class=\"form-control input-sm\" />\n        </div>\n      </div>\n      <div class=\"parsed-section\" ng-if=\"$ctrl.sizeOf($ctrl.data.excel)\">\n        <label>Excel File Preview</label>\n        <p>Please review the excel data below before importing.</p>\n        <div class=\"tabs-container\" ng-if=\"$ctrl.data.excelSelectedTabs.length > 1\">\n          <ul class=\"nav nav-tabs\">\n            <li role=\"presentation\" ng-repeat=\"tab in $ctrl.data.excelSelectedTabs track by $index\" ng-class=\"{'active': $index===$ctrl.data.excelSelectedTabIdx}\">\n              <a ng-click=\"$ctrl.selectTab($index)\">\n                {{tab}}\n              </a>\n            </li>\n          </ul>\n        </div>\n        <div class=\"alert alert-danger\" ng-if=\"$ctrl.invalidTabMsg\">\n          <i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> This tab does not match the required fields needed for company GL import.\n        </div>\n        <div class=\"table-responsive\">\n          <table class=\"table table-bordered table-striped table-hover table-inputs\">\n            <tbody>\n              <tr ng-if=\"$ctrl.data.excelSelectedTabData !== null\">\n                <td>&nbsp;</td>\n                <td class=\"text-center field-options\" ng-repeat=\"(a, b) in $ctrl.excelColumns\" repeat-end-watch=\"$ctrl.rendered()\">\n                  <select class=\"form-control input-sm\" ng-options=\"option.value as option.name for option in $ctrl.fieldOptions\" ng-model=\"$ctrl.form.mappedFields[$index]\">\n                    <option value=\"\">Select a Field</option>\n                  </select>\n                </td>\n              </tr>\n              <tr ng-if=\"$ctrl.data.excelSelectedTabData !== null\">\n                <td>&nbsp;</td>\n                <td class=\"text-center\" ng-repeat=\"(a, b) in $ctrl.excelColumns\">\n                  {{b}}\n                </td>\n              </tr>\n              <tr ng-repeat=\"(k, v) in $ctrl.data.excelSelectedTabData.rows\" ng-class=\"{'success': v.success, 'danger': v.failed}\">\n                <td width=\"15\">{{$index + 1}}</td>\n                <td ng-repeat=\"(a, b) in $ctrl.excelColumns\">\n                  <span class=\"text-bg\" ng-if=\"v[b].t === 'n' && b !== 'C'\">{{v[b].v}}</span>\n                  <span class=\"text-bg\" ng-if=\"v[b].t === 's' || b === 'C'\">{{v[b].v}}</span>\n                </td>\n              </tr>\n              <tr ng-if=\"$ctrl.data.excelSelectedTabData === null\">\n                <td colspan=\"{{$ctrl.fieldOptions.length}}\"><em>Loading....</em></td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer clearfix\">\n      <div class=\"alert alert-info pull-left\" ng-if=\"$ctrl.sizeOf($ctrl.data.excel) && !$ctrl.invalidTabMsg && $ctrl.isImporting\">\n        Please allow 5 to 10 minutes for system to save new companies.\n      </div>\n      <button class=\"btn btn-success btn-sm\" type=\"button\" ng-click=\"$ctrl.uploadFile()\" ng-if=\"!$ctrl.sizeOf($ctrl.data.excel)\" ng-disabled=\"$ctrl.isUploading || !$ctrl.fileInputField\">Upload</button>\n      <button class=\"btn btn-primary btn-sm\" type=\"submit\" ng-if=\"$ctrl.sizeOf($ctrl.data.excel) && !$ctrl.invalidTabMsg\" ng-disabled=\"$ctrl.isImporting\">Save</button>\n      <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"uploader-modal user\">\n  <form class=\"form\" name=\"form\" ng-submit=\"$ctrl.submitForm(form)\" novalidate>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\" id=\"modal-title\"><i class=\"fa\" ng-class=\"{'fa-plus': $ctrl.isAdd, 'fa-pencil-square-o': !$ctrl.isAdd}\" aria-hidden=\"true\"></i> {{!$ctrl.isAdd ? 'Edit' : 'Add'}} Facility</h4>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div class=\"form-group\" ng-class=\"{'has-error': form.facilityName.$invalid && $ctrl.submitted}\">\n        <label for=\"facilityName\" class=\"required\">Facility Name</label>\n        <input type=\"text\" id=\"facilityName\" name=\"facilityName\" class=\"form-control input-sm\" placeholder=\"Facility Name\" ng-model=\"$ctrl.form.facilityName\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"deptName\" class=\"required\">Dept Name</label>\n        <input type=\"text\" id=\"deptName\" name=\"deptName\" class=\"form-control input-sm\" placeholder=\"Dept Name\" ng-model=\"$ctrl.form.deptName\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"costCenter\" class=\"required\">Cost Center</label>\n        <input type=\"text\" id=\"costCenter\" name=\"costCenter\" class=\"form-control input-sm\" placeholder=\"Cost Center\" ng-model=\"$ctrl.form.costCenter\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"address\" class=\"required\">Address</label>\n        <input type=\"text\" id=\"address\" name=\"address\" class=\"form-control input-sm\" placeholder=\"Address\" ng-model=\"$ctrl.form.address\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"city\" class=\"required\">City</label>\n        <input type=\"text\" id=\"city\" name=\"city\" class=\"form-control input-sm\" placeholder=\"City\" ng-model=\"$ctrl.form.city\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"state\" class=\"required\">State</label>\n        <input type=\"text\" id=\"state\" name=\"state\" class=\"form-control input-sm\" placeholder=\"State\" ng-model=\"$ctrl.form.state\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"zip\" class=\"required\">Zip</label>\n        <input type=\"text\" id=\"zip\" name=\"zip\" class=\"form-control input-sm\" placeholder=\"Zip\" ng-model=\"$ctrl.form.zip\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"fsmClient\" class=\"required\">FSM Client</label>\n        <input type=\"text\" id=\"fsmClient\" name=\"fsmClient\" class=\"form-control input-sm\" placeholder=\"FSM Client\" ng-model=\"$ctrl.form.fsmClient\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"fsmArea\" class=\"required\">FSM Area</label>\n        <input type=\"text\" id=\"fsmArea\" name=\"fsmArea\" class=\"form-control input-sm\" placeholder=\"FSM Area\" ng-model=\"$ctrl.form.fsmArea\" required />\n      </div>\n    </div>\n    <div class=\"modal-footer clearfix\">\n      <div class=\"alert alert-info pull-left\" ng-if=\"$ctrl.isSaving\">\n        Saving....\n      </div>\n      <div class=\"alert alert-danger pull-left\" ng-if=\"$ctrl.errors\">\n        Form has error(s).\n      </div>\n      <button class=\"btn btn-primary btn-sm\" type=\"submit\" ng-disabled=\"!form.$dirty || form.$invalid || $ctrl.isSaving\">Save</button>\n      <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _async = __webpack_require__(55);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CompanyGLsUploadController = function () {
	  /*@ngInject*/
	  CompanyGLsUploadController.$inject = ['$http', '$q', '$cookies', '$timeout', '$uibModalInstance'];
	  function CompanyGLsUploadController($http, $q, $cookies, $timeout, $uibModalInstance) {
	    _classCallCheck(this, CompanyGLsUploadController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$cookies = $cookies;
	    this.$timeout = $timeout;
	    this.$uibModalInstance = $uibModalInstance;
	
	    this.fileInputField;
	    this.isUploading = false;
	
	    this.data = {
	      selectedFiles: [],
	      excelFileOnServer: '',
	      excel: null,
	      excelSelectedTabs: [],
	      excelSelectedTabIdx: 0,
	      excelSelectedTabData: null
	    };
	    this.excelColumns = [];
	
	    this.targetSheetName = 'Company.GL';
	    this.fieldOptions = [{ name: 'Region Name', value: 'regionName', alias: [] }, { name: 'Region Abbr', value: 'regionAbbr' }, { name: 'System Name', value: 'systemName', alias: [] }, { name: 'System Abbr', value: 'systemAbbr', alias: [] }, { name: 'Company Name', value: 'companyName', alias: [] }, { name: 'Ministry', value: 'ministry', alias: [] }, { name: 'GL', value: 'gl', alias: [] }];
	
	    this.form = {
	      mappedFields: {}
	    };
	    this.invalidTabMsg = false;
	    this.isImporting = false;
	    this.importProgress = {
	      current: 0,
	      total: 0
	    };
	  }
	
	  _createClass(CompanyGLsUploadController, [{
	    key: 'sizeOf',
	    value: function sizeOf(obj) {
	      return _lodash2.default.size(obj);
	    }
	  }, {
	    key: 'uploadFile',
	    value: function uploadFile() {
	      var self = this;
	      this.isUploading = true;
	      this.$http({
	        method: 'POST',
	        url: '/api/types/companies/gls/upload?access_token=' + this.$cookies.get('token'),
	        headers: {
	          'Content-Type': undefined
	        },
	        data: {
	          file: this.fileInputField
	        },
	        transformRequest: function transformRequest(data, headersGetter) {
	          var formData = new FormData();
	          angular.forEach(data, function (value, key) {
	            formData.append(key, value);
	          });
	          return formData;
	        }
	      }).then(function (response) {
	        self.data.excelFileOnServer = response.data;
	        self.parseFile(response.data);
	        self.isUploading = false;
	      }, function (error) {
	        self.isUploading = false;
	      });
	    }
	  }, {
	    key: 'parseFile',
	    value: function parseFile(filename) {
	      var self = this;
	      this.$http.post('/api/types/companies/gls/parse', {
	        filename: filename
	      }).then(function (response) {
	        self.data.excel = response.data;
	        if (_lodash2.default.size(self.data.excel.sheets)) {
	
	          var matchSheetIdx = void 0;
	
	          angular.forEach(self.data.excel.sheets, function (sheet, idx) {
	            self.data.excelSelectedTabs.push(sheet.name);
	            if (sheet.name === self.targetSheetName) {
	              matchSheetIdx = idx;
	            }
	          });
	          if (angular.isDefined(matchSheetIdx)) {
	            self.data.excelSelectedTabIdx = matchSheetIdx;
	          }
	          self.selectTab(self.data.excelSelectedTabIdx);
	        } else {
	          self.data.resultMsg = 'Invalid excel.';
	        }
	      }, function (error) {});
	    }
	  }, {
	    key: 'colName',
	    value: function colName(n) {
	      var ordA = 'a'.charCodeAt(0);
	      var ordZ = 'z'.charCodeAt(0);
	      var len = ordZ - ordA + 1;
	      var s = "";
	      while (n >= 0) {
	        s = String.fromCharCode(n % len + ordA) + s;
	        n = Math.floor(n / len) - 1;
	      }
	      return s.toUpperCase();
	    }
	  }, {
	    key: 'createEmptyArray',
	    value: function createEmptyArray(nth) {
	      var _array = [];
	      var i = 0;
	      for (i = 0; i < nth; i++) {
	        _array.push(this.colName(i));
	      }
	      this.excelColumns = _array;
	    }
	  }, {
	    key: 'guessColumnField',
	    value: function guessColumnField() {
	      var self = this;
	      var match = void 0;
	      var idx = void 0;
	
	      angular.forEach(this.data.excelSelectedTabData.rows[1], function (col, k) {
	        match = _lodash2.default.find(self.fieldOptions, function (o) {
	          return o.name.toLowerCase() === col.v.toLowerCase();
	        });
	        if (match) {
	          idx = _lodash2.default.findKey(self.excelColumns, function (o) {
	            return o === k;
	          });
	          if (idx) {
	            self.form.mappedFields[idx] = match.value;
	          }
	        } else {
	          match = _lodash2.default.find(self.fieldOptions, function (o) {
	            if (o.alias && o.alias.length) {
	              return o.alias.indexOf(col.v) !== -1;
	            }
	            return false;
	          });
	          if (match) {
	            idx = _lodash2.default.findKey(self.excelColumns, function (o) {
	              return o === k;
	            });
	            if (idx) {
	              self.form.mappedFields[idx] = match.value;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'selectTab',
	    value: function selectTab(idx) {
	      var self = this;
	      this.data.excelSelectedTabData = null;
	      this.invalidTabMsg = false;
	      this.$timeout(function () {
	        var i = 0;
	        var o = void 0;
	        for (o in self.data.excel.sheets) {
	          if (i === idx) {
	            self.data.excelSelectedTabData = self.data.excel.sheets[o];
	            self.createEmptyArray(self.data.excelSelectedTabData.overallMaxColumnCount);
	            break;
	          } else {
	            i++;
	          }
	        }
	        self.data.excelSelectedTabIdx = idx;
	      });
	    }
	  }, {
	    key: 'rendered',
	    value: function rendered() {
	      this.guessColumnField();
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        if (this.data.excel) {
	          var self = this;
	          this.isImporting = true;
	          var payload = {
	            filename: self.data.excelFileOnServer,
	            tabIdx: self.data.excelSelectedTabIdx,
	            mappedFields: this.form.mappedFields,
	            excelColumns: self.excelColumns
	          };
	          console.log(payload);
	
	          this.$http.post('/api/types/companies/gls/import', payload).then(function (response) {
	            self.$timeout(function () {
	              self.$uibModalInstance.close();
	            }, 5000);
	          }, function (error) {});
	        }
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return CompanyGLsUploadController;
	}();
	
	exports.default = CompanyGLsUploadController;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CompanyGLFormController = function () {
	  /*@ngInject*/
	  CompanyGLFormController.$inject = ['$http', '$q', '$uibModalInstance', 'facility'];
	  function CompanyGLFormController($http, $q, $uibModalInstance, facility) {
	    _classCallCheck(this, CompanyGLFormController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$uibModalInstance = $uibModalInstance;
	
	    this.facility = facility;
	
	    this.isAdd = true;
	    this.form = {};
	    this.submitted = false;
	    this.isSaving = false;
	    this.errors;
	  }
	
	  _createClass(CompanyGLFormController, [{
	    key: 'getData',
	    value: function getData(id) {
	      var self = this;
	      this.$http.get('/api/types/companies/' + id).then(function (response) {
	        self.result = response.data;
	      }, function (err) {});
	    }
	  }, {
	    key: 'update',
	    value: function update(form, id, payload) {
	      var self = this;
	      this.$http.put('/api/types/companies/' + id, payload).then(function (response) {
	        self.$uibModalInstance.close();
	      }, function (err) {
	        self.isSaving = false;
	
	        self.errors = {};
	        angular.forEach(err.data.errors, function (error, field) {
	          form[field].$setValidity('mongoose', false);
	          self.errors[field] = error.message;
	        });
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(form, payload) {
	      var self = this;
	      this.$http.post('/api/types/companies', payload).then(function (response) {
	        self.$uibModalInstance.close();
	      }, function (err) {
	        self.isSaving = false;
	
	        self.errors = {};
	        angular.forEach(err.data.errors, function (error, field) {
	          form[field].$setValidity('mongoose', false);
	          self.errors[field] = error.message;
	        });
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        var self = this;
	        this.submitted = true;
	        this.isSaving = true;
	        var payload = this.form;
	        if (this.facility && this.facility._id) {
	          this.update(form, this.facility._id, payload);
	        } else {
	          self.create(form, payload);
	        }
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.facility && this.facility._id) {
	        this.isAdd = false;
	        this.getData(this.facility._id);
	      }
	    }
	  }]);
	
	  return CompanyGLFormController;
	}();
	
	exports.default = CompanyGLFormController;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(59);
	var autocomplete = __webpack_require__(63);
	
	var AccountingUntisController = function () {
	  /*@ngInject*/
	  AccountingUntisController.$inject = ['$rootScope', '$scope', '$http', '$q', '$state', '$stateParams', '$uibModal', 'Modal'];
	  function AccountingUntisController($rootScope, $scope, $http, $q, $state, $stateParams, $uibModal, Modal) {
	    var _sortByOptions;
	
	    _classCallCheck(this, AccountingUntisController);
	
	    this.$scope = $scope;
	    this.$http = $http;
	    this.$q = $q;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$uibModal = $uibModal;
	    this.Modal = Modal;
	
	    $rootScope.currentAdminPageTitle = 'Accounting Units';
	    this.route = 'admin.accountingUnits';
	
	    this.tableMsg = '';
	    this.form = {};
	    this.systemOptions = [];
	    this.result = {};
	    this.pageSizeOptions = [10, 20, 30, 40, 50];
	    this.sortByOptions = (_sortByOptions = {
	      hrOrganizationUnit: 'HR Organization Unit',
	      shortDescription: 'Short Description',
	      description: 'Description'
	    }, _defineProperty(_sortByOptions, 'description', 'Description'), _defineProperty(_sortByOptions, 'parentUnitShortDescription', 'Parent Unit Short Description'), _defineProperty(_sortByOptions, 'modifiedDate', 'Re-Uploaded Date'), _sortByOptions);
	    this.pagination = {
	      _paging: true,
	      _selector: 'All',
	      _pageSize: 10,
	      _pageNum: 1,
	      _sortBy: 'hrOrganizationUnit asc'
	    };
	  }
	
	  _createClass(AccountingUntisController, [{
	    key: 'getSystems',
	    value: function getSystems() {
	      var deferred = this.$q.defer();
	      var self = this;
	      var params = {
	        _selector: 'name',
	        _pageSize: 'All'
	      };
	      this.$http.get('/api/types/systems', { params: params }).then(function (response) {
	        self.systemOptions = response.data;
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'setDefaultSearchForm',
	    value: function setDefaultSearchForm() {
	      var _pageNum = 1;
	      if (this.$stateParams._pageNum) {
	        _pageNum = parseInt(this.$stateParams._pageNum);
	      }
	      this.pageNumVal = _pageNum;
	      var _pageSize = 100;
	      if (this.$stateParams._pageSize) {
	        _pageSize = parseInt(this.$stateParams._pageSize);
	      }
	      this.pageSizeVal = _pageSize;
	    }
	  }, {
	    key: 'buildQuery',
	    value: function buildQuery() {
	      return angular.extend(angular.copy(this.form), this.pagination);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var self = this;
	      this.$http.get('/api/types/companies/accountingUnits', {
	        params: this.buildQuery()
	      }).then(function (response) {
	        if (response.data.total === 0) {
	          self.tableMsg = 'No record found.';
	        }
	        self.result = response.data;
	      }, function (err) {});
	    }
	  }, {
	    key: 'search',
	    value: function search(form) {
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'clearSearch',
	    value: function clearSearch() {
	      this.form = {};
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'openUploadModal',
	    value: function openUploadModal() {
	      var self = this;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        ariaLabelledBy: 'modal-title',
	        ariaDescribedBy: 'modal-body',
	        template: __webpack_require__(76),
	        controller: 'AccountingUnitsUploadController',
	        controllerAs: '$ctrl',
	        size: 'lg'
	      });
	      modalInstance.result.then(function () {
	        self.getData();
	      }, function () {});
	    }
	  }, {
	    key: 'openCompanyForm',
	    value: function openCompanyForm(item) {
	      var self = this;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        ariaLabelledBy: 'modal-title',
	        ariaDescribedBy: 'modal-body',
	        template: __webpack_require__(77),
	        controller: 'AccountingUnitFormController',
	        controllerAs: '$ctrl',
	        size: 'md',
	        resolve: {
	          facility: function facility() {
	            return item;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        self.getData();
	      }, function () {});
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(item) {
	      var self = this;
	      this.Modal.confirm.delete(function () {
	        self.$http.delete('/api/types/companies/accountingUnits/' + item._id).then(function (response) {
	          self.getData();
	        }, function (err) {});
	      })(item.facilityName + ' / ' + item.deptName + ' / ' + item.costCenter + ' company');
	    }
	  }, {
	    key: 'rowNumb',
	    value: function rowNumb(idx) {
	      return idx + 1 + (this.result.pageNum !== 1 ? this.result.pageSize * this.result.pageNum - this.result.pageSize : 0);
	    }
	  }, {
	    key: 'updateSortBy',
	    value: function updateSortBy(sortBy) {
	      this.pagination._sortBy = sortBy;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'updatePageSize',
	    value: function updatePageSize(pageSize) {
	      this.pagination._pageSize = pageSize;
	      this.pagination._pageNum = 1;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'gotoPage',
	    value: function gotoPage(pageNum) {
	      this.pagination._pageNum = pageNum;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var self = this;
	      this.getSystems().then(function () {
	        if (window.system) {
	          self.form.healthCareProviderSystem = window.system;
	        }
	        self.getData();
	      });
	    }
	  }]);
	
	  return AccountingUntisController;
	}();
	
	exports.default = AccountingUntisController;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"uploader-modal facility\">\n  <form class=\"form\" name=\"form\" ng-submit=\"$ctrl.submitForm(form)\" novalidate>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\" id=\"modal-title\">Accounting Unit Uploader</h4>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div class=\"alert alert-warning\">This uploader will only process data in sheet name \"{{$ctrl.targetSheetName}}\"</div>\n      <div class=\"uploader-section\" ng-if=\"!$ctrl.sizeOf($ctrl.data.excel)\">\n        <label>Select Your Excel File</label>\n        <div class=form-group\">\n          <input type=\"file\" file-input=\"$ctrl.fileInputField\" class=\"form-control input-sm\" />\n        </div>\n      </div>\n      <div class=\"parsed-section\" ng-if=\"$ctrl.sizeOf($ctrl.data.excel)\">\n        <label>Excel File Preview</label>\n        <p>Please review the excel data below before importing.</p>\n        <div class=\"tabs-container\" ng-if=\"$ctrl.data.excelSelectedTabs.length > 1\">\n          <ul class=\"nav nav-tabs\">\n            <li role=\"presentation\" ng-repeat=\"tab in $ctrl.data.excelSelectedTabs track by $index\" ng-class=\"{'active': $index===$ctrl.data.excelSelectedTabIdx}\">\n              <a ng-click=\"$ctrl.selectTab($index)\">\n                {{tab}}\n              </a>\n            </li>\n          </ul>\n        </div>\n        <div class=\"alert alert-danger\" ng-if=\"$ctrl.invalidTabMsg\">\n          <i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> This tab does not match the required fields needed for company GL import.\n        </div>\n        <div class=\"table-responsive\">\n          <table class=\"table table-bordered table-striped table-hover table-inputs\">\n            <tbody>\n              <tr ng-if=\"$ctrl.data.excelSelectedTabData !== null\">\n                <td>&nbsp;</td>\n                <td class=\"text-center field-options\" ng-repeat=\"(a, b) in $ctrl.excelColumns\" repeat-end-watch=\"$ctrl.rendered()\">\n                  <select class=\"form-control input-sm\" ng-options=\"option.value as option.name for option in $ctrl.fieldOptions\" ng-model=\"$ctrl.form.mappedFields[$index]\">\n                    <option value=\"\">Select a Field</option>\n                  </select>\n                </td>\n              </tr>\n              <tr ng-if=\"$ctrl.data.excelSelectedTabData !== null\">\n                <td>&nbsp;</td>\n                <td class=\"text-center\" ng-repeat=\"(a, b) in $ctrl.excelColumns\">\n                  {{b}}\n                </td>\n              </tr>\n              <tr ng-repeat=\"(k, v) in $ctrl.data.excelSelectedTabData.rows\" ng-class=\"{'success': v.success, 'danger': v.failed}\">\n                <td width=\"15\">{{$index + 1}}</td>\n                <td ng-repeat=\"(a, b) in $ctrl.excelColumns\">\n                  <span class=\"text-bg\" ng-if=\"v[b].t === 'n' && b !== 'C'\">{{v[b].v}}</span>\n                  <span class=\"text-bg\" ng-if=\"v[b].t === 's' || b === 'C'\">{{v[b].v}}</span>\n                </td>\n              </tr>\n              <tr ng-if=\"$ctrl.data.excelSelectedTabData === null\">\n                <td colspan=\"{{$ctrl.fieldOptions.length}}\"><em>Loading....</em></td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer clearfix\">\n      <div class=\"alert alert-info pull-left\" ng-if=\"$ctrl.sizeOf($ctrl.data.excel) && !$ctrl.invalidTabMsg && $ctrl.isImporting\">\n        Please allow 5 to 10 minutes for system to save new companies.\n      </div>\n      <button class=\"btn btn-success btn-sm\" type=\"button\" ng-click=\"$ctrl.uploadFile()\" ng-if=\"!$ctrl.sizeOf($ctrl.data.excel)\" ng-disabled=\"$ctrl.isUploading || !$ctrl.fileInputField\">Upload</button>\n      <button class=\"btn btn-primary btn-sm\" type=\"submit\" ng-if=\"$ctrl.sizeOf($ctrl.data.excel) && !$ctrl.invalidTabMsg\" ng-disabled=\"$ctrl.isImporting\">Save</button>\n      <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 77 */
72,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _async = __webpack_require__(55);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AccountingUnitsUploadController = function () {
	  /*@ngInject*/
	  AccountingUnitsUploadController.$inject = ['$http', '$q', '$cookies', '$timeout', '$uibModalInstance'];
	  function AccountingUnitsUploadController($http, $q, $cookies, $timeout, $uibModalInstance) {
	    _classCallCheck(this, AccountingUnitsUploadController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$cookies = $cookies;
	    this.$timeout = $timeout;
	    this.$uibModalInstance = $uibModalInstance;
	
	    this.fileInputField;
	    this.isUploading = false;
	
	    this.data = {
	      selectedFiles: [],
	      excelFileOnServer: '',
	      excel: null,
	      excelSelectedTabs: [],
	      excelSelectedTabIdx: 0,
	      excelSelectedTabData: null
	    };
	    this.excelColumns = [];
	
	    this.targetSheetName = 'Accounting Unit';
	    this.fieldOptions = [{ name: 'HROrganizationUnit', value: 'hrOrganizationUnit', alias: [] }, { name: 'ShortDescription', value: 'shortDescription' }, { name: 'Description', value: 'description', alias: [] }, { name: 'ParentUnitShortDescription', value: 'parentUnitShortDescription', alias: [] }, { name: 'MVS or BSC?', value: 'mvsOrBsc', alias: [] }];
	
	    this.form = {
	      mappedFields: {}
	    };
	    this.invalidTabMsg = false;
	    this.isImporting = false;
	    this.importProgress = {
	      current: 0,
	      total: 0
	    };
	  }
	
	  _createClass(AccountingUnitsUploadController, [{
	    key: 'sizeOf',
	    value: function sizeOf(obj) {
	      return _lodash2.default.size(obj);
	    }
	  }, {
	    key: 'uploadFile',
	    value: function uploadFile() {
	      var self = this;
	      this.isUploading = true;
	      this.$http({
	        method: 'POST',
	        url: '/api/types/companies/accountingUnits/upload?access_token=' + this.$cookies.get('token'),
	        headers: {
	          'Content-Type': undefined
	        },
	        data: {
	          file: this.fileInputField
	        },
	        transformRequest: function transformRequest(data, headersGetter) {
	          var formData = new FormData();
	          angular.forEach(data, function (value, key) {
	            formData.append(key, value);
	          });
	          return formData;
	        }
	      }).then(function (response) {
	        self.data.excelFileOnServer = response.data;
	        self.parseFile(response.data);
	        self.isUploading = false;
	      }, function (error) {
	        self.isUploading = false;
	      });
	    }
	  }, {
	    key: 'parseFile',
	    value: function parseFile(filename) {
	      var self = this;
	      this.$http.post('/api/types/companies/accountingUnits/parse', {
	        filename: filename
	      }).then(function (response) {
	        self.data.excel = response.data;
	        if (_lodash2.default.size(self.data.excel.sheets)) {
	
	          var matchSheetIdx = void 0;
	
	          angular.forEach(self.data.excel.sheets, function (sheet, idx) {
	            self.data.excelSelectedTabs.push(sheet.name);
	            if (sheet.name === self.targetSheetName) {
	              matchSheetIdx = idx;
	            }
	          });
	          if (angular.isDefined(matchSheetIdx)) {
	            self.data.excelSelectedTabIdx = matchSheetIdx;
	          }
	          self.selectTab(self.data.excelSelectedTabIdx);
	        } else {
	          self.data.resultMsg = 'Invalid excel.';
	        }
	      }, function (error) {});
	    }
	  }, {
	    key: 'colName',
	    value: function colName(n) {
	      var ordA = 'a'.charCodeAt(0);
	      var ordZ = 'z'.charCodeAt(0);
	      var len = ordZ - ordA + 1;
	      var s = "";
	      while (n >= 0) {
	        s = String.fromCharCode(n % len + ordA) + s;
	        n = Math.floor(n / len) - 1;
	      }
	      return s.toUpperCase();
	    }
	  }, {
	    key: 'createEmptyArray',
	    value: function createEmptyArray(nth) {
	      var _array = [];
	      var i = 0;
	      for (i = 0; i < nth; i++) {
	        _array.push(this.colName(i));
	      }
	      this.excelColumns = _array;
	    }
	  }, {
	    key: 'guessColumnField',
	    value: function guessColumnField() {
	      var self = this;
	      var match = void 0;
	      var idx = void 0;
	
	      angular.forEach(this.data.excelSelectedTabData.rows[1], function (col, k) {
	        match = _lodash2.default.find(self.fieldOptions, function (o) {
	          return o.name.toLowerCase() === col.v.toLowerCase();
	        });
	        if (match) {
	          idx = _lodash2.default.findKey(self.excelColumns, function (o) {
	            return o === k;
	          });
	          if (idx) {
	            self.form.mappedFields[idx] = match.value;
	          }
	        } else {
	          match = _lodash2.default.find(self.fieldOptions, function (o) {
	            if (o.alias && o.alias.length) {
	              return o.alias.indexOf(col.v) !== -1;
	            }
	            return false;
	          });
	          if (match) {
	            idx = _lodash2.default.findKey(self.excelColumns, function (o) {
	              return o === k;
	            });
	            if (idx) {
	              self.form.mappedFields[idx] = match.value;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'selectTab',
	    value: function selectTab(idx) {
	      var self = this;
	      this.data.excelSelectedTabData = null;
	      this.invalidTabMsg = false;
	      this.$timeout(function () {
	        var i = 0;
	        var o = void 0;
	        for (o in self.data.excel.sheets) {
	          if (i === idx) {
	            self.data.excelSelectedTabData = self.data.excel.sheets[o];
	            self.createEmptyArray(self.data.excelSelectedTabData.overallMaxColumnCount);
	            break;
	          } else {
	            i++;
	          }
	        }
	        self.data.excelSelectedTabIdx = idx;
	      });
	    }
	  }, {
	    key: 'rendered',
	    value: function rendered() {
	      this.guessColumnField();
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        if (this.data.excel) {
	          var self = this;
	          this.isImporting = true;
	          var payload = {
	            filename: self.data.excelFileOnServer,
	            tabIdx: self.data.excelSelectedTabIdx,
	            mappedFields: this.form.mappedFields,
	            excelColumns: self.excelColumns
	          };
	          console.log(payload);
	
	          this.$http.post('/api/types/companies/accountingUnits/import', payload).then(function (response) {
	            self.$timeout(function () {
	              self.$uibModalInstance.close();
	            }, 5000);
	          }, function (error) {});
	        }
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return AccountingUnitsUploadController;
	}();
	
	exports.default = AccountingUnitsUploadController;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AccountingUnitFormController = function () {
	  /*@ngInject*/
	  AccountingUnitFormController.$inject = ['$http', '$q', '$uibModalInstance', 'facility'];
	  function AccountingUnitFormController($http, $q, $uibModalInstance, facility) {
	    _classCallCheck(this, AccountingUnitFormController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$uibModalInstance = $uibModalInstance;
	
	    this.facility = facility;
	
	    this.isAdd = true;
	    this.form = {};
	    this.submitted = false;
	    this.isSaving = false;
	    this.errors;
	  }
	
	  _createClass(AccountingUnitFormController, [{
	    key: 'getData',
	    value: function getData(id) {
	      var self = this;
	      this.$http.get('/api/types/companies/' + id).then(function (response) {
	        self.result = response.data;
	      }, function (err) {});
	    }
	  }, {
	    key: 'update',
	    value: function update(form, id, payload) {
	      var self = this;
	      this.$http.put('/api/types/companies/' + id, payload).then(function (response) {
	        self.$uibModalInstance.close();
	      }, function (err) {
	        self.isSaving = false;
	
	        self.errors = {};
	        angular.forEach(err.data.errors, function (error, field) {
	          form[field].$setValidity('mongoose', false);
	          self.errors[field] = error.message;
	        });
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(form, payload) {
	      var self = this;
	      this.$http.post('/api/types/companies', payload).then(function (response) {
	        self.$uibModalInstance.close();
	      }, function (err) {
	        self.isSaving = false;
	
	        self.errors = {};
	        angular.forEach(err.data.errors, function (error, field) {
	          form[field].$setValidity('mongoose', false);
	          self.errors[field] = error.message;
	        });
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        var self = this;
	        this.submitted = true;
	        this.isSaving = true;
	        var payload = this.form;
	        if (this.facility && this.facility._id) {
	          this.update(form, this.facility._id, payload);
	        } else {
	          self.create(form, payload);
	        }
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.facility && this.facility._id) {
	        this.isAdd = false;
	        this.getData(this.facility._id);
	      }
	    }
	  }]);
	
	  return AccountingUnitFormController;
	}();
	
	exports.default = AccountingUnitFormController;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(59);
	var autocomplete = __webpack_require__(63);
	
	var LocationCodesController = function () {
	  /*@ngInject*/
	  LocationCodesController.$inject = ['$rootScope', '$scope', '$http', '$q', '$state', '$stateParams', '$uibModal', 'Modal'];
	  function LocationCodesController($rootScope, $scope, $http, $q, $state, $stateParams, $uibModal, Modal) {
	    _classCallCheck(this, LocationCodesController);
	
	    this.$scope = $scope;
	    this.$http = $http;
	    this.$q = $q;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$uibModal = $uibModal;
	    this.Modal = Modal;
	
	    $rootScope.currentAdminPageTitle = 'Location Codes';
	    this.route = 'admin.locationCodes';
	
	    this.tableMsg = '';
	    this.form = {};
	    this.systemOptions = [];
	    this.result = {};
	    this.pageSizeOptions = [10, 20, 30, 40, 50];
	    this.sortByOptions = {
	      companyName: 'Company Name',
	      gl: 'GL',
	      createdDate: 'Uploaded Date',
	      modifiedDate: 'Re-Uploaded Date'
	    };
	    this.pagination = {
	      _paging: true,
	      _selector: 'All',
	      _pageSize: 10,
	      _pageNum: 1,
	      _sortBy: 'companyName asc'
	    };
	  }
	
	  _createClass(LocationCodesController, [{
	    key: 'getSystems',
	    value: function getSystems() {
	      var deferred = this.$q.defer();
	      var self = this;
	      var params = {
	        _selector: 'name',
	        _pageSize: 'All'
	      };
	      this.$http.get('/api/types/systems', { params: params }).then(function (response) {
	        self.systemOptions = response.data;
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'setDefaultSearchForm',
	    value: function setDefaultSearchForm() {
	      var _pageNum = 1;
	      if (this.$stateParams._pageNum) {
	        _pageNum = parseInt(this.$stateParams._pageNum);
	      }
	      this.pageNumVal = _pageNum;
	      var _pageSize = 100;
	      if (this.$stateParams._pageSize) {
	        _pageSize = parseInt(this.$stateParams._pageSize);
	      }
	      this.pageSizeVal = _pageSize;
	    }
	  }, {
	    key: 'buildQuery',
	    value: function buildQuery() {
	      return angular.extend(angular.copy(this.form), this.pagination);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var self = this;
	      this.$http.get('/api/types/companies/locationCodes', {
	        params: this.buildQuery()
	      }).then(function (response) {
	        if (response.data.total === 0) {
	          self.tableMsg = 'No record found.';
	        }
	        self.result = response.data;
	      }, function (err) {});
	    }
	  }, {
	    key: 'search',
	    value: function search(form) {
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'clearSearch',
	    value: function clearSearch() {
	      this.form = {};
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'openUploadModal',
	    value: function openUploadModal() {
	      var self = this;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        ariaLabelledBy: 'modal-title',
	        ariaDescribedBy: 'modal-body',
	        template: __webpack_require__(81),
	        controller: 'LocationCodesUploadController',
	        controllerAs: '$ctrl',
	        size: 'lg'
	      });
	      modalInstance.result.then(function () {
	        self.getData();
	      }, function () {});
	    }
	  }, {
	    key: 'openCompanyForm',
	    value: function openCompanyForm(item) {
	      var self = this;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        ariaLabelledBy: 'modal-title',
	        ariaDescribedBy: 'modal-body',
	        template: __webpack_require__(82),
	        controller: 'LocationCodeFormController',
	        controllerAs: '$ctrl',
	        size: 'md',
	        resolve: {
	          facility: function facility() {
	            return item;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        self.getData();
	      }, function () {});
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(item) {
	      var self = this;
	      this.Modal.confirm.delete(function () {
	        self.$http.delete('/api/types/companies/locationCodes/' + item._id).then(function (response) {
	          self.getData();
	        }, function (err) {});
	      })(item.facilityName + ' / ' + item.deptName + ' / ' + item.costCenter + ' company');
	    }
	  }, {
	    key: 'rowNumb',
	    value: function rowNumb(idx) {
	      return idx + 1 + (this.result.pageNum !== 1 ? this.result.pageSize * this.result.pageNum - this.result.pageSize : 0);
	    }
	  }, {
	    key: 'updateSortBy',
	    value: function updateSortBy(sortBy) {
	      this.pagination._sortBy = sortBy;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'updatePageSize',
	    value: function updatePageSize(pageSize) {
	      this.pagination._pageSize = pageSize;
	      this.pagination._pageNum = 1;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'gotoPage',
	    value: function gotoPage(pageNum) {
	      this.pagination._pageNum = pageNum;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var self = this;
	      this.getSystems().then(function () {
	        if (window.system) {
	          self.form.system = window.system;
	        }
	        self.getData();
	      });
	    }
	  }]);
	
	  return LocationCodesController;
	}();
	
	exports.default = LocationCodesController;

/***/ }),
/* 81 */
76,
/* 82 */
72,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _async = __webpack_require__(55);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocationCodesUploadController = function () {
	  /*@ngInject*/
	  LocationCodesUploadController.$inject = ['$http', '$q', '$cookies', '$timeout', '$uibModalInstance'];
	  function LocationCodesUploadController($http, $q, $cookies, $timeout, $uibModalInstance) {
	    _classCallCheck(this, LocationCodesUploadController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$cookies = $cookies;
	    this.$timeout = $timeout;
	    this.$uibModalInstance = $uibModalInstance;
	
	    this.fileInputField;
	    this.isUploading = false;
	
	    this.data = {
	      selectedFiles: [],
	      excelFileOnServer: '',
	      excel: null,
	      excelSelectedTabs: [],
	      excelSelectedTabIdx: 0,
	      excelSelectedTabData: null
	    };
	    this.excelColumns = [];
	
	    this.targetSheetName = 'Location Code';
	    this.fieldOptions = [{ name: 'HRLocation', value: 'hrLocation', alias: [] }, { name: 'Description', value: 'description' }, { name: 'MVS or BSC?', value: 'mvsOrBsc', alias: [] }];
	
	    this.form = {
	      mappedFields: {}
	    };
	    this.invalidTabMsg = false;
	    this.isImporting = false;
	    this.importProgress = {
	      current: 0,
	      total: 0
	    };
	  }
	
	  _createClass(LocationCodesUploadController, [{
	    key: 'sizeOf',
	    value: function sizeOf(obj) {
	      return _lodash2.default.size(obj);
	    }
	  }, {
	    key: 'uploadFile',
	    value: function uploadFile() {
	      var self = this;
	      this.isUploading = true;
	      this.$http({
	        method: 'POST',
	        url: '/api/types/companies/locationCodes/upload?access_token=' + this.$cookies.get('token'),
	        headers: {
	          'Content-Type': undefined
	        },
	        data: {
	          file: this.fileInputField
	        },
	        transformRequest: function transformRequest(data, headersGetter) {
	          var formData = new FormData();
	          angular.forEach(data, function (value, key) {
	            formData.append(key, value);
	          });
	          return formData;
	        }
	      }).then(function (response) {
	        self.data.excelFileOnServer = response.data;
	        self.parseFile(response.data);
	        self.isUploading = false;
	      }, function (error) {
	        self.isUploading = false;
	      });
	    }
	  }, {
	    key: 'parseFile',
	    value: function parseFile(filename) {
	      var self = this;
	      this.$http.post('/api/types/companies/locationCodes/parse', {
	        filename: filename
	      }).then(function (response) {
	        self.data.excel = response.data;
	        if (_lodash2.default.size(self.data.excel.sheets)) {
	
	          var matchSheetIdx = void 0;
	
	          angular.forEach(self.data.excel.sheets, function (sheet, idx) {
	            self.data.excelSelectedTabs.push(sheet.name);
	            if (sheet.name === self.targetSheetName) {
	              matchSheetIdx = idx;
	            }
	          });
	          if (angular.isDefined(matchSheetIdx)) {
	            self.data.excelSelectedTabIdx = matchSheetIdx;
	          }
	          self.selectTab(self.data.excelSelectedTabIdx);
	        } else {
	          self.data.resultMsg = 'Invalid excel.';
	        }
	      }, function (error) {});
	    }
	  }, {
	    key: 'colName',
	    value: function colName(n) {
	      var ordA = 'a'.charCodeAt(0);
	      var ordZ = 'z'.charCodeAt(0);
	      var len = ordZ - ordA + 1;
	      var s = "";
	      while (n >= 0) {
	        s = String.fromCharCode(n % len + ordA) + s;
	        n = Math.floor(n / len) - 1;
	      }
	      return s.toUpperCase();
	    }
	  }, {
	    key: 'createEmptyArray',
	    value: function createEmptyArray(nth) {
	      var _array = [];
	      var i = 0;
	      for (i = 0; i < nth; i++) {
	        _array.push(this.colName(i));
	      }
	      this.excelColumns = _array;
	    }
	  }, {
	    key: 'guessColumnField',
	    value: function guessColumnField() {
	      var self = this;
	      var match = void 0;
	      var idx = void 0;
	
	      angular.forEach(this.data.excelSelectedTabData.rows[1], function (col, k) {
	        match = _lodash2.default.find(self.fieldOptions, function (o) {
	          return o.name.toLowerCase() === col.v.toLowerCase();
	        });
	        if (match) {
	          idx = _lodash2.default.findKey(self.excelColumns, function (o) {
	            return o === k;
	          });
	          if (idx) {
	            self.form.mappedFields[idx] = match.value;
	          }
	        } else {
	          match = _lodash2.default.find(self.fieldOptions, function (o) {
	            if (o.alias && o.alias.length) {
	              return o.alias.indexOf(col.v) !== -1;
	            }
	            return false;
	          });
	          if (match) {
	            idx = _lodash2.default.findKey(self.excelColumns, function (o) {
	              return o === k;
	            });
	            if (idx) {
	              self.form.mappedFields[idx] = match.value;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'selectTab',
	    value: function selectTab(idx) {
	      var self = this;
	      this.data.excelSelectedTabData = null;
	      this.invalidTabMsg = false;
	      this.$timeout(function () {
	        var i = 0;
	        var o = void 0;
	        for (o in self.data.excel.sheets) {
	          if (i === idx) {
	            self.data.excelSelectedTabData = self.data.excel.sheets[o];
	            self.createEmptyArray(self.data.excelSelectedTabData.overallMaxColumnCount);
	            break;
	          } else {
	            i++;
	          }
	        }
	        self.data.excelSelectedTabIdx = idx;
	      });
	    }
	  }, {
	    key: 'rendered',
	    value: function rendered() {
	      this.guessColumnField();
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        if (this.data.excel) {
	          var self = this;
	          this.isImporting = true;
	          var payload = {
	            filename: self.data.excelFileOnServer,
	            tabIdx: self.data.excelSelectedTabIdx,
	            mappedFields: this.form.mappedFields,
	            excelColumns: self.excelColumns
	          };
	          console.log(payload);
	
	          this.$http.post('/api/types/companies/locationCodes/import', payload).then(function (response) {
	            self.$timeout(function () {
	              self.$uibModalInstance.close();
	            }, 5000);
	          }, function (error) {});
	        }
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return LocationCodesUploadController;
	}();
	
	exports.default = LocationCodesUploadController;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocationCodeFormController = function () {
	  /*@ngInject*/
	  LocationCodeFormController.$inject = ['$http', '$q', '$uibModalInstance', 'facility'];
	  function LocationCodeFormController($http, $q, $uibModalInstance, facility) {
	    _classCallCheck(this, LocationCodeFormController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$uibModalInstance = $uibModalInstance;
	
	    this.facility = facility;
	
	    this.isAdd = true;
	    this.form = {};
	    this.submitted = false;
	    this.isSaving = false;
	    this.errors;
	  }
	
	  _createClass(LocationCodeFormController, [{
	    key: 'getData',
	    value: function getData(id) {
	      var self = this;
	      this.$http.get('/api/types/companies/' + id).then(function (response) {
	        self.result = response.data;
	      }, function (err) {});
	    }
	  }, {
	    key: 'update',
	    value: function update(form, id, payload) {
	      var self = this;
	      this.$http.put('/api/types/companies/' + id, payload).then(function (response) {
	        self.$uibModalInstance.close();
	      }, function (err) {
	        self.isSaving = false;
	
	        self.errors = {};
	        angular.forEach(err.data.errors, function (error, field) {
	          form[field].$setValidity('mongoose', false);
	          self.errors[field] = error.message;
	        });
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(form, payload) {
	      var self = this;
	      this.$http.post('/api/types/companies', payload).then(function (response) {
	        self.$uibModalInstance.close();
	      }, function (err) {
	        self.isSaving = false;
	
	        self.errors = {};
	        angular.forEach(err.data.errors, function (error, field) {
	          form[field].$setValidity('mongoose', false);
	          self.errors[field] = error.message;
	        });
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        var self = this;
	        this.submitted = true;
	        this.isSaving = true;
	        var payload = this.form;
	        if (this.facility && this.facility._id) {
	          this.update(form, this.facility._id, payload);
	        } else {
	          self.create(form, payload);
	        }
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.facility && this.facility._id) {
	        this.isAdd = false;
	        this.getData(this.facility._id);
	      }
	    }
	  }]);
	
	  return LocationCodeFormController;
	}();
	
	exports.default = LocationCodeFormController;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(59);
	var autocomplete = __webpack_require__(63);
	
	var CompanyAddressesController = function () {
	  /*@ngInject*/
	  CompanyAddressesController.$inject = ['$rootScope', '$scope', '$http', '$q', '$state', '$stateParams', '$uibModal', 'Modal'];
	  function CompanyAddressesController($rootScope, $scope, $http, $q, $state, $stateParams, $uibModal, Modal) {
	    _classCallCheck(this, CompanyAddressesController);
	
	    this.$scope = $scope;
	    this.$http = $http;
	    this.$q = $q;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$uibModal = $uibModal;
	    this.Modal = Modal;
	
	    $rootScope.currentAdminPageTitle = 'Addresses';
	    this.route = 'admin.addresses';
	
	    this.tableMsg = '';
	    this.form = {};
	    this.systemOptions = [];
	    this.result = {};
	    this.pageSizeOptions = [10, 20, 30, 40, 50];
	    this.sortByOptions = {
	      companyName: 'Company Name',
	      gl: 'GL',
	      createdDate: 'Uploaded Date',
	      modifiedDate: 'Re-Uploaded Date'
	    };
	    this.pagination = {
	      _paging: true,
	      _selector: 'All',
	      _pageSize: 10,
	      _pageNum: 1,
	      _sortBy: 'companyName asc'
	    };
	  }
	
	  _createClass(CompanyAddressesController, [{
	    key: 'setDefaultSearchForm',
	    value: function setDefaultSearchForm() {
	      var _pageNum = 1;
	      if (this.$stateParams._pageNum) {
	        _pageNum = parseInt(this.$stateParams._pageNum);
	      }
	      this.pageNumVal = _pageNum;
	      var _pageSize = 100;
	      if (this.$stateParams._pageSize) {
	        _pageSize = parseInt(this.$stateParams._pageSize);
	      }
	      this.pageSizeVal = _pageSize;
	    }
	  }, {
	    key: 'buildQuery',
	    value: function buildQuery() {
	      return angular.extend(angular.copy(this.form), this.pagination);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var self = this;
	      this.$http.get('/api/types/companies/addresses', {
	        params: this.buildQuery()
	      }).then(function (response) {
	        if (response.data.total === 0) {
	          self.tableMsg = 'No record found.';
	        }
	        self.result = response.data;
	      }, function (err) {});
	    }
	  }, {
	    key: 'search',
	    value: function search(form) {
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'clearSearch',
	    value: function clearSearch() {
	      this.form = {};
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'openUploadModal',
	    value: function openUploadModal() {
	      var self = this;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        ariaLabelledBy: 'modal-title',
	        ariaDescribedBy: 'modal-body',
	        template: __webpack_require__(86),
	        controller: 'CompanyAddressesUploadController',
	        controllerAs: '$ctrl',
	        size: 'lg'
	      });
	      modalInstance.result.then(function () {
	        self.getData();
	      }, function () {});
	    }
	  }, {
	    key: 'openForm',
	    value: function openForm(item) {
	      var self = this;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        ariaLabelledBy: 'modal-title',
	        ariaDescribedBy: 'modal-body',
	        template: __webpack_require__(87),
	        controller: 'CompanyAddressFormController',
	        controllerAs: '$ctrl',
	        size: 'md',
	        resolve: {
	          facility: function facility() {
	            return item;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        self.getData();
	      }, function () {});
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(item) {
	      var self = this;
	      this.Modal.confirm.delete(function () {
	        self.$http.delete('/api/types/companies/addresses/' + item._id).then(function (response) {
	          self.getData();
	        }, function (err) {});
	      })(item.facilityName + ' / ' + item.deptName + ' / ' + item.costCenter + ' company');
	    }
	  }, {
	    key: 'rowNumb',
	    value: function rowNumb(idx) {
	      return idx + 1 + (this.result.pageNum !== 1 ? this.result.pageSize * this.result.pageNum - this.result.pageSize : 0);
	    }
	  }, {
	    key: 'updateSortBy',
	    value: function updateSortBy(sortBy) {
	      this.pagination._sortBy = sortBy;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'updatePageSize',
	    value: function updatePageSize(pageSize) {
	      this.pagination._pageSize = pageSize;
	      this.pagination._pageNum = 1;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'gotoPage',
	    value: function gotoPage(pageNum) {
	      this.pagination._pageNum = pageNum;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      this.getData();
	    }
	  }]);
	
	  return CompanyAddressesController;
	}();
	
	exports.default = CompanyAddressesController;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"uploader-modal facility\">\n  <form class=\"form\" name=\"form\" ng-submit=\"$ctrl.submitForm(form)\" novalidate>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\" id=\"modal-title\">Company Address Uploader</h4>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div class=\"alert alert-warning\">This uploader will only process data in sheet name \"{{$ctrl.targetSheetName}}\"</div>\n      <div class=\"uploader-section\" ng-if=\"!$ctrl.sizeOf($ctrl.data.excel)\">\n        <label>Select Your Excel File</label>\n        <div class=form-group\">\n          <input type=\"file\" file-input=\"$ctrl.fileInputField\" class=\"form-control input-sm\" />\n        </div>\n      </div>\n      <div class=\"parsed-section\" ng-if=\"$ctrl.sizeOf($ctrl.data.excel)\">\n        <label>Excel File Preview</label>\n        <p>Please review the excel data below before importing.</p>\n        <div class=\"tabs-container\" ng-if=\"$ctrl.data.excelSelectedTabs.length > 1\">\n          <ul class=\"nav nav-tabs\">\n            <li role=\"presentation\" ng-repeat=\"tab in $ctrl.data.excelSelectedTabs track by $index\" ng-class=\"{'active': $index===$ctrl.data.excelSelectedTabIdx}\">\n              <a ng-click=\"$ctrl.selectTab($index)\">\n                {{tab}}\n              </a>\n            </li>\n          </ul>\n        </div>\n        <div class=\"alert alert-danger\" ng-if=\"$ctrl.invalidTabMsg\">\n          <i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> This tab does not match the required fields needed for import.\n        </div>\n        <div class=\"table-responsive\">\n          <table class=\"table table-bordered table-striped table-hover table-inputs\">\n            <tbody>\n              <tr ng-if=\"$ctrl.data.excelSelectedTabData !== null\">\n                <td>&nbsp;</td>\n                <td class=\"text-center field-options\" ng-repeat=\"(a, b) in $ctrl.excelColumns\" repeat-end-watch=\"$ctrl.rendered()\">\n                  <select class=\"form-control input-sm\" ng-options=\"option.value as option.name for option in $ctrl.fieldOptions\" ng-model=\"$ctrl.form.mappedFields[$index]\">\n                    <option value=\"\">Select a Field</option>\n                  </select>\n                </td>\n              </tr>\n              <tr ng-if=\"$ctrl.data.excelSelectedTabData !== null\">\n                <td>&nbsp;</td>\n                <td class=\"text-center\" ng-repeat=\"(a, b) in $ctrl.excelColumns\">\n                  {{b}}\n                </td>\n              </tr>\n              <tr ng-repeat=\"(k, v) in $ctrl.data.excelSelectedTabData.rows\" ng-class=\"{'success': v.success, 'danger': v.failed}\">\n                <td width=\"15\">{{$index + 1}}</td>\n                <td ng-repeat=\"(a, b) in $ctrl.excelColumns\">\n                  <span class=\"text-bg\" ng-if=\"v[b].t === 'n' && b !== 'C'\">{{v[b].v}}</span>\n                  <span class=\"text-bg\" ng-if=\"v[b].t === 's' || b === 'C'\">{{v[b].v}}</span>\n                </td>\n              </tr>\n              <tr ng-if=\"$ctrl.data.excelSelectedTabData === null\">\n                <td colspan=\"{{$ctrl.fieldOptions.length}}\"><em>Loading....</em></td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer clearfix\">\n      <div class=\"alert alert-info pull-left\" ng-if=\"$ctrl.sizeOf($ctrl.data.excel) && !$ctrl.invalidTabMsg && $ctrl.isImporting\">\n        Please allow 5 to 10 minutes for system to save new records.\n      </div>\n      <button class=\"btn btn-success btn-sm\" type=\"button\" ng-click=\"$ctrl.uploadFile()\" ng-if=\"!$ctrl.sizeOf($ctrl.data.excel)\" ng-disabled=\"$ctrl.isUploading || !$ctrl.fileInputField\">Upload</button>\n      <button class=\"btn btn-primary btn-sm\" type=\"submit\" ng-if=\"$ctrl.sizeOf($ctrl.data.excel) && !$ctrl.invalidTabMsg\" ng-disabled=\"$ctrl.isImporting\">Save</button>\n      <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"uploader-modal user\">\n  <form class=\"form\" name=\"form\" ng-submit=\"$ctrl.submitForm(form)\" novalidate>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\" id=\"modal-title\"><i class=\"fa\" ng-class=\"{'fa-plus': $ctrl.isAdd, 'fa-pencil-square-o': !$ctrl.isAdd}\" aria-hidden=\"true\"></i> {{!$ctrl.isAdd ? 'Edit' : 'Add'}} Company Address</h4>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div class=\"form-group\" ng-class=\"{'has-error': form.hrOrganization.$invalid && $ctrl.submitted}\">\n        <label for=\"hrOrganization\" class=\"required\">HR Organization</label>\n        <input type=\"text\" id=\"hrOrganization\" name=\"hrOrganization\" class=\"form-control input-sm\" placeholder=\"Facility Name\" ng-model=\"$ctrl.form.hrOrganization\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"hrLocation\" class=\"required\">HR Location</label>\n        <input type=\"text\" id=\"hrLocation\" name=\"hrLocation\" class=\"form-control input-sm\" placeholder=\"Dept Name\" ng-model=\"$ctrl.form.hrLocation\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"costCenter\" class=\"required\">Description</label>\n        <input type=\"text\" id=\"costCenter\" name=\"costCenter\" class=\"form-control input-sm\" placeholder=\"Cost Center\" ng-model=\"$ctrl.form.costCenter\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"address\" class=\"required\">Municipality</label>\n        <input type=\"text\" id=\"address\" name=\"address\" class=\"form-control input-sm\" placeholder=\"Address\" ng-model=\"$ctrl.form.address\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"city\" class=\"required\">State / Province</label>\n        <input type=\"text\" id=\"city\" name=\"city\" class=\"form-control input-sm\" placeholder=\"City\" ng-model=\"$ctrl.form.city\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"state\" class=\"required\">Country</label>\n        <input type=\"text\" id=\"state\" name=\"state\" class=\"form-control input-sm\" placeholder=\"State\" ng-model=\"$ctrl.form.state\" required />\n      </div>\n      <div class=\"form-group\" ng-class=\"{'has-error': form.email.$invalid && $ctrl.submitted}\">\n        <label for=\"zip\" class=\"required\">Display Address</label>\n        <input type=\"text\" id=\"zip\" name=\"zip\" class=\"form-control input-sm\" placeholder=\"Zip\" ng-model=\"$ctrl.form.zip\" required />\n      </div>\n    </div>\n    <div class=\"modal-footer clearfix\">\n      <div class=\"alert alert-info pull-left\" ng-if=\"$ctrl.isSaving\">\n        Saving....\n      </div>\n      <div class=\"alert alert-danger pull-left\" ng-if=\"$ctrl.errors\">\n        Form has error(s).\n      </div>\n      <button class=\"btn btn-primary btn-sm\" type=\"submit\" ng-disabled=\"!form.$dirty || form.$invalid || $ctrl.isSaving\">Save</button>\n      <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _async = __webpack_require__(55);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CompanyAddressesUploadController = function () {
	  /*@ngInject*/
	  CompanyAddressesUploadController.$inject = ['$http', '$q', '$cookies', '$timeout', '$uibModalInstance'];
	  function CompanyAddressesUploadController($http, $q, $cookies, $timeout, $uibModalInstance) {
	    _classCallCheck(this, CompanyAddressesUploadController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$cookies = $cookies;
	    this.$timeout = $timeout;
	    this.$uibModalInstance = $uibModalInstance;
	
	    this.fileInputField;
	    this.isUploading = false;
	
	    this.data = {
	      selectedFiles: [],
	      excelFileOnServer: '',
	      excel: null,
	      excelSelectedTabs: [],
	      excelSelectedTabIdx: 0,
	      excelSelectedTabData: null
	    };
	    this.excelColumns = [];
	
	    this.targetSheetName = 'Addresses';
	    this.fieldOptions = [{ name: 'HR Organization', value: 'hrOrganization', alias: ['HROrganization'] }, { name: 'HR Location', value: 'hrLocation', alias: ['HRLocation'] }, { name: 'Description', value: 'description', alias: [] }, { name: 'Municipality', value: 'municipality', alias: ['Address.Municipality'] }, { name: 'State/Province', value: 'stateProvince', alias: ['Address.StateProvince'] }, { name: 'Country', value: 'country', alias: ['Address.Country'] }, { name: 'DisplayAddress', value: 'displayAddress' }];
	
	    this.form = {
	      mappedFields: {}
	    };
	    this.invalidTabMsg = false;
	    this.isImporting = false;
	    this.importProgress = {
	      current: 0,
	      total: 0
	    };
	  }
	
	  _createClass(CompanyAddressesUploadController, [{
	    key: 'sizeOf',
	    value: function sizeOf(obj) {
	      return _lodash2.default.size(obj);
	    }
	  }, {
	    key: 'uploadFile',
	    value: function uploadFile() {
	      var self = this;
	      this.isUploading = true;
	      this.$http({
	        method: 'POST',
	        url: '/api/types/companies/addresses/upload?access_token=' + this.$cookies.get('token'),
	        headers: {
	          'Content-Type': undefined
	        },
	        data: {
	          file: this.fileInputField
	        },
	        transformRequest: function transformRequest(data, headersGetter) {
	          var formData = new FormData();
	          angular.forEach(data, function (value, key) {
	            formData.append(key, value);
	          });
	          return formData;
	        }
	      }).then(function (response) {
	        self.data.excelFileOnServer = response.data;
	        self.parseFile(response.data);
	        self.isUploading = false;
	      }, function (error) {
	        self.isUploading = false;
	      });
	    }
	  }, {
	    key: 'parseFile',
	    value: function parseFile(filename) {
	      var self = this;
	      this.$http.post('/api/types/companies/addresses/parse', {
	        filename: filename
	      }).then(function (response) {
	        self.data.excel = response.data;
	        if (_lodash2.default.size(self.data.excel.sheets)) {
	
	          var matchSheetIdx = void 0;
	
	          angular.forEach(self.data.excel.sheets, function (sheet, idx) {
	            self.data.excelSelectedTabs.push(sheet.name);
	            if (sheet.name === self.targetSheetName) {
	              matchSheetIdx = idx;
	            }
	          });
	          if (angular.isDefined(matchSheetIdx)) {
	            self.data.excelSelectedTabIdx = matchSheetIdx;
	          }
	          self.selectTab(self.data.excelSelectedTabIdx);
	        } else {
	          self.data.resultMsg = 'Invalid excel.';
	        }
	      }, function (error) {});
	    }
	  }, {
	    key: 'colName',
	    value: function colName(n) {
	      var ordA = 'a'.charCodeAt(0);
	      var ordZ = 'z'.charCodeAt(0);
	      var len = ordZ - ordA + 1;
	      var s = "";
	      while (n >= 0) {
	        s = String.fromCharCode(n % len + ordA) + s;
	        n = Math.floor(n / len) - 1;
	      }
	      return s.toUpperCase();
	    }
	  }, {
	    key: 'createEmptyArray',
	    value: function createEmptyArray(nth) {
	      var _array = [];
	      var i = 0;
	      for (i = 0; i < nth; i++) {
	        _array.push(this.colName(i));
	      }
	      this.excelColumns = _array;
	    }
	  }, {
	    key: 'guessColumnField',
	    value: function guessColumnField() {
	      var self = this;
	      var match = void 0;
	      var idx = void 0;
	
	      angular.forEach(this.data.excelSelectedTabData.rows[1], function (col, k) {
	        match = _lodash2.default.find(self.fieldOptions, function (o) {
	          return o.name.toLowerCase() === col.v.toLowerCase();
	        });
	        if (match) {
	          idx = _lodash2.default.findKey(self.excelColumns, function (o) {
	            return o === k;
	          });
	          if (idx) {
	            self.form.mappedFields[idx] = match.value;
	          }
	        } else {
	          match = _lodash2.default.find(self.fieldOptions, function (o) {
	            if (o.alias && o.alias.length) {
	              return o.alias.indexOf(col.v) !== -1;
	            }
	            return false;
	          });
	          if (match) {
	            idx = _lodash2.default.findKey(self.excelColumns, function (o) {
	              return o === k;
	            });
	            if (idx) {
	              self.form.mappedFields[idx] = match.value;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'selectTab',
	    value: function selectTab(idx) {
	      var self = this;
	      this.data.excelSelectedTabData = null;
	      this.invalidTabMsg = false;
	      this.$timeout(function () {
	        var i = 0;
	        var o = void 0;
	        for (o in self.data.excel.sheets) {
	          if (i === idx) {
	            self.data.excelSelectedTabData = self.data.excel.sheets[o];
	            self.createEmptyArray(self.data.excelSelectedTabData.overallMaxColumnCount);
	            break;
	          } else {
	            i++;
	          }
	        }
	        self.data.excelSelectedTabIdx = idx;
	      });
	    }
	  }, {
	    key: 'rendered',
	    value: function rendered() {
	      this.guessColumnField();
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        if (this.data.excel) {
	          var self = this;
	          this.isImporting = true;
	          var payload = {
	            filename: self.data.excelFileOnServer,
	            tabIdx: self.data.excelSelectedTabIdx,
	            mappedFields: this.form.mappedFields,
	            excelColumns: self.excelColumns
	          };
	          console.log(payload);
	
	          this.$http.post('/api/types/companies/addresses/import', payload).then(function (response) {
	            self.$timeout(function () {
	              self.$uibModalInstance.close();
	            }, 5000);
	          }, function (error) {});
	        }
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return CompanyAddressesUploadController;
	}();
	
	exports.default = CompanyAddressesUploadController;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CompanyAddressesFormController = function () {
	  /*@ngInject*/
	  CompanyAddressesFormController.$inject = ['$http', '$q', '$uibModalInstance', 'facility'];
	  function CompanyAddressesFormController($http, $q, $uibModalInstance, facility) {
	    _classCallCheck(this, CompanyAddressesFormController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$uibModalInstance = $uibModalInstance;
	
	    this.facility = facility;
	
	    this.isAdd = true;
	    this.form = {};
	    this.submitted = false;
	    this.isSaving = false;
	    this.errors;
	  }
	
	  _createClass(CompanyAddressesFormController, [{
	    key: 'getData',
	    value: function getData(id) {
	      var self = this;
	      this.$http.get('/api/types/companies/' + id).then(function (response) {
	        self.result = response.data;
	      }, function (err) {});
	    }
	  }, {
	    key: 'update',
	    value: function update(form, id, payload) {
	      var self = this;
	      this.$http.put('/api/types/companies/' + id, payload).then(function (response) {
	        self.$uibModalInstance.close();
	      }, function (err) {
	        self.isSaving = false;
	
	        self.errors = {};
	        angular.forEach(err.data.errors, function (error, field) {
	          form[field].$setValidity('mongoose', false);
	          self.errors[field] = error.message;
	        });
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(form, payload) {
	      var self = this;
	      this.$http.post('/api/types/companies', payload).then(function (response) {
	        self.$uibModalInstance.close();
	      }, function (err) {
	        self.isSaving = false;
	
	        self.errors = {};
	        angular.forEach(err.data.errors, function (error, field) {
	          form[field].$setValidity('mongoose', false);
	          self.errors[field] = error.message;
	        });
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        var self = this;
	        this.submitted = true;
	        this.isSaving = true;
	        var payload = this.form;
	        if (this.facility && this.facility._id) {
	          this.update(form, this.facility._id, payload);
	        } else {
	          self.create(form, payload);
	        }
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.facility && this.facility._id) {
	        this.isAdd = false;
	        this.getData(this.facility._id);
	      }
	    }
	  }]);
	
	  return CompanyAddressesFormController;
	}();
	
	exports.default = CompanyAddressesFormController;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobClassController = function () {
	  /*@ngInject*/
	  JobClassController.$inject = ['$rootScope', '$scope', '$http', '$q', '$state', '$stateParams', '$uibModal', 'Modal'];
	  function JobClassController($rootScope, $scope, $http, $q, $state, $stateParams, $uibModal, Modal) {
	    _classCallCheck(this, JobClassController);
	
	    this.$scope = $scope;
	    this.$http = $http;
	    this.$q = $q;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$uibModal = $uibModal;
	    this.Modal = Modal;
	
	    $rootScope.currentAdminPageTitle = 'Job Class';
	    this.route = 'admin.jobClass';
	
	    this.tableMsg = '';
	    this.form = {};
	    this.systemOptions = [];
	    this.result = {};
	    this.pageSizeOptions = [10, 20, 30, 40, 50];
	    this.sortByOptions = {
	      jobCode: 'Job Code',
	      jobClass: 'Job Class',
	      createdBy: 'Created By'
	    };
	    this.pagination = {
	      _paging: true,
	      _selector: 'All',
	      _pageSize: 10,
	      _pageNum: 1,
	      _sortBy: 'jobClass asc'
	    };
	  }
	
	  _createClass(JobClassController, [{
	    key: 'buildQuery',
	    value: function buildQuery() {
	      return angular.extend(angular.copy(this.form), this.pagination);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var self = this;
	      this.$http.get('/api/types/jobClasses', {
	        params: this.buildQuery()
	      }).then(function (response) {
	        if (response.data.total === 0) {
	          self.tableMsg = 'No record found.';
	        }
	        self.result = response.data;
	      }, function (err) {});
	    }
	  }, {
	    key: 'search',
	    value: function search(form) {
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'clearSearch',
	    value: function clearSearch() {
	      this.form = {};
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'openUploadModal',
	    value: function openUploadModal() {
	      var self = this;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        ariaLabelledBy: 'modal-title',
	        ariaDescribedBy: 'modal-body',
	        template: __webpack_require__(91),
	        controller: 'JobClassUploadController',
	        controllerAs: '$ctrl',
	        size: 'lg'
	      });
	      modalInstance.result.then(function () {
	        self.getData();
	      }, function () {});
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(item) {
	      var self = this;
	      this.Modal.confirm.delete(function () {
	        self.$http.delete('/api/types/jobClasses/' + item._id).then(function (response) {
	          self.getData();
	        }, function (err) {});
	      })(item.jobCode + ' / ' + item.jobClass + ' Job Class');
	    }
	  }, {
	    key: 'rowNumb',
	    value: function rowNumb(idx) {
	      return idx + 1 + (this.result.pageNum !== 1 ? this.result.pageSize * this.result.pageNum - this.result.pageSize : 0);
	    }
	  }, {
	    key: 'updateSortBy',
	    value: function updateSortBy(sortBy) {
	      this.pagination._sortBy = sortBy;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'updatePageSize',
	    value: function updatePageSize(pageSize) {
	      this.pagination._pageSize = pageSize;
	      this.pagination._pageNum = 1;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'gotoPage',
	    value: function gotoPage(pageNum) {
	      this.pagination._pageNum = pageNum;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      this.getData();
	    }
	  }]);
	
	  return JobClassController;
	}();
	
	exports.default = JobClassController;

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"uploader-modal job-class\">\n  <form class=\"form\" name=\"form\" ng-submit=\"$ctrl.submitForm(form)\" novalidate>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\" id=\"modal-title\">Job Class Uploader</h4>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div class=\"uploader-section\" ng-if=\"!$ctrl.sizeOf($ctrl.data.excel)\">\n        <label>Select Your Excel File</label>\n        <div class=form-group\">\n          <input type=\"file\" file-input=\"$ctrl.fileInputField\" class=\"form-control input-sm\" />\n        </div>\n      </div>\n      <div class=\"parsed-section\" ng-if=\"$ctrl.sizeOf($ctrl.data.excel)\">\n        <label>Excel File Preview</label>\n        <p>Please review the excel data below before importing.</p>\n        <div class=\"tabs-container\" ng-if=\"$ctrl.data.excelSelectedTabs.length > 1\">\n          <ul class=\"nav nav-tabs\">\n            <li role=\"presentation\" ng-repeat=\"tab in $ctrl.data.excelSelectedTabs track by $index\" ng-class=\"{'active': $index===$ctrl.data.excelSelectedTabIdx}\"><a ng-click=\"$ctrl.selectTab($index)\">{{tab}}</a></li>\n          </ul>\n        </div>\n        <div class=\"alert alert-danger\" ng-if=\"$ctrl.invalidTabMsg\">\n          <i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> This tab does not match the required fields needed for job class import.\n        </div>\n        <div class=\"table-responsive\">\n          <table class=\"table table-bordered table-striped table-hover table-inputs\">\n            <tbody>\n              <tr ng-if=\"$ctrl.data.excelSelectedTabData !== null\">\n                <td>&nbsp;</td>\n                <td class=\"text-center field-options\" ng-repeat=\"(a, b) in $ctrl.excelColumns\" repeat-end-watch=\"$ctrl.rendered()\">\n                  <select class=\"form-control input-sm\" ng-options=\"option.value as option.name for option in $ctrl.fieldOptions\" ng-model=\"$ctrl.form.mappedFields[$index]\">\n                    <option value=\"\">Select a Field</option>\n                  </select>\n                </td>\n              </tr>\n              <tr ng-if=\"$ctrl.data.excelSelectedTabData !== null\">\n                <td>&nbsp;</td>\n                <td class=\"text-center\" ng-repeat=\"(a, b) in $ctrl.excelColumns\">\n                  {{b}}\n                </td>\n              </tr>\n              <tr ng-repeat=\"(k, v) in $ctrl.data.excelSelectedTabData.rows\" ng-class=\"{'success': v.success, 'danger': v.failed}\">\n                <td width=\"15\">{{$index + 1}}</td>\n                <td ng-repeat=\"(a, b) in $ctrl.excelColumns\">\n                  <span class=\"text-bg\" ng-if=\"v[b].t === 'n' && b !== 'C'\">{{v[b].v}}</span>\n                  <span class=\"text-bg\" ng-if=\"v[b].t === 's' || b === 'C'\">{{v[b].v}}</span>\n                </td>\n              </tr>\n              <tr ng-if=\"$ctrl.data.excelSelectedTabData === null\">\n                <td colspan=\"{{$ctrl.fieldOptions.length}}\"><em>Loading....</em></td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer clearfix\">\n      <div class=\"alert alert-info pull-left\" ng-if=\"$ctrl.sizeOf($ctrl.data.excel) && !$ctrl.invalidTabMsg && $ctrl.isImporting\">\n        Please allow 5 to 10 minutes for system to save new job class.\n      </div>\n      <button class=\"btn btn-success btn-sm\" type=\"button\" ng-click=\"$ctrl.uploadFile()\" ng-if=\"!$ctrl.sizeOf($ctrl.data.excel)\" ng-disabled=\"$ctrl.isUploading || !$ctrl.fileInputField\">Upload</button>\n      <button class=\"btn btn-primary btn-sm\" type=\"submit\" ng-if=\"$ctrl.sizeOf($ctrl.data.excel) && !$ctrl.invalidTabMsg\" ng-disabled=\"$ctrl.isImporting\">Save</button>\n      <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _async = __webpack_require__(55);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobClassUploadController = function () {
	  /*@ngInject*/
	  JobClassUploadController.$inject = ['$http', '$q', '$cookies', '$timeout', '$uibModalInstance'];
	  function JobClassUploadController($http, $q, $cookies, $timeout, $uibModalInstance) {
	    _classCallCheck(this, JobClassUploadController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$cookies = $cookies;
	    this.$timeout = $timeout;
	    this.$uibModalInstance = $uibModalInstance;
	
	    this.fileInputField;
	    this.isUploading = false;
	
	    this.data = {
	      selectedFiles: [],
	      excelFileOnServer: '',
	      excel: null,
	      excelSelectedTabs: [],
	      excelSelectedTabIdx: 0,
	      excelSelectedTabData: null
	    };
	    this.excelColumns = [];
	    this.fieldOptions = [{ name: 'Name', value: 'name', alias: ['ClassName'] }, { name: 'Description', value: 'description', alias: ['ClassDesc'] }];
	    this.form = {
	      mappedFields: {}
	    };
	    this.invalidTabMsg = false;
	    this.isImporting = false;
	    this.importProgress = {
	      current: 0,
	      total: 0
	    };
	  }
	
	  _createClass(JobClassUploadController, [{
	    key: 'sizeOf',
	    value: function sizeOf(obj) {
	      return _lodash2.default.size(obj);
	    }
	  }, {
	    key: 'uploadFile',
	    value: function uploadFile() {
	      var self = this;
	      this.isUploading = true;
	      this.$http({
	        method: 'POST',
	        url: '/api/types/jobClasses/upload?access_token=' + this.$cookies.get('token'),
	        headers: {
	          'Content-Type': undefined
	        },
	        data: {
	          file: this.fileInputField
	        },
	        transformRequest: function transformRequest(data, headersGetter) {
	          var formData = new FormData();
	          angular.forEach(data, function (value, key) {
	            formData.append(key, value);
	          });
	          return formData;
	        }
	      }).then(function (response) {
	        self.data.excelFileOnServer = response.data;
	        self.parseFile(response.data);
	        self.isUploading = false;
	      }, function (error) {
	        self.isUploading = false;
	      });
	    }
	  }, {
	    key: 'parseFile',
	    value: function parseFile(filename) {
	      var self = this;
	      this.$http.post('/api/types/jobClasses/parse', {
	        filename: filename
	      }).then(function (response) {
	        self.data.excel = response.data;
	        if (_lodash2.default.size(self.data.excel.sheets)) {
	          angular.forEach(self.data.excel.sheets, function (tab) {
	            self.data.excelSelectedTabs.push(tab.name);
	          });
	
	          self.selectTab(self.data.excelSelectedTabIdx);
	        } else {
	          self.data.resultMsg = 'Invalid excel.';
	        }
	      }, function (error) {});
	    }
	  }, {
	    key: 'colName',
	    value: function colName(n) {
	      var ordA = 'a'.charCodeAt(0);
	      var ordZ = 'z'.charCodeAt(0);
	      var len = ordZ - ordA + 1;
	      var s = "";
	      while (n >= 0) {
	        s = String.fromCharCode(n % len + ordA) + s;
	        n = Math.floor(n / len) - 1;
	      }
	      return s.toUpperCase();
	    }
	  }, {
	    key: 'createEmptyArray',
	    value: function createEmptyArray(nth) {
	      var _array = [];
	      var i = 0;
	      for (i = 0; i < nth; i++) {
	        _array.push(this.colName(i));
	      }
	      this.excelColumns = _array;
	    }
	  }, {
	    key: 'guessColumnField',
	    value: function guessColumnField() {
	      var self = this;
	      var match = void 0;
	      var idx = void 0;
	
	      angular.forEach(this.data.excelSelectedTabData.rows[1], function (col, k) {
	        match = _lodash2.default.find(self.fieldOptions, function (o) {
	          return o.name.toLowerCase() === col.v.toLowerCase();
	        });
	        if (match) {
	          idx = _lodash2.default.findKey(self.excelColumns, function (o) {
	            return o === k;
	          });
	          if (idx) {
	            self.form.mappedFields[idx] = match.value;
	          }
	        } else {
	          match = _lodash2.default.find(self.fieldOptions, function (o) {
	            if (o.alias && o.alias.length) {
	              return o.alias.indexOf(col.v) !== -1;
	            }
	            return false;
	          });
	          if (match) {
	            idx = _lodash2.default.findKey(self.excelColumns, function (o) {
	              return o === k;
	            });
	            if (idx) {
	              self.form.mappedFields[idx] = match.value;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'selectTab',
	    value: function selectTab(idx) {
	      var self = this;
	      this.data.excelSelectedTabData = null;
	      this.invalidTabMsg = false;
	      this.$timeout(function () {
	        var i = 0;
	        var o = void 0;
	        for (o in self.data.excel.sheets) {
	          if (i === idx) {
	            self.data.excelSelectedTabData = self.data.excel.sheets[o];
	            self.createEmptyArray(self.data.excelSelectedTabData.overallMaxColumnCount);
	            break;
	          } else {
	            i++;
	          }
	        }
	        self.data.excelSelectedTabIdx = idx;
	      });
	    }
	  }, {
	    key: 'rendered',
	    value: function rendered() {
	      this.guessColumnField();
	    }
	  }, {
	    key: 'createSeriesOfRequest',
	    value: function createSeriesOfRequest(current, item, payload) {
	      var self = this;
	      return function (callback) {
	        self.importProgress.current = current;
	        self.$http.post('/api/types/jobClasses', payload).then(function (response) {
	          item.success = true;
	          callback(null);
	        }, function (err) {
	          item.failed = true;
	          callback(null);
	        });
	      };
	    }
	  }, {
	    key: 'processData',
	    value: function processData(data) {
	      var self = this;
	      var deferred = this.$q.defer();
	      var series = [];
	      var payload = {};
	      var excelCol = void 0;
	      var excelColValue = void 0;
	      angular.forEach(this.data.excelSelectedTabData.rows, function (item, rowNum) {
	        if (rowNum !== '1') {
	          payload = {};
	          angular.forEach(self.form.mappedFields, function (field, idx) {
	            excelCol = self.excelColumns[idx];
	            excelColValue = item[excelCol].v;
	            payload[field] = excelColValue;
	          });
	
	          series.push(self.createSeriesOfRequest(rowNum - 1, item, payload));
	        }
	      });
	
	      this.importProgress.total = series.length;
	      if (series.length) {
	        _async2.default.series(series, function (err, results) {
	          deferred.resolve();
	        });
	      }
	      return deferred.promise;
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      if (form.$valid) {
	        if (this.data.excel) {
	          var self = this;
	          this.isImporting = true;
	
	          this.$http.post('/api/types/jobClasses/import', {
	            filename: self.data.excelFileOnServer,
	            tabIdx: self.data.excelSelectedTabIdx,
	            mappedFields: this.form.mappedFields,
	            excelColumns: self.excelColumns
	          }).then(function (response) {
	            self.$timeout(function () {
	              self.$uibModalInstance.close();
	            }, 5000);
	          }, function (error) {});
	        }
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return JobClassUploadController;
	}();
	
	exports.default = JobClassUploadController;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarComponent = exports.NavbarComponent = function () {
	  NavbarComponent.$inject = ['$uibModal', 'Auth'];
	  function NavbarComponent($uibModal, Auth) {
	    'ngInject';
	
	    _classCallCheck(this, NavbarComponent);
	
	    this.menu = [{
	      title: 'Home',
	      state: 'main'
	    }, {
	      title: 'Client Order',
	      state: 'order'
	    }];
	    this.isCollapsed = true;
	    this.$uibModal = $uibModal;
	    this.isLoggedIn = Auth.isLoggedInSync;
	    this.isAdmin = Auth.isAdminSync;
	    this.getCurrentUser = Auth.getCurrentUserSync;
	    this.canExportOrders = Auth.canExportOrders;
	  }
	
	  _createClass(NavbarComponent, [{
	    key: 'openExportModal',
	    value: function openExportModal(user) {
	      var self = this;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        ariaLabelledBy: 'modal-title',
	        ariaDescribedBy: 'modal-body',
	        template: __webpack_require__(94),
	        controller: 'ExportModalController',
	        controllerAs: '$ctrl',
	        size: 'sm'
	      });
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }]);
	
	  return NavbarComponent;
	}();
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	  template: __webpack_require__(95),
	  controller: NavbarComponent
	}).name;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"uploader-modal user\">\n  <form class=\"form\" name=\"form\" ng-submit=\"$ctrl.submitForm(form)\" novalidate>\n    <div class=\"modal-header\">\n      <h5 class=\"modal-title\" id=\"modal-title\"><i class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></i> Export Orders</h5>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div class=\"form-group\">\n        <label class=\"required\">From Created Date</label>\n        <date-picker data-name=\"startDate\" data-ng-model=\"startDate\" data-required=\"required\"></date-picker>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"required\">To Created Date</label>\n        <date-picker data-name=\"endDate\" data-ng-model=\"endDate\" data-required=\"required\"></date-picker>\n      </div>\n    </div>\n    <div class=\"modal-footer clearfix\">\n      <div class=\"alert alert-info pull-left\" ng-if=\"$ctrl.isSaving\">\n        Saving....\n      </div>\n      <div class=\"download-iframe\" ng-bind-html=\"$ctrl.download\"></div>\n      <a class=\"btn btn-primary btn-sm\" type=\"submit\" ng-disabled=\"!form.$dirty || form.$invalid\" href=\"/api/orders/export?startDate={{$ctrl.formatDate(startDate)}}&endDate={{$ctrl.formatDate(endDate)}}\" target=\"_blank\">Export</a>\n      <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"navbar navbar-default navbar-fixed-top\">\n  <div class=\"container\">\n    <div class=\"navbar-header\">\n      <button class=\"navbar-toggle\" type=\"button\" ng-click=\"$ctrl.isCollapsed = !$ctrl.isCollapsed\">\n        <span class=\"sr-only\">Toggle navigation</span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n      </button>\n      <a href=\"/\" class=\"navbar-brand\"></a>\n    </div>\n    <div uib-collapse=\"$ctrl.isCollapsed\" class=\"navbar-collapse collapse\" id=\"navbar-main\">\n      <ul class=\"nav navbar-nav\" ng-if=\"$ctrl.isLoggedIn()\">\n        <li ng-if=\"$ctrl.isAdmin()\" ui-sref-active=\"active\"><a ui-sref=\"main\">Home</a></li>\n        <li ng-if=\"$ctrl.isAdmin()\" ui-sref-active=\"active\"><a ui-sref=\"order\">Client Order</a></li>\n        <li ng-if=\"$ctrl.canExportOrders()\" ui-sref-active=\"active\"><a ng-click=\"$ctrl.openExportModal()\">Export Orders</a></li>\n        <li ng-if=\"$ctrl.isAdmin()\" ui-sref-active=\"active\"><a ui-sref=\"admin.users\">Admin</a></li>\n      </ul>\n\n      <ul class=\"nav navbar-nav navbar-right\">\n        <li ng-if=\"!$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"login\">Login</a></li>\n        <li ng-if=\"$ctrl.isLoggedIn()\"><p class=\"navbar-text\">Hello {{ $ctrl.getCurrentUser().name }}</p> </li>\n        <li ng-if=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"settings\"><span class=\"glyphicon glyphicon-cog\"></span></a></li>\n        <li ng-if=\"$ctrl.isLoggedIn()\"><a ui-sref=\"logout\">Logout</a></li>\n      </ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterComponent = exports.FooterComponent = function FooterComponent() {
	  _classCallCheck(this, FooterComponent);
	};
	
	exports.default = _angular2.default.module('directives.footer', []).component('footer', {
	  template: __webpack_require__(97),
	  controller: FooterComponent
	}).name;

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <p></p>\n</div>\n"

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(10);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _main = __webpack_require__(99);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainController = exports.MainController = function () {
	
	  /*@ngInject*/
	  MainController.$inject = ['$http', '$q', '$scope', '$state', 'Modal', 'Auth'];
	  function MainController($http, $q, $scope, $state, Modal, Auth) {
	    'ngInject';
	
	    _classCallCheck(this, MainController);
	
	    this.awesomeThings = [];
	    this.newThing = '';
	    this.$http = $http;
	    this.$q = $q;
	    this.$state = $state;
	    this.Modal = Modal;
	    this.Auth = Auth;
	
	    this.ready = false;
	    this.route = 'main';
	
	    this.form = {};
	    this.systemOptions = [];
	    this.result = {};
	    this.pageSizeOptions = [10, 20, 30, 40, 50];
	    this.sortByOptions = {
	      favilityName: 'Facility Name',
	      jobClass: 'Job Class',
	      areaName: 'Area Name',
	      assignmentStartDate: 'Assignment Start Date',
	      createdDate: 'Created Date'
	    };
	    this.pagination = {
	      _paging: true,
	      _selector: 'All',
	      _pageSize: 10,
	      _pageNum: 1,
	      _sortBy: 'createdDate desc'
	    };
	    this.tableMsg = '';
	
	    $scope.$on('$destroy', function () {});
	  }
	
	  _createClass(MainController, [{
	    key: 'getSystems',
	    value: function getSystems(extraParams) {
	      var deferred = this.$q.defer();
	      var self = this;
	      var params = {
	        _selector: 'name',
	        _pageSize: 'All'
	      };
	      if (extraParams) {
	        _angular2.default.extend(params, extraParams);
	      }
	      this.$http.get('/api/types/systems', { params: params }).then(function (response) {
	        self.systemOptions = response.data;
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'buildQuery',
	    value: function buildQuery() {
	      return _angular2.default.extend(_angular2.default.copy(this.form), this.pagination);
	    }
	  }, {
	    key: 'noPad',
	    value: function noPad(n, size) {
	      var s = String(n);
	      while (s.length < (size || 2)) {
	        s = "0" + s;
	      }
	      return s;
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var self = this;
	      this.$http.get('/api/orders', {
	        params: this.buildQuery()
	      }).then(function (response) {
	        if (response.data.total === 0) {
	          self.tableMsg = 'No record.';
	        }
	        if (response.data) {
	          _angular2.default.forEach(response.data.items, function (item) {
	            if (item.orderNo) {
	              item.orderNo = self.noPad(item.orderNo, 5);
	            }
	          });
	        }
	        self.result = response.data;
	      }, function (err) {});
	    }
	  }, {
	    key: 'search',
	    value: function search() {
	      this.tableMsg = 'Searching....';
	      this.getData();
	    }
	  }, {
	    key: 'clearSearch',
	    value: function clearSearch() {
	      this.form = {};
	      this.pagination._pageNum = 1;
	      this.getData();
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(item) {
	      var self = this;
	      this.Modal.confirm.delete(function () {
	        self.$http.delete('/api/orders/' + item._id).then(function (response) {
	          self.getData();
	        }, function (err) {});
	      })(item.facilityName + ' / ' + item.areaName + ' - ' + item.quantity + ' ' + item.jobClass + ' on ' + item.assignmentStartDateStr);
	    }
	  }, {
	    key: 'resend',
	    value: function resend(item) {
	      var self = this;
	      this.Modal.confirm.general(function () {
	        self.$http.get('/api/orders/email/' + item._id);
	      })('Resend Email Confirmation', '<p>Are you sure you want to resend this order email?</p>');
	    }
	  }, {
	    key: 'rowNumb',
	    value: function rowNumb(idx) {
	      return idx + 1 + (this.result.pageNum !== 1 ? this.result.pageSize * this.result.pageNum - this.result.pageSize : 0);
	    }
	  }, {
	    key: 'updateSortBy',
	    value: function updateSortBy(sortBy) {
	      this.pagination._sortBy = sortBy;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'updatePageSize',
	    value: function updatePageSize(pageSize) {
	      this.pagination._pageSize = pageSize;
	      this.pagination._pageNum = 1;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: 'gotoPage',
	    value: function gotoPage(pageNum) {
	      this.pagination._pageNum = pageNum;
	      this.$state.go(this.route, this.buildQuery(), { notify: false });
	      this.getData();
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var self = this;
	      this.Auth.getCurrentUser(function (user) {
	        if (user.role === 'admin') {
	          self.ready = true;
	          self.tableMsg = 'Loading....';
	          self.getData();
	        } else {
	          self.$state.go('order');
	        }
	      });
	    }
	  }]);
	
	  return MainController;
	}();
	
	exports.default = _angular2.default.module('wftOrderFormApp.main', [_angularUiRouter2.default]).config(_main2.default).component('main', {
	  template: __webpack_require__(100),
	  controller: MainController,
	  controllerAs: 'MainCtrl'
	}).name;

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('main', {
	    url: '/?_pageNum&_pageSize&_sortyBy&facilityName&jobClass&areaName&assignmentStartDate',
	    template: '<main></main>',
	    authenticate: true
	  });
	}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"main-page\" ng-if=\"MainCtrl.ready\">\n  <header class=\"banner\" id=\"banner\">\n    <div class=\"container\"></div>\n  </header>\n  <div class=\"container\">\n    <div class=\"page-header\">\n      <h3>Home</h3>\n    </div>\n    <div class=\"form-container\">\n      <form name=\"form\" class=\"form-inline\" ng-submit=\"MainCtrl.search(form)\" novalidate>\n        <div class=\"form-group\">\n          <input type=\"text\" id=\"facilityName\" name=\"facilityName\" class=\"form-control input-sm\" placeholder=\"Facility Name\" ng-model=\"MainCtrl.form.facilityName\" />\n        </div>\n        <div class=\"form-group\">\n          <input type=\"text\" id=\"jobClass\" name=\"jobClass\" class=\"form-control input-sm\" placeholder=\"Job Class\" ng-model=\"MainCtrl.form.jobClass\" />\n        </div>\n        <div class=\"form-group\">\n          <input type=\"text\" id=\"deptName\" name=\"deptName\" class=\"form-control input-sm\" placeholder=\"Department\" ng-model=\"MainCtrl.form.deptName\" />\n        </div>\n        <div class=\"form-group\">\n          <input type=\"text\" id=\"orderNo\" name=\"orderNo\" class=\"form-control input-sm\" placeholder=\"Order #\" ng-model=\"MainCtrl.form.orderNo\" />\n        </div>\n        <div class=\"form-group\">\n          <date-picker data-name=\"assignmentStartDate\" data-ng-model=\"MainCtrl.form.assignmentStartDate\"></date-picker>\n        </div>\n        <div class=\"form-group\">\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\">Search</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"MainCtrl.clearSearch()\">Clear</button>\n        </div>\n      </form>\n    </div>\n    <div class=\"result-controls-pagination-container clearfix\">\n      <result-controls data-total=\"MainCtrl.result.total\"\n                       data-page-size-options=\"MainCtrl.pageSizeOptions\"\n                       data-page-size=\"MainCtrl.pagination._pageSize\"\n                       data-page-size-callback=\"MainCtrl.updatePageSize(pageSize)\"\n                       data-sort-by-options=\"MainCtrl.sortByOptions\"\n                       data-sort-by=\"MainCtrl.pagination._sortBy\"\n                       data-sort-by-callback=\"MainCtrl.updateSortBy(sortBy)\"></result-controls>\n      <pagination data-id=\"top\" data-total=\"MainCtrl.result.total\" data-page-num=\"MainCtrl.result.pageNum\" data-page-size=\"MainCtrl.result.pageSize\" data-callback=\"MainCtrl.gotoPage(pageNum)\"></pagination>\n    </div>\n    <div class=\"table-responsive\">\n      <table class=\"table table-bordered table-striped table-hover\">\n        <thead>\n          <tr>\n            <th width=\"10%\">Actions</th>\n            <th width=\"15\">#</th>\n            <th class=\"no-wrap\">Order #</th>\n            <th class=\"no-wrap\">Infor Requisition #</th>\n            <th class=\"no-wrap\">Company/GL</th>\n            <th class=\"no-wrap\">Accounting Unit</th>\n            <th class=\"no-wrap\">Location Code</th>\n            <th class=\"no-wrap\">Job Class</th>\n            <th>Quantity</th>\n            <th class=\"no-wrap\">Start Date</th>\n            <th class=\"no-wrap\">Requested By</th>\n            <th class=\"no-wrap\">Request Authorized By</th>\n            <th class=\"no-wrap\">Created Date</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"item in MainCtrl.result.items\">\n            <td class=\"actions no-wrap\">\n              <a ui-sref=\"orderEdit({id: item._id})\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> Edit</a>\n              <a ng-click=\"MainCtrl.delete(item)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i> Delete</a>\n              <a ng-click=\"MainCtrl.resend(item)\"><i class=\"fa fa-envelope-o\" aria-hidden=\"true\"></i> Resend</a>\n            </td>\n            <td>{{$index + 1}}</td>\n            <td class=\"no-wrap\">{{item.orderNo}}</td>\n            <td class=\"no-wrap\">{{item.inforRequisition}}</td>\n            <td class=\"no-wrap\">{{item.companyGL}}</td>\n            <td class=\"no-wrap\">{{item.accountingUnit}}</td>\n            <td class=\"no-wrap\">{{item.locationCode}}</td>\n            <td class=\"no-wrap\">{{item.jobClass}}</td>\n            <td class=\"no-wrap\">{{item.quantity}}</td>\n            <td class=\"no-wrap\">{{item.assignmentStartDate | date: 'MM/dd/yyyy'}}</td>\n            <td class=\"no-wrap\">{{item.requestedBy}}</td>\n            <td class=\"no-wrap\">{{item.requestAuthorizedBy}}</td>\n            <td class=\"no-wrap\">{{item.createdDate | date: 'MM/dd/yyyy @ hh:mm a'}}</td>\n          </tr>\n          <tr ng-if=\"MainCtrl.result.total===0\">\n            <td colspan=\"12\">{{MainCtrl.tableMsg}}</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrderComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _order = __webpack_require__(102);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _exportModal = __webpack_require__(103);
	
	var _exportModal2 = _interopRequireDefault(_exportModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	var uiRouter = __webpack_require__(10);
	var _ = __webpack_require__(22);
	
	var OrderComponent = exports.OrderComponent = function () {
	  OrderComponent.$inject = ['$scope', '$http', '$q', '$state', '$stateParams', '$timeout', '$filter', '$uibModal', 'Auth', 'Modal', 'Util'];
	  function OrderComponent($scope, $http, $q, $state, $stateParams, $timeout, $filter, $uibModal, Auth, Modal, Util) {
	    'ngInject';
	
	    _classCallCheck(this, OrderComponent);
	
	    this.$scope = $scope;
	    this.$http = $http;
	    this.$q = $q;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$timeout = $timeout;
	    this.$filter = $filter;
	    this.$uibModal = $uibModal;
	    this.Auth = Auth;
	    this.Modal = Modal;
	    this.Util = Util;
	
	    this.user;
	
	    this.isAdd = true;
	    this.submitted = false;
	    this.form = {};
	    this.isSaving = false;
	    this.showCreatedSuccessMsg = false;
	    this.showUpdatedSuccessMsg = false;
	
	    this.companyGLOptions = [];
	    this.accountingUnits = [];
	    this.locationCodes = [];
	
	    this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26];
	    this.lengthTypeOptions = ['Days', 'Weeks'];
	    this.timeOptions = ['12:00 AM', '12:15 AM', '12:30 AM', '12:45 AM', '1:00 AM', '1:15 AM', '1:30 AM', '1:45 AM', '2:00 AM', '2:15 AM', '2:30 AM', '2:45 AM', '3:00 AM', '3:15 AM', '3:30 AM', '3:45 AM', '4:00 AM', '4:15 AM', '4:30 AM', '4:45 AM', '5:00 AM', '5:15 AM', '5:30 AM', '5:45 AM', '6:00 AM', '6:15 AM', '6:30 AM', '6:45 AM', '7:00 AM', '7:15 AM', '7:30 AM', '7:45 AM', '8:00 AM', '8:15 AM', '8:30 AM', '8:45 AM', '9:00 AM', '9:15 AM', '9:30 AM', '9:45 AM', '10:00 AM', '10:15 AM', '10:30 AM', '10:45 AM', '11:00 AM', '11:15 AM', '11:30 AM', '11:45 AM', '12:00 PM', '12:15 PM', '12:30 PM', '12:45 PM', '1:00 PM', '1:15 PM', '1:30 PM', '1:45 PM', '2:00 PM', '2:15 PM', '2:30 PM', '2:45 PM', '3:00 PM', '3:15 PM', '3:30 PM', '3:45 PM', '4:00 PM', '4:15 PM', '4:30 PM', '4:45 PM', '5:00 PM', '5:15 PM', '5:30 PM', '5:45 PM', '6:00 PM', '6:15 PM', '6:30 PM', '6:45 PM', '7:00 PM', '7:15 PM', '7:30 PM', '7:45 PM', '8:00 PM', '8:15 PM', '8:30 PM', '8:45 PM', '9:00 PM', '9:15 PM', '9:30 PM', '9:45 PM', '10:00 PM', '10:15 PM', '10:30 PM', '10:45 PM', '11:00 PM', '11:15 PM', '11:30 PM', '11:45 PM'];
	    this.incentiveOptions = ['$0', '$1', '$2', '$3', '$4', '$5', 'Submit Required Rate'];
	    this.yearsExperienceOptions = ['0', '1', '2', '3', '4', '5+'];
	    this.yesNoOptions = ['Yes', 'No'];
	  }
	
	  _createClass(OrderComponent, [{
	    key: 'getCompanyGLs',
	    value: function getCompanyGLs(extraParams) {
	      var deferred = this.$q.defer();
	      var self = this;
	      var params = {
	        _pageSize: 'All',
	        _selector: 'companyName,gl',
	        _sortBy: 'gl asc'
	      };
	      if (extraParams) {
	        angular.extend(params, extraParams);
	      }
	      this.$http.get('/api/types/companies/gls', { params: params }).then(function (response) {
	        self.companyGLOptions = response.data;
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'getAccountingUnits',
	    value: function getAccountingUnits(extraParams) {
	      var deferred = this.$q.defer();
	      var self = this;
	      var params = {
	        _pageSize: 'All',
	        _selector: 'hrOrganizationUnit,shortDescription,description,parentUnitShortDescription,mvsOrBsc',
	        _sortBy: 'hrOrganizationUnit asc'
	      };
	      if (extraParams) {
	        angular.extend(params, extraParams);
	      }
	      this.$http.get('/api/types/companies/accountingUnits', { params: params }).then(function (response) {
	        self.accountingUnits = response.data;
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'getLocationCodes',
	    value: function getLocationCodes(extraParams) {
	      var deferred = this.$q.defer();
	      var self = this;
	      var params = {
	        _pageSize: 'All',
	        _selector: 'hrLocation,description,mvsOrBsc',
	        _sortBy: 'hrLocation asc'
	      };
	      if (extraParams) {
	        angular.extend(params, extraParams);
	      }
	      this.$http.get('/api/types/companies/locationCodes', { params: params }).then(function (response) {
	        self.locationCodes = response.data;
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'noPad',
	    value: function noPad(n, size) {
	      var s = String(n);
	      while (s.length < (size || 2)) {
	        s = "0" + s;
	      }
	      return s;
	    }
	  }, {
	    key: 'getData',
	    value: function getData(id) {
	      var deferred = this.$q.defer();
	      var self = this;
	      this.$http.get('/api/orders/' + id).then(function (response) {
	        if (response.data.orderNo) {
	          response.data._orderNo = self.noPad(response.data.orderNo, 5);
	        }
	        if (response.data.assignmentStartDate) {
	          response.data.assignmentStartDate = new Date(response.data.assignmentStartDate);
	        }
	        if (response.data.assignmentLength) {
	          response.data.assignmentLength = parseInt(response.data.assignmentLength);
	        }
	        if (response.data.credentialRequirements) {
	          var credentialRequirements = response.data.credentialRequirements.split(', ');
	          angular.forEach(credentialRequirements, function (cred) {
	            if (cred === 'ACLS') {
	              response.data.credentialRequirement_acls = true;
	            } else if (cred === 'AWHONN') {
	              response.data.credentialRequirement_awhonn = true;
	            } else if (cred === 'BLS') {
	              response.data.credentialRequirement_bls = true;
	            } else if (cred === 'EKG') {
	              response.data.credentialRequirement_ekg = true;
	            } else if (cred === 'NIH') {
	              response.data.credentialRequirement_nih = true;
	            } else if (cred === 'NRP') {
	              response.data.credentialRequirement_nrp = true;
	            } else if (cred === 'NVCI') {
	              response.data.credentialRequirement_nvci = true;
	            } else if (cred === 'ONC') {
	              response.data.credentialRequirement_onc = true;
	            } else if (cred === 'PALS') {
	              response.data.credentialRequirement_pals = true;
	            } else if (cred === 'TNCC') {
	              response.data.credentialRequirement_tncc = true;
	            }
	          });
	        }
	        self.form = response.data;
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'update',
	    value: function update(id, payload) {
	      var self = this;
	      this.$http.put('/api/orders/' + id, payload).then(function (response) {
	        self.showUpdatedSuccessMsg = true;
	        self.$timeout(function () {
	          self.showUpdatedSuccessMsg = false;
	          self.$state.go('main');
	        }, 5000);
	      }, function (err) {
	        self.isSaving = false;
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(payload) {
	      var self = this;
	      this.$http.post('/api/orders', payload).then(function (response) {
	        self.showCreatedSuccessMsg = true;
	        self.$timeout(function () {
	          self.showCreatedSuccessMsg = false;
	          self.$state.go('main');
	        }, 5000);
	      }, function (err) {
	        self.isSaving = false;
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      var self = this;
	      this.submitted = true;
	      if (form.$valid && self.form.companyGLRef && self.form.accountingUnitRef && self.form.locationCodeRef && self.form.jobClassRef) {
	        self.isSaving = true;
	        if (self.form.assignmentStartDate) {
	          self.form.assignmentStartDateStr = self.$filter('date')(self.form.assignmentStartDate, 'MM/dd/yyyy');
	        }
	        var credentialRequirements = [];
	        if (self.form.credentialRequirement_acls) {
	          credentialRequirements.push('ACLS');
	        }
	        if (self.form.credentialRequirement_awhonn) {
	          credentialRequirements.push('AWHONN');
	        }
	        if (self.form.credentialRequirement_bls) {
	          credentialRequirements.push('BLS');
	        }
	        if (self.form.credentialRequirement_ekg) {
	          credentialRequirements.push('EKG');
	        }
	        if (self.form.credentialRequirement_nih) {
	          credentialRequirements.push('NIH');
	        }
	        if (self.form.credentialRequirement_nrp) {
	          credentialRequirements.push('NRP');
	        }
	        if (self.form.credentialRequirement_nvci) {
	          credentialRequirements.push('NVCI');
	        }
	        if (self.form.credentialRequirement_onc) {
	          credentialRequirements.push('ONC');
	        }
	        if (self.form.credentialRequirement_pals) {
	          credentialRequirements.push('PALS');
	        }
	        if (self.form.credentialRequirement_tncc) {
	          credentialRequirements.push('TNCC');
	        }
	        if (credentialRequirements.length) {
	          self.form.credentialRequirements = credentialRequirements.join(', ');
	        }
	        if (!self.isAdd) {
	          self.update(self.form._id, self.form);
	        } else {
	          self.create(self.form);
	        }
	      }
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var self = this;
	      this.Modal.confirm.delete(function () {})('order');
	    }
	  }, {
	    key: 'companyGL_formatter',
	    value: function companyGL_formatter(items) {
	      var formattedItems = [];
	      var i = void 0;
	      for (i in items) {
	        formattedItems.push({
	          id: items[i]._id,
	          title: items[i].gl + ' / ' + items[i].regionName + ' / ' + items[i].companyName
	        });
	      }
	      return formattedItems;
	    }
	  }, {
	    key: 'companyGL_showAll',
	    value: function companyGL_showAll(id) {
	      this.$scope.$broadcast('autocomplete:showAll', id);
	    }
	  }, {
	    key: 'companyGL_onChanged',
	    value: function companyGL_onChanged(input) {
	      this.$parent.OrderCtrl.form.companyGL = input;
	    }
	  }, {
	    key: 'companyGL_onSelected',
	    value: function companyGL_onSelected(selected) {
	      if (selected) {
	        if (this.$parent.OrderCtrl.form.companyGLIsNew) {
	          this.$parent.OrderCtrl.form.companyGLIsNew = false;
	        }
	
	        this.$parent.OrderCtrl.form.companyGL = selected.title;
	        this.$parent.OrderCtrl.form.companyGLRef = selected.originalObject.id;
	      }
	    }
	  }, {
	    key: 'companyGL_clearInput',
	    value: function companyGL_clearInput(id) {
	      this.$scope.$broadcast('autocomplete:clearInput', id);
	      this.form.companyGL = null;
	      this.form.companyGLRef = null;
	    }
	  }, {
	    key: 'accountingUnit_formatter',
	    value: function accountingUnit_formatter(items) {
	      try {
	        var formattedItems = [];
	        var i = void 0;
	        var titles = [];
	        for (i in items) {
	          titles = [];
	          if (items[i].hrOrganizationUnit) {
	            titles.push(items[i].hrOrganizationUnit);
	          }
	          if (items[i].shortDescription) {
	            titles.push(items[i].shortDescription);
	          }
	          if (items[i].description) {
	            titles.push(items[i].description);
	          }
	          if (items[i].parentUnitShortDescription) {
	            titles.push(items[i].parentUnitShortDescription);
	          }
	          formattedItems.push({
	            id: items[i]._id,
	            title: titles.join(' / ')
	          });
	        }
	        return formattedItems;
	      } catch (err) {
	        console.log(err);
	        return;
	      }
	    }
	  }, {
	    key: 'accountingUnit_showAll',
	    value: function accountingUnit_showAll(id) {
	      this.$scope.$broadcast('autocomplete:showAll', id);
	    }
	  }, {
	    key: 'accountingUnit_onChanged',
	    value: function accountingUnit_onChanged(input) {
	      this.$parent.OrderCtrl.form.accountingUnit = input;
	    }
	  }, {
	    key: 'accountingUnit_onSelected',
	    value: function accountingUnit_onSelected(selected) {
	      if (selected) {
	        if (this.$parent.OrderCtrl.form.accountingUnitIsNew) {
	          this.$parent.OrderCtrl.form.accountingUnitIsNew = false;
	        }
	
	        this.$parent.OrderCtrl.form.accountingUnit = selected.title;
	        this.$parent.OrderCtrl.form.accountingUnitRef = selected.originalObject.id;
	      }
	    }
	  }, {
	    key: 'accountingUnit_clearInput',
	    value: function accountingUnit_clearInput(id) {
	      this.$scope.$broadcast('autocomplete:clearInput', id);
	      this.form.accountingUnit = null;
	      this.form.accountingUnitRef = null;
	    }
	  }, {
	    key: 'locationCode_formatter',
	    value: function locationCode_formatter(items) {
	      try {
	        var formattedItems = [];
	        var i = void 0;
	        var titles = [];
	        for (i in items) {
	          titles = [];
	          if (items[i].hrLocation) {
	            titles.push(items[i].hrLocation);
	          }
	          if (items[i].description) {
	            titles.push(items[i].description);
	          }
	          formattedItems.push({
	            id: items[i]._id,
	            hrLocation: items[i].hrLocation,
	            title: titles.join(' / ')
	          });
	        }
	        return formattedItems;
	      } catch (err) {
	        console.log(err);
	        return;
	      }
	    }
	  }, {
	    key: 'locationCode_showAll',
	    value: function locationCode_showAll(id) {
	      this.$scope.$broadcast('autocomplete:showAll', id);
	    }
	  }, {
	    key: 'locationCode_onChanged',
	    value: function locationCode_onChanged(input) {
	      this.$parent.OrderCtrl.form.locationCode = input;
	    }
	  }, {
	    key: 'locationCode_onSelected',
	    value: function locationCode_onSelected(selected) {
	      if (selected) {
	        if (this.$parent.OrderCtrl.form.locationCodeIsNew) {
	          this.$parent.OrderCtrl.form.locationCodeIsNew = false;
	        }
	
	        this.$parent.OrderCtrl.form.locationCode = selected.title;
	        this.$parent.OrderCtrl.form.locationCodeRef = selected.originalObject.id;
	
	        this.$parent.OrderCtrl.getAddress(selected.originalObject.hrLocation);
	      }
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(hrLocation) {
	
	      var deferred = this.$q.defer();
	      var self = this;
	      var params = {
	        hrLocation: hrLocation,
	        _pageSize: 'All',
	        _selector: 'hrLocation,displayAddress',
	        _sortBy: 'hrLocation asc'
	      };
	      this.$http.get('/api/types/companies/addresses', { params: params }).then(function (response) {
	        if (response.data && response.data.length) {
	          self.form.facilityAddress = response.data[0].displayAddress;
	        }
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'locationCode_clearInput',
	    value: function locationCode_clearInput(id) {
	      this.$scope.$broadcast('autocomplete:clearInput', id);
	      this.form.locationCode = null;
	      this.form.locationCodeRef = null;
	    }
	  }, {
	    key: 'jobClass_formatter',
	    value: function jobClass_formatter(items) {
	      try {
	        var formattedItems = [];
	        var i = void 0;
	        var titles = [];
	        for (i in items) {
	          titles = [];
	          if (items[i].name) {
	            titles.push(items[i].name);
	          }
	          if (items[i].description) {
	            titles.push(items[i].description);
	          }
	          formattedItems.push({
	            id: items[i]._id,
	            title: titles.join(' / ')
	          });
	        }
	        return formattedItems;
	      } catch (err) {
	        console.log(err);
	        return;
	      }
	    }
	  }, {
	    key: 'jobClass_showAll',
	    value: function jobClass_showAll(id) {
	      this.$scope.$broadcast('autocomplete:showAll', id);
	    }
	  }, {
	    key: 'jobClass_onChanged',
	    value: function jobClass_onChanged(input) {
	      this.$parent.OrderCtrl.form.jobClass = input;
	    }
	  }, {
	    key: 'jobClass_onSelected',
	    value: function jobClass_onSelected(selected) {
	      if (selected) {
	        this.$parent.OrderCtrl.form.jobClass = selected.title;
	        this.$parent.OrderCtrl.form.jobClassRef = selected.originalObject.id;
	      }
	    }
	  }, {
	    key: 'jobClass_clearInput',
	    value: function jobClass_clearInput(id) {
	      this.$scope.$broadcast('autocomplete:clearInput', id);
	      this.form.jobClass = null;
	      this.form.jobClassRef = null;
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var self = this;
	      this.Auth.getCurrentUser().then(function (user) {
	        self.user = user;
	        self.form.requestedBy = user.name;
	        if (self.$stateParams.id) {
	          self.isAdd = false;
	          self.getData(self.$stateParams.id);
	        }
	      });
	    }
	  }]);
	
	  return OrderComponent;
	}();
	
	exports.default = angular.module('wftOrderFormApp.order', [uiRouter]).config(_order2.default).component('order', {
	  template: __webpack_require__(104),
	  controller: OrderComponent,
	  controllerAs: 'OrderCtrl'
	}).controller('ExportModalController', _exportModal2.default).name;

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('order', {
	    url: '/order',
	    template: '<ordernew></ordernew>',
	    authenticate: true
	  }).state('orderEdit', {
	    url: '/order/:id',
	    template: '<ordernew></ordernew>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _async = __webpack_require__(55);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ExportModalController = function () {
	  /*@ngInject*/
	  ExportModalController.$inject = ['$http', '$q', '$timeout', '$filter', '$uibModalInstance'];
	  function ExportModalController($http, $q, $timeout, $filter, $uibModalInstance) {
	    _classCallCheck(this, ExportModalController);
	
	    this.$http = $http;
	    this.$q = $q;
	    this.$timeout = $timeout;
	    this.$filter = $filter;
	    this.$uibModalInstance = $uibModalInstance;
	
	    this.isAdd = true;
	    this.form = {};
	  }
	
	  _createClass(ExportModalController, [{
	    key: 'formatDate',
	    value: function formatDate(dt) {
	      if (dt) {
	        console.log(dt);
	        return this.$filter('date')(dt, 'yyyy-MM-dd');
	      }
	      return null;
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      return null;
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ExportModalController;
	}();
	
	exports.default = ExportModalController;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"order-page\">\n  <header class=\"banner\" id=\"banner\">\n    <div class=\"container\"></div>\n  </header>\n  <div class=\"container clearfix\">\n    <ol class=\"breadcrumb\">\n      <li><a href=\"/\">Home</a></li>\n      <li class=\"active\">Client Order</li>\n    </ol>\n    <div class=\"page-header\">\n      <h3>Client Order <small ng-if=\"!this.isAdd && OrderCtrl.form._orderNo\">#{{OrderCtrl.form._orderNo}}</small></h3>\n    </div>\n    <form name=\"orderForm\" class=\"form\" ng-submit=\"OrderCtrl.submitForm(orderForm)\" novalidate=\"novalidate\">\n      <div class=\"col-sm-8\">\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.inforRequisition.$invalid}\">\n          <label for=\"inforRequisition\" class=\"required\">Infor Requisition #</label>\n          <input type=\"text\" id=\"inforRequisition\" class=\"form-control input-sm\" name=\"inforRequisition\" ng-model=\"OrderCtrl.form.inforRequisition\" required aria-required=\"true\" />\n        </div>\n\n        <!-- <div class=\"form-group\" ng-class=\"{'has-error': orderForm.companyGL.$invalid}\">\n          <label for=\"companyGL\" class=\"required\">Company/GL</label>\n          <input type=\"text\" id=\"companyGL\" name=\"companyGL\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.companyGL\" \n            required aria-required=\"true\" placeholder=\"Enter Company Name or GL\" \n            auto-complete-company-gl auto-complete-form=\"orderForm\" auto-complete-extra-params=\"OrderCtrl.form\" \n            auto-complete-related-fields=\"['companyGLRef']\" />\n          <input type=\"hidden\" name=\"companyGLRef\" ng-model=\"OrderCtrl.form.companyGLRef\" />\n          <p class=\"help-block\" ng-if=\"OrderCtrl.form.jobClass && orderForm.jobClass.$error.invalidJobClass\">Invalid Company/GL. Please select from list.</p>\n        </div> -->\n\n        <div class=\"form-group\" ng-class=\"{'has-error': !OrderCtrl.form.companyGL || !OrderCtrl.form.companyGLRef}\">\n          <label for=\"companyGL\" class=\"required\">Company/GL</label>\n          <div class=\"input-group autocomplete\">\n            <div auto-complete\n              id=\"companyGL\"\n              placeholder=\"Enter Company Name or GL\" \n              initial-value=\"OrderCtrl.form.companyGL\"\n              pause=\"400\"\n              selected-object=\"OrderCtrl.companyGL_onSelected\"\n              remote-url=\"/api/types/companies/gls?_sortBy=gl&_pageNum=1&_pageSize=All&&keywords=\"\n              remote-url-response-formatter=\"OrderCtrl.companyGL_formatter\"\n              title-field=\"title\"\n              minlength=\"2\"\n              input-changed=\"OrderCtrl.companyGL_onChanged\"\n              input-class=\"form-control input-sm\"\n              match-class=\"highlight\">\n            </div>\n            <!-- <span class=\"input-group-addon new\">\n              <input id=\"companyGLIsNewLabel\" type=\"checkbox\" ng-model=\"OrderCtrl.form.companyGLIsNew\"> <label for=\"companyGLIsNewLabel\">New</label>\n            </span> -->\n            <div class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"OrderCtrl.companyGL_showAll('companyGL')\"> \n                View All\n              </button>\n              <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"OrderCtrl.companyGL_clearInput('companyGL')\"> \n                Clear\n              </button>\n            </div> \n          </div>\n          <p class=\"help-block\" ng-if=\"!OrderCtrl.form.companyGLRef\">Invalid Company/GL. Please select from list.</p>\n        </div>\n\n        <!-- <div class=\"form-group\" ng-class=\"{'has-error': orderForm.accountingUnit.$invalid}\">\n          <label for=\"accountingUnit\" class=\"required\">Accounting Unit</label>\n          <input type=\"text\" id=\"accountingUnit\" name=\"accountingUnit\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.accountingUnit\" \n            required aria-required=\"true\" placeholder=\"Enter HR Organization Unit, Short Description, Description, Parent Unit Short Description\" \n            auto-complete-accounting-unit auto-complete-form=\"orderForm\" auto-complete-extra-params=\"OrderCtrl.form\" \n            auto-complete-related-fields=\"['accountingUnitRef']\" />\n          <input type=\"hidden\" name=\"accountingUnitRef\" ng-model=\"OrderCtrl.form.accountingUnitRef\" />\n          <p class=\"help-block\" ng-if=\"OrderCtrl.form.jobClass && orderForm.jobClass.$error.invalidJobClass\">Invalid Job Class. Please select from list.</p>\n        </div> -->\n\n        <div class=\"form-group\" ng-class=\"{'has-error': !OrderCtrl.form.accountingUnit || !OrderCtrl.form.accountingUnitRef}\">\n          <label for=\"accountingUnit\" class=\"required\">Accounting Unit</label>\n          <div class=\"input-group autocomplete\">\n            <div auto-complete\n              id=\"accountingUnit\"\n              placeholder=\"Enter HR Organization Unit, Short Description, Description, Parent Unit Short Description\"\n              initial-value=\"OrderCtrl.form.accountingUnit\"\n              pause=\"400\"\n              selected-object=\"OrderCtrl.accountingUnit_onSelected\"\n              remote-url=\"/api/types/companies/accountingUnits?_sortBy=hrOrganizationUnit&_pageNum=1&_pageSize=All&&keywords=\"\n              remote-url-response-formatter=\"OrderCtrl.accountingUnit_formatter\"\n              title-field=\"title\"\n              minlength=\"2\"\n              input-changed=\"OrderCtrl.accountingUnit_onChanged\"\n              input-class=\"form-control input-sm\"\n              match-class=\"highlight\">\n            </div>\n            <!-- <span class=\"input-group-addon new\">\n              <input id=\"accountingUnitIsNewLabel\" type=\"checkbox\" ng-model=\"OrderCtrl.form.accountingUnitIsNew\"> <label for=\"accountingUnitIsNewLabel\">New</label>\n            </span> -->\n            <div class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"OrderCtrl.accountingUnit_showAll('accountingUnit')\"> \n                View All\n              </button>\n              <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"OrderCtrl.accountingUnit_clearInput('accountingUnit')\"> \n                Clear\n              </button>\n            </div> \n          </div>\n          <p class=\"help-block\" ng-if=\"!OrderCtrl.form.accountingUnitRef\">Invalid Accounting Unit. Please select from list.</p>\n        </div>\n\n        <!-- <div class=\"form-group\" ng-class=\"{'has-error': orderForm.locationCode.$invalid}\">\n          <label for=\"locationCode\" class=\"required\">Location Code</label>\n          <input type=\"text\" id=\"locationCode\" name=\"locationCode\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.locationCode\" \n            required aria-required=\"true\" placeholder=\"Enter HR Location, Description\"\n            auto-complete-location-code auto-complete-form=\"orderForm\" auto-complete-extra-params=\"OrderCtrl.form\" \n            auto-complete-related-fields=\"['locationCodeRef', 'hrLocation']\" \n            auto-complete-on-change=\"OrderCtrl.getAddress()\"\n          />\n          <input type=\"hidden\" name=\"locationCodeRef\" ng-model=\"OrderCtrl.form.locationCodeRef\" />\n          <input type=\"hidden\" name=\"hrLocation\" ng-model=\"OrderCtrl.form.hrLocation\" />\n          <p class=\"help-block\" ng-if=\"OrderCtrl.form.jobClass && orderForm.jobClass.$error.invalidJobClass\">Invalid Location Code. Please select from list.</p>\n        </div> -->\n\n        <div class=\"form-group\" ng-class=\"{'has-error': !OrderCtrl.form.locationCode || !OrderCtrl.form.locationCodeRef}\">\n          <label for=\"locationCode\" class=\"required\">Location Code</label>\n          <div class=\"input-group autocomplete\">\n            <div auto-complete\n              id=\"locationCode\"\n              placeholder=\"Enter HR Location, Description\"\n              initial-value=\"OrderCtrl.form.locationCode\"\n              pause=\"400\"\n              selected-object=\"OrderCtrl.locationCode_onSelected\"\n              remote-url=\"/api/types/companies/locationCodes?_sortBy=hrLocation&_pageNum=1&_pageSize=All&&keywords=\"\n              remote-url-response-formatter=\"OrderCtrl.locationCode_formatter\"\n              title-field=\"title\"\n              minlength=\"2\"\n              input-changed=\"OrderCtrl.locationCode_onChanged\"\n              input-class=\"form-control input-sm\"\n              match-class=\"highlight\">\n            </div>\n            <!-- <span class=\"input-group-addon new\">\n              <input id=\"locationCodeIsNewLabel\" type=\"checkbox\" ng-model=\"OrderCtrl.form.locationCodeIsNew\"> <label for=\"locationCodeIsNewLabel\">New</label>\n            </span> -->\n            <div class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"OrderCtrl.locationCode_showAll('locationCode')\"> \n                View All\n              </button>\n              <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"OrderCtrl.locationCode_clearInput('locationCode')\"> \n                Clear\n              </button>\n            </div> \n          </div>\n          <p class=\"help-block\" ng-if=\"!OrderCtrl.form.locationCodeRef\">Invalid Location Code. Please select from list.</p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.facilityAddress.$invalid}\">\n          <label for=\"facilityAddress\" class=\"required\">Facility Address</label>\n          <input type=\"text\" id=\"facilityAddress\" class=\"form-control input-sm\" name=\"facilityAddress\" ng-model=\"OrderCtrl.form.facilityAddress\" required aria-required=\"true\" />\n          <p class=\"help-block text-italic\">*Auto populate base on selected Location Code.</p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.orderType.$invalid}\">\n          <label for=\"contactOrPerDiemRequest\" class=\"required\">Order Type</label>\n          <div class=\"radio\">\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"orderType\" value=\"Contract\" ng-model=\"OrderCtrl.form.orderType\" ng-required=\"!OrderCtrl.form.orderType\"> Contract\n            </label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"orderType\" value=\"Per Diem\" ng-model=\"OrderCtrl.form.orderType\" ng-required=\"!OrderCtrl.form.orderType\"> Per Diem\n            </label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"orderType\" value=\"Permanent\" ng-model=\"OrderCtrl.form.orderType\" ng-required=\"!OrderCtrl.form.orderType\"> Permanent\n            </label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"orderType\" value=\"Temp to Perm\" ng-model=\"OrderCtrl.form.orderType\" ng-required=\"!OrderCtrl.form.orderType\"> Temp to Perm\n            </label>\n          </div>\n        </div>\n\n        <!-- <div class=\"form-group\" ng-class=\"{'has-error': orderForm.jobClass.$invalid}\">\n          <label for=\"jobClass\" class=\"required\">Job Class</label>\n          <input type=\"text\" id=\"jobClass\" name=\"jobClass\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.jobClass\" \n            required aria-required=\"true\" placeholder=\"Enter Job Class Name or Job Description\" \n            auto-complete-job-class auto-complete-form=\"orderForm\" auto-complete-extra-params=\"OrderCtrl.form\" \n            auto-complete-related-fields=\"['jobClassRef']\" auto-complete-on-closed=\"OrderCtrl.validateJobClass()\" />\n          <input type=\"hidden\" name=\"jobClassRef\" ng-model=\"OrderCtrl.form.jobClassRef\" />\n          <p class=\"help-block\" ng-if=\"OrderCtrl.form.jobClass && orderForm.jobClass.$error.invalidJobClass\">Invalid Job Class. Please select from list.</p>\n        </div> -->\n\n        <div class=\"form-group\" ng-class=\"{'has-error': !OrderCtrl.form.jobClass || !OrderCtrl.form.jobClassRef}\">\n          <label for=\"jobClass\" class=\"required\">Job Class</label>\n          <div class=\"input-group autocomplete\">\n            <div auto-complete\n              id=\"jobClass\"\n              placeholder=\"Enter Job Class Name or Job Description\"\n              initial-value=\"OrderCtrl.form.jobClass\"\n              pause=\"400\"\n              selected-object=\"OrderCtrl.jobClass_onSelected\"\n              remote-url=\"/api/types/jobClasses?_sortBy=jobClass&_pageNum=1&_pageSize=All&&keywords=\"\n              remote-url-response-formatter=\"OrderCtrl.jobClass_formatter\"\n              title-field=\"title\"\n              minlength=\"2\"\n              input-changed=\"OrderCtrl.jobClass_onChanged\"\n              input-class=\"form-control input-sm\"\n              match-class=\"highlight\">\n            </div>\n            <div class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"OrderCtrl.jobClass_showAll('jobClass')\"> \n                View All\n              </button>\n              <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"OrderCtrl.jobClass_clearInput('jobClass')\"> \n                Clear\n              </button>\n            </div> \n          </div>\n          <p class=\"help-block\" ng-if=\"!OrderCtrl.form.jobClassRef\">Invalid Job Class. Please select from list.</p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.quantity.$invalid}\">\n          <label for=\"quantity\" class=\"required\">Quantity</label>\n          <input type=\"text\" id=\"quantity\" name=\"quantity\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.quantity\" required aria-required=\"true\" />\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.assignmentStartDate.$invalid}\">\n          <label for=\"assignmentStartDate\" class=\"required\">Assignment Start Date</label>\n          <date-picker data-name=\"assignmentStartDate\" data-ng-model=\"OrderCtrl.form.assignmentStartDate\" data-required=\"required\"></date-picker>\n        </div>\n\n        <div class=\"form-group custom-input-group\" ng-class=\"{'has-error': orderForm.assignmentLength.$invalid || orderForm.assignmentLengthType.$invalid}\">\n          <label for=\"assignmentLength\" class=\"required\">Assignment Length</label>\n          <div class=\"input-group\">\n            <select id=\"assignmentLength\" name=\"assignmentLength\" class=\"form-control input-sm\" ng-options=\"option as option for option in OrderCtrl.lengthOptions\" ng-model=\"OrderCtrl.form.assignmentLength\" required aria-required=\"true\">\n              <option value=\"\">Select a Length Number</option>\n            </select>\n            <div class=\"input-group-btn\">\n              <select id=\"assignmentLengthType\" name=\"assignmentLengthType\" class=\"form-control input-sm\" ng-options=\"option as option for option in OrderCtrl.lengthTypeOptions\" ng-model=\"OrderCtrl.form.assignmentLengthType\" required aria-required=\"true\">\n                <option value=\"\">Select a Length Type</option>\n              </select>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row clearfix\">\n          <div class=\"col-sm-6\">\n            <div class=\"form-group\" ng-class=\"{'has-error': orderForm.shiftStart.$invalid}\">\n              <label for=\"shiftStart\" class=\"required\">Shift Start</label>\n              <select id=\"shiftStart\" name=\"shiftStart\" class=\"form-control input-sm\" ng-options=\"option as option for option in OrderCtrl.timeOptions\" ng-model=\"OrderCtrl.form.shiftStart\" required aria-required=\"true\">\n                <option value=\"\">Select a Time</option>\n              </select>\n            </div>\n          </div>\n          <div class=\"col-sm-6\">\n            <div class=\"form-group\" ng-class=\"{'has-error': orderForm.shiftEnd.$invalid}\">\n              <label for=\"shiftEnd\" class=\"required\">Shift End</label>\n              <select id=\"shiftEnd\" name=\"shiftEnd\" class=\"form-control input-sm\" ng-options=\"option as option for option in OrderCtrl.timeOptions\" ng-model=\"OrderCtrl.form.shiftEnd\" required aria-required=\"true\">\n                <option value=\"\">Select a Time</option>\n              </select>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"hoursGuaranteed\">Hours Guaranteed</label>\n          <input type=\"text\" id=\"hoursGuaranteed\" name=\"hoursGuaranteed\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.hoursGuaranteed\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label>Will you accommodate blocked scheduling?</label>\n          <div class=\"radio\">\n            <label class=\"radio-inline\">\n              <input type=\"radio\" id=\"blockedSchedulingAvailableYes\" name=\"blockedSchedulingAvailable\" value=\"Yes\" ng-model=\"OrderCtrl.form.blockedSchedulingAvailable\"> Yes\n            </label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" id=\"blockedSchedulingAvailableNo\" name=\"blockedSchedulingAvailable\" value=\"No\" ng-model=\"OrderCtrl.form.blockedSchedulingAvailable\"> No\n            </label>\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Credential Requirements, check all that apply:</label>\n          <div class=\"form-inline\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_acls\"> <span>ACLS</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_awhonn\"> <span>AWHONN</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_bls\"> <span>BLS</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_ekg\"> <span>EKG</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_nih\"> <span>NIH</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_nrp\"> <span>NRP</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_nvci\"> <span>NVCI</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_onc\"> <span>ONC</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_pals\"> <span>PALS</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_tncc\"> <span>TNCC</span>\n              </label>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"weekendRequirement\">Weekend Requirement</label>\n          <input type=\"text\" id=\"weekendRequirement\" name=\"weekendRequirement\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.weekendRequirement\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"onCallRequirement\">On Call Requirement</label>\n          <input type=\"text\" id=\"onCallRequirement\" name=\"onCallRequirement\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.onCallRequirement\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"floatingRequirementLocations\">Floating Requirement / Locations</label>\n          <input type=\"text\" id=\"floatingRequirementLocations\" name=\"floatingRequirementLocations\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.floatingRequirementLocations\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"yearsExperienceRequired\">Years Experience Required</label>\n          <select id=\"yearsExperienceRequired\" name=\"yearsExperienceRequired\" class=\"form-control input-sm\" ng-options=\"option as option for option in OrderCtrl.yearsExperienceOptions\" ng-model=\"OrderCtrl.form.yearsExperienceRequired\">\n            <option value=\"\">Select Your Answer</option>\n          </select>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"nursePatientRatio\">Nurse / Patient Ratio</label>\n          <input type=\"text\" id=\"nursePatientRatio\" name=\"nursePatientRatio\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.nursePatientRatio\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"emrUsed\">EMR Used</label>\n          <input type=\"text\" id=\"emrUsed\" class=\"form-control input-sm\" name=\"emrUsed\" ng-model=\"OrderCtrl.form.emrUsed\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"dressCode\">Dress Code (business professional, business casual, scrub color, etc.)</label>\n          <input type=\"text\" id=\"dressCode\" name=\"dressCode\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.dressCode\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"orientationDatesAdditionalInformation\">First Day Instructions</label>\n          <input type=\"text\" id=\"firstDayInstructions\" name=\"firstDayInstructions\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.firstDayInstructions\" />\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.requestedBy.$invalid}\">\n          <label for=\"requestedBy\" class=\"required\">Requested By</label>\n          <input type=\"text\" id=\"requestedBy\" name=\"requestedBy\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.requestedBy\" required aria-required=\"true\" />\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.requestAuthorizedBy.$invalid}\">\n          <label for=\"requestAuthorizedBy\" class=\"required\">Authorized By/Final Approver</label>\n          <input type=\"text\" id=\"requestAuthorizedBy\" name=\"requestAuthorizedBy\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.requestAuthorizedBy\" required aria-required=\"true\">\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.submitCandidatesTo.$invalid}\">\n          <label for=\"submitCandidatesTo\" class=\"required\">Hiring Manager/Submit Candidates To (Name and Email)</label>\n          <input type=\"text\" id=\"submitCandidatesTo\" name=\"submitCandidatesTo\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.submitCandidatesTo\" required aria-required=\"true\">\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"jobDescription\">Job Description/Additional Details</label>\n          <textarea id=\"jobDescription\" name=\"jobDescription\" class=\"form-control input-sm preserve-formatting\" ng-model=\"OrderCtrl.form.jobDescription\"></textarea>\n        </div>\n\n        <div class=\"alert alert-danger\" ng-if=\"orderForm.$invalid\">\n          <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i> Form contain error(s). Please scroll up....\n        </div>\n\n        <div class=\"alert alert-info\" ng-if=\"OrderCtrl.showCreatedSuccessMsg\">\n          <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i> Your order has been submitted.\n        </div>\n\n        <div class=\"alert alert-info\" ng-if=\"OrderCtrl.showUpdatedSuccessMsg\">\n          <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i> Your order has been updated.\n        </div>\n\n        <!-- <pre>{{OrderCtrl.form | json}}</pre> -->\n\n        <div class=\"form-group buttons\" ng-if=\"!OrderCtrl.showCreatedSuccessMsg && !OrderCtrl.showUpdatedSuccessMsg\">\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\" ng-if=\"OrderCtrl.isAdd\" ng-disabled=\"$OrderCtrl.isSaving\">Submit</button>\n          <button type=\"reset\" class=\"btn btn-default btn-sm\" ng-if=\"OrderCtrl.isAdd\">Reset</button>\n          <button type=\"submit\" class=\"btn btn-info btn-sm\" ng-if=\"!OrderCtrl.isAdd\" ng-disabled=\"form.$invalid || $OrderCtrl.isSaving\">Update</button>\n          <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"OrderCtrl.delete();\" ng-if=\"!OrderCtrl.isAdd\">Delete</button>\n        </div>\n      </div>\n      <div class=\"col-sm-4\" ng-if=\"!OrderCtrl.isAdd\">\n        <div class=\"alert alert-info\">\n          <div class=\"form-group\">\n            <label for=\"healthSystemName\">Created By</label>\n            <p>{{OrderCtrl.form.createdBy}} on {{OrderCtrl.form.createdDate | date: 'MM/dd/yyyy hh:mm a'}}</p>\n          </div>\n          <div class=\"form-group\" ng-if=\"OrderCtrl.form.modifiedBy\">\n            <label for=\"healthSystemName\">Modified By</label>\n            <p>{{OrderCtrl.form.modifiedBy}} on {{OrderCtrl.form.modifiedDate | date: 'MM/dd/yyyy hh:mm a'}}</p>\n          </div>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrderNewComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _orderNew = __webpack_require__(106);
	
	var _orderNew2 = _interopRequireDefault(_orderNew);
	
	var _exportModal = __webpack_require__(103);
	
	var _exportModal2 = _interopRequireDefault(_exportModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	var uiRouter = __webpack_require__(10);
	var _ = __webpack_require__(22);
	
	var OrderNewComponent = exports.OrderNewComponent = function () {
	  OrderNewComponent.$inject = ['$scope', '$http', '$q', '$state', '$stateParams', '$timeout', '$filter', '$uibModal', 'Auth', 'Modal', 'Util'];
	  function OrderNewComponent($scope, $http, $q, $state, $stateParams, $timeout, $filter, $uibModal, Auth, Modal, Util) {
	    'ngInject';
	
	    _classCallCheck(this, OrderNewComponent);
	
	    this.$scope = $scope;
	    this.$http = $http;
	    this.$q = $q;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$timeout = $timeout;
	    this.$filter = $filter;
	    this.$uibModal = $uibModal;
	    this.Auth = Auth;
	    this.Modal = Modal;
	    this.Util = Util;
	
	    this.user;
	
	    this.isAdd = true;
	    this.submitted = false;
	    this.form = {};
	    this.isSaving = false;
	    this.showCreatedSuccessMsg = false;
	    this.showUpdatedSuccessMsg = false;
	
	    this.companyGLOptions = [];
	    this.accountingUnits = [];
	    this.locationCodes = [];
	
	    this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26];
	    this.lengthTypeOptions = ['Days', 'Weeks'];
	    this.timeOptions = ['12:00 AM', '12:15 AM', '12:30 AM', '12:45 AM', '1:00 AM', '1:15 AM', '1:30 AM', '1:45 AM', '2:00 AM', '2:15 AM', '2:30 AM', '2:45 AM', '3:00 AM', '3:15 AM', '3:30 AM', '3:45 AM', '4:00 AM', '4:15 AM', '4:30 AM', '4:45 AM', '5:00 AM', '5:15 AM', '5:30 AM', '5:45 AM', '6:00 AM', '6:15 AM', '6:30 AM', '6:45 AM', '7:00 AM', '7:15 AM', '7:30 AM', '7:45 AM', '8:00 AM', '8:15 AM', '8:30 AM', '8:45 AM', '9:00 AM', '9:15 AM', '9:30 AM', '9:45 AM', '10:00 AM', '10:15 AM', '10:30 AM', '10:45 AM', '11:00 AM', '11:15 AM', '11:30 AM', '11:45 AM', '12:00 PM', '12:15 PM', '12:30 PM', '12:45 PM', '1:00 PM', '1:15 PM', '1:30 PM', '1:45 PM', '2:00 PM', '2:15 PM', '2:30 PM', '2:45 PM', '3:00 PM', '3:15 PM', '3:30 PM', '3:45 PM', '4:00 PM', '4:15 PM', '4:30 PM', '4:45 PM', '5:00 PM', '5:15 PM', '5:30 PM', '5:45 PM', '6:00 PM', '6:15 PM', '6:30 PM', '6:45 PM', '7:00 PM', '7:15 PM', '7:30 PM', '7:45 PM', '8:00 PM', '8:15 PM', '8:30 PM', '8:45 PM', '9:00 PM', '9:15 PM', '9:30 PM', '9:45 PM', '10:00 PM', '10:15 PM', '10:30 PM', '10:45 PM', '11:00 PM', '11:15 PM', '11:30 PM', '11:45 PM'];
	    this.incentiveOptions = ['$0', '$1', '$2', '$3', '$4', '$5', 'Submit Required Rate'];
	    this.yearsExperienceOptions = ['0', '1', '2', '3', '4', '5+'];
	    this.yesNoOptions = ['Yes', 'No'];
	
	    this.showTravelInput = false;
	  }
	
	  _createClass(OrderNewComponent, [{
	    key: 'getCompanyGLs',
	    value: function getCompanyGLs(extraParams) {
	      var deferred = this.$q.defer();
	      var self = this;
	      var params = {
	        _pageSize: 'All',
	        _selector: 'companyName,gl',
	        _sortBy: 'gl asc'
	      };
	      if (extraParams) {
	        angular.extend(params, extraParams);
	      }
	      this.$http.get('/api/types/companies/gls', { params: params }).then(function (response) {
	        self.companyGLOptions = response.data;
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'getAccountingUnits',
	    value: function getAccountingUnits(extraParams) {
	      var deferred = this.$q.defer();
	      var self = this;
	      var params = {
	        _pageSize: 'All',
	        _selector: 'hrOrganizationUnit,shortDescription,description,parentUnitShortDescription,mvsOrBsc',
	        _sortBy: 'hrOrganizationUnit asc'
	      };
	      if (extraParams) {
	        angular.extend(params, extraParams);
	      }
	      this.$http.get('/api/types/companies/accountingUnits', { params: params }).then(function (response) {
	        self.accountingUnits = response.data;
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'getLocationCodes',
	    value: function getLocationCodes(extraParams) {
	      var deferred = this.$q.defer();
	      var self = this;
	      var params = {
	        _pageSize: 'All',
	        _selector: 'hrLocation,description,mvsOrBsc',
	        _sortBy: 'hrLocation asc'
	      };
	      if (extraParams) {
	        angular.extend(params, extraParams);
	      }
	      this.$http.get('/api/types/companies/locationCodes', { params: params }).then(function (response) {
	        self.locationCodes = response.data;
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'noPad',
	    value: function noPad(n, size) {
	      var s = String(n);
	      while (s.length < (size || 2)) {
	        s = "0" + s;
	      }
	      return s;
	    }
	  }, {
	    key: 'getData',
	    value: function getData(id) {
	      var deferred = this.$q.defer();
	      var self = this;
	      this.$http.get('/api/orders/' + id).then(function (response) {
	        if (response.data.orderNo) {
	          response.data._orderNo = self.noPad(response.data.orderNo, 5);
	        }
	        if (response.data.assignmentStartDate) {
	          response.data.assignmentStartDate = new Date(response.data.assignmentStartDate);
	        }
	        if (response.data.assignmentLength) {
	          response.data.assignmentLength = parseInt(response.data.assignmentLength);
	        }
	        if (response.data.credentialRequirements) {
	          var credentialRequirements = response.data.credentialRequirements.split(', ');
	          angular.forEach(credentialRequirements, function (cred) {
	            if (cred === 'ACLS') {
	              response.data.credentialRequirement_acls = true;
	            } else if (cred === 'AWHONN') {
	              response.data.credentialRequirement_awhonn = true;
	            } else if (cred === 'BLS') {
	              response.data.credentialRequirement_bls = true;
	            } else if (cred === 'Certification') {
	              response.data.credentialRequirement_certification = true;
	            } else if (cred === 'De-Escalation') {
	              response.data.credentialRequirement_deescalation = true;
	            } else if (cred === 'EKG') {
	              response.data.credentialRequirement_ekg = true;
	            } else if (cred === 'NIH (Stroke Center)') {
	              response.data.credentialRequirement_nih = true;
	            } else if (cred === 'NRP') {
	              response.data.credentialRequirement_nrp = true;
	            } else if (cred === 'ONC') {
	              response.data.credentialRequirement_onc = true;
	            } else if (cred === 'PALS') {
	              response.data.credentialRequirement_pals = true;
	            } else if (cred === 'STABLE') {
	              response.data.credentialRequirement_stable = true;
	            } else if (cred === 'TCAR') {
	              response.data.credentialRequirement_tcar = true;
	            } else if (cred === 'TNCC') {
	              response.data.credentialRequirement_tncc = true;
	            } else if (cred === 'N/A') {
	              response.data.credentialRequirement_na = true;
	            }
	          });
	        }
	        self.form = response.data;
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'update',
	    value: function update(id, payload) {
	      var self = this;
	      this.$http.put('/api/orders/' + id, payload).then(function (response) {
	        self.showUpdatedSuccessMsg = true;
	        self.$timeout(function () {
	          self.showUpdatedSuccessMsg = false;
	          self.$state.go('main');
	        }, 5000);
	      }, function (err) {
	        self.isSaving = false;
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(payload) {
	      var self = this;
	      this.$http.post('/api/orders', payload).then(function (response) {
	        self.showCreatedSuccessMsg = true;
	        self.$timeout(function () {
	          self.showCreatedSuccessMsg = false;
	          self.$state.go('main');
	        }, 5000);
	      }, function (err) {
	        self.isSaving = false;
	      });
	    }
	  }, {
	    key: 'checkCredReq',
	    value: function checkCredReq() {
	      var self = this;
	      var credentialRequirements = [];
	      if (self.form.credentialRequirement_acls) {
	        credentialRequirements.push('ACLS');
	      }
	      if (self.form.credentialRequirement_awhonn) {
	        credentialRequirements.push('AWHONN');
	      }
	      if (self.form.credentialRequirement_bls) {
	        credentialRequirements.push('BLS');
	      }
	      if (self.form.credentialRequirement_certification) {
	        credentialRequirements.push('Certification');
	      }
	      if (self.form.credentialRequirement_deescalation) {
	        credentialRequirements.push('De-Escalation');
	      }
	      if (self.form.credentialRequirement_ekg) {
	        credentialRequirements.push('EKG');
	      }
	      if (self.form.credentialRequirement_nih) {
	        credentialRequirements.push('NIH');
	      }
	      if (self.form.credentialRequirement_nrp) {
	        credentialRequirements.push('NRP');
	      }
	      if (self.form.credentialRequirement_onc) {
	        credentialRequirements.push('ONC');
	      }
	      if (self.form.credentialRequirement_pals) {
	        credentialRequirements.push('PALS');
	      }
	      if (self.form.credentialRequirement_stable) {
	        credentialRequirements.push('STABLE');
	      }
	      if (self.form.credentialRequirement_tcar) {
	        credentialRequirements.push('TCAR');
	      }
	      if (self.form.credentialRequirement_tncc) {
	        credentialRequirements.push('TNCC');
	      }
	      if (self.form.credentialRequirement_na) {
	        credentialRequirements.push('N/A');
	      }
	      return credentialRequirements.length ? true : false;
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(form) {
	      var self = this;
	      this.submitted = true;
	      if (form.$valid && self.form.companyGLRef && self.form.accountingUnitRef && self.form.locationCodeRef && self.form.jobClassRef) {
	        self.isSaving = true;
	        if (self.form.assignmentStartDate) {
	          self.form.assignmentStartDateStr = self.$filter('date')(self.form.assignmentStartDate, 'MM/dd/yyyy');
	        }
	        var credentialRequirements = [];
	        if (self.form.credentialRequirement_acls) {
	          credentialRequirements.push('ACLS');
	        }
	        if (self.form.credentialRequirement_awhonn) {
	          credentialRequirements.push('AWHONN');
	        }
	        if (self.form.credentialRequirement_bls) {
	          credentialRequirements.push('BLS');
	        }
	        if (self.form.credentialRequirement_certification) {
	          credentialRequirements.push('Certification');
	        }
	        if (self.form.credentialRequirement_deescalation) {
	          credentialRequirements.push('De-Escalation');
	        }
	        if (self.form.credentialRequirement_ekg) {
	          credentialRequirements.push('EKG');
	        }
	        if (self.form.credentialRequirement_nih) {
	          credentialRequirements.push('NIH (Stroke Center)');
	        }
	        if (self.form.credentialRequirement_nrp) {
	          credentialRequirements.push('NRP');
	        }
	        if (self.form.credentialRequirement_onc) {
	          credentialRequirements.push('ONC');
	        }
	        if (self.form.credentialRequirement_pals) {
	          credentialRequirements.push('PALS');
	        }
	        if (self.form.credentialRequirement_stable) {
	          credentialRequirements.push('STABLE');
	        }
	        if (self.form.credentialRequirement_tcar) {
	          credentialRequirements.push('TCAR');
	        }
	        if (self.form.credentialRequirement_tncc) {
	          credentialRequirements.push('TNCC');
	        }
	        if (credentialRequirements.length) {
	          self.form.credentialRequirements = credentialRequirements.join(', ');
	        }
	        if (!self.isAdd) {
	          self.update(self.form._id, self.form);
	        } else {
	          self.create(self.form);
	        }
	      }
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var self = this;
	      this.Modal.confirm.delete(function () {})('order');
	    }
	  }, {
	    key: 'companyGL_formatter',
	    value: function companyGL_formatter(items) {
	      var formattedItems = [];
	      var i = void 0;
	      for (i in items) {
	        formattedItems.push({
	          id: items[i]._id,
	          title: items[i].gl + ' / ' + items[i].regionName + ' / ' + items[i].companyName
	        });
	      }
	      return formattedItems;
	    }
	  }, {
	    key: 'companyGL_showAll',
	    value: function companyGL_showAll(id) {
	      this.$scope.$broadcast('autocomplete:showAll', id);
	    }
	  }, {
	    key: 'companyGL_onChanged',
	    value: function companyGL_onChanged(input) {
	      this.$parent.OrderCtrl.form.companyGL = input;
	    }
	  }, {
	    key: 'companyGL_onSelected',
	    value: function companyGL_onSelected(selected) {
	      if (selected) {
	        if (this.$parent.OrderCtrl.form.companyGLIsNew) {
	          this.$parent.OrderCtrl.form.companyGLIsNew = false;
	        }
	
	        this.$parent.OrderCtrl.form.companyGL = selected.title;
	        this.$parent.OrderCtrl.form.companyGLRef = selected.originalObject.id;
	
	        if (/System Office/.test(selected.title)) {
	          this.$parent.OrderCtrl.showTravelInput = true;
	        }
	      }
	    }
	  }, {
	    key: 'companyGL_clearInput',
	    value: function companyGL_clearInput(id) {
	      this.$scope.$broadcast('autocomplete:clearInput', id);
	      this.form.companyGL = null;
	      this.form.companyGLRef = null;
	      this.showTravelInput = false;
	    }
	  }, {
	    key: 'accountingUnit_formatter',
	    value: function accountingUnit_formatter(items) {
	      try {
	        var formattedItems = [];
	        var i = void 0;
	        var titles = [];
	        for (i in items) {
	          titles = [];
	          if (items[i].hrOrganizationUnit) {
	            titles.push(items[i].hrOrganizationUnit);
	          }
	          if (items[i].shortDescription) {
	            titles.push(items[i].shortDescription);
	          }
	          if (items[i].description) {
	            titles.push(items[i].description);
	          }
	          if (items[i].parentUnitShortDescription) {
	            titles.push(items[i].parentUnitShortDescription);
	          }
	          formattedItems.push({
	            id: items[i]._id,
	            title: titles.join(' / ')
	          });
	        }
	        return formattedItems;
	      } catch (err) {
	        console.log(err);
	        return;
	      }
	    }
	  }, {
	    key: 'accountingUnit_showAll',
	    value: function accountingUnit_showAll(id) {
	      this.$scope.$broadcast('autocomplete:showAll', id);
	    }
	  }, {
	    key: 'accountingUnit_onChanged',
	    value: function accountingUnit_onChanged(input) {
	      this.$parent.OrderCtrl.form.accountingUnit = input;
	    }
	  }, {
	    key: 'accountingUnit_onSelected',
	    value: function accountingUnit_onSelected(selected) {
	      if (selected) {
	        if (this.$parent.OrderCtrl.form.accountingUnitIsNew) {
	          this.$parent.OrderCtrl.form.accountingUnitIsNew = false;
	        }
	
	        this.$parent.OrderCtrl.form.accountingUnit = selected.title;
	        this.$parent.OrderCtrl.form.accountingUnitRef = selected.originalObject.id;
	      }
	    }
	  }, {
	    key: 'accountingUnit_clearInput',
	    value: function accountingUnit_clearInput(id) {
	      this.$scope.$broadcast('autocomplete:clearInput', id);
	      this.form.accountingUnit = null;
	      this.form.accountingUnitRef = null;
	    }
	  }, {
	    key: 'locationCode_formatter',
	    value: function locationCode_formatter(items) {
	      try {
	        var formattedItems = [];
	        var i = void 0;
	        var titles = [];
	        for (i in items) {
	          titles = [];
	          if (items[i].hrLocation) {
	            titles.push(items[i].hrLocation);
	          }
	          if (items[i].description) {
	            titles.push(items[i].description);
	          }
	          formattedItems.push({
	            id: items[i]._id,
	            hrLocation: items[i].hrLocation,
	            title: titles.join(' / ')
	          });
	        }
	        return formattedItems;
	      } catch (err) {
	        console.log(err);
	        return;
	      }
	    }
	  }, {
	    key: 'locationCode_showAll',
	    value: function locationCode_showAll(id) {
	      this.$scope.$broadcast('autocomplete:showAll', id);
	    }
	  }, {
	    key: 'locationCode_onChanged',
	    value: function locationCode_onChanged(input) {
	      this.$parent.OrderCtrl.form.locationCode = input;
	    }
	  }, {
	    key: 'locationCode_onSelected',
	    value: function locationCode_onSelected(selected) {
	      if (selected) {
	        if (this.$parent.OrderCtrl.form.locationCodeIsNew) {
	          this.$parent.OrderCtrl.form.locationCodeIsNew = false;
	        }
	
	        this.$parent.OrderCtrl.form.locationCode = selected.title;
	        this.$parent.OrderCtrl.form.locationCodeRef = selected.originalObject.id;
	
	        this.$parent.OrderCtrl.getAddress(selected.originalObject.hrLocation);
	      }
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(hrLocation) {
	
	      var deferred = this.$q.defer();
	      var self = this;
	      var params = {
	        hrLocation: hrLocation,
	        _pageSize: 'All',
	        _selector: 'hrLocation,displayAddress',
	        _sortBy: 'hrLocation asc'
	      };
	      this.$http.get('/api/types/companies/addresses', { params: params }).then(function (response) {
	        if (response.data && response.data.length) {
	          self.form.facilityAddress = response.data[0].displayAddress;
	        }
	        deferred.resolve();
	      }, function (err) {
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'locationCode_clearInput',
	    value: function locationCode_clearInput(id) {
	      this.$scope.$broadcast('autocomplete:clearInput', id);
	      this.form.locationCode = null;
	      this.form.locationCodeRef = null;
	    }
	  }, {
	    key: 'jobClass_formatter',
	    value: function jobClass_formatter(items) {
	      try {
	        var formattedItems = [];
	        var i = void 0;
	        var titles = [];
	        for (i in items) {
	          titles = [];
	          if (items[i].name) {
	            titles.push(items[i].name);
	          }
	          if (items[i].description) {
	            titles.push(items[i].description);
	          }
	          formattedItems.push({
	            id: items[i]._id,
	            title: titles.join(' / ')
	          });
	        }
	        return formattedItems;
	      } catch (err) {
	        console.log(err);
	        return;
	      }
	    }
	  }, {
	    key: 'jobClass_showAll',
	    value: function jobClass_showAll(id) {
	      this.$scope.$broadcast('autocomplete:showAll', id);
	    }
	  }, {
	    key: 'jobClass_onChanged',
	    value: function jobClass_onChanged(input) {
	      this.$parent.OrderCtrl.form.jobClass = input;
	    }
	  }, {
	    key: 'jobClass_onSelected',
	    value: function jobClass_onSelected(selected) {
	      if (selected) {
	        this.$parent.OrderCtrl.form.jobClass = selected.title;
	        this.$parent.OrderCtrl.form.jobClassRef = selected.originalObject.id;
	      }
	    }
	  }, {
	    key: 'jobClass_clearInput',
	    value: function jobClass_clearInput(id) {
	      this.$scope.$broadcast('autocomplete:clearInput', id);
	      this.form.jobClass = null;
	      this.form.jobClassRef = null;
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var self = this;
	      this.Auth.getCurrentUser().then(function (user) {
	        self.user = user;
	        self.form.requestedBy = user.name;
	        if (self.$stateParams.id) {
	          self.isAdd = false;
	          self.getData(self.$stateParams.id);
	        }
	      });
	    }
	  }]);
	
	  return OrderNewComponent;
	}();
	
	exports.default = angular.module('wftOrderFormApp.orderNew', [uiRouter]).config(_orderNew2.default).component('ordernew', {
	  template: __webpack_require__(107),
	  controller: OrderNewComponent,
	  controllerAs: 'OrderCtrl'
	}).controller('ExportModalController', _exportModal2.default).name;

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('orderNew', {
	    url: '/order-new',
	    template: '<ordernew></ordernew>',
	    authenticate: true
	  }).state('orderNewEdit', {
	    url: '/order-new/:id',
	    template: '<ordernew></ordernew>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"order-page\">\n  <header class=\"banner\" id=\"banner\">\n    <div class=\"container\"></div>\n  </header>\n  <div class=\"container clearfix\">\n    <ol class=\"breadcrumb\">\n      <li><a href=\"/\">Home</a></li>\n      <li class=\"active\">Client Order</li>\n    </ol>\n    <div class=\"page-header\">\n      <h3>Client Order <small ng-if=\"!this.isAdd && OrderCtrl.form._orderNo\">#{{OrderCtrl.form._orderNo}}</small></h3>\n    </div>\n    <form name=\"orderForm\" class=\"form\" ng-submit=\"OrderCtrl.submitForm(orderForm)\" novalidate=\"novalidate\">\n      <div class=\"col-sm-8\">\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.inforRequisition.$invalid}\">\n          <label for=\"inforRequisition\" class=\"required\">Infor Requisition #</label>\n          <input type=\"text\" id=\"inforRequisition\" class=\"form-control input-sm\" name=\"inforRequisition\" ng-model=\"OrderCtrl.form.inforRequisition\" required aria-required=\"true\" />\n        </div>\n\n        <!-- <div class=\"form-group\" ng-class=\"{'has-error': orderForm.companyGL.$invalid}\">\n          <label for=\"companyGL\" class=\"required\">Company/GL</label>\n          <input type=\"text\" id=\"companyGL\" name=\"companyGL\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.companyGL\" \n            required aria-required=\"true\" placeholder=\"Enter Company Name or GL\" \n            auto-complete-company-gl auto-complete-form=\"orderForm\" auto-complete-extra-params=\"OrderCtrl.form\" \n            auto-complete-related-fields=\"['companyGLRef']\" />\n          <input type=\"hidden\" name=\"companyGLRef\" ng-model=\"OrderCtrl.form.companyGLRef\" />\n          <p class=\"help-block\" ng-if=\"OrderCtrl.form.jobClass && orderForm.jobClass.$error.invalidJobClass\">Invalid Company/GL. Please select from list.</p>\n        </div> -->\n\n        <div class=\"form-group\" ng-class=\"{'has-error': !OrderCtrl.form.companyGL || !OrderCtrl.form.companyGLRef}\">\n          <label for=\"companyGL\" class=\"required\">Company/GL</label>\n          <div class=\"input-group autocomplete\">\n            <div auto-complete\n              id=\"companyGL\"\n              placeholder=\"Enter Company Name or GL\" \n              initial-value=\"OrderCtrl.form.companyGL\"\n              pause=\"400\"\n              selected-object=\"OrderCtrl.companyGL_onSelected\"\n              remote-url=\"/api/types/companies/gls?_sortBy=gl&_pageNum=1&_pageSize=All&&keywords=\"\n              remote-url-response-formatter=\"OrderCtrl.companyGL_formatter\"\n              title-field=\"title\"\n              minlength=\"2\"\n              input-changed=\"OrderCtrl.companyGL_onChanged\"\n              input-class=\"form-control input-sm\"\n              match-class=\"highlight\">\n            </div>\n            <!-- <span class=\"input-group-addon new\">\n              <input id=\"companyGLIsNewLabel\" type=\"checkbox\" ng-model=\"OrderCtrl.form.companyGLIsNew\"> <label for=\"companyGLIsNewLabel\">New</label>\n            </span> -->\n            <div class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"OrderCtrl.companyGL_showAll('companyGL')\"> \n                View All\n              </button>\n              <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"OrderCtrl.companyGL_clearInput('companyGL')\"> \n                Clear\n              </button>\n            </div> \n          </div>\n          <p class=\"help-block\" ng-if=\"!OrderCtrl.form.companyGLRef\">Invalid Company/GL. Please select from list.</p>\n        </div>\n\n        <!-- <div class=\"form-group\" ng-class=\"{'has-error': orderForm.accountingUnit.$invalid}\">\n          <label for=\"accountingUnit\" class=\"required\">Accounting Unit</label>\n          <input type=\"text\" id=\"accountingUnit\" name=\"accountingUnit\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.accountingUnit\" \n            required aria-required=\"true\" placeholder=\"Enter HR Organization Unit, Short Description, Description, Parent Unit Short Description\" \n            auto-complete-accounting-unit auto-complete-form=\"orderForm\" auto-complete-extra-params=\"OrderCtrl.form\" \n            auto-complete-related-fields=\"['accountingUnitRef']\" />\n          <input type=\"hidden\" name=\"accountingUnitRef\" ng-model=\"OrderCtrl.form.accountingUnitRef\" />\n          <p class=\"help-block\" ng-if=\"OrderCtrl.form.jobClass && orderForm.jobClass.$error.invalidJobClass\">Invalid Job Class. Please select from list.</p>\n        </div> -->\n\n        <div class=\"form-group\" ng-class=\"{'has-error': !OrderCtrl.form.accountingUnit || !OrderCtrl.form.accountingUnitRef}\">\n          <label for=\"accountingUnit\" class=\"required\">Accounting Unit</label>\n          <div class=\"input-group autocomplete\">\n            <div auto-complete\n              id=\"accountingUnit\"\n              placeholder=\"Enter HR Organization Unit, Short Description, Description, Parent Unit Short Description\"\n              initial-value=\"OrderCtrl.form.accountingUnit\"\n              pause=\"400\"\n              selected-object=\"OrderCtrl.accountingUnit_onSelected\"\n              remote-url=\"/api/types/companies/accountingUnits?_sortBy=hrOrganizationUnit&_pageNum=1&_pageSize=All&&keywords=\"\n              remote-url-response-formatter=\"OrderCtrl.accountingUnit_formatter\"\n              title-field=\"title\"\n              minlength=\"2\"\n              input-changed=\"OrderCtrl.accountingUnit_onChanged\"\n              input-class=\"form-control input-sm\"\n              match-class=\"highlight\">\n            </div>\n            <!-- <span class=\"input-group-addon new\">\n              <input id=\"accountingUnitIsNewLabel\" type=\"checkbox\" ng-model=\"OrderCtrl.form.accountingUnitIsNew\"> <label for=\"accountingUnitIsNewLabel\">New</label>\n            </span> -->\n            <div class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"OrderCtrl.accountingUnit_showAll('accountingUnit')\"> \n                View All\n              </button>\n              <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"OrderCtrl.accountingUnit_clearInput('accountingUnit')\"> \n                Clear\n              </button>\n            </div> \n          </div>\n          <p class=\"help-block\" ng-if=\"!OrderCtrl.form.accountingUnitRef\">Invalid Accounting Unit. Please select from list.</p>\n        </div>\n\n        <!-- <div class=\"form-group\" ng-class=\"{'has-error': orderForm.locationCode.$invalid}\">\n          <label for=\"locationCode\" class=\"required\">Location Code</label>\n          <input type=\"text\" id=\"locationCode\" name=\"locationCode\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.locationCode\" \n            required aria-required=\"true\" placeholder=\"Enter HR Location, Description\"\n            auto-complete-location-code auto-complete-form=\"orderForm\" auto-complete-extra-params=\"OrderCtrl.form\" \n            auto-complete-related-fields=\"['locationCodeRef', 'hrLocation']\" \n            auto-complete-on-change=\"OrderCtrl.getAddress()\"\n          />\n          <input type=\"hidden\" name=\"locationCodeRef\" ng-model=\"OrderCtrl.form.locationCodeRef\" />\n          <input type=\"hidden\" name=\"hrLocation\" ng-model=\"OrderCtrl.form.hrLocation\" />\n          <p class=\"help-block\" ng-if=\"OrderCtrl.form.jobClass && orderForm.jobClass.$error.invalidJobClass\">Invalid Location Code. Please select from list.</p>\n        </div> -->\n\n        <div class=\"form-group\" ng-class=\"{'has-error': !OrderCtrl.form.locationCode || !OrderCtrl.form.locationCodeRef}\">\n          <label for=\"locationCode\" class=\"required\">Location Code</label>\n          <div class=\"input-group autocomplete\">\n            <div auto-complete\n              id=\"locationCode\"\n              placeholder=\"Enter HR Location, Description\"\n              initial-value=\"OrderCtrl.form.locationCode\"\n              pause=\"400\"\n              selected-object=\"OrderCtrl.locationCode_onSelected\"\n              remote-url=\"/api/types/companies/locationCodes?_sortBy=hrLocation&_pageNum=1&_pageSize=All&&keywords=\"\n              remote-url-response-formatter=\"OrderCtrl.locationCode_formatter\"\n              title-field=\"title\"\n              minlength=\"2\"\n              input-changed=\"OrderCtrl.locationCode_onChanged\"\n              input-class=\"form-control input-sm\"\n              match-class=\"highlight\">\n            </div>\n            <!-- <span class=\"input-group-addon new\">\n              <input id=\"locationCodeIsNewLabel\" type=\"checkbox\" ng-model=\"OrderCtrl.form.locationCodeIsNew\"> <label for=\"locationCodeIsNewLabel\">New</label>\n            </span> -->\n            <div class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"OrderCtrl.locationCode_showAll('locationCode')\"> \n                View All\n              </button>\n              <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"OrderCtrl.locationCode_clearInput('locationCode')\"> \n                Clear\n              </button>\n            </div> \n          </div>\n          <p class=\"help-block\" ng-if=\"!OrderCtrl.form.locationCodeRef\">Invalid Location Code. Please select from list.</p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.facilityAddress.$invalid}\">\n          <label for=\"facilityAddress\" class=\"required\">Facility Address</label>\n          <input type=\"text\" id=\"facilityAddress\" class=\"form-control input-sm\" name=\"facilityAddress\" ng-model=\"OrderCtrl.form.facilityAddress\" required aria-required=\"true\" />\n          <p class=\"help-block text-italic\">*Auto populate base on selected Location Code.</p>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"settingTypeLabel\">Setting Type</label>\n          <div class=\"radio\">\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"settingType\" value=\"Onsite\" ng-model=\"OrderCtrl.form.settingType\"> Onsite\n            </label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"settingType\" value=\"Remote\" ng-model=\"OrderCtrl.form.settingType\"> Remote\n            </label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"settingType\" value=\"Hybrid\" ng-model=\"OrderCtrl.form.settingType\"> Hybrid\n            </label>\n          </div>\n        </div>\n\n        <div class=\"form-group\" ng-if=\"OrderCtrl.showTravelInput\">\n          <label for=\"travelLabel\">At any point in assignment, will the contractor need to travel onsite to a Christus clinical-setting address?</label>\n          <div class=\"radio\">\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"travel\" value=\"Yes\" ng-model=\"OrderCtrl.form.travel\"> Yes\n            </label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"travel\" value=\"No\" ng-model=\"OrderCtrl.form.travel\"> No\n            </label>\n          </div>\n          <em>Per Christus policy, contractors going to clinical settings must have medical credentials. If any changes are made to the assignment, it is the responsibility of the hiring manager to update Christus MSP.</em>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.orderType.$invalid}\">\n          <label for=\"orderTypeLabel\" class=\"required\">Order Type</label>\n          <div class=\"radio\">\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"orderType\" value=\"Contract\" ng-model=\"OrderCtrl.form.orderType\" ng-required=\"!OrderCtrl.form.orderType\"> Contract\n            </label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"orderType\" value=\"Per Diem\" ng-model=\"OrderCtrl.form.orderType\" ng-required=\"!OrderCtrl.form.orderType\"> Per Diem\n            </label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"orderType\" value=\"Permanent\" ng-model=\"OrderCtrl.form.orderType\" ng-required=\"!OrderCtrl.form.orderType\"> Permanent\n            </label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" name=\"orderType\" value=\"Temp to Perm\" ng-model=\"OrderCtrl.form.orderType\" ng-required=\"!OrderCtrl.form.orderType\"> Temp to Perm\n            </label>\n          </div>\n        </div>\n\n        <!-- <div class=\"form-group\" ng-class=\"{'has-error': orderForm.jobClass.$invalid}\">\n          <label for=\"jobClass\" class=\"required\">Job Class</label>\n          <input type=\"text\" id=\"jobClass\" name=\"jobClass\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.jobClass\" \n            required aria-required=\"true\" placeholder=\"Enter Job Class Name or Job Description\" \n            auto-complete-job-class auto-complete-form=\"orderForm\" auto-complete-extra-params=\"OrderCtrl.form\" \n            auto-complete-related-fields=\"['jobClassRef']\" auto-complete-on-closed=\"OrderCtrl.validateJobClass()\" />\n          <input type=\"hidden\" name=\"jobClassRef\" ng-model=\"OrderCtrl.form.jobClassRef\" />\n          <p class=\"help-block\" ng-if=\"OrderCtrl.form.jobClass && orderForm.jobClass.$error.invalidJobClass\">Invalid Job Class. Please select from list.</p>\n        </div> -->\n\n        <div class=\"form-group\" ng-class=\"{'has-error': !OrderCtrl.form.jobClass || !OrderCtrl.form.jobClassRef}\">\n          <label for=\"jobClass\" class=\"required\">Job Class</label>\n          <div class=\"input-group autocomplete\">\n            <div auto-complete\n              id=\"jobClass\"\n              placeholder=\"Enter Job Class Name or Job Description\"\n              initial-value=\"OrderCtrl.form.jobClass\"\n              pause=\"400\"\n              selected-object=\"OrderCtrl.jobClass_onSelected\"\n              remote-url=\"/api/types/jobClasses?_sortBy=jobClass&_pageNum=1&_pageSize=All&&keywords=\"\n              remote-url-response-formatter=\"OrderCtrl.jobClass_formatter\"\n              title-field=\"title\"\n              minlength=\"2\"\n              input-changed=\"OrderCtrl.jobClass_onChanged\"\n              input-class=\"form-control input-sm\"\n              match-class=\"highlight\">\n            </div>\n            <div class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"OrderCtrl.jobClass_showAll('jobClass')\"> \n                View All\n              </button>\n              <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"OrderCtrl.jobClass_clearInput('jobClass')\"> \n                Clear\n              </button>\n            </div> \n          </div>\n          <p class=\"help-block\" ng-if=\"!OrderCtrl.form.jobClassRef\">Invalid Job Class. Please select from list.</p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.quantity.$invalid}\">\n          <label for=\"quantity\" class=\"required\">Quantity</label>\n          <input type=\"text\" id=\"quantity\" name=\"quantity\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.quantity\" required aria-required=\"true\" />\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.assignmentStartDate.$invalid}\">\n          <label for=\"assignmentStartDate\" class=\"required\">Assignment Start Date</label>\n          <date-picker data-name=\"assignmentStartDate\" data-ng-model=\"OrderCtrl.form.assignmentStartDate\" data-required=\"required\"></date-picker>\n        </div>\n\n        <div class=\"form-group custom-input-group\" ng-class=\"{'has-error': orderForm.assignmentLength.$invalid || orderForm.assignmentLengthType.$invalid}\">\n          <label for=\"assignmentLength\" class=\"required\">Assignment Length</label>\n          <div class=\"input-group\">\n            <select id=\"assignmentLength\" name=\"assignmentLength\" class=\"form-control input-sm\" ng-options=\"option as option for option in OrderCtrl.lengthOptions\" ng-model=\"OrderCtrl.form.assignmentLength\" required aria-required=\"true\">\n              <option value=\"\">Select a Length Number</option>\n            </select>\n            <div class=\"input-group-btn\">\n              <select id=\"assignmentLengthType\" name=\"assignmentLengthType\" class=\"form-control input-sm\" ng-options=\"option as option for option in OrderCtrl.lengthTypeOptions\" ng-model=\"OrderCtrl.form.assignmentLengthType\" required aria-required=\"true\">\n                <option value=\"\">Select a Length Type</option>\n              </select>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row clearfix\">\n          <div class=\"col-sm-6\">\n            <div class=\"form-group\" ng-class=\"{'has-error': orderForm.shiftStart.$invalid}\">\n              <label for=\"shiftStart\" class=\"required\">Shift Start</label>\n              <select id=\"shiftStart\" name=\"shiftStart\" class=\"form-control input-sm\" ng-options=\"option as option for option in OrderCtrl.timeOptions\" ng-model=\"OrderCtrl.form.shiftStart\" required aria-required=\"true\">\n                <option value=\"\">Select a Time</option>\n              </select>\n            </div>\n          </div>\n          <div class=\"col-sm-6\">\n            <div class=\"form-group\" ng-class=\"{'has-error': orderForm.shiftEnd.$invalid}\">\n              <label for=\"shiftEnd\" class=\"required\">Shift End</label>\n              <select id=\"shiftEnd\" name=\"shiftEnd\" class=\"form-control input-sm\" ng-options=\"option as option for option in OrderCtrl.timeOptions\" ng-model=\"OrderCtrl.form.shiftEnd\" required aria-required=\"true\">\n                <option value=\"\">Select a Time</option>\n              </select>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"hoursGuaranteed\">Hours Guaranteed</label>\n          <input type=\"text\" id=\"hoursGuaranteed\" name=\"hoursGuaranteed\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.hoursGuaranteed\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label>Will you accommodate blocked scheduling?</label>\n          <div class=\"radio\">\n            <label class=\"radio-inline\">\n              <input type=\"radio\" id=\"blockedSchedulingAvailableYes\" name=\"blockedSchedulingAvailable\" value=\"Yes\" ng-model=\"OrderCtrl.form.blockedSchedulingAvailable\"> Yes\n            </label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" id=\"blockedSchedulingAvailableNo\" name=\"blockedSchedulingAvailable\" value=\"No\" ng-model=\"OrderCtrl.form.blockedSchedulingAvailable\"> No\n            </label>\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Credential Requirements, check all that apply:</label>\n          <div class=\"form-inline\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_acls\"> <span>ACLS</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_awhonn\"> <span>AWHONN</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_bls\"> <span>BLS</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_certification\"> <span>Certification</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_deescalation\"> <span>De-Escalation</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_ekg\"> <span>EKG</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_nih\"> <span>NIH (Stroke Center)</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_nrp\"> <span>NRP</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_onc\"> <span>ONC</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_pals\"> <span>PALS</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_stable\"> <span>STABLE</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_tcar\"> <span>TCAR</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_tncc\"> <span>TNCC</span>\n              </label>\n            </div>\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"OrderCtrl.form.credentialRequirement_na\"> <span>N/A</span>\n              </label>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"weekendRequirement\">Weekend Requirement</label>\n          <input type=\"text\" id=\"weekendRequirement\" name=\"weekendRequirement\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.weekendRequirement\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"onCallRequirement\">On Call Requirement</label>\n          <input type=\"text\" id=\"onCallRequirement\" name=\"onCallRequirement\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.onCallRequirement\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"floatingRequirementLocations\">Floating Requirement / Locations</label>\n          <input type=\"text\" id=\"floatingRequirementLocations\" name=\"floatingRequirementLocations\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.floatingRequirementLocations\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"yearsExperienceRequired\">Years Experience Required</label>\n          <select id=\"yearsExperienceRequired\" name=\"yearsExperienceRequired\" class=\"form-control input-sm\" ng-options=\"option as option for option in OrderCtrl.yearsExperienceOptions\" ng-model=\"OrderCtrl.form.yearsExperienceRequired\">\n            <option value=\"\">Select Your Answer</option>\n          </select>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.requiredEducationLevel.$invalid}\">\n          <label for=\"requiredEducationLevel\" class=\"required\">Required Education Level</label>\n          <input type=\"text\" id=\"requiredEducationLevel\" name=\"requiredEducationLevel\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.requiredEducationLevel\" required aria-required=\"true\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"nursePatientRatio\">Nurse / Patient Ratio</label>\n          <input type=\"text\" id=\"nursePatientRatio\" name=\"nursePatientRatio\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.nursePatientRatio\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"emrUsed\">EMR Used</label>\n          <input type=\"text\" id=\"emrUsed\" class=\"form-control input-sm\" name=\"emrUsed\" ng-model=\"OrderCtrl.form.emrUsed\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"dressCode\">Dress Code (business professional, business casual, scrub color, etc.)</label>\n          <input type=\"text\" id=\"dressCode\" name=\"dressCode\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.dressCode\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"orientationDatesAdditionalInformation\">First Day Instructions</label>\n          <input type=\"text\" id=\"firstDayInstructions\" name=\"firstDayInstructions\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.firstDayInstructions\" />\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.requestedBy.$invalid}\">\n          <label for=\"requestedBy\" class=\"required\">Requested By</label>\n          <input type=\"text\" id=\"requestedBy\" name=\"requestedBy\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.requestedBy\" required aria-required=\"true\" />\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.requestAuthorizedBy.$invalid}\">\n          <label for=\"requestAuthorizedBy\" class=\"required\">Authorized By/Final Approver</label>\n          <input type=\"text\" id=\"requestAuthorizedBy\" name=\"requestAuthorizedBy\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.requestAuthorizedBy\" required aria-required=\"true\">\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{'has-error': orderForm.submitCandidatesTo.$invalid}\">\n          <label for=\"submitCandidatesTo\" class=\"required\">Hiring Manager/Submit Candidates To (Name and Email)</label>\n          <input type=\"text\" id=\"submitCandidatesTo\" name=\"submitCandidatesTo\" class=\"form-control input-sm\" ng-model=\"OrderCtrl.form.submitCandidatesTo\" required aria-required=\"true\">\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"jobDescription\">Job Description/Additional Details</label>\n          <textarea id=\"jobDescription\" name=\"jobDescription\" class=\"form-control input-sm preserve-formatting\" ng-model=\"OrderCtrl.form.jobDescription\"></textarea>\n        </div>\n\n        <div class=\"alert alert-danger\" ng-if=\"orderForm.$invalid\">\n          <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i> Form contain error(s). Please scroll up....\n        </div>\n\n        <div class=\"alert alert-info\" ng-if=\"OrderCtrl.showCreatedSuccessMsg\">\n          <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i> Your order has been submitted.\n        </div>\n\n        <div class=\"alert alert-info\" ng-if=\"OrderCtrl.showUpdatedSuccessMsg\">\n          <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i> Your order has been updated.\n        </div>\n\n        <!-- <pre>{{OrderCtrl.form | json}}</pre> -->\n\n        <div class=\"form-group buttons\" ng-if=\"!OrderCtrl.showCreatedSuccessMsg && !OrderCtrl.showUpdatedSuccessMsg\">\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\" ng-if=\"OrderCtrl.isAdd\" ng-disabled=\"$OrderCtrl.isSaving\">Submit</button>\n          <button type=\"reset\" class=\"btn btn-default btn-sm\" ng-if=\"OrderCtrl.isAdd\">Reset</button>\n          <button type=\"submit\" class=\"btn btn-info btn-sm\" ng-if=\"!OrderCtrl.isAdd\" ng-disabled=\"form.$invalid || $OrderCtrl.isSaving\">Update</button>\n          <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"OrderCtrl.delete();\" ng-if=\"!OrderCtrl.isAdd\">Delete</button>\n        </div>\n      </div>\n      <div class=\"col-sm-4\" ng-if=\"!OrderCtrl.isAdd\">\n        <div class=\"alert alert-info\">\n          <div class=\"form-group\">\n            <label for=\"healthSystemName\">Created By</label>\n            <p>{{OrderCtrl.form.createdBy}} on {{OrderCtrl.form.createdDate | date: 'MM/dd/yyyy hh:mm a'}}</p>\n          </div>\n          <div class=\"form-group\" ng-if=\"OrderCtrl.form.modifiedBy\">\n            <label for=\"healthSystemName\">Modified By</label>\n            <p>{{OrderCtrl.form.modifiedBy}} on {{OrderCtrl.form.modifiedDate | date: 'MM/dd/yyyy hh:mm a'}}</p>\n          </div>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Socket.$inject = ['socketFactory'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(22);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _socket = __webpack_require__(109);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function Socket(socketFactory) {
	  'ngInject';
	
	  var ioSocket = (0, _socket2.default)('', {
	    path: '/socket.io-client'
	  });
	
	  var socket = socketFactory({
	    ioSocket: ioSocket
	  });
	
	  return {
	    socket: socket,
	
	    syncUpdates: function syncUpdates(modelName, array, cb) {
	      cb = cb || _angular2.default.noop;
	
	      socket.on(modelName + ':save', function (item) {
	        var oldItem = _.find(array, {
	          _id: item._id
	        });
	        var index = array.indexOf(oldItem);
	        var event = 'created';
	
	        if (oldItem) {
	          array.splice(index, 1, item);
	          event = 'updated';
	        } else {
	          array.push(item);
	        }
	
	        cb(event, item, array);
	      });
	
	      socket.on(modelName + ':remove', function (item) {
	        var event = 'deleted';
	        _.remove(array, {
	          _id: item._id
	        });
	        cb(event, item, array);
	      });
	    },
	    unsyncUpdates: function unsyncUpdates(modelName) {
	      socket.removeAllListeners(modelName + ':save');
	      socket.removeAllListeners(modelName + ':remove');
	    }
	  };
	}
	
	exports.default = _angular2.default.module('wftOrderFormApp.socket', []).factory('socket', Socket).name;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(110);
	var parser = __webpack_require__(115);
	var Manager = __webpack_require__(125);
	var debug = __webpack_require__(112)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  } else if (opts && 'object' === typeof opts.query) {
	    opts.query = encodeQueryString(opts.query);
	  }
	  return io.socket(parsed.path, opts);
	}
	/**
	 *  Helper method to parse query objects to string.
	 * @param {object} query
	 * @returns {string}
	 */
	function encodeQueryString (obj) {
	  var str = [];
	  for (var p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	    }
	  }
	  return str.join('&');
	}
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(125);
	exports.Socket = __webpack_require__(156);


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(111);
	var debug = __webpack_require__(112)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || global.location;
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    return uri;
	};


/***/ }),
/* 112 */
[485, 113],
/* 113 */
[486, 114],
/* 114 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(116)('socket.io-parser');
	var json = __webpack_require__(119);
	var Emitter = __webpack_require__(121);
	var binary = __webpack_require__(122);
	var isBuf = __webpack_require__(124);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    encodeAsBinary(obj, callback);
	  }
	  else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	  var str = '';
	  var nsp = false;
	
	  // first is type
	  str += obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    str += obj.attachments;
	    str += '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' != obj.nsp) {
	    nsp = true;
	    str += obj.nsp;
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    if (nsp) {
	      str += ',';
	      nsp = false;
	    }
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    if (nsp) str += ',';
	    str += json.stringify(obj.data);
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an ecoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if ('string' == typeof obj) {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  }
	  else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  }
	  else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var p = {};
	  var i = 0;
	
	  // look up type
	  p.type = Number(str.charAt(0));
	  if (null == exports.types[p.type]) return error();
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
	    var buf = '';
	    while (str.charAt(++i) != '-') {
	      buf += str.charAt(i);
	      if (i == str.length) break;
	    }
	    if (buf != Number(buf) || str.charAt(i) != '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' == str.charAt(i + 1)) {
	    p.nsp = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' == c) break;
	      p.nsp += c;
	      if (i == str.length) break;
	    }
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    p.id = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      p.id += str.charAt(i);
	      if (i == str.length) break;
	    }
	    p.id = Number(p.id);
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    p = tryParse(p, str.substr(i));
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(p, str) {
	  try {
	    p.data = json.parse(str);
	  } catch(e){
	    return error();
	  }
	  return p; 
	};
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error(data){
	  return {
	    type: exports.ERROR,
	    data: 'parser error'
	  };
	}


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(117);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(118);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 118 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	;(function () {
	  // Detect the `define` function exposed by asynchronous module loaders. The
	  // strict `define` check is necessary for compatibility with `r.js`.
	  var isLoader = "function" === "function" && __webpack_require__(120);
	
	  // A set of types used to distinguish objects from primitives.
	  var objectTypes = {
	    "function": true,
	    "object": true
	  };
	
	  // Detect the `exports` object exposed by CommonJS implementations.
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  // Use the `global` object exposed by Node (including Browserify via
	  // `insert-module-globals`), Narwhal, and Ringo as the default context,
	  // and the `window` object in browsers. Rhino exports a `global` function
	  // instead.
	  var root = objectTypes[typeof window] && window || this,
	      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;
	
	  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  // Public: Initializes JSON 3 using the given `context` object, attaching the
	  // `stringify` and `parse` functions to the specified `exports` object.
	  function runInContext(context, exports) {
	    context || (context = root["Object"]());
	    exports || (exports = root["Object"]());
	
	    // Native constructor aliases.
	    var Number = context["Number"] || root["Number"],
	        String = context["String"] || root["String"],
	        Object = context["Object"] || root["Object"],
	        Date = context["Date"] || root["Date"],
	        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
	        TypeError = context["TypeError"] || root["TypeError"],
	        Math = context["Math"] || root["Math"],
	        nativeJSON = context["JSON"] || root["JSON"];
	
	    // Delegate to the native `stringify` and `parse` implementations.
	    if (typeof nativeJSON == "object" && nativeJSON) {
	      exports.stringify = nativeJSON.stringify;
	      exports.parse = nativeJSON.parse;
	    }
	
	    // Convenience aliases.
	    var objectProto = Object.prototype,
	        getClass = objectProto.toString,
	        isProperty, forEach, undef;
	
	    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
	    var isExtended = new Date(-3509827334573292);
	    try {
	      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
	      // results for certain dates in Opera >= 10.53.
	      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
	        // Safari < 2.0.2 stores the internal millisecond time value correctly,
	        // but clips the values returned by the date methods to the range of
	        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
	        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
	    } catch (exception) {}
	
	    // Internal: Determines whether the native `JSON.stringify` and `parse`
	    // implementations are spec-compliant. Based on work by Ken Snyder.
	    function has(name) {
	      if (has[name] !== undef) {
	        // Return cached feature test result.
	        return has[name];
	      }
	      var isSupported;
	      if (name == "bug-string-char-index") {
	        // IE <= 7 doesn't support accessing string characters using square
	        // bracket notation. IE 8 only supports this for primitives.
	        isSupported = "a"[0] != "a";
	      } else if (name == "json") {
	        // Indicates whether both `JSON.stringify` and `JSON.parse` are
	        // supported.
	        isSupported = has("json-stringify") && has("json-parse");
	      } else {
	        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
	        // Test `JSON.stringify`.
	        if (name == "json-stringify") {
	          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
	          if (stringifySupported) {
	            // A test function object with a custom `toJSON` method.
	            (value = function () {
	              return 1;
	            }).toJSON = value;
	            try {
	              stringifySupported =
	                // Firefox 3.1b1 and b2 serialize string, number, and boolean
	                // primitives as object literals.
	                stringify(0) === "0" &&
	                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
	                // literals.
	                stringify(new Number()) === "0" &&
	                stringify(new String()) == '""' &&
	                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
	                // does not define a canonical JSON representation (this applies to
	                // objects with `toJSON` properties as well, *unless* they are nested
	                // within an object or array).
	                stringify(getClass) === undef &&
	                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
	                // FF 3.1b3 pass this test.
	                stringify(undef) === undef &&
	                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
	                // respectively, if the value is omitted entirely.
	                stringify() === undef &&
	                // FF 3.1b1, 2 throw an error if the given value is not a number,
	                // string, array, object, Boolean, or `null` literal. This applies to
	                // objects with custom `toJSON` methods as well, unless they are nested
	                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
	                // methods entirely.
	                stringify(value) === "1" &&
	                stringify([value]) == "[1]" &&
	                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
	                // `"[null]"`.
	                stringify([undef]) == "[null]" &&
	                // YUI 3.0.0b1 fails to serialize `null` literals.
	                stringify(null) == "null" &&
	                // FF 3.1b1, 2 halts serialization if an array contains a function:
	                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
	                // elides non-JSON values from objects and arrays, unless they
	                // define custom `toJSON` methods.
	                stringify([undef, getClass, null]) == "[null,null,null]" &&
	                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
	                // where character escape codes are expected (e.g., `\b` => `\u0008`).
	                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
	                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
	                stringify(null, value) === "1" &&
	                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
	                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
	                // serialize extended years.
	                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
	                // The milliseconds are optional in ES 5, but required in 5.1.
	                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
	                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
	                // four-digit years instead of six-digit years. Credits: @Yaffle.
	                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
	                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
	                // values less than 1000. Credits: @Yaffle.
	                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
	            } catch (exception) {
	              stringifySupported = false;
	            }
	          }
	          isSupported = stringifySupported;
	        }
	        // Test `JSON.parse`.
	        if (name == "json-parse") {
	          var parse = exports.parse;
	          if (typeof parse == "function") {
	            try {
	              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
	              // Conforming implementations should also coerce the initial argument to
	              // a string prior to parsing.
	              if (parse("0") === 0 && !parse(false)) {
	                // Simple parsing test.
	                value = parse(serialized);
	                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
	                if (parseSupported) {
	                  try {
	                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
	                    parseSupported = !parse('"\t"');
	                  } catch (exception) {}
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
	                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
	                      // certain octal literals.
	                      parseSupported = parse("01") !== 1;
	                    } catch (exception) {}
	                  }
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
	                      // points. These environments, along with FF 3.1b1 and 2,
	                      // also allow trailing commas in JSON objects and arrays.
	                      parseSupported = parse("1.") !== 1;
	                    } catch (exception) {}
	                  }
	                }
	              }
	            } catch (exception) {
	              parseSupported = false;
	            }
	          }
	          isSupported = parseSupported;
	        }
	      }
	      return has[name] = !!isSupported;
	    }
	
	    if (!has("json")) {
	      // Common `[[Class]]` name aliases.
	      var functionClass = "[object Function]",
	          dateClass = "[object Date]",
	          numberClass = "[object Number]",
	          stringClass = "[object String]",
	          arrayClass = "[object Array]",
	          booleanClass = "[object Boolean]";
	
	      // Detect incomplete support for accessing string characters by index.
	      var charIndexBuggy = has("bug-string-char-index");
	
	      // Define additional utility methods if the `Date` methods are buggy.
	      if (!isExtended) {
	        var floor = Math.floor;
	        // A mapping between the months of the year and the number of days between
	        // January 1st and the first of the respective month.
	        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
	        // Internal: Calculates the number of days between the Unix epoch and the
	        // first day of the given month.
	        var getDay = function (year, month) {
	          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
	        };
	      }
	
	      // Internal: Determines if a property is a direct property of the given
	      // object. Delegates to the native `Object#hasOwnProperty` method.
	      if (!(isProperty = objectProto.hasOwnProperty)) {
	        isProperty = function (property) {
	          var members = {}, constructor;
	          if ((members.__proto__ = null, members.__proto__ = {
	            // The *proto* property cannot be set multiple times in recent
	            // versions of Firefox and SeaMonkey.
	            "toString": 1
	          }, members).toString != getClass) {
	            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
	            // supports the mutable *proto* property.
	            isProperty = function (property) {
	              // Capture and break the object's prototype chain (see section 8.6.2
	              // of the ES 5.1 spec). The parenthesized expression prevents an
	              // unsafe transformation by the Closure Compiler.
	              var original = this.__proto__, result = property in (this.__proto__ = null, this);
	              // Restore the original prototype chain.
	              this.__proto__ = original;
	              return result;
	            };
	          } else {
	            // Capture a reference to the top-level `Object` constructor.
	            constructor = members.constructor;
	            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
	            // other environments.
	            isProperty = function (property) {
	              var parent = (this.constructor || constructor).prototype;
	              return property in this && !(property in parent && this[property] === parent[property]);
	            };
	          }
	          members = null;
	          return isProperty.call(this, property);
	        };
	      }
	
	      // Internal: Normalizes the `for...in` iteration algorithm across
	      // environments. Each enumerated key is yielded to a `callback` function.
	      forEach = function (object, callback) {
	        var size = 0, Properties, members, property;
	
	        // Tests for bugs in the current environment's `for...in` algorithm. The
	        // `valueOf` property inherits the non-enumerable flag from
	        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
	        (Properties = function () {
	          this.valueOf = 0;
	        }).prototype.valueOf = 0;
	
	        // Iterate over a new instance of the `Properties` class.
	        members = new Properties();
	        for (property in members) {
	          // Ignore all properties inherited from `Object.prototype`.
	          if (isProperty.call(members, property)) {
	            size++;
	          }
	        }
	        Properties = members = null;
	
	        // Normalize the iteration algorithm.
	        if (!size) {
	          // A list of non-enumerable properties inherited from `Object.prototype`.
	          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
	          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
	          // properties.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, length;
	            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
	            for (property in object) {
	              // Gecko <= 1.0 enumerates the `prototype` property of functions under
	              // certain conditions; IE does not.
	              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for each non-enumerable property.
	            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
	          };
	        } else if (size == 2) {
	          // Safari <= 2.0.4 enumerates shadowed properties twice.
	          forEach = function (object, callback) {
	            // Create a set of iterated properties.
	            var members = {}, isFunction = getClass.call(object) == functionClass, property;
	            for (property in object) {
	              // Store each property name to prevent double enumeration. The
	              // `prototype` property of functions is not enumerated due to cross-
	              // environment inconsistencies.
	              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	          };
	        } else {
	          // No bugs detected; use the standard `for...in` algorithm.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
	            for (property in object) {
	              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for the `constructor` property due to
	            // cross-environment inconsistencies.
	            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
	              callback(property);
	            }
	          };
	        }
	        return forEach(object, callback);
	      };
	
	      // Public: Serializes a JavaScript `value` as a JSON string. The optional
	      // `filter` argument may specify either a function that alters how object and
	      // array members are serialized, or an array of strings and numbers that
	      // indicates which properties should be serialized. The optional `width`
	      // argument may be either a string or number that specifies the indentation
	      // level of the output.
	      if (!has("json-stringify")) {
	        // Internal: A map of control characters and their escaped equivalents.
	        var Escapes = {
	          92: "\\\\",
	          34: '\\"',
	          8: "\\b",
	          12: "\\f",
	          10: "\\n",
	          13: "\\r",
	          9: "\\t"
	        };
	
	        // Internal: Converts `value` into a zero-padded string such that its
	        // length is at least equal to `width`. The `width` must be <= 6.
	        var leadingZeroes = "000000";
	        var toPaddedString = function (width, value) {
	          // The `|| 0` expression is necessary to work around a bug in
	          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
	          return (leadingZeroes + (value || 0)).slice(-width);
	        };
	
	        // Internal: Double-quotes a string `value`, replacing all ASCII control
	        // characters (characters with code unit values between 0 and 31) with
	        // their escaped equivalents. This is an implementation of the
	        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
	        var unicodePrefix = "\\u00";
	        var quote = function (value) {
	          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
	          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
	          for (; index < length; index++) {
	            var charCode = value.charCodeAt(index);
	            // If the character is a control character, append its Unicode or
	            // shorthand escape sequence; otherwise, append the character as-is.
	            switch (charCode) {
	              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
	                result += Escapes[charCode];
	                break;
	              default:
	                if (charCode < 32) {
	                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
	                  break;
	                }
	                result += useCharIndex ? symbols[index] : value.charAt(index);
	            }
	          }
	          return result + '"';
	        };
	
	        // Internal: Recursively serializes an object. Implements the
	        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
	        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
	          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
	          try {
	            // Necessary for host object support.
	            value = object[property];
	          } catch (exception) {}
	          if (typeof value == "object" && value) {
	            className = getClass.call(value);
	            if (className == dateClass && !isProperty.call(value, "toJSON")) {
	              if (value > -1 / 0 && value < 1 / 0) {
	                // Dates are serialized according to the `Date#toJSON` method
	                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
	                // for the ISO 8601 date time string format.
	                if (getDay) {
	                  // Manually compute the year, month, date, hours, minutes,
	                  // seconds, and milliseconds if the `getUTC*` methods are
	                  // buggy. Adapted from @Yaffle's `date-shim` project.
	                  date = floor(value / 864e5);
	                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
	                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
	                  date = 1 + date - getDay(year, month);
	                  // The `time` value specifies the time within the day (see ES
	                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
	                  // to compute `A modulo B`, as the `%` operator does not
	                  // correspond to the `modulo` operation for negative numbers.
	                  time = (value % 864e5 + 864e5) % 864e5;
	                  // The hours, minutes, seconds, and milliseconds are obtained by
	                  // decomposing the time within the day. See section 15.9.1.10.
	                  hours = floor(time / 36e5) % 24;
	                  minutes = floor(time / 6e4) % 60;
	                  seconds = floor(time / 1e3) % 60;
	                  milliseconds = time % 1e3;
	                } else {
	                  year = value.getUTCFullYear();
	                  month = value.getUTCMonth();
	                  date = value.getUTCDate();
	                  hours = value.getUTCHours();
	                  minutes = value.getUTCMinutes();
	                  seconds = value.getUTCSeconds();
	                  milliseconds = value.getUTCMilliseconds();
	                }
	                // Serialize extended years correctly.
	                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
	                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
	                  // Months, dates, hours, minutes, and seconds should have two
	                  // digits; milliseconds should have three.
	                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
	                  // Milliseconds are optional in ES 5.0, but required in 5.1.
	                  "." + toPaddedString(3, milliseconds) + "Z";
	              } else {
	                value = null;
	              }
	            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
	              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
	              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
	              // ignores all `toJSON` methods on these objects unless they are
	              // defined directly on an instance.
	              value = value.toJSON(property);
	            }
	          }
	          if (callback) {
	            // If a replacement function was provided, call it to obtain the value
	            // for serialization.
	            value = callback.call(object, property, value);
	          }
	          if (value === null) {
	            return "null";
	          }
	          className = getClass.call(value);
	          if (className == booleanClass) {
	            // Booleans are represented literally.
	            return "" + value;
	          } else if (className == numberClass) {
	            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
	            // `"null"`.
	            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
	          } else if (className == stringClass) {
	            // Strings are double-quoted and escaped.
	            return quote("" + value);
	          }
	          // Recursively serialize objects and arrays.
	          if (typeof value == "object") {
	            // Check for cyclic structures. This is a linear search; performance
	            // is inversely proportional to the number of unique nested objects.
	            for (length = stack.length; length--;) {
	              if (stack[length] === value) {
	                // Cyclic structures cannot be serialized by `JSON.stringify`.
	                throw TypeError();
	              }
	            }
	            // Add the object to the stack of traversed objects.
	            stack.push(value);
	            results = [];
	            // Save the current indentation level and indent one additional level.
	            prefix = indentation;
	            indentation += whitespace;
	            if (className == arrayClass) {
	              // Recursively serialize array elements.
	              for (index = 0, length = value.length; index < length; index++) {
	                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
	                results.push(element === undef ? "null" : element);
	              }
	              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
	            } else {
	              // Recursively serialize object members. Members are selected from
	              // either a user-specified list of property names, or the object
	              // itself.
	              forEach(properties || value, function (property) {
	                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
	                if (element !== undef) {
	                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
	                  // is not the empty string, let `member` {quote(property) + ":"}
	                  // be the concatenation of `member` and the `space` character."
	                  // The "`space` character" refers to the literal space
	                  // character, not the `space` {width} argument provided to
	                  // `JSON.stringify`.
	                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
	                }
	              });
	              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
	            }
	            // Remove the object from the traversed object stack.
	            stack.pop();
	            return result;
	          }
	        };
	
	        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
	        exports.stringify = function (source, filter, width) {
	          var whitespace, callback, properties, className;
	          if (objectTypes[typeof filter] && filter) {
	            if ((className = getClass.call(filter)) == functionClass) {
	              callback = filter;
	            } else if (className == arrayClass) {
	              // Convert the property names array into a makeshift set.
	              properties = {};
	              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
	            }
	          }
	          if (width) {
	            if ((className = getClass.call(width)) == numberClass) {
	              // Convert the `width` to an integer and create a string containing
	              // `width` number of space characters.
	              if ((width -= width % 1) > 0) {
	                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
	              }
	            } else if (className == stringClass) {
	              whitespace = width.length <= 10 ? width : width.slice(0, 10);
	            }
	          }
	          // Opera <= 7.54u2 discards the values associated with empty string keys
	          // (`""`) only if they are used directly within an object member list
	          // (e.g., `!("" in { "": 1})`).
	          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
	        };
	      }
	
	      // Public: Parses a JSON source string.
	      if (!has("json-parse")) {
	        var fromCharCode = String.fromCharCode;
	
	        // Internal: A map of escaped control characters and their unescaped
	        // equivalents.
	        var Unescapes = {
	          92: "\\",
	          34: '"',
	          47: "/",
	          98: "\b",
	          116: "\t",
	          110: "\n",
	          102: "\f",
	          114: "\r"
	        };
	
	        // Internal: Stores the parser state.
	        var Index, Source;
	
	        // Internal: Resets the parser state and throws a `SyntaxError`.
	        var abort = function () {
	          Index = Source = null;
	          throw SyntaxError();
	        };
	
	        // Internal: Returns the next token, or `"$"` if the parser has reached
	        // the end of the source string. A token may be a string, number, `null`
	        // literal, or Boolean literal.
	        var lex = function () {
	          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
	          while (Index < length) {
	            charCode = source.charCodeAt(Index);
	            switch (charCode) {
	              case 9: case 10: case 13: case 32:
	                // Skip whitespace tokens, including tabs, carriage returns, line
	                // feeds, and space characters.
	                Index++;
	                break;
	              case 123: case 125: case 91: case 93: case 58: case 44:
	                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
	                // the current position.
	                value = charIndexBuggy ? source.charAt(Index) : source[Index];
	                Index++;
	                return value;
	              case 34:
	                // `"` delimits a JSON string; advance to the next character and
	                // begin parsing the string. String tokens are prefixed with the
	                // sentinel `@` character to distinguish them from punctuators and
	                // end-of-string tokens.
	                for (value = "@", Index++; Index < length;) {
	                  charCode = source.charCodeAt(Index);
	                  if (charCode < 32) {
	                    // Unescaped ASCII control characters (those with a code unit
	                    // less than the space character) are not permitted.
	                    abort();
	                  } else if (charCode == 92) {
	                    // A reverse solidus (`\`) marks the beginning of an escaped
	                    // control character (including `"`, `\`, and `/`) or Unicode
	                    // escape sequence.
	                    charCode = source.charCodeAt(++Index);
	                    switch (charCode) {
	                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
	                        // Revive escaped control characters.
	                        value += Unescapes[charCode];
	                        Index++;
	                        break;
	                      case 117:
	                        // `\u` marks the beginning of a Unicode escape sequence.
	                        // Advance to the first character and validate the
	                        // four-digit code point.
	                        begin = ++Index;
	                        for (position = Index + 4; Index < position; Index++) {
	                          charCode = source.charCodeAt(Index);
	                          // A valid sequence comprises four hexdigits (case-
	                          // insensitive) that form a single hexadecimal value.
	                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
	                            // Invalid Unicode escape sequence.
	                            abort();
	                          }
	                        }
	                        // Revive the escaped character.
	                        value += fromCharCode("0x" + source.slice(begin, Index));
	                        break;
	                      default:
	                        // Invalid escape sequence.
	                        abort();
	                    }
	                  } else {
	                    if (charCode == 34) {
	                      // An unescaped double-quote character marks the end of the
	                      // string.
	                      break;
	                    }
	                    charCode = source.charCodeAt(Index);
	                    begin = Index;
	                    // Optimize for the common case where a string is valid.
	                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
	                      charCode = source.charCodeAt(++Index);
	                    }
	                    // Append the string as-is.
	                    value += source.slice(begin, Index);
	                  }
	                }
	                if (source.charCodeAt(Index) == 34) {
	                  // Advance to the next character and return the revived string.
	                  Index++;
	                  return value;
	                }
	                // Unterminated string.
	                abort();
	              default:
	                // Parse numbers and literals.
	                begin = Index;
	                // Advance past the negative sign, if one is specified.
	                if (charCode == 45) {
	                  isSigned = true;
	                  charCode = source.charCodeAt(++Index);
	                }
	                // Parse an integer or floating-point value.
	                if (charCode >= 48 && charCode <= 57) {
	                  // Leading zeroes are interpreted as octal literals.
	                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
	                    // Illegal octal literal.
	                    abort();
	                  }
	                  isSigned = false;
	                  // Parse the integer component.
	                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
	                  // Floats cannot contain a leading decimal point; however, this
	                  // case is already accounted for by the parser.
	                  if (source.charCodeAt(Index) == 46) {
	                    position = ++Index;
	                    // Parse the decimal component.
	                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal trailing decimal.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Parse exponents. The `e` denoting the exponent is
	                  // case-insensitive.
	                  charCode = source.charCodeAt(Index);
	                  if (charCode == 101 || charCode == 69) {
	                    charCode = source.charCodeAt(++Index);
	                    // Skip past the sign following the exponent, if one is
	                    // specified.
	                    if (charCode == 43 || charCode == 45) {
	                      Index++;
	                    }
	                    // Parse the exponential component.
	                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal empty exponent.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Coerce the parsed value to a JavaScript number.
	                  return +source.slice(begin, Index);
	                }
	                // A negative sign may only precede numbers.
	                if (isSigned) {
	                  abort();
	                }
	                // `true`, `false`, and `null` literals.
	                if (source.slice(Index, Index + 4) == "true") {
	                  Index += 4;
	                  return true;
	                } else if (source.slice(Index, Index + 5) == "false") {
	                  Index += 5;
	                  return false;
	                } else if (source.slice(Index, Index + 4) == "null") {
	                  Index += 4;
	                  return null;
	                }
	                // Unrecognized token.
	                abort();
	            }
	          }
	          // Return the sentinel `$` character if the parser has reached the end
	          // of the source string.
	          return "$";
	        };
	
	        // Internal: Parses a JSON `value` token.
	        var get = function (value) {
	          var results, hasMembers;
	          if (value == "$") {
	            // Unexpected end of input.
	            abort();
	          }
	          if (typeof value == "string") {
	            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
	              // Remove the sentinel `@` character.
	              return value.slice(1);
	            }
	            // Parse object and array literals.
	            if (value == "[") {
	              // Parses a JSON array, returning a new JavaScript array.
	              results = [];
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing square bracket marks the end of the array literal.
	                if (value == "]") {
	                  break;
	                }
	                // If the array literal contains elements, the current token
	                // should be a comma separating the previous element from the
	                // next.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "]") {
	                      // Unexpected trailing `,` in array literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each array element.
	                    abort();
	                  }
	                }
	                // Elisions and leading commas are not permitted.
	                if (value == ",") {
	                  abort();
	                }
	                results.push(get(value));
	              }
	              return results;
	            } else if (value == "{") {
	              // Parses a JSON object, returning a new JavaScript object.
	              results = {};
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing curly brace marks the end of the object literal.
	                if (value == "}") {
	                  break;
	                }
	                // If the object literal contains members, the current token
	                // should be a comma separator.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "}") {
	                      // Unexpected trailing `,` in object literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each object member.
	                    abort();
	                  }
	                }
	                // Leading commas are not permitted, object property names must be
	                // double-quoted strings, and a `:` must separate each property
	                // name and value.
	                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
	                  abort();
	                }
	                results[value.slice(1)] = get(lex());
	              }
	              return results;
	            }
	            // Unexpected token encountered.
	            abort();
	          }
	          return value;
	        };
	
	        // Internal: Updates a traversed object member.
	        var update = function (source, property, callback) {
	          var element = walk(source, property, callback);
	          if (element === undef) {
	            delete source[property];
	          } else {
	            source[property] = element;
	          }
	        };
	
	        // Internal: Recursively traverses a parsed JSON object, invoking the
	        // `callback` function for each value. This is an implementation of the
	        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
	        var walk = function (source, property, callback) {
	          var value = source[property], length;
	          if (typeof value == "object" && value) {
	            // `forEach` can't be used to traverse an array in Opera <= 8.54
	            // because its `Object#hasOwnProperty` implementation returns `false`
	            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
	            if (getClass.call(value) == arrayClass) {
	              for (length = value.length; length--;) {
	                update(value, length, callback);
	              }
	            } else {
	              forEach(value, function (property) {
	                update(value, property, callback);
	              });
	            }
	          }
	          return callback.call(source, property, value);
	        };
	
	        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
	        exports.parse = function (source, callback) {
	          var result, value;
	          Index = 0;
	          Source = "" + source;
	          result = get(lex());
	          // If a JSON string contains multiple tokens, it is invalid.
	          if (lex() != "$") {
	            abort();
	          }
	          // Reset the parser state.
	          Index = Source = null;
	          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
	        };
	      }
	    }
	
	    exports["runInContext"] = runInContext;
	    return exports;
	  }
	
	  if (freeExports && !isLoader) {
	    // Export for CommonJS environments.
	    runInContext(root, freeExports);
	  } else {
	    // Export for web browsers and JavaScript engines.
	    var nativeJSON = root.JSON,
	        previousJSON = root["JSON3"],
	        isRestored = false;
	
	    var JSON3 = runInContext(root, (root["JSON3"] = {
	      // Public: Restores the original value of the global `JSON` object and
	      // returns a reference to the `JSON3` object.
	      "noConflict": function () {
	        if (!isRestored) {
	          isRestored = true;
	          root.JSON = nativeJSON;
	          root["JSON3"] = previousJSON;
	          nativeJSON = previousJSON = null;
	        }
	        return JSON3;
	      }
	    }));
	
	    root.JSON = {
	      "parse": JSON3.parse,
	      "stringify": JSON3.stringify
	    };
	  }
	
	  // Export for asynchronous module loaders.
	  if (isLoader) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return JSON3;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)(module), (function() { return this; }())))

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(123);
	var isBuf = __webpack_require__(124);
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet){
	  var buffers = [];
	  var packetData = packet.data;
	
	  function _deconstructPacket(data) {
	    if (!data) return data;
	
	    if (isBuf(data)) {
	      var placeholder = { _placeholder: true, num: buffers.length };
	      buffers.push(data);
	      return placeholder;
	    } else if (isArray(data)) {
	      var newData = new Array(data.length);
	      for (var i = 0; i < data.length; i++) {
	        newData[i] = _deconstructPacket(data[i]);
	      }
	      return newData;
	    } else if ('object' == typeof data && !(data instanceof Date)) {
	      var newData = {};
	      for (var key in data) {
	        newData[key] = _deconstructPacket(data[key]);
	      }
	      return newData;
	    }
	    return data;
	  }
	
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  var curPlaceHolder = 0;
	
	  function _reconstructPacket(data) {
	    if (data && data._placeholder) {
	      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
	      return buf;
	    } else if (isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        data[i] = _reconstructPacket(data[i]);
	      }
	      return data;
	    } else if (data && 'object' == typeof data) {
	      for (var key in data) {
	        data[key] = _reconstructPacket(data[key]);
	      }
	      return data;
	    }
	    return data;
	  }
	
	  packet.data = _reconstructPacket(packet.data);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((global.Blob && obj instanceof Blob) ||
	        (global.File && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 124 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	module.exports = isBuf;
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(126);
	var Socket = __webpack_require__(156);
	var Emitter = __webpack_require__(157);
	var parser = __webpack_require__(115);
	var on = __webpack_require__(159);
	var bind = __webpack_require__(160);
	var debug = __webpack_require__(112)('socket.io-client:manager');
	var indexOf = __webpack_require__(154);
	var Backoff = __webpack_require__(161);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  this.encoder = new parser.Encoder();
	  this.decoder = new parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.engine.id;
	    }
	  }
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.engine.id;
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting evnet is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(127);


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(128);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(135);


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(129);
	var Emitter = __webpack_require__(144);
	var debug = __webpack_require__(148)('engine.io-client:socket');
	var index = __webpack_require__(154);
	var parser = __webpack_require__(135);
	var parseuri = __webpack_require__(111);
	var parsejson = __webpack_require__(155);
	var parseqs = __webpack_require__(145);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (global.location && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (global.location ? location.hostname : 'localhost');
	  this.port = opts.port || (global.location && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // other options for Node.js client
	  var freeGlobal = typeof global === 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(134);
	Socket.transports = __webpack_require__(129);
	Socket.parser = __webpack_require__(135);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    agent: this.agent,
	    hostname: this.hostname,
	    port: this.port,
	    secure: this.secure,
	    path: this.path,
	    query: query,
	    forceJSONP: this.forceJSONP,
	    jsonp: this.jsonp,
	    forceBase64: this.forceBase64,
	    enablesXDR: this.enablesXDR,
	    timestampRequests: this.timestampRequests,
	    timestampParam: this.timestampParam,
	    policyPort: this.policyPort,
	    socket: this,
	    pfx: this.pfx,
	    key: this.key,
	    passphrase: this.passphrase,
	    cert: this.cert,
	    ca: this.ca,
	    ciphers: this.ciphers,
	    rejectUnauthorized: this.rejectUnauthorized,
	    perMessageDeflate: this.perMessageDeflate,
	    extraHeaders: this.extraHeaders,
	    forceNode: this.forceNode,
	    localAddress: this.localAddress
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(parsejson(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(130);
	var XHR = __webpack_require__(132);
	var JSONP = __webpack_require__(151);
	var websocket = __webpack_require__(152);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(131);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(130);
	var Polling = __webpack_require__(133);
	var Emitter = __webpack_require__(144);
	var inherit = __webpack_require__(146);
	var debug = __webpack_require__(148)('engine.io-client:polling-xhr');
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = opts.hostname !== global.location.hostname ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  } else {
	    this.extraHeaders = opts.extraHeaders;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	    if (this.supportsBinary) {
	      // This has to be done after open because Firefox is stupid
	      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
	      xhr.responseType = 'arraybuffer';
	    }
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = true;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(xhr.status);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (global.document) {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (global.document) {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
	    } catch (e) {}
	    if (contentType === 'application/octet-stream') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      if (!this.supportsBinary) {
	        data = this.xhr.responseText;
	      } else {
	        try {
	          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
	        } catch (e) {
	          var ui8Arr = new Uint8Array(this.xhr.response);
	          var dataArray = [];
	          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
	            dataArray.push(ui8Arr[idx]);
	          }
	
	          data = String.fromCharCode.apply(null, dataArray);
	        }
	      }
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (global.document) {
	  if (global.attachEvent) {
	    global.attachEvent('onunload', unloadHandler);
	  } else if (global.addEventListener) {
	    global.addEventListener('beforeunload', unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(134);
	var parseqs = __webpack_require__(145);
	var parser = __webpack_require__(135);
	var inherit = __webpack_require__(146);
	var yeast = __webpack_require__(147);
	var debug = __webpack_require__(148)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(130);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(135);
	var Emitter = __webpack_require__(144);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(136);
	var hasBinary = __webpack_require__(137);
	var sliceBuffer = __webpack_require__(139);
	var after = __webpack_require__(140);
	var utf8 = __webpack_require__(141);
	
	var base64encoder;
	if (global && global.ArrayBuffer) {
	  base64encoder = __webpack_require__(142);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(143);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if ('function' == typeof supportsBinary) {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if ('function' == typeof utf8encode) {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (Blob && data instanceof global.Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    packet.data = fr.result;
	    exports.encodePacket(packet, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (Blob && packet.data instanceof global.Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += global.btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data == 'string') {
	    if (data.charAt(0) == 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data);
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary == 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data != 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data == '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = ''
	    , n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (':' != chr) {
	      length += chr;
	    } else {
	      if ('' == length || (length != (n = Number(length)))) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      msg = data.substr(i + 1, n);
	
	      if (length != msg.length) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      if (msg.length) {
	        packet = exports.decodePacket(msg, binaryType, true);
	
	        if (err.type == packet.type && err.data == packet.data) {
	          // parser error in individual packet - ignoring payload
	          return callback(err, 0, 1);
	        }
	
	        var ret = callback(packet, i + n, l);
	        if (false === ret) return;
	      }
	
	      // advance cursor
	      i += n;
	      length = '';
	    }
	  }
	
	  if (length != '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  var numberTooLong = false;
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] == 255) break;
	
	      if (msgLength.length > 310) {
	        numberTooLong = true;
	        break;
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    if(numberTooLong) return callback(err, 0, 1);
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(138);
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Right now only Buffer and ArrayBuffer are supported..
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary(data) {
	
	  function _hasBinary(obj) {
	    if (!obj) return false;
	
	    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
	         (global.Blob && obj instanceof Blob) ||
	         (global.File && obj instanceof File)
	        ) {
	      return true;
	    }
	
	    if (isArray(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	          if (_hasBinary(obj[i])) {
	              return true;
	          }
	      }
	    } else if (obj && 'object' == typeof obj) {
	      // see: https://github.com/Automattic/has-binary/pull/4
	      if (obj.toJSON && 'function' == typeof obj.toJSON) {
	        obj = obj.toJSON();
	      }
	
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  return _hasBinary(data);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 138 */
123,
/* 139 */
/***/ (function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/wtf8 v1.0.0 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function wtf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte.
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read the first byte.
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				var byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid WTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function wtf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var wtf8 = {
			'version': '1.0.0',
			'encode': wtf8encode,
			'decode': wtf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return wtf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = wtf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in wtf8) {
					hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.wtf8 = wtf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)(module), (function() { return this; }())))

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(){
	  "use strict";
	
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	
	  // Use a lookup table to find the index.
	  var lookup = new Uint8Array(256);
	  for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	  }
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = lookup[base64.charCodeAt(i)];
	      encoded2 = lookup[base64.charCodeAt(i+1)];
	      encoded3 = lookup[base64.charCodeAt(i+2)];
	      encoded4 = lookup[base64.charCodeAt(i+3)];
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})();


/***/ }),
/* 143 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = global.BlobBuilder
	  || global.WebKitBlobBuilder
	  || global.MSBlobBuilder
	  || global.MozBlobBuilder;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  for (var i = 0; i < ary.length; i++) {
	    var chunk = ary[i];
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      ary[i] = buf;
	    }
	  }
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary);
	
	  for (var i = 0; i < ary.length; i++) {
	    bb.append(ary[i]);
	  }
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  mapArrayBufferViews(ary);
	  return new Blob(ary, options || {});
	};
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 145 */
/***/ (function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ }),
/* 148 */
[485, 149],
/* 149 */
[486, 150],
/* 150 */
114,
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(133);
	var inherit = __webpack_require__(146);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    if (!global.___eio) global.___eio = [];
	    callbacks = global.___eio;
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (global.document && global.addEventListener) {
	    global.addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(134);
	var parser = __webpack_require__(135);
	var parseqs = __webpack_require__(145);
	var inherit = __webpack_require__(146);
	var yeast = __webpack_require__(147);
	var debug = __webpack_require__(148)('engine.io-client:websocket');
	var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
	var NodeWebSocket;
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(153);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocket = BrowserWebSocket;
	if (!WebSocket && typeof window === 'undefined') {
	  WebSocket = NodeWebSocket;
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  if (!this.usingBrowserWebSocket) {
	    WebSocket = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = void (0);
	  var opts = {
	    agent: this.agent,
	    perMessageDeflate: this.perMessageDeflate
	  };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * JSON parse.
	 *
	 * @see Based on jQuery#parseJSON (MIT) and JSON2
	 * @api private
	 */
	
	var rvalidchars = /^[\],:{}\s]*$/;
	var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
	var rtrimLeft = /^\s+/;
	var rtrimRight = /\s+$/;
	
	module.exports = function parsejson(data) {
	  if ('string' != typeof data || !data) {
	    return null;
	  }
	
	  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');
	
	  // Attempt to parse using the native JSON parser first
	  if (global.JSON && JSON.parse) {
	    return JSON.parse(data);
	  }
	
	  if (rvalidchars.test(data.replace(rvalidescape, '@')
	      .replace(rvalidtokens, ']')
	      .replace(rvalidbraces, ''))) {
	    return (new Function('return ' + data))();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(115);
	var Emitter = __webpack_require__(157);
	var toArray = __webpack_require__(158);
	var on = __webpack_require__(159);
	var bind = __webpack_require__(160);
	var debug = __webpack_require__(112)('socket.io-client:socket');
	var hasBin = __webpack_require__(137);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var parserType = parser.EVENT; // default
	  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
	  var packet = { type: parserType, data: args };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  delete this.flags;
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      this.packet({type: parser.CONNECT, query: this.query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  if (packet.nsp !== this.nsp) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
	    self.packet({
	      type: type,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags = this.flags || {};
	  this.flags.compress = compress;
	  return this;
	};


/***/ }),
/* 157 */
144,
/* 158 */
/***/ (function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ }),
/* 160 */
/***/ (function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Modal.$inject = ['$rootScope', '$uibModal'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Modal = Modal;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	function Modal($rootScope, $uibModal) {
	  function openModal() {
	    var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var modalClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'modal-default';
	
	    var modalScope = $rootScope.$new();
	
	    _angular2.default.extend(modalScope, scope);
	
	    return $uibModal.open({
	      template: __webpack_require__(163),
	      windowClass: modalClass,
	      scope: modalScope
	    });
	  }
	
	  return {
	    confirm: {
	      delete: function _delete() {
	        var del = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _angular2.default.noop;
	
	        return function () {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          var name = args.shift();
	          var deleteModal;
	
	          deleteModal = openModal({
	            modal: {
	              dismissable: true,
	              title: 'Confirm Delete',
	              html: '<p>Are you sure you want to delete <strong>' + name + '</strong> ?</p>',
	              buttons: [{
	                classes: 'btn-danger btn-sm',
	                text: 'Delete',
	                click: function click(e) {
	                  deleteModal.close(e);
	                }
	              }, {
	                classes: 'btn-default btn-sm',
	                text: 'Cancel',
	                click: function click(e) {
	                  deleteModal.dismiss(e);
	                }
	              }]
	            }
	          }, 'modal-danger');
	
	          deleteModal.result.then(function (event) {
	            Reflect.apply(del, event, args);
	          });
	        };
	      },
	      general: function general() {
	        var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _angular2.default.noop;
	
	        return function () {
	          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }
	
	          var title = args.shift();
	          var html = args.shift();
	
	          var m = openModal({
	            modal: {
	              dismissable: true,
	              title: title,
	              html: html,
	              buttons: [{
	                classes: 'btn-warning btn-sm',
	                text: 'Ok',
	                click: function click(e) {
	                  m.close(e);
	                }
	              }, {
	                classes: 'btn-default btn-sm',
	                text: 'Cancel',
	                click: function click(e) {
	                  m.dismiss(false);
	                }
	              }]
	            }
	          }, 'modal-warning');
	
	          m.result.then(function (event) {
	            Reflect.apply(fn, event, args);
	          });
	        };
	      }
	    }
	  };
	}
	
	exports.default = _angular2.default.module('wftOrderFormApp.Modal', []).factory('Modal', Modal).name;

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <button ng-if=\"modal.dismissable\" type=\"button\" ng-click=\"$dismiss()\" class=\"close\">&times;</button>\n  <h4 ng-if=\"modal.title\" ng-bind=\"modal.title\" class=\"modal-title\"></h4>\n</div>\n<div class=\"modal-body\">\n  <p ng-if=\"modal.text\" ng-bind=\"modal.text\"></p>\n  <div ng-if=\"modal.html\" ng-bind-html=\"modal.html\"></div>\n</div>\n<div class=\"modal-footer\">\n  <button ng-repeat=\"button in modal.buttons\" ng-class=\"button.classes\" ng-click=\"button.click($event)\" ng-bind=\"button.text\" class=\"btn\"></button>\n</div>\n"

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('wftOrderFormApp.file-input', []).directive('fileInput', function () {
	  return {
	    restrict: 'A',
	    scope: {
	      fileInput: '='
	    },
	    link: function link(scope, element, attrs) {
	      element.bind('change', function (event) {
	        var file = event.target.files[0];
	        scope.fileInput = file ? file : undefined;
	        scope.$apply();
	      });
	    }
	  };
	}).name;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('wftOrderFormApp.datePicker', []).directive('datePicker', function () {
	  return {
	    template: __webpack_require__(166),
	    translude: true,
	    restrict: 'E',
	    replace: true,
	    scope: {
	      name: '<',
	      ngModel: '=',
	      required: '<'
	    },
	    link: function link(scope, element, attrs) {
	      scope.options = {
	        formatYear: 'yyyy',
	        startingDay: 0,
	
	        showWeeks: true
	      };
	      scope.format = 'MM/dd/yyyy';
	      scope.opened = false;
	      scope.open = function ($event) {
	        $event.preventDefault();
	        $event.stopPropagation();
	        scope.opened = true;
	      };
	    }
	  };
	}).name;

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"input-group datepicker date-picker\">\n  <input type=\"text\" id=\"{{name}}\" name=\"{{name}}\" class=\"form-control input-sm\" uib-datepicker-popup=\"{{format}}\" ng-model=\"ngModel\" is-open=\"opened\" datepicker-options=\"options\" ng-click=\"open($event)\" ng-required=\"{{required}}\" />\n  <span class=\"input-group-btn\">\n    <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"open($event)\">\n      <i class=\"fa fa-calendar\" aria-hidden=\"true\"></i>\n    </button>\n  </span>\n</div>\n"

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('wftOrderFormApp.repeatEndWatch', []).directive('repeatEndWatch', function () {
	  return {
	    restrict: 'A',
	    scope: {},
	    link: function link(scope, element, attrs) {
	      if (attrs.ngRepeat) {
	        if (scope.$parent.$last) {
	          if (attrs.repeatEndWatch !== '') {
	            scope.$parent.$eval(attrs.repeatEndWatch);
	          }
	        }
	      } else {
	        throw 'repeatEndWatch: `ngRepeat` Directive required to use this Directive';
	      }
	    }
	  };
	}).name;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('wftOrderFormApp.resultControls', []).directive('resultControls', function () {
	  return {
	    template: __webpack_require__(169),
	    restrict: 'E',
	    replace: true,
	    scope: {
	      total: '<',
	      pageSizeOptions: '<',
	      pageSize: '=',
	      pageSizeCallback: '&',
	      sortByOptions: '<',
	      sortBy: '=',
	      sortByCallback: '&'
	    },
	    link: function link(scope, element, attrs) {
	      scope.sortByDir = 'asc';
	
	      if (scope.sortBy) {
	        var sortBy = [];
	        if (/\s/.test(scope.sortBy)) {
	          sortBy = scope.sortBy.split(/\s/);
	        } else {
	          sortBy = [sortBy];
	        }
	        scope.sortByField = sortBy[0];
	        scope.sortByDir = sortBy[1] && sortBy[1] === 'asc' ? 'asc' : 'desc';
	      }
	
	      scope.updateSortByField = function () {
	        if (!scope.sortByField) {
	          return scope.sortByCallback({ sortBy: scope.sortByField });
	        }
	        scope.sortByCallback({ sortBy: scope.sortByField + ' ' + scope.sortByDir });
	      };
	
	      scope.updateSortByDir = function () {
	        scope.sortByDir = scope.sortByDir === 'asc' ? 'desc' : 'asc';
	        scope.sortByCallback({ sortBy: scope.sortByField + ' ' + scope.sortByDir });
	      };
	    }
	  };
	}).name;

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"result-controls\">\n  <div class=\"total\">\n    Total: {{total | currency:'':0}}\n  </div>\n  <div class=\"page-size\">\n    <select class=\"form-control input-sm pull-left\" ng-options=\"pageSize for pageSize in pageSizeOptions\" ng-model=\"pageSize\" ng-change=\"pageSizeCallback({pageSize: pageSize})\">\n      <option value=\"\">Display Size...</option>\n    </select>\n  </div>\n  <div class=\"sort-by\">\n    <div class=\"input-group\">\n      <select class=\"form-control input-sm pull-left\" ng-options=\"k as v for (k, v) in sortByOptions\" ng-model=\"sortByField\" ng-change=\"updateSortByField()\">\n        <option value=\"\">Sort By...</option>\n      </select>\n      <button class=\"btn btn-default btn-sm\" ng-click=\"updateSortByDir()\">\n        <span class=\"glyphicon\" ng-class=\"{'glyphicon-sort-by-alphabet-alt': sortByDir === 'desc', 'glyphicon-sort-by-alphabet': !sortByDir || sortByDir === 'asc'}\" aria-hidden=\"true\"></span>\n      </button>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('wftOrderFormApp.pagination', []).directive('pagination', function () {
	  return {
	    template: '<div class="pagination-nav pull-right">\
	        <nav ng-if="pageNums.length">\
	          <ul class="pagination pagination-sm">\
	            <li ng-class="pageNum == 1 ? \'disabled\' : \'\'"><a ng-click="firstPage()"><span aria-hidden="true">First</span><span class="sr-only">First</span></a></li>\
	            <li ng-class="pageNum == 1 ? \'disabled\' : \'\'"><a ng-click="selectPrevPage()"><span aria-hidden="true">«</span><span class="sr-only">Previous</span></a></li>\
	            <li ng-repeat="num in pageNums track by $index" ng-class="{\'active\': pageNum === num}"><a ng-click="selectPage(num)">{{num | currency:\'\':0}} <span class="sr-only" ng-if="num == pageNum">(current)</span></a></li>\
	            <li ng-class="pageNum == totalPages ? \'disabled\' : \'\'"><a ng-click="selectNextPage()"><span aria-hidden="true">»</span><span class="sr-only">Next</span></a></li>\
	            <li ng-class="pageNum == totalPages ? \'disabled\' : \'\'"><a ng-click="lastPage(totalPages)"><span aria-hidden="true">Last</span><span class="sr-only">Last</span></a></li>\
	          </ul>\
	        </nav>\
	      </div>',
	    restrict: 'E',
	    replace: true,
	    scope: {
	      id: '<',
	      total: '<',
	      pageNum: '<',
	      pageSize: '<',
	      callback: '&'
	    },
	    link: function link(scope) {
	      scope.curPageNum = 1;
	      scope.maxTotalPageDisplay = 5;
	
	      scope.pageNums = [];
	      scope.totalPages = 0;
	      scope.pageNum = 1;
	
	      function calTotalPages() {
	        scope.pageNums = [];
	        if (scope.total > 1 && scope.total > scope.pageSize) {
	          scope.totalPages = Math.ceil(scope.total / scope.pageSize);
	          var startAt = 1;
	          var endAt = scope.totalPages;
	          if (scope.totalPages > scope.maxTotalPageDisplay) {
	            startAt = scope.pageNum;
	
	            var maxBothDir = Math.floor(scope.maxTotalPageDisplay / 2);
	            var maxCombo = maxBothDir * 2;
	            var newStartAt = startAt - maxBothDir;
	            if (newStartAt <= 0) {
	              newStartAt = 1;
	              var newEndAt = newStartAt + maxCombo;
	            } else {
	              var newEndAt = newStartAt + maxCombo;
	              if (newEndAt > scope.totalPages) {
	                newStartAt = scope.totalPages - maxCombo;
	                newEndAt = scope.totalPages;
	              }
	            }
	            startAt = newStartAt;
	            endAt = newEndAt;
	          }
	
	          for (startAt; startAt <= endAt; startAt++) {
	            scope.pageNums.push(startAt);
	          }
	        }
	      };
	
	      scope.$watchGroup(['total', 'pageNum', 'pageSize'], function (v) {
	        if (v[0] && v[1] && v[2]) {
	          calTotalPages();
	        }
	      });
	
	      scope.selectPrevPage = function () {
	        var pageNum = scope.pageNum - 1;
	        if (pageNum > 0) {
	          calTotalPages();
	          scope.selectPage(pageNum);
	        }
	      };
	
	      scope.selectNextPage = function () {
	        var pageNum = scope.pageNum + 1;
	        if (pageNum < scope.totalPages) {
	          calTotalPages();
	          scope.selectPage(pageNum);
	        }
	      };
	
	      scope.firstPage = function () {
	        scope.pageNum = 1;
	        scope.curPageNum = 1;
	        calTotalPages();
	        scope.selectPage(1);
	      };
	
	      scope.lastPage = function (pageNum) {
	        scope.curPageNum = pageNum;
	        calTotalPages();
	        scope.selectPage(pageNum);
	      };
	
	      scope.selectPage = function (pageNum) {
	        if (parseInt(pageNum) <= scope.totalPages) {
	          scope.pageNum = pageNum;
	          scope.curPageNum = pageNum;
	          calTotalPages();
	          scope.callback({ pageNum: pageNum });
	        }
	      };
	    }
	  };
	}).name;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('wftOrderFormApp.autoComplete', []).directive('autoComplete', ['$q', '$parse', '$http', '$sce', '$timeout', '$templateCache', '$interpolate', function ($q, $parse, $http, $sce, $timeout, $templateCache, $interpolate) {
	  var KEY_DW = 40;
	  var KEY_RT = 39;
	  var KEY_UP = 38;
	  var KEY_LF = 37;
	  var KEY_ES = 27;
	  var KEY_EN = 13;
	  var KEY_TAB = 9;
	
	  var MIN_LENGTH = 3;
	  var MAX_LENGTH = 524288;
	  var PAUSE = 500;
	  var BLUR_TIMEOUT = 200;
	
	  var REQUIRED_CLASS = 'autocomplete-required';
	  var TEXT_SEARCHING = 'Searching...';
	  var TEXT_NORESULTS = 'No results found';
	  var TEMPLATE_URL = '/autocomplete/index.html';
	
	  $templateCache.put(TEMPLATE_URL, '<div class="autocomplete-holder" ng-class="{\'autocomplete-dropdown-visible\': showDropdown}">' + '  <input id="{{id}}_value" name="{{inputName}}" tabindex="{{fieldTabindex}}" ng-class="{\'autocomplete-input-not-empty\': notEmpty}" ng-model="searchStr" ng-disabled="disableInput" type="{{inputType}}" placeholder="{{placeholder}}" maxlength="{{maxlength}}" ng-focus="onFocusHandler()" class="{{inputClass}}" ng-focus="resetHideResults()" ng-blur="hideResults($event)" autocapitalize="off" autocorrect="off" autocomplete="off" ng-change="inputChangeHandler(searchStr)"/>' + '  <div id="{{id}}_dropdown" class="autocomplete-dropdown" ng-show="showDropdown">' + '    <div class="autocomplete-searching" ng-show="searching" ng-bind="textSearching"></div>' + '    <div class="autocomplete-searching" ng-show="!searching && (!results || results.length == 0)" ng-bind="textNoResults"></div>' + '    <div class="autocomplete-row" ng-repeat="result in results" ng-click="selectResult(result)" ng-mouseenter="hoverRow($index)" ng-class="{\'autocomplete-selected-row\': $index == currentIndex}">' + '      <div ng-if="imageField" class="autocomplete-image-holder">' + '        <img ng-if="result.image && result.image != \'\'" ng-src="{{result.image}}" class="autocomplete-image"/>' + '        <div ng-if="!result.image && result.image != \'\'" class="autocomplete-image-default"></div>' + '      </div>' + '      <div class="autocomplete-title" ng-if="matchClass" ng-bind-html="result.title"></div>' + '      <div class="autocomplete-title" ng-if="!matchClass">{{ result.title }}</div>' + '      <div ng-if="matchClass && result.description && result.description != \'\'" class="autocomplete-description" ng-bind-html="result.description"></div>' + '      <div ng-if="!matchClass && result.description && result.description != \'\'" class="autocomplete-description">{{result.description}}</div>' + '    </div>' + '  </div>' + '</div>');
	
	  function link(scope, elem, attrs, ctrl) {
	    var inputField = elem.find('input');
	    var minlength = MIN_LENGTH;
	    var searchTimer = null;
	    var hideTimer;
	    var requiredClassName = REQUIRED_CLASS;
	    var responseFormatter;
	    var validState = null;
	    var httpCanceller = null;
	    var httpCallInProgress = false;
	    var dd = elem[0].querySelector('.autocomplete-dropdown');
	    var isScrollOn = false;
	    var mousedownOn = null;
	    var unbindInitialValue;
	    var displaySearching;
	    var displayNoResults;
	
	    elem.on('mousedown', function (event) {
	      if (event.target.id) {
	        mousedownOn = event.target.id;
	        if (mousedownOn === scope.id + '_dropdown') {
	          document.body.addEventListener('click', clickoutHandlerForDropdown);
	        }
	      } else {
	        mousedownOn = event.target.className;
	      }
	    });
	
	    scope.currentIndex = scope.focusFirst ? 0 : null;
	    scope.searching = false;
	    unbindInitialValue = scope.$watch('initialValue', function (newval) {
	      if (newval) {
	        unbindInitialValue();
	
	        handleInputChange(newval, true);
	      }
	    });
	
	    scope.$watch('fieldRequired', function (newval, oldval) {
	      if (newval !== oldval) {
	        if (!newval) {
	          ctrl[scope.inputName].$setValidity(requiredClassName, true);
	        } else if (!validState || scope.currentIndex === -1) {
	          handleRequired(false);
	        } else {
	          handleRequired(true);
	        }
	      }
	    });
	
	    scope.$on('autocomplete:clearInput', function (event, elementId) {
	      if (!elementId || elementId === scope.id) {
	        scope.searchStr = null;
	        callOrAssign();
	        handleRequired(false);
	        clearResults();
	      }
	    });
	
	    scope.$on('autocomplete:changeInput', function (event, elementId, newval) {
	      if (!!elementId && elementId === scope.id) {
	        handleInputChange(newval);
	      }
	    });
	
	    scope.$on('autocomplete:showAll', function (event, elementId, newval) {
	      if (!!elementId && elementId === scope.id) {
	        showAll();
	      }
	    });
	
	    function handleInputChange(newval, initial) {
	      if (newval) {
	        if ((typeof newval === 'undefined' ? 'undefined' : _typeof(newval)) === 'object') {
	          scope.searchStr = extractTitle(newval);
	          callOrAssign({ originalObject: newval });
	        } else if (typeof newval === 'string' && newval.length > 0) {
	          scope.searchStr = newval;
	        } else {
	          if (console && console.error) {
	            console.error('Tried to set ' + (!!initial ? 'initial' : '') + ' value of autocomplete to', newval, 'which is an invalid value');
	          }
	        }
	
	        handleRequired(true);
	      }
	    }
	
	    function clickoutHandlerForDropdown(event) {
	      mousedownOn = null;
	      scope.hideResults(event);
	      document.body.removeEventListener('click', clickoutHandlerForDropdown);
	    }
	
	    function ie8EventNormalizer(event) {
	      return event.which ? event.which : event.keyCode;
	    }
	
	    function callOrAssign(value) {
	      if (typeof scope.selectedObject === 'function') {
	        scope.selectedObject(value, scope.selectedObjectData);
	      } else {
	        scope.selectedObject = value;
	      }
	
	      if (value) {
	        handleRequired(true);
	      } else {
	        handleRequired(false);
	      }
	    }
	
	    function callFunctionOrIdentity(fn) {
	      return function (data) {
	        return scope[fn] ? scope[fn](data) : data;
	      };
	    }
	
	    function setInputString(str) {
	      callOrAssign({ originalObject: str });
	
	      if (scope.clearSelected) {
	        scope.searchStr = null;
	      }
	      clearResults();
	    }
	
	    function extractTitle(data) {
	      return scope.titleField.split(',').map(function (field) {
	        return extractValue(data, field);
	      }).join(' ');
	    }
	
	    function extractValue(obj, key) {
	      var keys, result;
	      if (key) {
	        keys = key.split('.');
	        result = obj;
	        for (var i = 0; i < keys.length; i++) {
	          result = result[keys[i]];
	        }
	      } else {
	        result = obj;
	      }
	      return result;
	    }
	
	    function findMatchString(target, str) {
	      var result, matches, re;
	
	      re = new RegExp(str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
	      if (!target) {
	        return;
	      }
	      if (!target.match || !target.replace) {
	        target = target.toString();
	      }
	      matches = target.match(re);
	      if (matches) {
	        result = target.replace(re, '<span class="' + scope.matchClass + '">' + matches[0] + '</span>');
	      } else {
	        result = target;
	      }
	      return $sce.trustAsHtml(result);
	    }
	
	    function handleRequired(valid) {
	      scope.notEmpty = valid;
	      validState = scope.searchStr;
	      if (scope.fieldRequired && ctrl && scope.inputName) {
	        ctrl[scope.inputName].$setValidity(requiredClassName, valid);
	      }
	    }
	
	    function keyupHandler(event) {
	      var which = ie8EventNormalizer(event);
	      if (which === KEY_LF || which === KEY_RT) {
	        return;
	      }
	
	      if (which === KEY_UP || which === KEY_EN) {
	        event.preventDefault();
	      } else if (which === KEY_DW) {
	        event.preventDefault();
	        if (!scope.showDropdown && scope.searchStr && scope.searchStr.length >= minlength) {
	          initResults();
	          scope.searching = true;
	          searchTimerComplete(scope.searchStr);
	        }
	      } else if (which === KEY_ES) {
	        clearResults();
	        scope.$apply(function () {
	          inputField.val(scope.searchStr);
	        });
	      } else {
	        if (minlength === 0 && !scope.searchStr) {
	          return;
	        }
	
	        if (!scope.searchStr || scope.searchStr === '') {
	          scope.showDropdown = false;
	        } else if (scope.searchStr.length >= minlength) {
	          initResults();
	
	          if (searchTimer) {
	            $timeout.cancel(searchTimer);
	          }
	
	          scope.searching = true;
	
	          searchTimer = $timeout(function () {
	            searchTimerComplete(scope.searchStr);
	          }, scope.pause);
	        }
	
	        if (validState && validState !== scope.searchStr && !scope.clearSelected) {
	          scope.$apply(function () {
	            callOrAssign();
	          });
	        }
	      }
	    }
	
	    function handleOverrideSuggestions(event) {
	      if (scope.overrideSuggestions && !(scope.selectedObject && scope.selectedObject.originalObject === scope.searchStr)) {
	        if (event) {
	          event.preventDefault();
	        }
	
	        $timeout.cancel(searchTimer);
	
	        cancelHttpRequest();
	
	        setInputString(scope.searchStr);
	      }
	    }
	
	    function dropdownRowOffsetHeight(row) {
	      var css = getComputedStyle(row);
	      return row.offsetHeight + parseInt(css.marginTop, 10) + parseInt(css.marginBottom, 10);
	    }
	
	    function dropdownHeight() {
	      return dd.getBoundingClientRect().top + parseInt(getComputedStyle(dd).maxHeight, 10);
	    }
	
	    function dropdownRow() {
	      return elem[0].querySelectorAll('.autocomplete-row')[scope.currentIndex];
	    }
	
	    function dropdownRowTop() {
	      return dropdownRow().getBoundingClientRect().top - (dd.getBoundingClientRect().top + parseInt(getComputedStyle(dd).paddingTop, 10));
	    }
	
	    function dropdownScrollTopTo(offset) {
	      dd.scrollTop = dd.scrollTop + offset;
	    }
	
	    function updateInputField() {
	      var current = scope.results[scope.currentIndex];
	      if (scope.matchClass) {
	        inputField.val(extractTitle(current.originalObject));
	      } else {
	        inputField.val(current.title);
	      }
	    }
	
	    function keydownHandler(event) {
	      var which = ie8EventNormalizer(event);
	      var row = null;
	      var rowTop = null;
	
	      if (which === KEY_EN && scope.results) {
	        if (scope.currentIndex >= 0 && scope.currentIndex < scope.results.length) {
	          event.preventDefault();
	          scope.selectResult(scope.results[scope.currentIndex]);
	        } else {
	          handleOverrideSuggestions(event);
	          clearResults();
	        }
	        scope.$apply();
	      } else if (which === KEY_DW && scope.results) {
	        event.preventDefault();
	        if (scope.currentIndex + 1 < scope.results.length && scope.showDropdown) {
	          scope.$apply(function () {
	            scope.currentIndex++;
	            updateInputField();
	          });
	
	          if (isScrollOn) {
	            row = dropdownRow();
	            if (dropdownHeight() < row.getBoundingClientRect().bottom) {
	              dropdownScrollTopTo(dropdownRowOffsetHeight(row));
	            }
	          }
	        }
	      } else if (which === KEY_UP && scope.results) {
	        event.preventDefault();
	        if (scope.currentIndex >= 1) {
	          scope.$apply(function () {
	            scope.currentIndex--;
	            updateInputField();
	          });
	
	          if (isScrollOn) {
	            rowTop = dropdownRowTop();
	            if (rowTop < 0) {
	              dropdownScrollTopTo(rowTop - 1);
	            }
	          }
	        } else if (scope.currentIndex === 0) {
	          scope.$apply(function () {
	            scope.currentIndex = -1;
	            inputField.val(scope.searchStr);
	          });
	        }
	      } else if (which === KEY_TAB) {
	        if (scope.results && scope.results.length > 0 && scope.showDropdown) {
	          if (scope.currentIndex === -1 && scope.overrideSuggestions) {
	            handleOverrideSuggestions();
	          } else {
	            if (scope.currentIndex === -1) {
	              scope.currentIndex = 0;
	            }
	            scope.selectResult(scope.results[scope.currentIndex]);
	            scope.$digest();
	          }
	        } else {
	          if (scope.searchStr && scope.searchStr.length > 0) {
	            handleOverrideSuggestions();
	          }
	        }
	      } else if (which === KEY_ES) {
	        event.preventDefault();
	      }
	    }
	
	    function httpSuccessCallbackGen(str) {
	      return function (responseData, status, headers, config) {
	        if (!status && !headers && !config && responseData.data) {
	          responseData = responseData.data;
	        }
	        scope.searching = false;
	        processResults(extractValue(responseFormatter(responseData), scope.remoteUrlDataField), str);
	      };
	    }
	
	    function httpErrorCallback(errorRes, status, headers, config) {
	      scope.searching = httpCallInProgress;
	
	      if (!status && !headers && !config) {
	        status = errorRes.status;
	      }
	
	      if (status === 0 || status === -1) {
	        return;
	      }
	      if (scope.remoteUrlErrorCallback) {
	        scope.remoteUrlErrorCallback(errorRes, status, headers, config);
	      } else {
	        if (console && console.error) {
	          console.error('http error');
	        }
	      }
	    }
	
	    function cancelHttpRequest() {
	      if (httpCanceller) {
	        httpCanceller.resolve();
	      }
	    }
	
	    function getRemoteResults(str) {
	      var params = {},
	          url = scope.remoteUrl + encodeURIComponent(str);
	      if (scope.remoteUrlRequestFormatter) {
	        params = { params: scope.remoteUrlRequestFormatter(str) };
	        url = scope.remoteUrl;
	      }
	      if (!!scope.remoteUrlRequestWithCredentials) {
	        params.withCredentials = true;
	      }
	      cancelHttpRequest();
	      httpCanceller = $q.defer();
	      params.timeout = httpCanceller.promise;
	      httpCallInProgress = true;
	      $http.get(url, params).then(httpSuccessCallbackGen(str)).catch(httpErrorCallback).finally(function () {
	        httpCallInProgress = false;
	      });
	    }
	
	    function getRemoteResultsWithCustomHandler(str) {
	      cancelHttpRequest();
	
	      httpCanceller = $q.defer();
	
	      scope.remoteApiHandler(str, httpCanceller.promise).then(httpSuccessCallbackGen(str)).catch(httpErrorCallback);
	    }
	
	    function clearResults() {
	      scope.showDropdown = false;
	      scope.results = [];
	      if (dd) {
	        dd.scrollTop = 0;
	      }
	    }
	
	    function initResults() {
	      scope.showDropdown = displaySearching;
	      scope.currentIndex = scope.focusFirst ? 0 : -1;
	      scope.results = [];
	    }
	
	    function getLocalResults(str) {
	      var i,
	          match,
	          s,
	          value,
	          searchFields = scope.searchFields.split(','),
	          matches = [];
	      if (typeof scope.parseInput() !== 'undefined') {
	        str = scope.parseInput()(str);
	      }
	      for (i = 0; i < scope.localData.length; i++) {
	        match = false;
	
	        for (s = 0; s < searchFields.length; s++) {
	          value = extractValue(scope.localData[i], searchFields[s]) || '';
	          match = match || value.toString().toLowerCase().indexOf(str.toString().toLowerCase()) >= 0;
	        }
	
	        if (match) {
	          matches[matches.length] = scope.localData[i];
	        }
	      }
	      return matches;
	    }
	
	    function checkExactMatch(result, obj, str) {
	      if (!str) {
	        return false;
	      }
	      for (var key in obj) {
	        if (obj[key].toLowerCase() === str.toLowerCase()) {
	          scope.selectResult(result);
	          return true;
	        }
	      }
	      return false;
	    }
	
	    function searchTimerComplete(str) {
	      if (!str || str.length < minlength) {
	        return;
	      }
	      if (scope.localData) {
	        scope.$apply(function () {
	          var matches;
	          if (typeof scope.localSearch() !== 'undefined') {
	            matches = scope.localSearch()(str, scope.localData);
	          } else {
	            matches = getLocalResults(str);
	          }
	          scope.searching = false;
	          processResults(matches, str);
	        });
	      } else if (scope.remoteApiHandler) {
	        getRemoteResultsWithCustomHandler(str);
	      } else {
	        getRemoteResults(str);
	      }
	    }
	
	    function processResults(responseData, str) {
	      var i, description, image, text, formattedText, formattedDesc;
	
	      if (responseData && responseData.length > 0) {
	        scope.results = [];
	
	        for (i = 0; i < responseData.length; i++) {
	          if (scope.titleField && scope.titleField !== '') {
	            text = formattedText = extractTitle(responseData[i]);
	          }
	
	          description = '';
	          if (scope.descriptionField) {
	            description = formattedDesc = extractValue(responseData[i], scope.descriptionField);
	          }
	
	          image = '';
	          if (scope.imageField) {
	            image = extractValue(responseData[i], scope.imageField);
	          }
	
	          if (scope.matchClass) {
	            formattedText = findMatchString(text, str);
	            formattedDesc = findMatchString(description, str);
	          }
	
	          scope.results[scope.results.length] = {
	            title: formattedText,
	            description: formattedDesc,
	            image: image,
	            originalObject: responseData[i]
	          };
	        }
	      } else {
	        scope.results = [];
	      }
	
	      if (scope.autoMatch && scope.results.length === 1 && checkExactMatch(scope.results[0], { title: text, desc: description || '' }, scope.searchStr)) {
	        scope.showDropdown = false;
	      } else if (scope.results.length === 0 && !displayNoResults) {
	        scope.showDropdown = false;
	      } else {
	        scope.showDropdown = true;
	      }
	    }
	
	    function showAll() {
	      if (scope.localData) {
	        scope.searching = false;
	        processResults(scope.localData, '');
	      } else if (scope.remoteApiHandler) {
	        scope.searching = true;
	        getRemoteResultsWithCustomHandler('');
	      } else {
	        scope.searching = true;
	        getRemoteResults('');
	      }
	    }
	
	    scope.onFocusHandler = function () {
	      if (scope.focusIn) {
	        scope.focusIn();
	      }
	      if (minlength === 0 && (!scope.searchStr || scope.searchStr.length === 0)) {
	        scope.currentIndex = scope.focusFirst ? 0 : scope.currentIndex;
	        scope.showDropdown = true;
	        showAll();
	      }
	    };
	
	    scope.hideResults = function () {
	      if (mousedownOn && (mousedownOn === scope.id + '_dropdown' || mousedownOn.indexOf('autocomplete') >= 0)) {
	        mousedownOn = null;
	      } else {
	        hideTimer = $timeout(function () {
	          clearResults();
	          scope.$apply(function () {
	            if (scope.searchStr && scope.searchStr.length > 0) {
	              inputField.val(scope.searchStr);
	            }
	          });
	        }, BLUR_TIMEOUT);
	        cancelHttpRequest();
	
	        if (scope.focusOut) {
	          scope.focusOut();
	        }
	
	        if (scope.overrideSuggestions) {
	          if (scope.searchStr && scope.searchStr.length > 0 && scope.currentIndex === -1) {
	            handleOverrideSuggestions();
	          }
	        }
	      }
	    };
	
	    scope.resetHideResults = function () {
	      if (hideTimer) {
	        $timeout.cancel(hideTimer);
	      }
	    };
	
	    scope.hoverRow = function (index) {
	      scope.currentIndex = index;
	    };
	
	    scope.selectResult = function (result) {
	      if (scope.matchClass) {
	        result.title = extractTitle(result.originalObject);
	        result.description = extractValue(result.originalObject, scope.descriptionField);
	      }
	
	      if (scope.clearSelected) {
	        scope.searchStr = null;
	      } else {
	        scope.searchStr = result.title;
	      }
	      callOrAssign(result);
	      clearResults();
	    };
	
	    scope.inputChangeHandler = function (str) {
	      if (str.length < minlength) {
	        cancelHttpRequest();
	        clearResults();
	      } else if (str.length === 0 && minlength === 0) {
	        showAll();
	      }
	
	      if (scope.inputChanged) {
	        str = scope.inputChanged(str);
	      }
	      return str;
	    };
	
	    if (scope.fieldRequiredClass && scope.fieldRequiredClass !== '') {
	      requiredClassName = scope.fieldRequiredClass;
	    }
	
	    if (scope.minlength && scope.minlength !== '') {
	      minlength = parseInt(scope.minlength, 10);
	    }
	
	    if (!scope.pause) {
	      scope.pause = PAUSE;
	    }
	
	    if (!scope.clearSelected) {
	      scope.clearSelected = false;
	    }
	
	    if (!scope.overrideSuggestions) {
	      scope.overrideSuggestions = false;
	    }
	
	    if (scope.fieldRequired && ctrl) {
	      if (scope.initialValue) {
	        handleRequired(true);
	      } else {
	        handleRequired(false);
	      }
	    }
	
	    scope.inputType = attrs.type ? attrs.type : 'text';
	
	    scope.textSearching = attrs.textSearching ? attrs.textSearching : TEXT_SEARCHING;
	    scope.textNoResults = attrs.textNoResults ? attrs.textNoResults : TEXT_NORESULTS;
	    displaySearching = scope.textSearching === 'false' ? false : true;
	    displayNoResults = scope.textNoResults === 'false' ? false : true;
	
	    scope.maxlength = attrs.maxlength ? attrs.maxlength : MAX_LENGTH;
	
	    inputField.on('keydown', keydownHandler);
	    inputField.on('keyup compositionend', keyupHandler);
	
	    responseFormatter = callFunctionOrIdentity('remoteUrlResponseFormatter');
	
	    $timeout(function () {
	      var css = getComputedStyle(dd);
	      isScrollOn = css.maxHeight && css.overflowY === 'auto';
	    });
	  }
	
	  return {
	    restrict: 'EA',
	    require: '^?form',
	    scope: {
	      selectedObject: '=',
	      selectedObjectData: '=',
	      disableInput: '=',
	      initialValue: '=',
	      localData: '=',
	      localSearch: '&',
	      remoteUrlRequestFormatter: '=',
	      remoteUrlRequestWithCredentials: '@',
	      remoteUrlResponseFormatter: '=',
	      remoteUrlErrorCallback: '=',
	      remoteApiHandler: '=',
	      id: '@',
	      type: '@',
	      placeholder: '@',
	      textSearching: '@',
	      textNoResults: '@',
	      remoteUrl: '@',
	      remoteUrlDataField: '@',
	      titleField: '@',
	      descriptionField: '@',
	      imageField: '@',
	      inputClass: '@',
	      pause: '@',
	      searchFields: '@',
	      minlength: '@',
	      matchClass: '@',
	      clearSelected: '@',
	      overrideSuggestions: '@',
	      fieldRequired: '=',
	      fieldRequiredClass: '@',
	      inputChanged: '=',
	      autoMatch: '@',
	      focusOut: '&',
	      focusIn: '&',
	      fieldTabindex: '@',
	      inputName: '@',
	      focusFirst: '@',
	      parseInput: '&'
	    },
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || TEMPLATE_URL;
	    },
	    compile: function compile(tElement) {
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      if (!(startSym === '{{' && endSym === '}}')) {
	        var interpolatedHtml = tElement.html().replace(/\{\{/g, startSym).replace(/\}\}/g, endSym);
	        tElement.html(interpolatedHtml);
	      }
	      return link;
	    }
	  };
	}]).name;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('wftOrderFormApp.autoCompleteJobClass', []).directive('autoCompleteJobClass', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  return {
	    restrict: "A",
	    scope: {
	      ngModel: '=',
	      autoCompleteForm: '=',
	      autoCompleteExtraParams: '<',
	      autoCompleteRelatedFields: '<',
	      autoCompleteOnChange: '&',
	      autoCompleteOnClosed: '&'
	    },
	    link: function link(scope, elem) {
	      var lastSelectedItem = void 0;
	      var el = $(elem[0]);
	
	      var arrow = $('<a class="auto-complete-arrow-down"><span class="glyphicon glyphicon-chevron-down"></span></a>');
	      arrow.on('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        el.trigger('open.xdsoft');
	        el.trigger('updateContent.xdsoft');
	      });
	      el.after(arrow);
	
	      var clear = $('<a class="auto-complete-clear hide">x</a>');
	      clear.on('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        el.val('');
	        el.trigger('focus');
	        scope.ngModel = '';
	        angular.forEach(scope.autoCompleteRelatedFields, function (field) {
	          if (scope.autoCompleteForm[field]) {
	            scope.autoCompleteForm[field].$setViewValue(null);
	            scope.autoCompleteForm[field].$render();
	          }
	        });
	        if (scope.autoCompleteOnChange) {
	          $timeout(function () {
	            scope.autoCompleteOnChange();
	          }, 500);
	        }
	      });
	      el.after(clear);
	
	      $(window).on('click', function () {
	        el.trigger('close.xdsoft');
	      });
	
	      var getData = function getData(extraParams) {
	        var deferred = $q.defer();
	        var params = {
	          _pageSize: 'All',
	          _selector: 'name,description',
	          _sortBy: 'name asc'
	        };
	        if (extraParams) {
	          angular.extend(params, extraParams);
	        }
	        $http.get('/api/types/jobClasses', {
	          params: params
	        }).then(function (res) {
	          deferred.resolve(res.data);
	        }, function () {
	          deferred.resolve();
	        });
	        return deferred.promise;
	      };
	
	      var getSelected = function getSelected(item) {
	        var names = [];
	        if (item.name) {
	          names.push(item.name);
	        }
	        if (item.description) {
	          names.push(item.description);
	        }
	        return names.join(' / ');
	      };
	
	      el.autocomplete({
	        dropdownWidth: 'auto',
	        appendMethod: 'replace',
	        showHint: false,
	        limit: 1000,
	
	        valid: function valid(value, query) {
	          return true;
	        },
	
	        source: [function (q, add) {
	          getData({ keywords: q }).then(function (data) {
	            add(data);
	          });
	        }],
	        getTitle: function getTitle(item) {
	          return getSelected(item);
	        },
	        getValue: function getValue(item) {
	          return getSelected(item);
	        },
	        minLength: 0
	      }).on('open.xdsoft', function (event) {}).on('pick.xdsoft', function (event) {}).on('updateContent.xdsoft', function (event) {}).on('selected.xdsoft', function (event, selectedItem) {
	
	        if (selectedItem) {
	          clear.removeClass('hide');
	        }
	
	        lastSelectedItem = selectedItem;
	        scope.ngModel = getSelected(selectedItem);
	        angular.forEach(scope.autoCompleteRelatedFields, function (field) {
	          if (/Ref$/.test(field)) {
	            scope.autoCompleteForm[field].$setViewValue(selectedItem._id);
	            scope.autoCompleteForm[field].$render();
	          } else {
	            if (scope.autoCompleteForm[field] && selectedItem[field]) {
	              scope.autoCompleteForm[field].$setViewValue(selectedItem[field]);
	              scope.autoCompleteForm[field].$render();
	            }
	          }
	        });
	
	        if (scope.autoCompleteOnChange) {
	          $timeout(function () {
	            scope.autoCompleteOnChange();
	          }, 500);
	        }
	      }).on('close.xdsoft', function (event) {}).bind('focus', function (event) {
	        if (!event.target.value) {
	          clear.addClass('hide');
	        }
	      });
	    }
	  };
	}]).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bluebird = __webpack_require__(174);
	
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('wftOrderFormApp.autoCompleteCompanyGl', []).directive('autoCompleteCompanyGl', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  return {
	    restrict: "A",
	    scope: {
	      ngModel: '=',
	      autoCompleteForm: '=',
	      autoCompleteExtraParams: '<',
	      autoCompleteRelatedFields: '<',
	      autoCompleteOnChange: '&',
	      autoCompleteOnClosed: '&'
	    },
	    link: function link(scope, elem) {
	      var lastSelectedItem = void 0;
	      var el = $(elem[0]);
	
	      var arrow = $('<a class="auto-complete-arrow-down"><span class="glyphicon glyphicon-chevron-down"></span></a>');
	      arrow.on('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        el.trigger('open.xdsoft');
	        el.trigger('updateContent.xdsoft');
	      });
	      el.after(arrow);
	
	      var clear = $('<a class="auto-complete-clear hide">x</a>');
	      clear.on('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        el.val('');
	        el.trigger('focus');
	        scope.ngModel = '';
	        angular.forEach(scope.autoCompleteRelatedFields, function (field) {
	          if (scope.autoCompleteForm[field]) {
	            scope.autoCompleteForm[field].$setViewValue(null);
	            scope.autoCompleteForm[field].$render();
	          }
	        });
	        if (scope.autoCompleteOnChange) {
	          $timeout(function () {
	            scope.autoCompleteOnChange();
	          }, 500);
	        }
	      });
	      el.after(clear);
	
	      $(window).on('click', function () {
	        el.trigger('close.xdsoft');
	      });
	
	      var getData = function getData(extraParams) {
	        var deferred = $q.defer();
	        var params = {
	          _pageSize: 'All',
	          _selector: 'gl,regionName,companyName',
	          _sortBy: 'gl asc'
	        };
	        if (extraParams) {
	          angular.extend(params, extraParams);
	        }
	        $http.get('/api/types/companies/gls', {
	          params: params
	        }).then(function (res) {
	          deferred.resolve(res.data);
	        }, function () {
	          deferred.resolve();
	        });
	        return deferred.promise;
	      };
	
	      var getSelected = function getSelected(item) {
	        var names = [];
	        if (item.gl) {
	          names.push(item.gl);
	        }
	        if (item.regionName) {
	          names.push(item.regionName);
	        }
	        if (item.companyName) {
	          names.push(item.companyName);
	        }
	        return names.join(' / ');
	      };
	
	      el.autocomplete({
	        dropdownWidth: 'auto',
	        appendMethod: 'replace',
	        showHint: false,
	        limit: 1000,
	        visibleLimit: 20,
	        valid: function valid() {
	          return true;
	        },
	        source: [function (q, add) {
	          getData({ keywords: q }).then(function (data) {
	            add(data);
	          });
	        }],
	        getTitle: function getTitle(item) {
	          return getSelected(item);
	        },
	        getValue: function getValue(item) {
	          return getSelected(item);
	        },
	        minLength: 0
	      }).on('open.xdsoft', function (event) {}).on('pick.xdsoft', function (event) {}).on('updateContent.xdsoft', function (event) {}).on('selected.xdsoft', function (event, selectedItem) {
	
	        if (selectedItem) {
	          clear.removeClass('hide');
	        }
	
	        lastSelectedItem = selectedItem;
	        scope.ngModel = getSelected(selectedItem);
	
	        angular.forEach(scope.autoCompleteRelatedFields, function (field) {
	          if (/Ref$/.test(field)) {
	            scope.autoCompleteForm[field].$setViewValue(selectedItem._id);
	            scope.autoCompleteForm[field].$render();
	          } else {
	            if (scope.autoCompleteForm[field] && selectedItem[field]) {
	              scope.autoCompleteForm[field].$setViewValue(selectedItem[field]);
	              scope.autoCompleteForm[field].$render();
	            }
	          }
	        });
	        if (scope.autoCompleteOnChange) {
	          $timeout(function () {
	            scope.autoCompleteOnChange();
	          }, 500);
	        }
	      }).on('close.xdsoft', function (event) {}).bind('focus', function (event) {
	        if (!event.target.value) {
	          clear.addClass('hide');
	        }
	      });
	    }
	  };
	}]).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = __webpack_require__(175)();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = __webpack_require__(176);
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = __webpack_require__(177);
	var Async = __webpack_require__(178);
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = __webpack_require__(181);
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = __webpack_require__(182)(Promise, INTERNAL);
	var PromiseArray =
	    __webpack_require__(183)(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = __webpack_require__(184)(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = __webpack_require__(185)(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    __webpack_require__(186)(Promise, tryConvertToPromise, NEXT_FILTER);
	var catchFilter = __webpack_require__(187)(NEXT_FILTER);
	var nodebackForPromise = __webpack_require__(188);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (self == null || self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	
	}
	
	function Promise(executor) {
	    if (executor !== INTERNAL) {
	        check(this, executor);
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._resolveFromExecutor(executor);
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("Catch statement predicate: " +
	                    "expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" &&
	                    util.domainBind(domain, handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setWillBeCancelled = function() {
	    this._bitField = this._bitField | 8388608;
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    if (executor === INTERNAL) return;
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	        this._dereferenceTrace();
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	__webpack_require__(189)(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	__webpack_require__(190)(Promise, INTERNAL, tryConvertToPromise, debug);
	__webpack_require__(191)(Promise, PromiseArray, apiRejection, debug);
	__webpack_require__(192)(Promise);
	__webpack_require__(193)(Promise);
	__webpack_require__(194)(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
	Promise.Promise = Promise;
	Promise.version = "3.5.2";
	__webpack_require__(195)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(196)(Promise);
	__webpack_require__(197)(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
	__webpack_require__(198)(Promise, INTERNAL, debug);
	__webpack_require__(199)(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
	__webpack_require__(200)(Promise);
	__webpack_require__(201)(Promise, INTERNAL);
	__webpack_require__(202)(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	__webpack_require__(203)(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	__webpack_require__(204)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(205)(Promise, PromiseArray, debug);
	__webpack_require__(206)(Promise, PromiseArray, apiRejection);
	__webpack_require__(207)(Promise, INTERNAL);
	__webpack_require__(208)(Promise, INTERNAL);
	__webpack_require__(209)(Promise);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	var es5 = __webpack_require__(177);
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var receiver = new FakeConstructor();
	    function ic() {
	        return typeof receiver.foo;
	    }
	    ic();
	    ic();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj instanceof Error ||
	        (obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string");
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	var hasEnvVariables = typeof process !== "undefined" &&
	    "object" !== "undefined";
	
	function env(key) {
	    return hasEnvVariables ? ({"NODE_ENV":"production"})[key] : undefined;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	function domainBind(self, cb) {
	    return self.bind(cb);
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    hasEnvVariables: hasEnvVariables,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise,
	    domainBind: domainBind
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(56)))

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = __webpack_require__(179);
	var Queue = __webpack_require__(180);
	var util = __webpack_require__(176);
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	function _drainQueue(queue) {
	    while (queue.length() > 0) {
	        _drainQueueStep(queue);
	    }
	}
	
	function _drainQueueStep(queue) {
	    var fn = queue.shift();
	    if (typeof fn !== "function") {
	        fn._settlePromises();
	    } else {
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	}
	
	Async.prototype._drainQueues = function () {
	    _drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    _drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	var util = __webpack_require__(176);
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function" &&
	           typeof NativePromise.resolve === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            (window.navigator.standalone || window.cordova))) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	            toggleScheduled = true;
	            div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(56)))

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var es5 = __webpack_require__(177);
	var Objectfreeze = es5.freeze;
	var util = __webpack_require__(176);
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = __webpack_require__(176);
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = __webpack_require__(176);
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    case -6: return new Map();
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise._isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = __webpack_require__(181).Warning;
	var util = __webpack_require__(176);
	var es5 = __webpack_require__(177);
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
	var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (false ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    var self = this;
	    setTimeout(function() {
	        self._notifyUnhandledRejection();
	    }, 1);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        if (typeof CustomEvent === "function") {
	            var event = new CustomEvent("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var eventData = {
	                    detail: event,
	                    cancelable: true
	                };
	                es5.defineProperty(
	                    eventData, "promise", {value: event.promise});
	                es5.defineProperty(eventData, "reason", {value: event.reason});
	                var domEvent = new CustomEvent(name.toLowerCase(), eventData);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else if (typeof Event === "function") {
	            var event = new Event("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new Event(name.toLowerCase(), {
	                    cancelable: true
	                });
	                domEvent.detail = event;
	                es5.defineProperty(domEvent, "promise", {value: event.promise});
	                es5.defineProperty(domEvent, "reason", {value: event.reason});
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else {
	            var event = document.createEvent("CustomEvent");
	            event.initCustomEvent("testingtheevent", false, true, {});
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = document.createEvent("CustomEvent");
	                domEvent.initCustomEvent(name.toLowerCase(), false, true,
	                    event);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        }
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	    return Promise;
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._dereferenceTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this._isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function longStackTracesDereferenceTrace() {
	    this._trace = undefined;
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var handlerLine = "";
	        var creatorLine = "";
	        if (promiseCreated._trace) {
	            var traceLines = promiseCreated._trace.stack.split("\n");
	            var stack = cleanStack(traceLines);
	            for (var i = stack.length - 1; i >= 0; --i) {
	                var line = stack[i];
	                if (!nodeFramePattern.test(line)) {
	                    var lineMatches = line.match(parseLinePattern);
	                    if (lineMatches) {
	                        handlerLine  = "at " + lineMatches[1] +
	                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
	                    }
	                    break;
	                }
	            }
	
	            if (stack.length > 0) {
	                var firstUserLine = stack[0];
	                for (var i = 0; i < traceLines.length; ++i) {
	
	                    if (traceLines[i] === firstUserLine) {
	                        if (i > 0) {
	                            creatorLine = "\n" + traceLines[i - 1];
	                        }
	                        break;
	                    }
	                }
	
	            }
	        }
	        var msg = "a promise was created in a " + name +
	            "handler " + handlerLine + "but was not returned from it, " +
	            "see http://goo.gl/rRqMUw" +
	            creatorLine;
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0 && error.name != "SyntaxError") {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
	var util = __webpack_require__(176);
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	var catchFilter = __webpack_require__(187)(NEXT_FILTER);
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret === NEXT_FILTER) {
	            return ret;
	        } else if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise._isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	Promise.prototype.tapCatch = function (handlerOrPredicate) {
	    var len = arguments.length;
	    if(len === 1) {
	        return this._passThrough(handlerOrPredicate,
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    } else {
	         var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(new TypeError(
	                    "tapCatch statement predicate: "
	                    + "expecting an object but got " + util.classString(item)
	                ));
	            }
	        }
	        catchInstances.length = j;
	        var handler = arguments[i];
	        return this._passThrough(catchFilter(catchInstances, handler, this),
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    }
	
	};
	
	return PassThroughHandlerContext;
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = __webpack_require__(176);
	var getKeys = __webpack_require__(177).keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var util = __webpack_require__(176);
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = __webpack_require__(181);
	var OperationalError = errors.OperationalError;
	var es5 = __webpack_require__(177);
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = __webpack_require__(176);
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};


/***/ }),
/* 190 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = __webpack_require__(176);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise._isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent._isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            promise._setWillBeCancelled();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this._isCancellable()) return;
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype._isCancellable = function() {
	    return this.isPending() && !this._isCancelled();
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this._isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};


/***/ }),
/* 192 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled = function() {
	    return (this._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.__isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype._isCancelled = function() {
	    return this._target().__isCancelled();
	};
	
	Promise.prototype.isCancelled = function() {
	    return (this._target()._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
	         getDomain) {
	var util = __webpack_require__(176);
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (true) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", "async", code)
	                           (tryCatch, errorObj, Promise, async);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (true) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                            holder.asyncNeeded = false;
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	
	                if (!ret._isFateSealed()) {
	                    if (holder.asyncNeeded) {
	                        var domain = getDomain();
	                        if (domain !== null) {
	                            holder.fn = util.domainBind(domain, holder.fn);
	                        }
	                    }
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];};
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(176);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : util.domainBind(domain, fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = [];
	    async.invoke(this._asyncInit, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	
	MappingPromiseArray.prototype._asyncInit = function() {
	    this._init$(undefined, -2);
	};
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	
	    if (index < 0) {
	        index = (index * -1) - 1;
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return true;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return false;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var promise = this._promise;
	        var callback = this._callback;
	        var receiver = promise._boundValue();
	        promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        var promiseCreated = promise._popContext();
	        debug.checkForgottenReturns(
	            ret,
	            promiseCreated,
	            preservedValues !== null ? "Promise.filter" : "Promise.map",
	            promise
	        );
	        if (ret === errorObj) {
	            this._reject(ret.e);
	            return true;
	        }
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            var bitField = maybePromise._bitField;
	            ;
	            if (((bitField & 50397184) === 0)) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = maybePromise;
	                maybePromise._proxy(this, (index + 1) * -1);
	                return false;
	            } else if (((bitField & 33554432) !== 0)) {
	                ret = maybePromise._value();
	            } else if (((bitField & 16777216) !== 0)) {
	                this._reject(maybePromise._reason());
	                return true;
	            } else {
	                this._cancel();
	                return true;
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	        return true;
	    }
	    return false;
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	
	    var limit = 0;
	    if (options !== undefined) {
	        if (typeof options === "object" && options !== null) {
	            if (typeof options.concurrency !== "number") {
	                return Promise.reject(
	                    new TypeError("'concurrency' must be a number but it is " +
	                                    util.classString(options.concurrency)));
	            }
	            limit = options.concurrency;
	        } else {
	            return Promise.reject(new TypeError(
	                            "options argument must be an object but it is " +
	                             util.classString(options)));
	        }
	    }
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
	}
	
	Promise.prototype.map = function (fn, options) {
	    return map(this, fn, options, null);
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    return map(promises, fn, options, _filter);
	};
	
	
	};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = __webpack_require__(176);
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (true) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	    if (true) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext, INTERNAL, debug) {
	    var util = __webpack_require__(176);
	    var TypeError = __webpack_require__(181).TypeError;
	    var inherits = __webpack_require__(176).inherits;
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var NULL = {};
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = new Promise(INTERNAL);
	        function iterator() {
	            if (i >= len) return ret._fulfill();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret;
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return NULL;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== NULL
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    function ResourceList(length) {
	        this.length = length;
	        this.promise = null;
	        this[length-1] = null;
	    }
	
	    ResourceList.prototype._resultCancelled = function() {
	        var len = this.length;
	        for (var i = 0; i < len; ++i) {
	            var item = this[i];
	            if (item instanceof Promise) {
	                item.cancel();
	            }
	        }
	    };
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new ResourceList(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var reflectedResources = new Array(resources.length);
	        for (var i = 0; i < reflectedResources.length; ++i) {
	            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
	        }
	
	        var resultPromise = Promise.all(reflectedResources)
	            .then(function(inspections) {
	                for (var i = 0; i < inspections.length; ++i) {
	                    var inspection = inspections[i];
	                    if (inspection.isRejected()) {
	                        errorObj.e = inspection.error();
	                        return errorObj;
	                    } else if (!inspection.isFulfilled()) {
	                        resultPromise.cancel();
	                        return;
	                    }
	                    inspections[i] = inspection.value();
	                }
	                promise._pushContext();
	
	                fn = tryCatch(fn);
	                var ret = spreadArgs
	                    ? fn.apply(undefined, inspections) : fn(inspections);
	                var promiseCreated = promise._popContext();
	                debug.checkForgottenReturns(
	                    ret, promiseCreated, "Promise.using", promise);
	                return ret;
	            });
	
	        var promise = resultPromise.lastly(function() {
	            var inspection = new Promise.PromiseInspection(resultPromise);
	            return dispose(resources, inspection);
	        });
	        resources.promise = promise;
	        promise._setOnCancel(resources);
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 131072;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 131072) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~131072);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, debug) {
	var util = __webpack_require__(176);
	var TimeoutError = Promise.TimeoutError;
	
	function HandleWrapper(handle)  {
	    this.handle = handle;
	}
	
	HandleWrapper.prototype._resultCancelled = function() {
	    clearTimeout(this.handle);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (ms, value) {
	    var ret;
	    var handle;
	    if (value !== undefined) {
	        ret = Promise.resolve(value)
	                ._then(afterValue, null, null, ms, undefined);
	        if (debug.cancellation() && value instanceof Promise) {
	            ret._setOnCancel(value);
	        }
	    } else {
	        ret = new Promise(INTERNAL);
	        handle = setTimeout(function() { ret._fulfill(); }, +ms);
	        if (debug.cancellation()) {
	            ret._setOnCancel(new HandleWrapper(handle));
	        }
	        ret._captureStackTrace();
	    }
	    ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(ms, this);
	};
	
	var afterTimeout = function (promise, message, parent) {
	    var err;
	    if (typeof message !== "string") {
	        if (message instanceof Error) {
	            err = message;
	        } else {
	            err = new TimeoutError("operation timed out");
	        }
	    } else {
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._reject(err);
	
	    if (parent != null) {
	        parent.cancel();
	    }
	};
	
	function successClear(value) {
	    clearTimeout(this.handle);
	    return value;
	}
	
	function failureClear(reason) {
	    clearTimeout(this.handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret, parent;
	
	    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
	        if (ret.isPending()) {
	            afterTimeout(ret, message, parent);
	        }
	    }, ms));
	
	    if (debug.cancellation()) {
	        parent = this.then();
	        ret = parent._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	        ret._setOnCancel(handleWrapper);
	    } else {
	        ret = this._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	    }
	
	    return ret;
	};
	
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise,
	                          Proxyable,
	                          debug) {
	var errors = __webpack_require__(181);
	var TypeError = errors.TypeError;
	var util = __webpack_require__(176);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    if (debug.cancellation()) {
	        var internal = new Promise(INTERNAL);
	        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
	        this._promise = internal.lastly(function() {
	            return _finallyPromise;
	        });
	        internal._captureStackTrace();
	        internal._setOnCancel(this);
	    } else {
	        var promise = this._promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	    }
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	    this._yieldedPromise = null;
	    this._cancellationPhase = false;
	}
	util.inherits(PromiseSpawn, Proxyable);
	
	PromiseSpawn.prototype._isResolved = function() {
	    return this._promise === null;
	};
	
	PromiseSpawn.prototype._cleanup = function() {
	    this._promise = this._generator = null;
	    if (debug.cancellation() && this._finallyPromise !== null) {
	        this._finallyPromise._fulfill();
	        this._finallyPromise = null;
	    }
	};
	
	PromiseSpawn.prototype._promiseCancelled = function() {
	    if (this._isResolved()) return;
	    var implementsReturn = typeof this._generator["return"] !== "undefined";
	
	    var result;
	    if (!implementsReturn) {
	        var reason = new Promise.CancellationError(
	            "generator .return() sentinel");
	        Promise.coroutine.returnSentinel = reason;
	        this._promise._attachExtraTrace(reason);
	        this._promise._pushContext();
	        result = tryCatch(this._generator["throw"]).call(this._generator,
	                                                         reason);
	        this._promise._popContext();
	    } else {
	        this._promise._pushContext();
	        result = tryCatch(this._generator["return"]).call(this._generator,
	                                                          undefined);
	        this._promise._popContext();
	    }
	    this._cancellationPhase = true;
	    this._yieldedPromise = null;
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseFulfilled = function(value) {
	    this._yieldedPromise = null;
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseRejected = function(reason) {
	    this._yieldedPromise = null;
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._resultCancelled = function() {
	    if (this._yieldedPromise instanceof Promise) {
	        var promise = this._yieldedPromise;
	        this._yieldedPromise = null;
	        promise.cancel();
	    }
	};
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._promiseFulfilled(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    var promise = this._promise;
	    if (result === errorObj) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._rejectCallback(result.e, false);
	        }
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._resolveCallback(value);
	        }
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._promiseRejected(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise = maybePromise._target();
	        var bitField = maybePromise._bitField;
	        ;
	        if (((bitField & 50397184) === 0)) {
	            this._yieldedPromise = maybePromise;
	            maybePromise._proxy(this, null);
	        } else if (((bitField & 33554432) !== 0)) {
	            Promise._async.invoke(
	                this._promiseFulfilled, this, maybePromise._value()
	            );
	        } else if (((bitField & 16777216) !== 0)) {
	            Promise._async.invoke(
	                this._promiseRejected, this, maybePromise._reason()
	            );
	        } else {
	            this._promiseCancelled();
	        }
	    }
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        var ret = spawn.promise();
	        spawn._generator = generator;
	        spawn._promiseFulfilled(undefined);
	        return ret;
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise) {
	var util = __webpack_require__(176);
	var async = Promise._async;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var newReason = new Error(reason + "");
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
	                                                                     options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = __webpack_require__(176);
	var nodebackForPromise = __webpack_require__(188);
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = __webpack_require__(181).TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (true) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn, _, multiArgs) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	    var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode);
	    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL",
	                        body)(
	                    Promise,
	                    fn,
	                    receiver,
	                    withAppended,
	                    maybeWrapAsError,
	                    nodebackForPromise,
	                    util.tryCatch,
	                    util.errorObj,
	                    util.notEnumerableProp,
	                    INTERNAL);
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise, multiArgs);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key,
	                                           fn, suffix, multiArgs);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver, multiArgs) {
	    return makeNodePromisified(callback, receiver, undefined,
	                                callback, null, multiArgs);
	}
	
	Promise.promisify = function (fn, options) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    options = Object(options);
	    var receiver = options.context === undefined ? THIS : options.context;
	    var multiArgs = !!options.multiArgs;
	    var ret = promisify(fn, receiver, multiArgs);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    options = Object(options);
	    var multiArgs = !!options.multiArgs;
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier,
	                multiArgs);
	            promisifyAll(value, suffix, filter, promisifier, multiArgs);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
	};
	};
	


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(176);
	var isObject = util.isObject;
	var es5 = __webpack_require__(177);
	var Es6Map;
	if (typeof Map === "function") Es6Map = Map;
	
	var mapToEntries = (function() {
	    var index = 0;
	    var size = 0;
	
	    function extractEntry(value, key) {
	        this[index] = value;
	        this[index + size] = key;
	        index++;
	    }
	
	    return function mapToEntries(map) {
	        size = map.size;
	        index = 0;
	        var ret = new Array(map.size * 2);
	        map.forEach(extractEntry, ret);
	        return ret;
	    };
	})();
	
	var entriesToMap = function(entries) {
	    var ret = new Es6Map();
	    var length = entries.length / 2 | 0;
	    for (var i = 0; i < length; ++i) {
	        var key = entries[length + i];
	        var value = entries[i];
	        ret.set(key, value);
	    }
	    return ret;
	};
	
	function PropertiesPromiseArray(obj) {
	    var isMap = false;
	    var entries;
	    if (Es6Map !== undefined && obj instanceof Es6Map) {
	        entries = mapToEntries(obj);
	        isMap = true;
	    } else {
	        var keys = es5.keys(obj);
	        var len = keys.length;
	        entries = new Array(len * 2);
	        for (var i = 0; i < len; ++i) {
	            var key = keys[i];
	            entries[i] = obj[key];
	            entries[i + len] = key;
	        }
	    }
	    this.constructor$(entries);
	    this._isMap = isMap;
	    this._init$(undefined, isMap ? -6 : -3);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val;
	        if (this._isMap) {
	            val = entriesToMap(this._values);
	        } else {
	            val = {};
	            var keyOffset = this.length();
	            for (var i = 0, len = this.length(); i < len; ++i) {
	                val[this._values[i + keyOffset]] = this._values[i];
	            }
	        }
	        this._resolve(val);
	        return true;
	    }
	    return false;
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 2);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(176);
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else {
	        promises = util.asArray(promises);
	        if (promises === null)
	            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 3);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(176);
	var tryCatch = util.tryCatch;
	
	function ReductionPromiseArray(promises, fn, initialValue, _each) {
	    this.constructor$(promises);
	    var domain = getDomain();
	    this._fn = domain === null ? fn : util.domainBind(domain, fn);
	    if (initialValue !== undefined) {
	        initialValue = Promise.resolve(initialValue);
	        initialValue._attachCancellationCallback(this);
	    }
	    this._initialValue = initialValue;
	    this._currentCancellable = null;
	    if(_each === INTERNAL) {
	        this._eachValues = Array(this._length);
	    } else if (_each === 0) {
	        this._eachValues = null;
	    } else {
	        this._eachValues = undefined;
	    }
	    this._promise._captureStackTrace();
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._gotAccum = function(accum) {
	    if (this._eachValues !== undefined && 
	        this._eachValues !== null && 
	        accum !== INTERNAL) {
	        this._eachValues.push(accum);
	    }
	};
	
	ReductionPromiseArray.prototype._eachComplete = function(value) {
	    if (this._eachValues !== null) {
	        this._eachValues.push(value);
	    }
	    return this._eachValues;
	};
	
	ReductionPromiseArray.prototype._init = function() {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function() {
	    this._resolve(this._eachValues !== undefined ? this._eachValues
	                                                 : this._initialValue);
	};
	
	ReductionPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	ReductionPromiseArray.prototype._resolve = function(value) {
	    this._promise._resolveCallback(value);
	    this._values = null;
	};
	
	ReductionPromiseArray.prototype._resultCancelled = function(sender) {
	    if (sender === this._initialValue) return this._cancel();
	    if (this._isResolved()) return;
	    this._resultCancelled$();
	    if (this._currentCancellable instanceof Promise) {
	        this._currentCancellable.cancel();
	    }
	    if (this._initialValue instanceof Promise) {
	        this._initialValue.cancel();
	    }
	};
	
	ReductionPromiseArray.prototype._iterate = function (values) {
	    this._values = values;
	    var value;
	    var i;
	    var length = values.length;
	    if (this._initialValue !== undefined) {
	        value = this._initialValue;
	        i = 0;
	    } else {
	        value = Promise.resolve(values[0]);
	        i = 1;
	    }
	
	    this._currentCancellable = value;
	
	    if (!value.isRejected()) {
	        for (; i < length; ++i) {
	            var ctx = {
	                accum: null,
	                value: values[i],
	                index: i,
	                length: length,
	                array: this
	            };
	            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
	        }
	    }
	
	    if (this._eachValues !== undefined) {
	        value = value
	            ._then(this._eachComplete, undefined, undefined, this, undefined);
	    }
	    value._then(completed, completed, undefined, value, this);
	};
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	
	function completed(valueOrReason, array) {
	    if (this.isFulfilled()) {
	        array._resolve(valueOrReason);
	    } else {
	        array._reject(valueOrReason);
	    }
	}
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	function gotAccum(accum) {
	    this.accum = accum;
	    this.array._gotAccum(accum);
	    var value = tryConvertToPromise(this.value, this.array._promise);
	    if (value instanceof Promise) {
	        this.array._currentCancellable = value;
	        return value._then(gotValue, undefined, undefined, this, undefined);
	    } else {
	        return gotValue.call(this, value);
	    }
	}
	
	function gotValue(value) {
	    var array = this.array;
	    var promise = array._promise;
	    var fn = tryCatch(array._fn);
	    promise._pushContext();
	    var ret;
	    if (array._eachValues !== undefined) {
	        ret = fn.call(promise._boundValue(), value, this.index, this.length);
	    } else {
	        ret = fn.call(promise._boundValue(),
	                              this.accum, value, this.index, this.length);
	    }
	    if (ret instanceof Promise) {
	        array._currentCancellable = ret;
	    }
	    var promiseCreated = promise._popContext();
	    debug.checkForgottenReturns(
	        ret,
	        promiseCreated,
	        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
	        promise
	    );
	    return ret;
	}
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	    function(Promise, PromiseArray, debug) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = __webpack_require__(176);
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 33554432;
	    ret._settledValueField = value;
	    return this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 16777216;
	    ret._settledValueField = reason;
	    return this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    debug.deprecated(".settle()", ".reflect()");
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return Promise.settle(this);
	};
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = __webpack_require__(176);
	var RangeError = __webpack_require__(181).RangeError;
	var AggregateError = __webpack_require__(181).AggregateError;
	var isArray = util.isArray;
	var CANCELLATION = {};
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	        return true;
	    }
	    return false;
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._promiseCancelled = function () {
	    if (this._values instanceof Promise || this._values == null) {
	        return this._cancel();
	    }
	    this._addRejected(CANCELLATION);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._checkOutcome = function() {
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            if (this._values[i] !== CANCELLATION) {
	                e.push(this._values[i]);
	            }
	        }
	        if (e.length > 0) {
	            this._reject(e);
	        } else {
	            this._cancel();
	        }
	        return true;
	    }
	    return false;
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	var PromiseAll = Promise.all;
	
	function promiseAllThis() {
	    return PromiseAll(this);
	}
	
	function PromiseMapSeries(promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
	}
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, this, undefined);
	};
	
	Promise.prototype.mapSeries = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, promises, undefined);
	};
	
	Promise.mapSeries = PromiseMapSeries;
	};
	


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('wftOrderFormApp.autoCompleteAccountingUnit', []).directive('autoCompleteAccountingUnit', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  return {
	    restrict: "A",
	    scope: {
	      ngModel: '=',
	      autoCompleteForm: '=',
	      autoCompleteExtraParams: '<',
	      autoCompleteRelatedFields: '<',
	      autoCompleteOnChange: '&',
	      autoCompleteOnClosed: '&'
	    },
	    link: function link(scope, elem) {
	      var lastSelectedItem = void 0;
	      var el = $(elem[0]);
	
	      var arrow = $('<a class="auto-complete-arrow-down"><span class="glyphicon glyphicon-chevron-down"></span></a>');
	      arrow.on('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        el.trigger('open.xdsoft');
	        el.trigger('updateContent.xdsoft');
	      });
	      el.after(arrow);
	
	      var clear = $('<a class="auto-complete-clear hide">x</a>');
	      clear.on('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        el.val('');
	        el.trigger('focus');
	        scope.ngModel = '';
	        angular.forEach(scope.autoCompleteRelatedFields, function (field) {
	          if (scope.autoCompleteForm[field]) {
	            scope.autoCompleteForm[field].$setViewValue(null);
	            scope.autoCompleteForm[field].$render();
	          }
	        });
	        if (scope.autoCompleteOnChange) {
	          $timeout(function () {
	            scope.autoCompleteOnChange();
	          }, 500);
	        }
	      });
	      el.after(clear);
	
	      $(window).on('click', function () {
	        el.trigger('close.xdsoft');
	      });
	
	      var getData = function getData(extraParams) {
	        var deferred = $q.defer();
	        var params = {
	          _pageSize: 'All',
	          _selector: 'hrOrganizationUnit,shortDescription,description,parentUnitShortDescription,mvsOrBsc',
	          _sortBy: 'hrOrganizationUnit asc'
	        };
	        if (extraParams) {
	          angular.extend(params, extraParams);
	        }
	        $http.get('/api/types/companies/accountingUnits', {
	          params: params
	        }).then(function (res) {
	          deferred.resolve(res.data);
	        }, function () {
	          deferred.resolve();
	        });
	        return deferred.promise;
	      };
	
	      var getSelected = function getSelected(item) {
	        var names = [];
	        if (item.hrOrganizationUnit) {
	          names.push(item.hrOrganizationUnit);
	        }
	        if (item.shortDescription) {
	          names.push(item.shortDescription);
	        }
	        if (item.description) {
	          names.push(item.description);
	        }
	        if (item.parentUnitShortDescription) {
	          names.push(item.parentUnitShortDescription);
	        }
	        return names.join(' / ');
	      };
	
	      el.autocomplete({
	        dropdownWidth: 'auto',
	        appendMethod: 'replace',
	        showHint: false,
	        limit: 1000,
	        visibleLimit: 20,
	        valid: function valid() {
	          return true;
	        },
	        source: [function (q, add) {
	          getData({ keywords: q }).then(function (data) {
	            add(data);
	          });
	        }],
	        getTitle: function getTitle(item) {
	          return getSelected(item);
	        },
	        getValue: function getValue(item) {
	          return getSelected(item);
	        },
	        minLength: 0
	      }).on('open.xdsoft', function (event) {}).on('pick.xdsoft', function (event) {}).on('updateContent.xdsoft', function (event) {}).on('selected.xdsoft', function (event, selectedItem) {
	
	        if (selectedItem) {
	          clear.removeClass('hide');
	        }
	
	        lastSelectedItem = selectedItem;
	        scope.ngModel = getSelected(selectedItem);
	        angular.forEach(scope.autoCompleteRelatedFields, function (field) {
	          if (/Ref$/.test(field)) {
	            scope.autoCompleteForm[field].$setViewValue(selectedItem._id);
	            scope.autoCompleteForm[field].$render();
	          } else {
	            if (scope.autoCompleteForm[field] && selectedItem[field]) {
	              scope.autoCompleteForm[field].$setViewValue(selectedItem[field]);
	              scope.autoCompleteForm[field].$render();
	            }
	          }
	        });
	        if (scope.autoCompleteOnChange) {
	          $timeout(function () {
	            scope.autoCompleteOnChange();
	          }, 500);
	        }
	      }).on('close.xdsoft', function (event) {}).bind('focus', function (event) {
	        if (!event.target.value) {
	          clear.addClass('hide');
	        }
	      });
	    }
	  };
	}]).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bluebird = __webpack_require__(174);
	
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('wftOrderFormApp.autoCompleteLocationCode', []).directive('autoCompleteLocationCode', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  return {
	    restrict: "A",
	    scope: {
	      ngModel: '=',
	      autoCompleteForm: '=',
	      autoCompleteExtraParams: '<',
	      autoCompleteRelatedFields: '<',
	      autoCompleteOnChange: '&',
	      autoCompleteOnClosed: '&'
	    },
	    link: function link(scope, elem) {
	      var lastSelectedItem = void 0;
	      var el = $(elem[0]);
	
	      var arrow = $('<a class="auto-complete-arrow-down"><span class="glyphicon glyphicon-chevron-down"></span></a>');
	      arrow.on('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        el.trigger('open.xdsoft');
	        el.trigger('updateContent.xdsoft');
	      });
	      el.after(arrow);
	
	      var clear = $('<a class="auto-complete-clear hide">x</a>');
	      clear.on('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        el.val('');
	        el.trigger('focus');
	        scope.ngModel = '';
	        angular.forEach(scope.autoCompleteRelatedFields, function (field) {
	          if (scope.autoCompleteForm[field]) {
	            scope.autoCompleteForm[field].$setViewValue(null);
	            scope.autoCompleteForm[field].$render();
	          }
	        });
	        if (scope.autoCompleteOnChange) {
	          $timeout(function () {
	            scope.autoCompleteOnChange();
	          }, 500);
	        }
	      });
	      el.after(clear);
	
	      $(window).on('click', function () {
	        el.trigger('close.xdsoft');
	      });
	
	      var getData = function getData(extraParams) {
	        var deferred = $q.defer();
	        var params = {
	          _pageSize: 'All',
	          _selector: 'hrLocation,description,mvsOrBsc',
	          _sortBy: 'gl asc'
	        };
	        if (extraParams) {
	          angular.extend(params, extraParams);
	        }
	        $http.get('/api/types/companies/locationCodes', {
	          params: params
	        }).then(function (res) {
	          deferred.resolve(res.data);
	        }, function () {
	          deferred.resolve();
	        });
	        return deferred.promise;
	      };
	
	      var getSelected = function getSelected(item) {
	        var names = [];
	        if (item.hrLocation) {
	          names.push(item.hrLocation);
	        }
	        if (item.description) {
	          names.push(item.description);
	        }
	
	        return names.join(' / ');
	      };
	
	      el.autocomplete({
	        dropdownWidth: 'auto',
	        appendMethod: 'replace',
	        showHint: false,
	        limit: 1000,
	        visibleLimit: 25,
	        valid: function valid() {
	          return true;
	        },
	        source: [function (q, add) {
	          getData({ keywords: q }).then(function (data) {
	            add(data);
	          });
	        }],
	        getTitle: function getTitle(item) {
	          return getSelected(item);
	        },
	        getValue: function getValue(item) {
	          return getSelected(item);
	        },
	        minLength: 0
	      }).on('open.xdsoft', function (event) {}).on('pick.xdsoft', function (event) {}).on('updateContent.xdsoft', function (event) {}).on('selected.xdsoft', function (event, selectedItem) {
	
	        if (selectedItem) {
	          clear.removeClass('hide');
	        }
	
	        lastSelectedItem = selectedItem;
	        scope.ngModel = getSelected(selectedItem);
	        angular.forEach(scope.autoCompleteRelatedFields, function (field) {
	          if (/Ref$/.test(field)) {
	            scope.autoCompleteForm[field].$setViewValue(selectedItem._id);
	            scope.autoCompleteForm[field].$render();
	          } else {
	            if (scope.autoCompleteForm[field] && selectedItem[field]) {
	              scope.autoCompleteForm[field].$setViewValue(selectedItem[field]);
	              scope.autoCompleteForm[field].$render();
	            }
	          }
	        });
	
	        if (scope.autoCompleteOnChange) {
	          $timeout(function () {
	            scope.autoCompleteOnChange();
	          }, 500);
	        }
	      }).on('close.xdsoft', function (event) {}).bind('focus', function (event) {
	        if (!event.target.value) {
	          clear.addClass('hide');
	        }
	      });
	    }
	  };
	}]).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(213);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(61)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot\");src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2\") format(\"woff2\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff\") format(\"woff\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf\") format(\"truetype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\") format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:transparent}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.428571429;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.428571429}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{content:\" \";display:table}.dl-horizontal dd:after{clear:both}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.428571429;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.428571429}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.428571429;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container-fluid:after,.container-fluid:before{content:\" \";display:table}.container-fluid:after{clear:both}.row{margin-left:-15px;margin-right:-15px}.row:after,.row:before{content:\" \";display:table}.row:after{clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-1{width:8.3333333333%}.col-xs-2{width:16.6666666667%}.col-xs-3{width:25%}.col-xs-4{width:33.3333333333%}.col-xs-5{width:41.6666666667%}.col-xs-6{width:50%}.col-xs-7{width:58.3333333333%}.col-xs-8{width:66.6666666667%}.col-xs-9{width:75%}.col-xs-10{width:83.3333333333%}.col-xs-11{width:91.6666666667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.3333333333%}.col-xs-pull-2{right:16.6666666667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.3333333333%}.col-xs-pull-5{right:41.6666666667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.3333333333%}.col-xs-pull-8{right:66.6666666667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.3333333333%}.col-xs-pull-11{right:91.6666666667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.3333333333%}.col-xs-push-2{left:16.6666666667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.3333333333%}.col-xs-push-5{left:41.6666666667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.3333333333%}.col-xs-push-8{left:66.6666666667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.3333333333%}.col-xs-push-11{left:91.6666666667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.3333333333%}.col-xs-offset-2{margin-left:16.6666666667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.3333333333%}.col-xs-offset-5{margin-left:41.6666666667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.3333333333%}.col-xs-offset-8{margin-left:66.6666666667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.3333333333%}.col-xs-offset-11{margin-left:91.6666666667%}.col-xs-offset-12{margin-left:100%}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1{width:8.3333333333%}.col-sm-2{width:16.6666666667%}.col-sm-3{width:25%}.col-sm-4{width:33.3333333333%}.col-sm-5{width:41.6666666667%}.col-sm-6{width:50%}.col-sm-7{width:58.3333333333%}.col-sm-8{width:66.6666666667%}.col-sm-9{width:75%}.col-sm-10{width:83.3333333333%}.col-sm-11{width:91.6666666667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.3333333333%}.col-sm-pull-2{right:16.6666666667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.3333333333%}.col-sm-pull-5{right:41.6666666667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.3333333333%}.col-sm-pull-8{right:66.6666666667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.3333333333%}.col-sm-pull-11{right:91.6666666667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.3333333333%}.col-sm-push-2{left:16.6666666667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.3333333333%}.col-sm-push-5{left:41.6666666667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.3333333333%}.col-sm-push-8{left:66.6666666667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.3333333333%}.col-sm-push-11{left:91.6666666667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.3333333333%}.col-sm-offset-2{margin-left:16.6666666667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.3333333333%}.col-sm-offset-5{margin-left:41.6666666667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.3333333333%}.col-sm-offset-8{margin-left:66.6666666667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.3333333333%}.col-sm-offset-11{margin-left:91.6666666667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.3333333333%}.col-md-2{width:16.6666666667%}.col-md-3{width:25%}.col-md-4{width:33.3333333333%}.col-md-5{width:41.6666666667%}.col-md-6{width:50%}.col-md-7{width:58.3333333333%}.col-md-8{width:66.6666666667%}.col-md-9{width:75%}.col-md-10{width:83.3333333333%}.col-md-11{width:91.6666666667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.3333333333%}.col-md-pull-2{right:16.6666666667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.3333333333%}.col-md-pull-5{right:41.6666666667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.3333333333%}.col-md-pull-8{right:66.6666666667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.3333333333%}.col-md-pull-11{right:91.6666666667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.3333333333%}.col-md-push-2{left:16.6666666667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.3333333333%}.col-md-push-5{left:41.6666666667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.3333333333%}.col-md-push-8{left:66.6666666667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.3333333333%}.col-md-push-11{left:91.6666666667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.3333333333%}.col-md-offset-2{margin-left:16.6666666667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.3333333333%}.col-md-offset-5{margin-left:41.6666666667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.3333333333%}.col-md-offset-8{margin-left:66.6666666667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.3333333333%}.col-md-offset-11{margin-left:91.6666666667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.3333333333%}.col-lg-2{width:16.6666666667%}.col-lg-3{width:25%}.col-lg-4{width:33.3333333333%}.col-lg-5{width:41.6666666667%}.col-lg-6{width:50%}.col-lg-7{width:58.3333333333%}.col-lg-8{width:66.6666666667%}.col-lg-9{width:75%}.col-lg-10{width:83.3333333333%}.col-lg-11{width:91.6666666667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.3333333333%}.col-lg-pull-2{right:16.6666666667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.3333333333%}.col-lg-pull-5{right:41.6666666667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.3333333333%}.col-lg-pull-8{right:66.6666666667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.3333333333%}.col-lg-pull-11{right:91.6666666667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.3333333333%}.col-lg-push-2{left:16.6666666667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.3333333333%}.col-lg-push-5{left:41.6666666667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.3333333333%}.col-lg-push-8{left:66.6666666667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.3333333333%}.col-lg-push-11{left:91.6666666667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.3333333333%}.col-lg-offset-2{margin-left:16.6666666667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.3333333333%}.col-lg-offset-5{margin-left:41.6666666667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.3333333333%}.col-lg-offset-8{margin-left:66.6666666667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.3333333333%}.col-lg-offset-11{margin-left:91.6666666667%}.col-lg-offset-12{margin-left:100%}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.428571429;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.428571429;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm>.input-group-btn>input[type=date].btn,.input-group-sm>.input-group-btn>input[type=datetime-local].btn,.input-group-sm>.input-group-btn>input[type=month].btn,.input-group-sm>.input-group-btn>input[type=time].btn,.input-group-sm>input[type=date].form-control,.input-group-sm>input[type=date].input-group-addon,.input-group-sm>input[type=datetime-local].form-control,.input-group-sm>input[type=datetime-local].input-group-addon,.input-group-sm>input[type=month].form-control,.input-group-sm>input[type=month].input-group-addon,.input-group-sm>input[type=time].form-control,.input-group-sm>input[type=time].input-group-addon,.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input[type=date].btn,.input-group-lg>.input-group-btn>input[type=datetime-local].btn,.input-group-lg>.input-group-btn>input[type=month].btn,.input-group-lg>.input-group-btn>input[type=time].btn,.input-group-lg>input[type=date].form-control,.input-group-lg>input[type=date].input-group-addon,.input-group-lg>input[type=datetime-local].form-control,.input-group-lg>input[type=datetime-local].input-group-addon,.input-group-lg>input[type=month].form-control,.input-group-lg>input[type=month].input-group-addon,.input-group-lg>input[type=time].form-control,.input-group-lg>input[type=time].input-group-addon,.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-left:0;padding-right:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select[multiple].btn,.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select[multiple].btn,.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{content:\" \";display:table}.form-horizontal .form-group:after{clear:both}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.428571429;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.btn-default.dropdown-toggle{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.428571429;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.428571429;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{content:\" \";display:table}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav:after,.nav:before{content:\" \";display:table}.nav:after{clear:both}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.428571429;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}.navbar:after,.navbar:before{content:\" \";display:table}.navbar:after{clear:both}@media (min-width:768px){.navbar{border-radius:4px}}.navbar-header:after,.navbar-header:before{content:\" \";display:table}.navbar-header:after{clear:both}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{content:\" \";display:table}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#090909;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.428571429;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#337ab7;border-color:#337ab7;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager:after,.pager:before{content:\" \";display:table}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto;margin-left:auto;margin-right:auto}.thumbnail .caption{padding:9px;color:#333}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-body:after,.panel-body:before{content:\" \";display:table}.panel-body:after{clear:both}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{content:\" \";display:table}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.428571429}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{content:\" \";display:table}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?v=4.7.0\");src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.2857142857em;text-align:center}.fa-ul{padding-left:0;margin-left:2.1428571429em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.1428571429em;width:2.1428571429em;top:.1428571429em;text-align:center}.fa-li.fa-lg{left:-1.8571428571em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}form label{font-size:12px}form label.required:after{color:red;content:\" *\";font-size:16px}a{cursor:pointer}p{font-size:12px}.breadcrumb{font-size:11px;margin-top:75px;background-color:transparent!important;padding:0}table td,table th{font-size:12px}.buttons{margin:30px 0}td.actions a{text-decoration:none;border-right:1px solid #ccc;padding-right:5px}td.actions a:last-child{border-right:none;padding-right:0}.no-wrap{white-space:nowrap}.small-text{font-size:11px}.text-italic{font-style:italic}.xdsoft_autocomplete_dropdown{font-size:12px;color:#555;font-style:italic;max-height:250px!important}.form-group{position:relative}.form-group .auto-complete-clear{position:absolute;z-index:100;right:30px;top:31px;cursor:pointer;color:#555;padding:0 7px;border:1px solid #fff;border-radius:24px;transition:background .4s}.form-group .auto-complete-clear:hover{border:1px solid #999}.form-group .auto-complete-arrow-down{position:absolute;z-index:100;right:0;top:26px;cursor:pointer;padding:11px 5px 5px 10px;font-size:10px;color:#666;font-weight:100}.result-controls-pagination-container{margin-bottom:15px}.form-inline .form-group{margin-bottom:5px!important}.login-page .banner{position:fixed;z-index:1000;width:100%;height:52px;background-image:url(/assets/images/ImpactSlide-1024x581.jpg);background-position:50%;background-repeat:no-repeat;background-size:cover;background-origin:content-box}.login-page .page-header{margin-top:75px}.login-page .recover-password-link{padding-top:5px;float:right;font-size:12px}.recover-page .banner{position:fixed;z-index:1000;width:100%;height:52px;background-image:url(/assets/images/ImpactSlide-1024x581.jpg);background-position:50%;background-repeat:no-repeat;background-size:cover;background-origin:content-box}.recover-page .page-header{margin-top:75px}.recover-page .alert{font-size:12px}.settings-page .banner{position:fixed;z-index:1000;width:100%;height:52px;background-image:url(/assets/images/ImpactSlide-1024x581.jpg);background-position:50%;background-repeat:no-repeat;background-size:cover;background-origin:content-box}.settings-page .page-header{margin-top:75px}.admin-page .banner{position:fixed;z-index:1000;width:100%;height:52px;background-image:url(/assets/images/ImpactSlide-1024x581.jpg);background-position:50%;background-repeat:no-repeat;background-size:cover;background-origin:content-box}.admin-page .page-header{margin-top:75px}.admin-page .nav-tabs{font-size:12px}.admin-page .tab-content{margin-top:25px}.admin-page .tab-content .form-container{margin-bottom:20px}.uploader-modal label{font-size:12px}.uploader-modal .alert,.uploader-modal .parsed-section .nav-tabs,.uploader-modal .parsed-section p{font-size:11px}.uploader-modal .parsed-section .tabs-container{margin-bottom:5px}.uploader-modal .parsed-section .table-responsive{height:400px}.uploader-modal .parsed-section table span,.uploader-modal .parsed-section table td,.uploader-modal .parsed-section table th{font-size:11px;white-space:nowrap}.uploader-modal.facility .field-options select{min-width:150px}.uploader-modal .modal-footer .alert{margin:0;padding:5px 10px}.autocomplete-holder{position:relative}.autocomplete-dropdown{border:1px solid #ececec;border-radius:2px;width:100%;padding:6px;cursor:pointer;z-index:9999;position:absolute;top:32px;left:0;background-color:#fff;overflow-y:auto;max-height:200px}.autocomplete-searching{color:#acacac;font-size:14px}.autocomplete-description{font-size:14px}.autocomplete-row{padding:5px;color:#000;margin-bottom:4px;clear:both}.autocomplete-selected-row{background-color:#269abc;color:#fff}.autocomplete-image-holder{padding-top:2px;float:left;margin-right:10px;margin-left:5px}.autocomplete-image{height:34px;width:34px;border-radius:50%;border:1px solid #ececec}.autocomplete-image-default{background-position:50%;background-size:contain;height:34px;width:34px}.highlight{color:#ff4500}.pagination-nav{height:30px}.pagination-nav ul.pagination{margin:0!important}.result-controls{font-size:12px}.result-controls .total{float:left;line-height:30px;padding-right:5px}.result-controls .page-size{float:left;padding-left:5px;padding-right:5px}.result-controls .page-size select{width:60px}.result-controls .sort-by{float:left;padding-left:5px}.result-controls .sort-by select{width:120px;border-top-right-radius:0;border-bottom-right-radius:0}.result-controls .sort-by button{margin-bottom:0;border-top-left-radius:0;border-bottom-left-radius:0}.main-page .banner{position:fixed;z-index:1000;width:100%;height:52px;background-image:url(/assets/images/ImpactSlide-1024x581.jpg);background-position:50%;background-repeat:no-repeat;background-size:cover;background-origin:content-box}.main-page .page-header{margin-top:75px}.main-page .form-container{margin-bottom:20px}.order-page .banner{position:fixed;z-index:1000;width:100%;height:52px;background-image:url(/assets/images/PeoplePinsBackground-1.jpg);background-position:50%;background-repeat:no-repeat;background-size:cover}.order-page form{margin-top:30px;font-size:12px}.order-page form .form-group.custom-input-group .input-group{width:100%}.order-page form .form-group.custom-input-group .input-group-btn{width:50%}.order-page form .form-group.custom-input-group .input-group-btn select{border-bottom-right-radius:4px;border-top-right-radius:4px}.order-page form .input-group.autocomplete .input-group-addon.new{position:relative;color:#555;background-color:#eee;border:1px solid #ccc}.order-page form .input-group.autocomplete .input-group-addon.new input[type=checkbox]{position:absolute}.order-page form .input-group.autocomplete .input-group-addon.new label{font-weight:400;margin-bottom:2px;padding-left:18px}.order-page form .checkbox{margin-right:25px!important}.order-page form textarea{height:150px}.order-page form textarea#jobDescription,.order-page form textarea.preserve-formatting{white-space:pre-wrap;word-wrap:break-word}.order-page form .alert{font-size:12px}footer.footer{text-align:center;padding:30px 0;margin-top:70px;border-top:1px solid #e5e5e5}.modal-danger .modal-header,.modal-info .modal-header,.modal-primary .modal-header,.modal-success .modal-header,.modal-warning .modal-header{color:#fff;border-radius:5px 5px 0 0}.modal-primary .modal-header{background:#337ab7}.modal-info .modal-header{background:#5bc0de}.modal-success .modal-header{background:#5cb85c}.modal-warning .modal-header{background:#f0ad4e}.modal-danger .modal-header{background:#d9534f}.navbar-fixed-top{background:rgba(38,38,38,.7);z-index:1001;border:1px solid #000}.navbar-fixed-top .navbar-brand{display:inline-block;width:160px;background-image:url(/assets/images/wtclogo.png);background-position:50%;background-size:contain;background-repeat:no-repeat}.navbar-fixed-top a,.navbar-fixed-top p{color:#fff!important;font-size:13px}.navbar-fixed-top #navbar-main{margin-left:200px;overflow:hidden}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{background-color:#000!important}", ""]);
	
	// exports


/***/ }),
/* 214 */
59,
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * @preserve jQuery Autocomplete plugin v1.2.6
	 * @homepage http://xdsoft.net/jqplugins/autocomplete/
	 * @license MIT - MIT-LICENSE.txt
	 * (c) 2014, Chupurnov Valeriy <chupurnov@gmail.com>
	 */
	(function ($) {
		'use strict';
		var	ARROWLEFT = 37,
			ARROWRIGHT = 39,
			ARROWUP = 38,
			ARROWDOWN = 40,
			TAB = 9,
			CTRLKEY = 17,
			SHIFTKEY = 16,
			DEL = 46,
			ENTER = 13,
			ESC = 27,
			BACKSPACE = 8,
			AKEY = 65,
			CKEY = 67,
			VKEY = 86,
			ZKEY = 90,
			YKEY = 89,
			defaultSetting = {},
			//currentInput = false,
			ctrlDown = false,
			shiftDown = false,
			publics = {},
			accent_map = {
				'ẚ':'a','Á':'a','á':'a','À':'a','à':'a','Ă':'a','ă':'a','Ắ':'a','ắ':'a','Ằ':'a','ằ':'a','Ẵ':'a','ẵ':'a','Ẳ':'a',
				'Ẫ':'a','ẫ':'a','Ẩ':'a','ẩ':'a','Ǎ':'a','ǎ':'a','Å':'a','å':'a','Ǻ':'a','ǻ':'a','Ä':'a','ä':'a','Ǟ':'a','ǟ':'a',
				'Ã':'a','ã':'a','Ȧ':'a','ȧ':'a','Ǡ':'a','ǡ':'a','Ą':'a','ą':'a','Ā':'a','ā':'a','Ả':'a','ả':'a','Ȁ':'a','ȁ':'a',
				'Ȃ':'a','ȃ':'a','Ạ':'a','ạ':'a','Ặ':'a','ặ':'a','Ậ':'a','ậ':'a','Ḁ':'a','ḁ':'a','Ⱥ':'a','ⱥ':'a','Ǽ':'a','ǽ':'a',
				'Ǣ':'a','ǣ':'a','Ḃ':'b','ḃ':'b','Ḅ':'b','ḅ':'b','Ḇ':'b','ḇ':'b','Ƀ':'b','ƀ':'b','ᵬ':'b','Ɓ':'b','ɓ':'b','Ƃ':'b',
				'ƃ':'b','Ć':'c','ć':'c','Ĉ':'c','ĉ':'c','Č':'c','č':'c','Ċ':'c','ċ':'c','Ç':'c','ç':'c','Ḉ':'c','ḉ':'c','Ȼ':'c',
				'ȼ':'c','Ƈ':'c','ƈ':'c','ɕ':'c','Ď':'d','ď':'d','Ḋ':'d','ḋ':'d','Ḑ':'d','ḑ':'d','Ḍ':'d','ḍ':'d','Ḓ':'d','ḓ':'d',
				'Ḏ':'d','ḏ':'d','Đ':'d','đ':'d','ᵭ':'d','Ɖ':'d','ɖ':'d','Ɗ':'d','ɗ':'d','Ƌ':'d','ƌ':'d','ȡ':'d','ð':'d','É':'e',
				'Ə':'e','Ǝ':'e','ǝ':'e','é':'e','È':'e','è':'e','Ĕ':'e','ĕ':'e','Ê':'e','ê':'e','Ế':'e','ế':'e','Ề':'e','ề':'e',
				'Ễ':'e','ễ':'e','Ể':'e','ể':'e','Ě':'e','ě':'e','Ë':'e','ë':'e','Ẽ':'e','ẽ':'e','Ė':'e','ė':'e','Ȩ':'e','ȩ':'e',
				'Ḝ':'e','ḝ':'e','Ę':'e','ę':'e','Ē':'e','ē':'e','Ḗ':'e','ḗ':'e','Ḕ':'e','ḕ':'e','Ẻ':'e','ẻ':'e','Ȅ':'e','ȅ':'e',
				'Ȇ':'e','ȇ':'e','Ẹ':'e','ẹ':'e','Ệ':'e','ệ':'e','Ḙ':'e','ḙ':'e','Ḛ':'e','ḛ':'e','Ɇ':'e','ɇ':'e','ɚ':'e','ɝ':'e',
				'Ḟ':'f','ḟ':'f','ᵮ':'f','Ƒ':'f','ƒ':'f','Ǵ':'g','ǵ':'g','Ğ':'g','ğ':'g','Ĝ':'g','ĝ':'g','Ǧ':'g','ǧ':'g','Ġ':'g',
				'ġ':'g','Ģ':'g','ģ':'g','Ḡ':'g','ḡ':'g','Ǥ':'g','ǥ':'g','Ɠ':'g','ɠ':'g','Ĥ':'h','ĥ':'h','Ȟ':'h','ȟ':'h','Ḧ':'h',
				'ḧ':'h','Ḣ':'h','ḣ':'h','Ḩ':'h','ḩ':'h','Ḥ':'h','ḥ':'h','Ḫ':'h','ḫ':'h','H':'h','̱':'h','ẖ':'h','Ħ':'h','ħ':'h',
				'Ⱨ':'h','ⱨ':'h','Í':'i','í':'i','Ì':'i','ì':'i','Ĭ':'i','ĭ':'i','Î':'i','î':'i','Ǐ':'i','ǐ':'i','Ï':'i','ï':'i',
				'Ḯ':'i','ḯ':'i','Ĩ':'i','ĩ':'i','İ':'i','i':'i','Į':'i','į':'i','Ī':'i','ī':'i','Ỉ':'i','ỉ':'i','Ȉ':'i','ȉ':'i',
				'Ȋ':'i','ȋ':'i','Ị':'i','ị':'i','Ḭ':'i','ḭ':'i','I':'i','ı':'i','Ɨ':'i','ɨ':'i','Ĵ':'j','ĵ':'j','J':'j','̌':'j',
				'ǰ':'j','ȷ':'j','Ɉ':'j','ɉ':'j','ʝ':'j','ɟ':'j','ʄ':'j','Ḱ':'k','ḱ':'k','Ǩ':'k','ǩ':'k','Ķ':'k','ķ':'k','Ḳ':'k',
				'ḳ':'k','Ḵ':'k','ḵ':'k','Ƙ':'k','ƙ':'k','Ⱪ':'k','ⱪ':'k','Ĺ':'a','ĺ':'l','Ľ':'l','ľ':'l','Ļ':'l','ļ':'l','Ḷ':'l',
				'ḷ':'l','Ḹ':'l','ḹ':'l','Ḽ':'l','ḽ':'l','Ḻ':'l','ḻ':'l','Ł':'l','ł':'l','̣':'l','Ŀ':'l',
				'ŀ':'l','Ƚ':'l','ƚ':'l','Ⱡ':'l','ⱡ':'l','Ɫ':'l','ɫ':'l','ɬ':'l','ɭ':'l','ȴ':'l','Ḿ':'m','ḿ':'m','Ṁ':'m','ṁ':'m',
				'Ṃ':'m','ṃ':'m','ɱ':'m','Ń':'n','ń':'n','Ǹ':'n','ǹ':'n','Ň':'n','ň':'n','Ñ':'n','ñ':'n','Ṅ':'n','ṅ':'n','Ņ':'n',
				'ņ':'n','Ṇ':'n','ṇ':'n','Ṋ':'n','ṋ':'n','Ṉ':'n','ṉ':'n','Ɲ':'n','ɲ':'n','Ƞ':'n','ƞ':'n','ɳ':'n','ȵ':'n','N':'n',
				'̈':'n','n':'n','Ó':'o','ó':'o','Ò':'o','ò':'o','Ŏ':'o','ŏ':'o','Ô':'o','ô':'o','Ố':'o','ố':'o','Ồ':'o',
				'ồ':'o','Ỗ':'o','ỗ':'o','Ổ':'o','ổ':'o','Ǒ':'o','ǒ':'o','Ö':'o','ö':'o','Ȫ':'o','ȫ':'o','Ő':'o','ő':'o','Õ':'o',
				'õ':'o','Ṍ':'o','ṍ':'o','Ṏ':'o','ṏ':'o','Ȭ':'o','ȭ':'o','Ȯ':'o','ȯ':'o','Ȱ':'o','ȱ':'o','Ø':'o','ø':'o','Ǿ':'o',
				'ǿ':'o','Ǫ':'o','ǫ':'o','Ǭ':'o','ǭ':'o','Ō':'o','ō':'o','Ṓ':'o','ṓ':'o','Ṑ':'o','ṑ':'o','Ỏ':'o','ỏ':'o','Ȍ':'o',
				'ȍ':'o','Ȏ':'o','ȏ':'o','Ơ':'o','ơ':'o','Ớ':'o','ớ':'o','Ờ':'o','ờ':'o','Ỡ':'o','ỡ':'o','Ở':'o','ở':'o','Ợ':'o',
				'ợ':'o','Ọ':'o','ọ':'o','Ộ':'o','ộ':'o','Ɵ':'o','ɵ':'o','Ṕ':'p','ṕ':'p','Ṗ':'p','ṗ':'p','Ᵽ':'p','Ƥ':'p','ƥ':'p',
				'P':'p','̃':'p','p':'p','ʠ':'q','Ɋ':'q','ɋ':'q','Ŕ':'r','ŕ':'r','Ř':'r','ř':'r','Ṙ':'r','ṙ':'r','Ŗ':'r',
				'ŗ':'r','Ȑ':'r','ȑ':'r','Ȓ':'r','ȓ':'r','Ṛ':'r','ṛ':'r','Ṝ':'r','ṝ':'r','Ṟ':'r','ṟ':'r','Ɍ':'r','ɍ':'r','ᵲ':'r',
				'ɼ':'r','Ɽ':'r','ɽ':'r','ɾ':'r','ᵳ':'r','ß':'s','Ś':'s','ś':'s','Ṥ':'s','ṥ':'s','Ŝ':'s','ŝ':'s','Š':'s','š':'s',
				'Ṧ':'s','ṧ':'s','Ṡ':'s','ṡ':'s','ẛ':'s','Ş':'s','ş':'s','Ṣ':'s','ṣ':'s','Ṩ':'s','ṩ':'s','Ș':'s','ș':'s','ʂ':'s',
				'S':'s','̩':'s','s':'s','Þ':'t','þ':'t','Ť':'t','ť':'t','T':'t','ẗ':'t','Ṫ':'t','ṫ':'t','Ţ':'t','ţ':'t','Ṭ':'t',
				'ṭ':'t','Ț':'t','ț':'t','Ṱ':'t','ṱ':'t','Ṯ':'t','ṯ':'t','Ŧ':'t','ŧ':'t','Ⱦ':'t','ⱦ':'t','ᵵ':'t',
				'ƫ':'t','Ƭ':'t','ƭ':'t','Ʈ':'t','ʈ':'t','ȶ':'t','Ú':'u','ú':'u','Ù':'u','ù':'u','Ŭ':'u','ŭ':'u','Û':'u','û':'u',
				'Ǔ':'u','ǔ':'u','Ů':'u','ů':'u','Ü':'u','ü':'u','Ǘ':'u','ǘ':'u','Ǜ':'u','ǜ':'u','Ǚ':'u','ǚ':'u','Ǖ':'u','ǖ':'u',
				'Ű':'u','ű':'u','Ũ':'u','ũ':'u','Ṹ':'u','ṹ':'u','Ų':'u','ų':'u','Ū':'u','ū':'u','Ṻ':'u','ṻ':'u','Ủ':'u','ủ':'u',
				'Ȕ':'u','ȕ':'u','Ȗ':'u','ȗ':'u','Ư':'u','ư':'u','Ứ':'u','ứ':'u','Ừ':'u','ừ':'u','Ữ':'u','ữ':'u','Ử':'u','ử':'u',
				'Ự':'u','ự':'u','Ụ':'u','ụ':'u','Ṳ':'u','ṳ':'u','Ṷ':'u','ṷ':'u','Ṵ':'u','ṵ':'u','Ʉ':'u','ʉ':'u','Ṽ':'v','ṽ':'v',
				'Ṿ':'v','ṿ':'v','Ʋ':'v','ʋ':'v','Ẃ':'w','ẃ':'w','Ẁ':'w','ẁ':'w','Ŵ':'w','ŵ':'w','W':'w','̊':'w','ẘ':'w','Ẅ':'w',
				'ẅ':'w','Ẇ':'w','ẇ':'w','Ẉ':'w','ẉ':'w','Ẍ':'x','ẍ':'x','Ẋ':'x','ẋ':'x','Ý':'y','ý':'y','Ỳ':'y','ỳ':'y','Ŷ':'y',
				'ŷ':'y','Y':'y','ẙ':'y','Ÿ':'y','ÿ':'y','Ỹ':'y','ỹ':'y','Ẏ':'y','ẏ':'y','Ȳ':'y','ȳ':'y','Ỷ':'y','ỷ':'y',
				'Ỵ':'y','ỵ':'y','ʏ':'y','Ɏ':'y','ɏ':'y','Ƴ':'y','ƴ':'y','Ź':'z','ź':'z','Ẑ':'z','ẑ':'z','Ž':'z','ž':'z','Ż':'z',
				'ż':'z','Ẓ':'z','ẓ':'z','Ẕ':'z','ẕ':'z','Ƶ':'z','ƶ':'z','Ȥ':'z','ȥ':'z','ʐ':'z','ʑ':'z','Ⱬ':'z','ⱬ':'z','Ǯ':'z',
				'ǯ':'z','ƺ':'z','２':'2','６':'6','Ｂ':'B','Ｆ':'F','Ｊ':'J','Ｎ':'N','Ｒ':'R','Ｖ':'V','Ｚ':'Z','ｂ':'b','ｆ':'f','ｊ':'j',
				'ｎ':'n','ｒ':'r','ｖ':'v','ｚ':'z','１':'1','５':'5','９':'9','Ａ':'A','Ｅ':'E','Ｉ':'I','Ｍ':'M','Ｑ':'Q','Ｕ':'U','Ｙ':'Y',
				'ａ':'a','ｅ':'e','ｉ':'i','ｍ':'m','ｑ':'q','ｕ':'u','ｙ':'y','０':'0','４':'4','８':'8','Ｄ':'D','Ｈ':'H','Ｌ':'L','Ｐ':'P',
				'Ｔ':'T','Ｘ':'X','ｄ':'d','ｈ':'h','ｌ':'l','ｐ':'p','ｔ':'t','ｘ':'x','３':'3','７':'7','Ｃ':'C','Ｇ':'G','Ｋ':'K','Ｏ':'O',
				'Ｓ':'S','Ｗ':'W','ｃ':'c','ｇ':'g','ｋ':'k','ｏ':'o','ｓ':'s','ｗ':'w','ẳ':'a','Â':'a','â':'a','Ấ':'a','ấ':'a','Ầ':'a','ầ':'a'
			};
	
		if (window.getComputedStyle === undefined) {
			window.getComputedStyle = (function () {
				function getPixelSize(element, style, property, fontSize) {
					var	sizeWithSuffix = style[property],
						size = parseFloat(sizeWithSuffix),
						suffix = sizeWithSuffix.split(/\d/)[0],
						rootSize;
	
					fontSize = fontSize !== null ? fontSize : /%|em/.test(suffix) && element.parentElement ? getPixelSize(element.parentElement, element.parentElement.currentStyle, 'fontSize', null) : 16;
					rootSize = property === 'fontSize' ? fontSize : /width/i.test(property) ? element.clientWidth : element.clientHeight;
	
					return (suffix === 'em') ? size * fontSize : (suffix === 'in') ? size * 96 : (suffix === 'pt') ? size * 96 / 72 : (suffix === '%') ? size / 100 * rootSize : size;
				}
	
				function setShortStyleProperty(style, property) {
					var	borderSuffix = property === 'border' ? 'Width' : '',
						t = property + 'Top' + borderSuffix,
						r = property + 'Right' + borderSuffix,
						b = property + 'Bottom' + borderSuffix,
						l = property + 'Left' + borderSuffix;
	
					style[property] = (style[t] === style[r] === style[b] === style[l] ? [style[t]]
						: style[t] === style[b] && style[l] === style[r] ? [style[t], style[r]]
							: style[l] === style[r] ? [style[t], style[r], style[b]]
								: [style[t], style[r], style[b], style[l]]).join(' ');
				}
	
				function CSSStyleDeclaration(element) {
					var	currentStyle = element.currentStyle,
						style = this,
						property,
						fontSize = getPixelSize(element, currentStyle, 'fontSize', null);
					
					for (property in currentStyle) {
						if (Object.prototype.hasOwnProperty.call(currentStyle, property)) {
							if (/width|height|margin.|padding.|border.+W/.test(property) && style[property] !== 'auto') {
								style[property] = getPixelSize(element, currentStyle, property, fontSize) + 'px';
							} else if (property === 'styleFloat') {
								style.float = currentStyle[property];
							} else {
								style[property] = currentStyle[property];
							}
						}
					}
	
					setShortStyleProperty(style, 'margin');
					setShortStyleProperty(style, 'padding');
					setShortStyleProperty(style, 'border');
	
					style.fontSize = fontSize + 'px';
	
					return style;
				}
	
				CSSStyleDeclaration.prototype = {
					constructor: CSSStyleDeclaration,
					getPropertyPriority: function () {},
					getPropertyValue: function (prop) {
						return this[prop] || '';
					},
					item: function () {},
					removeProperty: function () {},
					setProperty: function () {},
					getPropertyCSSValue: function () {}
				};
	
				function getComputedStyle(element) {
					return new CSSStyleDeclaration(element);
				}
	
				return getComputedStyle;
			}(this));
		}
	
	
		$(document)
			.on('keydown.xdsoftctrl', function (e) {
				if (e.keyCode === CTRLKEY) {
					ctrlDown = true;
				}
				if (e.keyCode === SHIFTKEY) {
					ctrlDown = true;
				}
			})
			.on('keyup.xdsoftctrl', function (e) {
				if (e.keyCode === CTRLKEY) {
					ctrlDown = false;
				}
				if (e.keyCode === SHIFTKEY) {
					ctrlDown = false;
				}
			});
		
		function accentReplace (s) {
			if (!s) { return ''; }
			var ret = '',i;
			for (i=0; i < s.length; i+=1) {
				ret += accent_map[s.charAt(i)] || s.charAt(i);
			}
			return ret;
		}
		
		function escapeRegExp (str) {
			return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
		}
		
		function getCaretPosition(input) {
			if (!input) {
				return;
			}
			if (input.selectionStart) {
				return input.selectionStart;
			}
			if (document.selection) {
				input.focus();
				var sel = document.selection.createRange(),
					selLen = document.selection.createRange().text.length;
				sel.moveStart('character', -input.value.length);
				return sel.text.length - selLen;
			}
		}
	
		function setCaretPosition(input, pos) {
			if (input.setSelectionRange) {
				input.focus();
				input.setSelectionRange(pos, pos);
			} else if (input.createTextRange) {
				var range = input.createTextRange();
				range.collapse(true);
				range.moveEnd('character', pos);
				range.moveStart('character', pos);
				range.select();
			}
		}
	
		function isset(value) {
			return value !== undefined;
		}
	
		function safe_call(callback, args, callback2, defaultValue) {
			if (isset(callback) && !$.isArray(callback)) {
				return $.isFunction(callback) ? callback.apply(this,args):defaultValue;
			}
			if(isset(callback2)) {
				return safe_call.call(this,callback2,args);
			}
			return defaultValue;
		};
	
		function __safe( callbackName,source,args,defaultValue ){
			var undefinedVar;
			return safe_call.call( this, (isset(this.source[source])&&
				Object.prototype.hasOwnProperty.call(this.source[source], callbackName)) ? this.source[source][callbackName] : undefinedVar, args, function(){
				return safe_call.call(this,
						isset(this[callbackName][source])?
							this[callbackName][source]:(
								isset(this[callbackName][0])?
									this[callbackName][0]:(
										Object.prototype.hasOwnProperty.call(this, callbackName)?
											this[callbackName]:
											undefinedVar
									)
							),
						args,
						defaultSetting[callbackName][source]||defaultSetting[callbackName][0]||defaultSetting[callbackName],
						defaultValue
				);
			},defaultValue);
		};
	
		function __get( property,source ){
			if(!isset(source))
				source = 0;
			
			if( $.isArray(this.source) && isset(this.source[source]) && isset(this.source[source][property]))
				return this.source[source][property];
				
			if( isset(this[property]) ){
				if( $.isArray(this[property]) ){
					if( isset(this[property][source]) )
						return this[property][source];
					if( isset(this[property][0]) )
						return this[property][0];
					return null;
				}
				return this[property];
			}
			
			return null;
		};
	
		function loadRemote( url,sourceObject,done,debug ){
			 if (sourceObject.xhr) {
				sourceObject.xhr.abort();
			 }
			 sourceObject.xhr = $.ajax($.extend(true,{
				url : url,
				type  : 'GET' ,
				async:true,
				cache :false,
				dataType : 'json'
			 },sourceObject.ajax))
			 
			 .done(function( data ){
				done&&done.apply(this,$.makeArray(arguments));
			 })
			 
			 .fail(function( jqXHR, textStatus ){
				if( debug )
					console.log("Request failed: " + textStatus);
			 });
		}
	
	
		function findRight( data,query ){
			var right = false,source;
			
			for (source = 0;source < data.length;source += 1) {
				if( right = __safe.call(this,"findRight",source,[data[source],query,source]) ){
					return {right:right,source:source};
				}
			}
			
			return false;
		}
	
		function processData( data,query ){
			var source;
			preparseData
				.call( this,data,query );
			
			for (source = 0;source < data.length;source += 1) {
				data[source] = __safe.call(this,
					'filter',
					source,
					[data[source], query, source],
					data[source]
				);
			}
		};
	
	
		function collectData( query,datasource,callback ){
			var options = this,source;
			
			if( $.isFunction(options.source) ){
					options.source.apply(options,[query,function(items){
						datasource = [items];
						safe_call.call(options,callback,[query]);
					},datasource,0]);
			}else{
				for (source = 0;source < options.source.length;source += 1) {
					if ($.isArray(options.source[source])) {
						datasource[source] = options.source[source];
					} else if ($.isFunction(options.source[source])) {
						(function (source) {
							options.source[source].apply(options,[query, function(items){
								if (!datasource[source]) {
									datasource[source] = [];
								}
									
								if (items && $.isArray(items)) {
									switch (options.appendMethod) {
										case 'replace':
											datasource[source] = items;
										break;
										default:
											datasource[source] = datasource[source].concat(items);
									}
								}
									
								safe_call.call(options,callback,[query]);
							}, datasource,source]);
						}(source));
					} else {
						switch (options.source[source].type) {
							case 'remote':
								if (isset(options.source[source].url)) {
									if (!isset(options.source[source].minLength) || query.length >= options.source[source].minLength){
										var url = __safe.call(options,'replace',source,[options.source[source].url,query],'');
										if (!datasource[source]) {
											datasource[source] = [];
										}
										(function (source) {
											loadRemote(url,options.source[source], function(resp){
												datasource[source] = resp;
												safe_call.call(options,callback,[query]);
											},options.debug);
										}(source));
									}
								}
							break;
							default:
								if( isset(options.source[source]['data']) ){
									datasource[source] = options.source[source]['data'];
								}else{
									datasource[source] = options.source[source];
								}
						}
					}
				}
			}
			safe_call.call(options,callback,[query]);
		};
	
		function preparseData( data,query ){
			for( var source=0;source<data.length;source++ ){
				data[source] = __safe.call(this,
					'preparse',
					source,
					[data[source],query],
					data[source]
				);
			}
		};
	
		function renderData( data,query ){
			var  source, i, $div, $divs = [];
			
			for (source = 0;source < data.length;source += 1) {
				for (i = 0;i < data[source].length;i += 1) {
					if( $divs.length>=this.limit )
						break;
						
					$div = $(__safe.call(this,
						'render',source,
						[data[source][i],source,i,query],
						''
					));
					
					$div.data('source',source);
					$div.data('pid',i);
					$div.data('item',data[source][i]);
					
					$divs.push($div);
				}
			}
			
			return $divs;
		};
	
		function getItem( $div,dataset ){
			if( isset($div.data('source')) && 
				isset($div.data('pid')) && 
				isset(dataset[$div.data('source')]) && 
				isset(dataset[$div.data('source')][$div.data('pid')]) 
			){
				return dataset[$div.data('source')][$div.data('pid')];
			}
			return false;
		};
	
		function getValue( $div,dataset ){
			var item = getItem($div,dataset);
			
			if( item ){
				return __safe.call(this,
					'getValue',$div.data('source'),
					[item,$div.data('source')]
				);
			}else{
				if( isset($div.data('value')) ){
					return decodeURIComponent($div.data('value'));
				}else{
					return $div.html();
				}
			}
		};
	
		defaultSetting = {
			minLength: 0,
			valueKey: 'value',
			titleKey: 'title',
			highlight: true,
	
			showHint: true,
	
			dropdownWidth: '100%',
			dropdownStyle: {},
			itemStyle: {},
			hintStyle: false,
			style: false,
	
			debug: true,
			openOnFocus: false,
			closeOnBlur: true,
	
			autoselect: false,
			
			accents: true,
			replaceAccentsForRemote: true,
			
			limit: 20,
			visibleLimit: 20,
			visibleHeight: 0,
			defaultHeightItem: 30,
	
			timeoutUpdate: 10,
	
			get: function (property, source) {
				return __get.call(this,property,source);
			},
			
			replace: [
				function (url, query) {
					if (this.replaceAccentsForRemote) {
						query = accentReplace(query);
					}
					return url.replace('%QUERY%',encodeURIComponent(query));
				}
			],
			
			equal:function( value,query ){
				return query.toLowerCase()==value.substr(0,query.length).toLowerCase();
			},
			
			findRight:[
				function(items,query,source){
					var results = [],value = '',i;
					if (items) {
						for (i = 0;i < items.length;i += 1) {
							value = __safe.call(this,'getValue',source,[items[i],source]);
							if (__safe.call(this, 'equal', source, [value,query,source], false)) {
								return items[i];
							}
						}				
					}
					return false;
				}
			],
			
			valid:[
				function (value, query) {
					if (this.accents) {
						value = accentReplace(value);
						query = accentReplace(query);
					}
					return value.toLowerCase().indexOf(query.toLowerCase())!=-1;
					
				}
			],
			
			filter:[
				function (items, query, source) {
					var results = [], value = '',i;
					if (items) {					
						for (i = 0;i < items.length;i += 1) {
							value = isset(items[i][this.get('valueKey', source)]) ? items[i][this.get('valueKey', source)] : items[i].toString();
							if (__safe.call(this, 'valid', source, [value, query])) {
								results.push(items[i]); 
							}
						}
					}
					return results;
				}
			],
			
			preparse:function(items){
				return items;
			},
			
			getValue: [
				function (item, source) {
					return isset(item[this.get('valueKey',source)])?item[this.get('valueKey',source)]:item.toString();
				}
			],
			
			getTitle: [
				function (item, source) {
					return isset(item[this.get('titleKey',source)])?item[this.get('titleKey',source)]:item.toString();
				}
			],
			
			render: [
				function (item, source, pid, query) {
					var value = __safe.call(this, "getValue", source, [item, source], defaultSetting.getValue[0].call(this, item, source)),
						title = __safe.call(this, "getTitle", source, [item, source], defaultSetting.getTitle[0].call(this, item, source)),
						_value = '',
						_query = '',
						_title = '',
						hilite_hints = '',
						highlighted = '',
						c, h, i,
						spos = 0;
						
					if (this.highlight) {
						if (!this.accents) {
							title = title.replace(new RegExp('('+escapeRegExp(query)+')','i'),'<b>$1</b>');
						}else{
							_title = accentReplace(title).toLowerCase().replace(/[<>]+/g, ''),
							_query = accentReplace(query).toLowerCase().replace(/[<>]+/g, '');
							
							hilite_hints = _title.replace(new RegExp(escapeRegExp(_query), 'g'), '<'+_query+'>');
							for (i=0;i < hilite_hints.length;i += 1) {
								c = title.charAt(spos);
								h = hilite_hints.charAt(i);
								if (h === '<') {
									highlighted += '<b>';
								} else if (h === '>') {
									highlighted += '</b>';
								} else {
									spos += 1;
									highlighted += c;
								}
							}
							title = highlighted;
						}
					}
						
					return '<div '+(value==query?'class="active"':'')+' data-value="'+encodeURIComponent(value)+'">'
								+title+
							'</div>';
				}
			],
			appendMethod: 'concat', // supported merge and replace 
			source:[],
			afterSelected: function() {
	        }
		};
		function init( that,options ){
			if( $(that).hasClass('xdsoft_input') )
					return;
			
			var $box = $('<div class="xdsoft_autocomplete"></div>'),
				$dropdown = $('<div class="xdsoft_autocomplete_dropdown"></div>'),
				$hint = $('<input readonly class="xdsoft_autocomplete_hint"/>'),
				$input = $(that),
				timer1 = 0,
				intervalForVisibility,
				dataset = [],
				iOpen	= false,
				value = '',
				currentValue = '',
				currentSelect = '',
				active = null,
				pos = 0;
			
			//it can be used to access settings
			$input.data('autocomplete_options', options);
			
			$dropdown
				.on('mousedown', function(e) {
					e.preventDefault();
					e.stopPropagation();
				})
				.on('updatescroll.xdsoft', function() {
					var _act = $dropdown.find('.active');
					if (!_act.length) {
						return;
					}
					
					var top = _act.position().top,
						actHght = _act.outerHeight(true),
						scrlTop = $dropdown.scrollTop(),
						hght = $dropdown.height();
						
					if (top <0) {
						$dropdown.scrollTop(scrlTop-Math.abs(top));
					} else if (top+actHght>hght) {
						$dropdown.scrollTop(scrlTop+top+actHght-hght);
					}
				});
			
			$box
				.css({
					'display':$input.css('display'),
					'width':$input.css('width')
				});
			
			if( options.style )
				$box.css(options.style);
				
			$input
				.addClass('xdsoft_input')
				.attr('autocomplete','off');
			
			var xDown = null;
			var yDown = null;
			var isSwipe = false;
			$dropdown
				.on('mousemove','div',function(){
					if( $(this).hasClass('active') )
						return true;
					$dropdown.find('div').removeClass('active');
					$(this).addClass('active');
				})
				.on('mousedown','div',function(e){
					$dropdown.find('div').removeClass('active');
					$(this).addClass('active');
					$input.trigger('pick.xdsoft');
				})
				.on('touchstart','div',function(e){
					xDown = e.originalEvent.touches[0].clientX;
					yDown = e.originalEvent.touches[0].clientY;
				})
				.on('touchend','div',function(e){
					if(isSwipe === false) {
						$dropdown.find('div').removeClass('active');
						$(this).addClass('active');
						$input.trigger('pick.xdsoft');
					}
	
					isSwipe = false;
				})
				.on('touchmove','div',function(e){
					if ( ! xDown || ! yDown ) {
						return;
					}
	
					var xUp = e.originalEvent.touches[0].clientX;
					var yUp = e.originalEvent.touches[0].clientY;
	
					var xDiff = xDown - xUp;
					var yDiff = yDown - yUp;
	
					if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
						if ( xDiff > 0 ) {
							isSwipe = 'left';
						} else {
							isSwipe = 'right';
						}
					} else {
						if ( yDiff > 0 ) {
							isSwipe = 'top';
						} else {
							isSwipe = 'bottm';
						}
					}
	
					xDown = null;
					yDown = null;
				});
	
			function manageData(){
				if ($input.val()!=currentValue){
					currentValue = $input.val();
				} else {
					return;
				}
				if (currentValue.length < options.minLength) {
					$input.trigger('close.xdsoft');
					return;
				}
				collectData.call(options,currentValue,dataset,function( query ){
					if (query != currentValue) {
						return;
					}
					var right;	
					processData.call(options, dataset,query);
	
					$input.trigger('updateContent.xdsoft');
	
					if (options.showHint && currentValue.length && currentValue.length<=$input.prop('size') && (right = findRight.call(options,dataset,currentValue))) {
						var title 	=  __safe.call(options,'getTitle',right.source,[right.right,right.source]);
						title = query + title.substr(query.length);
						$hint.val(title);
					} else {
						$hint.val('');
					}
				});
	
				return;
			}
	
			function manageKey (event) {
				var key = event.keyCode, right;
				
				switch( key ){
					case AKEY: case CKEY: case VKEY: case ZKEY: case YKEY:
						if (event.shiftKey || event.ctrlKey) {
							return true;
						}
					break;
					case SHIFTKEY:	
					case CTRLKEY:
						return true;
					break;
					case ARROWRIGHT:	
					case ARROWLEFT:
						if (ctrlDown || shiftDown || event.shiftKey || event.ctrlKey) {
							return true;
						}
						value = $input.val();
						pos = getCaretPosition($input[0]);
						if (key === ARROWRIGHT && pos === value.length) {
							if (right = findRight.call(options, dataset, value)){
								$input.trigger('pick.xdsoft', [
									__safe.call(options,
										'getValue', right.source,
										[right.right, right.source]
									)
								]);
							} else {
								$input.trigger('pick.xdsoft');
							}
							event.preventDefault();
							return false;
						}
						return true;
					case TAB:
					return true;
					case ENTER:
						if (iOpen) {
							$input.trigger('pick.xdsoft');
							event.preventDefault();
							return false;
						} else {
							return true;
						}
					break;
					case ESC:
						$input
							.val(currentValue)
							.trigger('close.xdsoft');
						event.preventDefault();
						return false;
					case ARROWDOWN:
					case ARROWUP:
						if (!iOpen) {
							$input.trigger('open.xdsoft');
							$input.trigger('updateContent.xdsoft');
							event.preventDefault();
							return false;
						}
						
						active = $dropdown.find('div.active');
						
						var next = key==ARROWDOWN?'next':'prev', timepick = true;
						
						if( active.length ){
							active.removeClass('active');
							if( active[next]().length ){
								active[next]().addClass('active');
							}else{
								$input.val(currentValue);
								timepick = false;
							}
						}else{
							$dropdown.children().eq(key==ARROWDOWN?0:-1).addClass('active');
						}
						
						if( timepick ){
							$input.trigger('timepick.xdsoft');
						}
						
						$dropdown
							.trigger('updatescroll.xdsoft');
						
						event.preventDefault();
						return false;	
				}
				return;
			}
			
			$input
				.data('xdsoft_autocomplete',dataset)
				.after($box)
				.on('pick.xdsoft', function( event,_value ){
	
					$input.trigger('timepick.xdsoft',_value);
					
					currentSelect = currentValue = $input.val();
					
					$input.trigger('close.xdsoft');
					
					//currentInput = false;
					
					active = $dropdown.find('div.active').eq(0);
								
					if( !active.length )
						active = $dropdown.children().first();
						
					$input.trigger('selected.xdsoft',[getItem(active,dataset)]);
					
					if (options.afterSelected)
						options.afterSelected();
				})
				.on('timepick.xdsoft', function( event,_value ){
					active = $dropdown.find('div.active');
								
					if( !active.length )
						active = $dropdown.children().first();
					
					if( active.length ){
						if( !isset(_value) ){
							$input.val(getValue.call(options,active,dataset));
						}else{
							$input.val(_value);
						}
						$input.trigger('autocompleted.xdsoft',[getItem(active,dataset)]);
						$hint.val('');
						setCaretPosition($input[0],$input.val().length);
					}
				})
				.on('keydown.xdsoft input.xdsoft cut.xdsoft paste.xdsoft', function( event ){
					var ret = manageKey(event);
					
					if (ret === false || ret === true) {
						return ret;
					}
					
					setTimeout(function(){
						manageData();
					},1);
					
					manageData();
				})
				.on('change.xdsoft', function( event ){
					currentValue = $input.val();
				});
			
			currentValue = $input.val();
			
			collectData.call(options, $input.val(),dataset,function( query ){
				processData.call(options,dataset,query);
			});
			
			if( options.openOnFocus ){
				$input.on('focusin.xdsoft',function(){
					$input.trigger('open.xdsoft');
					$input.trigger('updateContent.xdsoft');
				});
			}
			
			if( options.closeOnBlur )
				$input.on('focusout.xdsoft',function(){
					$input.trigger('close.xdsoft');
				});
				
			$box
				.append($input)
				.append($dropdown);
	
	
			var olderBackground = false,
				timerUpdate = 0;
			
			$input
				.on('updateHelperPosition.xdsoft',function(){
					clearTimeout(timerUpdate);
					timerUpdate = setTimeout(function(){
						$box.css({
							'display':$input.css('display'),
							'width':$input.css('width')
						});
						$dropdown.css($.extend(true,{
							left:$input.position().left,
							top:$input.position().top + parseInt($input.css('marginTop'))+parseInt($input[0].offsetHeight),
							marginLeft:$input.css('marginLeft'),
							marginRight:$input.css('marginRight'),
							width:options.dropdownWidth=='100%'?$input[0].offsetWidth:options.dropdownWidth
						},options.dropdownStyle));
						
						if (options.showHint) {
							var style = getComputedStyle($input[0], "");
							
							$hint[0].style.cssText = style.cssText;
							
							$hint.css({
								'box-sizing':style.boxSizing,
								borderStyle:'solid',
								borderCollapse:style.borderCollapse,
								borderLeftWidth:style.borderLeftWidth,
								borderRightWidth:style.borderRightWidth,
								borderTopWidth:style.borderTopWidth,
								borderBottomWidth:style.borderBottomWidth,
								paddingBottom:style.paddingBottom,
								marginBottom:style.marginBottom,
								paddingTop:style.paddingTop,
								marginTop:style.marginTop,
								paddingLeft:style.paddingLeft,
								marginLeft:style.marginLeft,
								paddingRight:style.paddingRight,
								marginRight:style.marginRight,
								maxHeight:style.maxHeight,
								minHeight:style.minHeight,
								maxWidth:style.maxWidth,
								minWidth:style.minWidth,
								width:style.width,
								letterSpacing:style.letterSpacing,
								lineHeight:style.lineHeight,
								outlineWidth:style.outlineWidth,
								fontFamily:style.fontFamily,
								fontVariant:style.fontVariant,
								fontStyle:$input.css('fontStyle'),
								fontSize:$input.css('fontSize'),
								fontWeight:$input.css('fontWeight'),
								flex:style.flex,
								justifyContent:style.justifyContent,
								borderRadius:style.borderRadius,
								'-webkit-box-shadow':'none',
								'box-shadow':'none'
							});
							
							$input.css('font-size',$input.css('fontSize'))// fix bug with em font size
							
							$hint.innerHeight($input.innerHeight());
							
							$hint.css($.extend(true,{
								position:'absolute',
								zIndex:'1',
								borderColor:'transparent',
								outlineColor:'transparent',
								left:$input.position().left,
								top:$input.position().top,
								background:$input.css('background')
							},options.hintStyle));
							
							
							if( olderBackground!==false ){
								$hint.css('background',olderBackground);
							}else{
								olderBackground = $input.css('background');
							}
							
							try{
								$input[0].style.setProperty('background', 'transparent', 'important');
							} catch(e) {
								$input.css('background','transparent')
							}
	
							$box
								.append($hint);
						}
					}, options.timeoutUpdate||1);
				});
			
			if ($input.is(':visible')) {
				$input
					.trigger('updateHelperPosition.xdsoft');
			} else {
				intervalForVisibility = setInterval(function () {
					if ($input.is(':visible')) {
						$input
							.trigger('updateHelperPosition.xdsoft');
						clearInterval(intervalForVisibility);
					}
				},100);
			}
			
			$(window).on('resize',function () {
				$box.css({
					'width':'auto'
				});
				$input
					.trigger('updateHelperPosition.xdsoft');
			})
			
			$input	
				.on('close.xdsoft',function(){
					if (!iOpen) {
						return;
					}
	
					$dropdown
						.hide();
	
					$hint
						.val('');	
	
					if (!options.autoselect) {
						$input.val(currentValue);
					}
	
					iOpen = false;
	
					//currentInput = false;
				})
				
				.on('updateContent.xdsoft',function(){
					var out = renderData.call(options,dataset,$input.val()),
						hght = 10;
					
					if (out.length) {
						$input.trigger('open.xdsoft');
					} else {
						$input.trigger('close.xdsoft');
						return;
					}
	
					$(out).each(function(){
						this.css($.extend(true,{
							paddingLeft:$input.css('paddingLeft'),
							paddingRight:$input.css('paddingRight')
						},options.itemStyle));
					});
	
					$dropdown
						.html(out);
						
					if (options.visibleHeight){
						hght = options.visibleHeight;
					} else {
						hght = options.visibleLimit * ((out[0] ? out[0].outerHeight(true) : 0) || options.defaultHeightItem) + 5;
					}
					
					$dropdown
						.css('maxHeight', hght+'px')
				})
				
				.on('open.xdsoft',function(){
					if( iOpen )
						return;
					
					$dropdown
						.show();
	
					iOpen = true;
						
					//currentInput = $input;
				})
				.on('destroy.xdsoft',function(){
					$input.removeClass('xdsoft');
					$box.after($input);
					$box.remove();
					clearTimeout(timer1);
					clearTimeout(intervalForVisibility);
					//currentInput = false;
					$input.data('xdsoft_autocomplete',null);
					$input
						.off('.xdsoft')
				});
		};
		
		publics = {
			destroy: function () {
				return this.trigger('destroy.xdsoft');
			},
			update: function () {
				return this.trigger('updateHelperPosition.xdsoft');	
			},
			options: function (_options) {
				if (this.data('autocomplete_options') && $.isPlainObject(_options)) {
					this.data('autocomplete_options', $.extend(true, this.data('autocomplete_options'), _options));
				}
				return this;
			},
			setSource: function (_newsource, id) {
				if(this.data('autocomplete_options') && ($.isPlainObject(_newsource) || $.isFunction(_newsource) || $.isArray(_newsource))) {
					var options = this.data('autocomplete_options'), 
						dataset = this.data('xdsoft_autocomplete'),
						source 	= options.source;
					if (id!==undefined && !isNaN(id)) {
						if ($.isPlainObject(_newsource) || $.isArray(_newsource)) {
							source[id] =  $.extend(true,$.isArray(_newsource) ? [] : {}, _newsource);
						} else {
							source[id] =  _newsource;
						}
					} else {
						if ($.isFunction(_newsource)) {
							this.data('autocomplete_options').source = _newsource;
						} else {
							$.extend(true, source, _newsource);
						}
					}
					
					collectData.call(options, this.val(), dataset,function( query ){
						processData.call(options,dataset,query);
					});
				}
				return this;
			},
			getSource: function (id) {
				if (this.data('autocomplete_options')) {
					var source = this.data('autocomplete_options').source;
					if (id!==undefined && !isNaN(id) &&source[id]) {
						return source[id];
					} else {
						return source;
					}
				}
				return null;
			} 
		};
		
		$.fn.autocomplete = function(_options, _second, _third){
			if ($.type(_options) === 'string' && publics[_options]) {
				return publics[_options].call(this, _second, _third);
			}
			return this.each(function () {
				var options = $.extend(true, {}, defaultSetting, _options);
				init(this, options);
			});
		};
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    return exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (typeof process !== 'undefined' && 'env' in process) {
	    return ({"NODE_ENV":"production"}).DEBUG;
	  }
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug.debug = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting
	    args = exports.formatArgs.apply(self, args);
	
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ })
]);


// WEBPACK FOOTER //
// app.327ce86cd909d6510ed8.js